/* Office runtime JavaScript library */
/* Version: 16.0.10908.10000 */
/*
	Copyright (c) Microsoft Corporation.  All rights reserved.
*/

/*
    The '!' acts as an escape character that ensures that the following
    license comment is not removed in prod builds of OWA. Please do not remove.
    The OSS license must be provided in order to provide attribution.
*/
/*!
    Your use of this file is governed by the Microsoft Services Agreement http://go.microsoft.com/fwlink/?LinkId=266419.

    This file also contains the following Promise implementation (with a few small modifications):
        * @overview es6-promise - a tiny implementation of Promises/A+.
        * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
        * @license   Licensed under MIT license
        *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
        * @version   2.3.0
*/
var OfficeExt;
(function(b) {
    var a = (function() {
        var a = true;
        function b() {}
        b.prototype.isMsAjaxLoaded = function() {
            var b = 'function',
                c = 'undefined';
            if (
                typeof Sys !== c &&
                typeof Type !== c &&
                Sys.StringBuilder &&
                typeof Sys.StringBuilder === b &&
                Type.registerNamespace &&
                typeof Type.registerNamespace === b &&
                Type.registerClass &&
                typeof Type.registerClass === b &&
                typeof Function._validateParams === b &&
                Sys.Serialization &&
                Sys.Serialization.JavaScriptSerializer &&
                typeof Sys.Serialization.JavaScriptSerializer.serialize === b
            )
                return a;
            else return false;
        };
        b.prototype.loadMsAjaxFull = function(b) {
            var a =
                (window.location.protocol.toLowerCase() === 'https:' ? 'https:' : 'http:') +
                '//ajax.aspnetcdn.com/ajax/3.5/MicrosoftAjax.js';
            OSF.OUtil.loadScript(a, b);
        };
        Object.defineProperty(b.prototype, 'msAjaxError', {
            get: function() {
                var a = this;
                if (a._msAjaxError == null && a.isMsAjaxLoaded()) a._msAjaxError = Error;
                return a._msAjaxError;
            },
            set: function(a) {
                this._msAjaxError = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, 'msAjaxString', {
            get: function() {
                var a = this;
                if (a._msAjaxString == null && a.isMsAjaxLoaded()) a._msAjaxString = String;
                return a._msAjaxString;
            },
            set: function(a) {
                this._msAjaxString = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, 'msAjaxDebug', {
            get: function() {
                var a = this;
                if (a._msAjaxDebug == null && a.isMsAjaxLoaded()) a._msAjaxDebug = Sys.Debug;
                return a._msAjaxDebug;
            },
            set: function(a) {
                this._msAjaxDebug = a;
            },
            enumerable: a,
            configurable: a,
        });
        return b;
    })();
    b.MicrosoftAjaxFactory = a;
})(OfficeExt || (OfficeExt = {}));
var OsfMsAjaxFactory = new OfficeExt.MicrosoftAjaxFactory(),
    OSF = OSF || {},
    OfficeExt;
(function(b) {
    var a = (function() {
        function a(a) {
            this._internalStorage = a;
        }
        a.prototype.getItem = function(a) {
            try {
                return this._internalStorage && this._internalStorage.getItem(a);
            } catch (b) {
                return null;
            }
        };
        a.prototype.setItem = function(b, a) {
            try {
                this._internalStorage && this._internalStorage.setItem(b, a);
            } catch (c) {}
        };
        a.prototype.clear = function() {
            try {
                this._internalStorage && this._internalStorage.clear();
            } catch (a) {}
        };
        a.prototype.removeItem = function(a) {
            try {
                this._internalStorage && this._internalStorage.removeItem(a);
            } catch (b) {}
        };
        a.prototype.getKeysWithPrefix = function(d) {
            var b = [];
            try {
                for (
                    var e = (this._internalStorage && this._internalStorage.length) || 0, a = 0;
                    a < e;
                    a++
                ) {
                    var c = this._internalStorage.key(a);
                    c.indexOf(d) === 0 && b.push(c);
                }
            } catch (f) {}
            return b;
        };
        return a;
    })();
    b.SafeStorage = a;
})(OfficeExt || (OfficeExt = {}));
OSF.XdmFieldName = { ConversationUrl: 'ConversationUrl', AppId: 'AppId' };
OSF.WindowNameItemKeys = {
    BaseFrameName: 'baseFrameName',
    HostInfo: 'hostInfo',
    XdmInfo: 'xdmInfo',
    SerializerVersion: 'serializerVersion',
    AppContext: 'appContext',
};
OSF.OUtil = (function() {
    var h = 'focus',
        g = 'on',
        n = 'configurable',
        m = 'writable',
        f = 'enumerable',
        e = '',
        i = 'undefined',
        d = false,
        b = true,
        j = 2147483647,
        a = null,
        c = -1,
        t = c,
        y = '&_xdm_Info=',
        w = '&_serializer_version=',
        x = '_xdm_',
        B = '_serializer_version=',
        p = '#',
        v = '&',
        k = 'class',
        s = {},
        A = 3e4,
        o = a,
        r = a,
        l = new Date().getTime();
    function z() {
        var a = j * Math.random();
        a ^= l ^ (new Date().getMilliseconds() << Math.floor(Math.random() * (31 - 10)));
        return a.toString(16);
    }
    function q() {
        if (!o) {
            try {
                var b = window.sessionStorage;
            } catch (c) {
                b = a;
            }
            o = new OfficeExt.SafeStorage(b);
        }
        return o;
    }
    function u(e) {
        for (var c = [], b = [], f = e.length, a, d = 0; d < f; d++) {
            a = e[d];
            if (a.tabIndex)
                if (a.tabIndex > 0) b.push(a);
                else a.tabIndex === 0 && c.push(a);
            else c.push(a);
        }
        b = b.sort(function(d, c) {
            var a = d.tabIndex - c.tabIndex;
            if (a === 0) a = b.indexOf(d) - b.indexOf(c);
            return a;
        });
        return [].concat(b, c);
    }
    return {
        set_entropy: function(a) {
            if (typeof a == 'string')
                for (var b = 0; b < a.length; b += 4) {
                    for (var d = 0, c = 0; c < 4 && b + c < a.length; c++)
                        d = (d << 8) + a.charCodeAt(b + c);
                    l ^= d;
                }
            else if (typeof a == 'number') l ^= a;
            else l ^= j * Math.random();
            l &= j;
        },
        extend: function(b, a) {
            var c = function() {};
            c.prototype = a.prototype;
            b.prototype = new c();
            b.prototype.constructor = b;
            b.uber = a.prototype;
            if (a.prototype.constructor === Object.prototype.constructor)
                a.prototype.constructor = a;
        },
        setNamespace: function(b, a) {
            if (a && b && !a[b]) a[b] = {};
        },
        unsetNamespace: function(b, a) {
            if (a && b && a[b]) delete a[b];
        },
        serializeSettings: function(b) {
            var d = {};
            for (var c in b) {
                var a = b[c];
                try {
                    if (JSON)
                        a = JSON.stringify(a, function(a, b) {
                            return OSF.OUtil.isDate(this[a])
                                ? OSF.DDA.SettingsManager.DateJSONPrefix +
                                      this[a].getTime() +
                                      OSF.DDA.SettingsManager.DataJSONSuffix
                                : b;
                        });
                    else a = Sys.Serialization.JavaScriptSerializer.serialize(a);
                    d[c] = a;
                } catch (e) {}
            }
            return d;
        },
        deserializeSettings: function(d) {
            var f = {};
            d = d || {};
            for (var e in d) {
                var a = d[e];
                try {
                    if (JSON)
                        a = JSON.parse(a, function(d, a) {
                            var b;
                            if (
                                typeof a === 'string' &&
                                a &&
                                a.length > 6 &&
                                a.slice(0, 5) === OSF.DDA.SettingsManager.DateJSONPrefix &&
                                a.slice(c) === OSF.DDA.SettingsManager.DataJSONSuffix
                            ) {
                                b = new Date(parseInt(a.slice(5, c)));
                                if (b) return b;
                            }
                            return a;
                        });
                    else a = Sys.Serialization.JavaScriptSerializer.deserialize(a, b);
                    f[e] = a;
                } catch (g) {}
            }
            return f;
        },
        loadScript: function(f, g, h) {
            if (f && g) {
                var k = window.document,
                    c = s[f];
                if (!c) {
                    var e = k.createElement('script');
                    e.type = 'text/javascript';
                    c = { loaded: d, pendingCallbacks: [g], timer: a };
                    s[f] = c;
                    var i = function() {
                            if (c.timer != a) {
                                clearTimeout(c.timer);
                                delete c.timer;
                            }
                            c.loaded = b;
                            for (var e = c.pendingCallbacks.length, d = 0; d < e; d++) {
                                var f = c.pendingCallbacks.shift();
                                f();
                            }
                        },
                        j = function() {
                            delete s[f];
                            if (c.timer != a) {
                                clearTimeout(c.timer);
                                delete c.timer;
                            }
                            for (var d = c.pendingCallbacks.length, b = 0; b < d; b++) {
                                var e = c.pendingCallbacks.shift();
                                e();
                            }
                        };
                    if (e.readyState)
                        e.onreadystatechange = function() {
                            if (e.readyState == 'loaded' || e.readyState == 'complete') {
                                e.onreadystatechange = a;
                                i();
                            }
                        };
                    else e.onload = i;
                    e.onerror = j;
                    h = h || A;
                    c.timer = setTimeout(j, h);
                    e.setAttribute('crossOrigin', 'anonymous');
                    e.src = f;
                    k.getElementsByTagName('head')[0].appendChild(e);
                } else if (c.loaded) g();
                else c.pendingCallbacks.push(g);
            }
        },
        loadCSS: function(c) {
            if (c) {
                var b = window.document,
                    a = b.createElement('link');
                a.type = 'text/css';
                a.rel = 'stylesheet';
                a.href = c;
                b.getElementsByTagName('head')[0].appendChild(a);
            }
        },
        parseEnum: function(b, c) {
            var a = c[b.trim()];
            if (typeof a == i) {
                OsfMsAjaxFactory.msAjaxDebug.trace('invalid enumeration string:' + b);
                throw OsfMsAjaxFactory.msAjaxError.argument('str');
            }
            return a;
        },
        delayExecutionAndCache: function() {
            var a = { calc: arguments[0] };
            return function() {
                if (a.calc) {
                    a.val = a.calc.apply(this, arguments);
                    delete a.calc;
                }
                return a.val;
            };
        },
        getUniqueId: function() {
            t = t + 1;
            return t.toString();
        },
        formatString: function() {
            var a = arguments,
                b = a[0];
            return b.replace(/{(\d+)}/gm, function(d, b) {
                var c = parseInt(b, 10) + 1;
                return a[c] === undefined ? '{' + b + '}' : a[c];
            });
        },
        generateConversationId: function() {
            return [z(), z(), new Date().getTime().toString()].join('_');
        },
        getFrameName: function(a) {
            return x + a + this.generateConversationId();
        },
        addXdmInfoAsHash: function(b, a) {
            return OSF.OUtil.addInfoAsHash(b, y, a, d);
        },
        addSerializerVersionAsHash: function(c, a) {
            return OSF.OUtil.addInfoAsHash(c, w, a, b);
        },
        addInfoAsHash: function(b, g, c, i) {
            b = b.trim() || e;
            var f = b.split(p),
                h = f.shift(),
                d = f.join(p),
                a;
            if (i) a = [g, encodeURIComponent(c), d].join(e);
            else a = [d, g, c].join(e);
            return [h, p, a].join(e);
        },
        parseHostInfoFromWindowName: function(a, b) {
            return OSF.OUtil.parseInfoFromWindowName(a, b, OSF.WindowNameItemKeys.HostInfo);
        },
        parseXdmInfo: function(b) {
            var a = OSF.OUtil.parseXdmInfoWithGivenFragment(b, window.location.hash);
            if (!a) a = OSF.OUtil.parseXdmInfoFromWindowName(b, window.name);
            return a;
        },
        parseXdmInfoFromWindowName: function(a, b) {
            return OSF.OUtil.parseInfoFromWindowName(a, b, OSF.WindowNameItemKeys.XdmInfo);
        },
        parseXdmInfoWithGivenFragment: function(a, b) {
            return OSF.OUtil.parseInfoWithGivenFragment(y, x, d, a, b);
        },
        parseSerializerVersion: function(b) {
            var a = OSF.OUtil.parseSerializerVersionWithGivenFragment(b, window.location.hash);
            if (isNaN(a)) a = OSF.OUtil.parseSerializerVersionFromWindowName(b, window.name);
            return a;
        },
        parseSerializerVersionFromWindowName: function(a, b) {
            return parseInt(
                OSF.OUtil.parseInfoFromWindowName(a, b, OSF.WindowNameItemKeys.SerializerVersion)
            );
        },
        parseSerializerVersionWithGivenFragment: function(a, c) {
            return parseInt(OSF.OUtil.parseInfoWithGivenFragment(w, B, b, a, c));
        },
        parseInfoFromWindowName: function(g, h, f) {
            try {
                var b = JSON.parse(h),
                    c = b != a ? b[f] : a,
                    d = q();
                if (!g && d && b != a) {
                    var e = b[OSF.WindowNameItemKeys.BaseFrameName] + f;
                    if (c) d.setItem(e, c);
                    else c = d.getItem(e);
                }
                return c;
            } catch (i) {
                return a;
            }
        },
        parseInfoWithGivenFragment: function(m, j, k, i, l) {
            var f = l.split(m),
                b = f.length > 1 ? f[f.length - 1] : a;
            if (k && b != a) {
                if (b.indexOf(v) >= 0) b = b.split(v)[0];
                b = decodeURIComponent(b);
            }
            var d = q();
            if (!i && d) {
                var e = window.name.indexOf(j);
                if (e > c) {
                    var g = window.name.indexOf(';', e);
                    if (g == c) g = window.name.length;
                    var h = window.name.substring(e, g);
                    if (b) d.setItem(h, b);
                    else b = d.getItem(h);
                }
            }
            return b;
        },
        getConversationId: function() {
            var c = window.location.search,
                b = a;
            if (c) {
                var d = c.indexOf('&');
                b = d > 0 ? c.substring(1, d) : c.substr(1);
                if (b && b.charAt(b.length - 1) === '=') {
                    b = b.substring(0, b.length - 1);
                    if (b) b = decodeURIComponent(b);
                }
            }
            return b;
        },
        getInfoItems: function(b) {
            var a = b.split('$');
            if (typeof a[1] == i) a = b.split('|');
            if (typeof a[1] == i) a = b.split('%7C');
            return a;
        },
        getXdmFieldValue: function(f, d) {
            var b = e,
                c = OSF.OUtil.parseXdmInfo(d);
            if (c) {
                var a = OSF.OUtil.getInfoItems(c);
                if (a != undefined && a.length >= 3)
                    switch (f) {
                        case OSF.XdmFieldName.ConversationUrl:
                            b = a[2];
                            break;
                        case OSF.XdmFieldName.AppId:
                            b = a[1];
                    }
            }
            return b;
        },
        validateParamObject: function(f, e) {
            var a = Function._validateParams(arguments, [
                { name: 'params', type: Object, mayBeNull: d },
                { name: 'expectedProperties', type: Object, mayBeNull: d },
                { name: 'callback', type: Function, mayBeNull: b },
            ]);
            if (a) throw a;
            for (var c in e) {
                a = Function._validateParameter(f[c], e[c], c);
                if (a) throw a;
            }
        },
        writeProfilerMark: function(a) {
            if (window.msWriteProfilerMark) {
                window.msWriteProfilerMark(a);
                OsfMsAjaxFactory.msAjaxDebug.trace(a);
            }
        },
        outputDebug: function(a) {
            typeof OsfMsAjaxFactory !== i &&
                OsfMsAjaxFactory.msAjaxDebug &&
                OsfMsAjaxFactory.msAjaxDebug.trace &&
                OsfMsAjaxFactory.msAjaxDebug.trace(a);
        },
        defineNondefaultProperty: function(e, f, a, c) {
            a = a || {};
            for (var g in c) {
                var d = c[g];
                if (a[d] == undefined) a[d] = b;
            }
            Object.defineProperty(e, f, a);
            return e;
        },
        defineNondefaultProperties: function(c, a, d) {
            a = a || {};
            for (var b in a) OSF.OUtil.defineNondefaultProperty(c, b, a[b], d);
            return c;
        },
        defineEnumerableProperty: function(c, b, a) {
            return OSF.OUtil.defineNondefaultProperty(c, b, a, [f]);
        },
        defineEnumerableProperties: function(b, a) {
            return OSF.OUtil.defineNondefaultProperties(b, a, [f]);
        },
        defineMutableProperty: function(c, b, a) {
            return OSF.OUtil.defineNondefaultProperty(c, b, a, [m, f, n]);
        },
        defineMutableProperties: function(b, a) {
            return OSF.OUtil.defineNondefaultProperties(b, a, [m, f, n]);
        },
        finalizeProperties: function(e, c) {
            c = c || {};
            for (var g = Object.getOwnPropertyNames(e), i = g.length, f = 0; f < i; f++) {
                var h = g[f],
                    a = Object.getOwnPropertyDescriptor(e, h);
                if (!a.get && !a.set) a.writable = c.writable || d;
                a.configurable = c.configurable || d;
                a.enumerable = c.enumerable || b;
                Object.defineProperty(e, h, a);
            }
            return e;
        },
        mapList: function(a, c) {
            var b = [];
            if (a) for (var d in a) b.push(c(a[d]));
            return b;
        },
        listContainsKey: function(c, e) {
            for (var a in c) if (e == a) return b;
            return d;
        },
        listContainsValue: function(a, c) {
            for (var e in a) if (c == a[e]) return b;
            return d;
        },
        augmentList: function(a, b) {
            var d = a.push
                ? function(c, b) {
                      a.push(b);
                  }
                : function(c, b) {
                      a[c] = b;
                  };
            for (var c in b) d(c, b[c]);
        },
        redefineList: function(a, b) {
            for (var d in a) delete a[d];
            for (var c in b) a[c] = b[c];
        },
        isArray: function(a) {
            return Object.prototype.toString.apply(a) === '[object Array]';
        },
        isFunction: function(a) {
            return Object.prototype.toString.apply(a) === '[object Function]';
        },
        isDate: function(a) {
            return Object.prototype.toString.apply(a) === '[object Date]';
        },
        addEventListener: function(a, b, c) {
            if (a.addEventListener) a.addEventListener(b, c, d);
            else if (Sys.Browser.agent === Sys.Browser.InternetExplorer && a.attachEvent)
                a.attachEvent(g + b, c);
            else a[g + b] = c;
        },
        removeEventListener: function(b, c, e) {
            if (b.removeEventListener) b.removeEventListener(c, e, d);
            else if (Sys.Browser.agent === Sys.Browser.InternetExplorer && b.detachEvent)
                b.detachEvent(g + c, e);
            else b[g + c] = a;
        },
        getCookieValue: function(b) {
            var a = RegExp(b + '[^;]+').exec(document.cookie);
            return a.toString().replace(/^[^=]+./, e);
        },
        xhrGet: function(f, e, c) {
            var a;
            try {
                a = new XMLHttpRequest();
                a.onreadystatechange = function() {
                    if (a.readyState == 4)
                        if (a.status == 200) e(a.responseText);
                        else c(a.status);
                };
                a.open('GET', f, b);
                a.send();
            } catch (d) {
                c(d);
            }
        },
        xhrGetFull: function(h, f, g, c) {
            var a,
                e = f;
            try {
                a = new XMLHttpRequest();
                a.onreadystatechange = function() {
                    if (a.readyState == 4)
                        if (a.status == 200) g(a, e);
                        else c(a.status);
                };
                a.open('GET', h, b);
                a.send();
            } catch (d) {
                c(d);
            }
        },
        encodeBase64: function(c) {
            if (!c) return c;
            var o = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
                m = [],
                b = [],
                i = 0,
                k,
                h,
                j,
                d,
                f,
                g,
                a,
                n = c.length;
            do {
                k = c.charCodeAt(i++);
                h = c.charCodeAt(i++);
                j = c.charCodeAt(i++);
                a = 0;
                d = k & 255;
                f = k >> 8;
                g = h & 255;
                b[a++] = d >> 2;
                b[a++] = ((d & 3) << 4) | (f >> 4);
                b[a++] = ((f & 15) << 2) | (g >> 6);
                b[a++] = g & 63;
                if (!isNaN(h)) {
                    d = h >> 8;
                    f = j & 255;
                    g = j >> 8;
                    b[a++] = d >> 2;
                    b[a++] = ((d & 3) << 4) | (f >> 4);
                    b[a++] = ((f & 15) << 2) | (g >> 6);
                    b[a++] = g & 63;
                }
                if (isNaN(h)) b[a - 1] = 64;
                else if (isNaN(j)) {
                    b[a - 2] = 64;
                    b[a - 1] = 64;
                }
                for (var l = 0; l < a; l++) m.push(o.charAt(b[l]));
            } while (i < n);
            return m.join(e);
        },
        getSessionStorage: function() {
            return q();
        },
        getLocalStorage: function() {
            if (!r) {
                try {
                    var b = window.localStorage;
                } catch (c) {
                    b = a;
                }
                r = new OfficeExt.SafeStorage(b);
            }
            return r;
        },
        convertIntToCssHexColor: function(b) {
            var a = '#' + (Number(b) + 16777216).toString(16).slice(-6);
            return a;
        },
        attachClickHandler: function(a, b) {
            a.onclick = function() {
                b();
            };
            a.ontouchend = function(a) {
                b();
                a.preventDefault();
            };
        },
        getQueryStringParamValue: function(a, c) {
            var f = Function._validateParams(arguments, [
                { name: 'queryString', type: String, mayBeNull: d },
                { name: 'paramName', type: String, mayBeNull: d },
            ]);
            if (f) {
                OsfMsAjaxFactory.msAjaxDebug.trace(
                    'OSF_Outil_getQueryStringParamValue: Parameters cannot be null.'
                );
                return e;
            }
            var b = new RegExp('[\\?&]' + c + '=([^&#]*)', 'i');
            if (!b.test(a)) {
                OsfMsAjaxFactory.msAjaxDebug.trace(
                    'OSF_Outil_getQueryStringParamValue: The parameter is not found.'
                );
                return e;
            }
            return b.exec(a)[1];
        },
        isiOS: function() {
            return window.navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? b : d;
        },
        isChrome: function() {
            return window.navigator.userAgent.indexOf('Chrome') > 0 && !OSF.OUtil.isEdge();
        },
        isEdge: function() {
            return window.navigator.userAgent.indexOf('Edge') > 0;
        },
        isIE: function() {
            return window.navigator.userAgent.indexOf('Trident') > 0;
        },
        isFirefox: function() {
            return window.navigator.userAgent.indexOf('Firefox') > 0;
        },
        shallowCopy: function(b) {
            if (b == a) return a;
            else if (!(b instanceof Object)) return b;
            else if (Array.isArray(b)) {
                for (var e = [], d = 0; d < b.length; d++) e.push(b[d]);
                return e;
            } else {
                var f = b.constructor();
                for (var c in b) if (b.hasOwnProperty(c)) f[c] = b[c];
                return f;
            }
        },
        createObject: function(b) {
            var d = a;
            if (b) {
                d = {};
                for (var e = b.length, c = 0; c < e; c++) d[b[c].name] = b[c].value;
            }
            return d;
        },
        addClass: function(a, b) {
            if (!OSF.OUtil.hasClass(a, b)) {
                var c = a.getAttribute(k);
                if (c) a.setAttribute(k, c + ' ' + b);
                else a.setAttribute(k, b);
            }
        },
        removeClass: function(b, c) {
            if (OSF.OUtil.hasClass(b, c)) {
                var a = b.getAttribute(k),
                    d = new RegExp('(\\s|^)' + c + '(\\s|$)');
                a = a.replace(d, e);
                b.setAttribute(k, a);
            }
        },
        hasClass: function(c, b) {
            var a = c.getAttribute(k);
            return a && a.match(new RegExp('(\\s|^)' + b + '(\\s|$)'));
        },
        focusToFirstTabbable: function(e, j) {
            var g,
                i = d,
                f,
                k = function() {
                    i = b;
                },
                l = function(d, a, b) {
                    if (a < 0 || a > d) return c;
                    else if (a === 0 && b) return c;
                    else if (a === d - 1 && !b) return c;
                    if (b) return a - 1;
                    else return a + 1;
                };
            e = u(e);
            g = j ? e.length - 1 : 0;
            if (e.length === 0) return a;
            while (!i && g >= 0 && g < e.length) {
                f = e[g];
                window.focus();
                f.addEventListener(h, k);
                f.focus();
                f.removeEventListener(h, k);
                g = l(e.length, g, j);
                if (!i && f === document.activeElement) i = b;
            }
            if (i) return f;
            else return a;
        },
        focusToNextTabbable: function(f, o, m) {
            var k,
                e,
                i = d,
                g,
                l = function() {
                    i = b;
                },
                n = function(b, d) {
                    for (var a = 0; a < b.length; a++) if (b[a] === d) return a;
                    return c;
                },
                j = function(d, a, b) {
                    if (a < 0 || a > d) return c;
                    else if (a === 0 && b) return c;
                    else if (a === d - 1 && !b) return c;
                    if (b) return a - 1;
                    else return a + 1;
                };
            f = u(f);
            k = n(f, o);
            e = j(f.length, k, m);
            if (e < 0) return a;
            while (!i && e >= 0 && e < f.length) {
                g = f[e];
                g.addEventListener(h, l);
                g.focus();
                g.removeEventListener(h, l);
                e = j(f.length, e, m);
                if (!i && g === document.activeElement) i = b;
            }
            if (i) return g;
            else return a;
        },
    };
})();
OSF.OUtil.Guid = (function() {
    var a = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
    return {
        generateNewGuid: function() {
            for (var c = '', d = new Date().getTime(), b = 0; b < 32 && d > 0; b++) {
                if (b == 8 || b == 12 || b == 16 || b == 20) c += '-';
                c += a[d % 16];
                d = Math.floor(d / 16);
            }
            for (; b < 32; b++) {
                if (b == 8 || b == 12 || b == 16 || b == 20) c += '-';
                c += a[Math.floor(Math.random() * 16)];
            }
            return c;
        },
    };
})();
window.OSF = OSF;
var OfficeExt;
(function(g) {
    var c = '\n',
        d = true,
        a = null,
        b = 'undefined',
        j = (function() {
            function c() {}
            c.isInstanceOfType = function(f, e) {
                if (typeof e === b || e === a) return false;
                if (e instanceof f) return d;
                var c = e.constructor;
                if (!c || typeof c !== 'function' || !c.__typeName || c.__typeName === 'Object')
                    c = Object;
                return (
                    !!(c === f) || (c.__typeName && f.__typeName && c.__typeName === f.__typeName)
                );
            };
            return c;
        })();
    g.MsAjaxTypeHelper = j;
    var h = (function() {
        var e = 'Parameter name: {0}';
        function d() {}
        d.create = function(c, b) {
            var a = new Error(c);
            a.message = c;
            if (b) for (var d in b) a[d] = b[d];
            a.popStackFrame();
            return a;
        };
        d.parameterCount = function(a) {
            var c = 'Sys.ParameterCountException: ' + (a ? a : 'Parameter count mismatch.'),
                b = d.create(c, { name: 'Sys.ParameterCountException' });
            b.popStackFrame();
            return b;
        };
        d.argument = function(a, g) {
            var b =
                'Sys.ArgumentException: ' +
                (g ? g : 'Value does not fall within the expected range.');
            if (a) b += c + f.format(e, a);
            var h = d.create(b, { name: 'Sys.ArgumentException', paramName: a });
            h.popStackFrame();
            return h;
        };
        d.argumentNull = function(a, g) {
            var b = 'Sys.ArgumentNullException: ' + (g ? g : 'Value cannot be null.');
            if (a) b += c + f.format(e, a);
            var h = d.create(b, { name: 'Sys.ArgumentNullException', paramName: a });
            h.popStackFrame();
            return h;
        };
        d.argumentOutOfRange = function(i, g, j) {
            var h =
                'Sys.ArgumentOutOfRangeException: ' +
                (j ? j : 'Specified argument was out of the range of valid values.');
            if (i) h += c + f.format(e, i);
            if (typeof g !== b && g !== a) h += c + f.format('Actual value was {0}.', g);
            var k = d.create(h, {
                name: 'Sys.ArgumentOutOfRangeException',
                paramName: i,
                actualValue: g,
            });
            k.popStackFrame();
            return k;
        };
        d.argumentType = function(h, g, b, i) {
            var a = 'Sys.ArgumentTypeException: ';
            if (i) a += i;
            else if (g && b)
                a += f.format(
                    "Object of type '{0}' cannot be converted to type '{1}'.",
                    g.getName ? g.getName() : g,
                    b.getName ? b.getName() : b
                );
            else a += 'Object cannot be converted to the required type.';
            if (h) a += c + f.format(e, h);
            var j = d.create(a, {
                name: 'Sys.ArgumentTypeException',
                paramName: h,
                actualType: g,
                expectedType: b,
            });
            j.popStackFrame();
            return j;
        };
        d.argumentUndefined = function(a, g) {
            var b = 'Sys.ArgumentUndefinedException: ' + (g ? g : 'Value cannot be undefined.');
            if (a) b += c + f.format(e, a);
            var h = d.create(b, { name: 'Sys.ArgumentUndefinedException', paramName: a });
            h.popStackFrame();
            return h;
        };
        d.invalidOperation = function(a) {
            var c =
                    'Sys.InvalidOperationException: ' +
                    (a ? a : 'Operation is not valid due to the current state of the object.'),
                b = d.create(c, { name: 'Sys.InvalidOperationException' });
            b.popStackFrame();
            return b;
        };
        return d;
    })();
    g.MsAjaxError = h;
    var f = (function() {
        function a() {}
        a.format = function(c) {
            for (var b = [], a = 1; a < arguments.length; a++) b[a - 1] = arguments[a];
            var d = c;
            return d.replace(/{(\d+)}/gm, function(d, a) {
                var c = parseInt(a, 10);
                return b[c] === undefined ? '{' + a + '}' : b[c];
            });
        };
        a.startsWith = function(b, a) {
            return b.substr(0, a.length) === a;
        };
        return a;
    })();
    g.MsAjaxString = f;
    var i = (function() {
        function a() {}
        a.trace = function() {};
        return a;
    })();
    g.MsAjaxDebug = i;
    if (!OsfMsAjaxFactory.isMsAjaxLoaded()) {
        var e = function(b, d, c) {
            if (b.__typeName === undefined || b.__typeName === a) b.__typeName = d;
            if (b.__class === undefined || b.__class === a) b.__class = c;
        };
        e(Function, 'Function', d);
        e(Error, 'Error', d);
        e(Object, 'Object', d);
        e(String, 'String', d);
        e(Boolean, 'Boolean', d);
        e(Date, 'Date', d);
        e(Number, 'Number', d);
        e(RegExp, 'RegExp', d);
        e(Array, 'Array', d);
        if (!Function.createCallback)
            Function.createCallback = function(b, a) {
                var c = Function._validateParams(arguments, [
                    { name: 'method', type: Function },
                    { name: 'context', mayBeNull: d },
                ]);
                if (c) throw c;
                return function() {
                    var e = arguments.length;
                    if (e > 0) {
                        for (var d = [], c = 0; c < e; c++) d[c] = arguments[c];
                        d[e] = a;
                        return b.apply(this, d);
                    }
                    return b.call(this, a);
                };
            };
        if (!Function.createDelegate)
            Function.createDelegate = function(b, c) {
                var a = Function._validateParams(arguments, [
                    { name: 'instance', mayBeNull: d },
                    { name: 'method', type: Function },
                ]);
                if (a) throw a;
                return function() {
                    return c.apply(b, arguments);
                };
            };
        if (!Function._validateParams)
            Function._validateParams = function(i, g, e) {
                var c,
                    f = g.length;
                e = e || typeof e === b;
                c = Function._validateParameterCount(i, g, e);
                if (c) {
                    c.popStackFrame();
                    return c;
                }
                for (var d = 0, k = i.length; d < k; d++) {
                    var h = g[Math.min(d, f - 1)],
                        j = h.name;
                    if (h.parameterArray) j += '[' + (d - f + 1) + ']';
                    else if (!e && d >= f) break;
                    c = Function._validateParameter(i[d], h, j);
                    if (c) {
                        c.popStackFrame();
                        return c;
                    }
                }
                return a;
            };
        if (!Function._validateParameterCount)
            Function._validateParameterCount = function(m, f, l) {
                var b,
                    e,
                    c = f.length,
                    g = m.length;
                if (g < c) {
                    var i = c;
                    for (b = 0; b < c; b++) {
                        var j = f[b];
                        if (j.optional || j.parameterArray) i--;
                    }
                    if (g < i) e = d;
                } else if (l && g > c) {
                    e = d;
                    for (b = 0; b < c; b++)
                        if (f[b].parameterArray) {
                            e = false;
                            break;
                        }
                }
                if (e) {
                    var k = h.parameterCount();
                    k.popStackFrame();
                    return k;
                }
                return a;
            };
        if (!Function._validateParameter)
            Function._validateParameter = function(e, c, j) {
                var d,
                    i = c.type,
                    n = !!c.integer,
                    m = !!c.domElement,
                    o = !!c.mayBeNull;
                d = Function._validateParameterType(e, i, n, m, o, j);
                if (d) {
                    d.popStackFrame();
                    return d;
                }
                var g = c.elementType,
                    h = !!c.elementMayBeNull;
                if (i === Array && typeof e !== b && e !== a && (g || !h))
                    for (
                        var l = !!c.elementInteger, k = !!c.elementDomElement, f = 0;
                        f < e.length;
                        f++
                    ) {
                        var p = e[f];
                        d = Function._validateParameterType(p, g, l, k, h, j + '[' + f + ']');
                        if (d) {
                            d.popStackFrame();
                            return d;
                        }
                    }
                return a;
            };
        if (!Function._validateParameterType)
            Function._validateParameterType = function(d, e, j, i, h, f) {
                var c, k;
                if (typeof d === b)
                    if (h) return a;
                    else {
                        c = g.MsAjaxError.argumentUndefined(f);
                        c.popStackFrame();
                        return c;
                    }
                if (d === a)
                    if (h) return a;
                    else {
                        c = g.MsAjaxError.argumentNull(f);
                        c.popStackFrame();
                        return c;
                    }
                if (e && !g.MsAjaxTypeHelper.isInstanceOfType(e, d)) {
                    c = g.MsAjaxError.argumentType(f, typeof d, e);
                    c.popStackFrame();
                    return c;
                }
                return a;
            };
        if (!window.Type) window.Type = Function;
        if (!Type.registerNamespace)
            Type.registerNamespace = function(d) {
                for (var c = d.split('.'), b = window, a = 0; a < c.length; a++) {
                    b[c[a]] = b[c[a]] || {};
                    b = b[c[a]];
                }
            };
        if (!Type.prototype.registerClass)
            Type.prototype.registerClass = function(a) {
                a = {};
            };
        typeof Sys === b && Type.registerNamespace('Sys');
        if (!Error.prototype.popStackFrame)
            Error.prototype.popStackFrame = function() {
                var d = this;
                if (arguments.length !== 0) throw h.parameterCount();
                if (
                    typeof d.stack === b ||
                    d.stack === a ||
                    typeof d.fileName === b ||
                    d.fileName === a ||
                    typeof d.lineNumber === b ||
                    d.lineNumber === a
                )
                    return;
                var e = d.stack.split(c),
                    g = e[0],
                    j = d.fileName + ':' + d.lineNumber;
                while (typeof g !== b && g !== a && g.indexOf(j) === -1) {
                    e.shift();
                    g = e[0];
                }
                var i = e[1];
                if (typeof i === b || i === a) return;
                var f = i.match(/@(.*):(\d+)$/);
                if (typeof f === b || f === a) return;
                d.fileName = f[1];
                d.lineNumber = parseInt(f[2]);
                e.shift();
                d.stack = e.join(c);
            };
        OsfMsAjaxFactory.msAjaxError = h;
        OsfMsAjaxFactory.msAjaxString = f;
        OsfMsAjaxFactory.msAjaxDebug = i;
    }
})(OfficeExt || (OfficeExt = {}));
OSF.OUtil.setNamespace('Microsoft', window);
OSF.OUtil.setNamespace('Office', Microsoft);
OSF.OUtil.setNamespace('Common', Microsoft.Office);
Microsoft.Office.Common.InvokeType = {
    async: 0,
    sync: 1,
    asyncRegisterEvent: 2,
    asyncUnregisterEvent: 3,
    syncRegisterEvent: 4,
    syncUnregisterEvent: 5,
};
OSF.SerializerVersion = { MsAjax: 0, Browser: 1 };
var OfficeExt;
(function(b) {
    function a() {
        return false;
    }
    b.appSpecificCheckOrigin = a;
})(OfficeExt || (OfficeExt = {}));
Microsoft.Office.Common.InvokeType = {
    async: 0,
    sync: 1,
    asyncRegisterEvent: 2,
    asyncUnregisterEvent: 3,
    syncRegisterEvent: 4,
    syncUnregisterEvent: 5,
};
Microsoft.Office.Common.InvokeResultCode = {
    noError: 0,
    errorInRequest: -1,
    errorHandlingRequest: -2,
    errorInResponse: -3,
    errorHandlingResponse: -4,
    errorHandlingRequestAccessDenied: -5,
    errorHandlingMethodCallTimedout: -6,
};
Microsoft.Office.Common.MessageType = { request: 0, response: 1 };
Microsoft.Office.Common.ActionType = { invoke: 0, registerEvent: 1, unregisterEvent: 2 };
Microsoft.Office.Common.ResponseType = { forCalling: 0, forEventing: 1 };
Microsoft.Office.Common.MethodObject = function(c, b, a) {
    this._method = c;
    this._invokeType = b;
    this._blockingOthers = a;
};
Microsoft.Office.Common.MethodObject.prototype = {
    getMethod: function() {
        return this._method;
    },
    getInvokeType: function() {
        return this._invokeType;
    },
    getBlockingFlag: function() {
        return this._blockingOthers;
    },
};
Microsoft.Office.Common.EventMethodObject = function(b, a) {
    this._registerMethodObject = b;
    this._unregisterMethodObject = a;
};
Microsoft.Office.Common.EventMethodObject.prototype = {
    getRegisterMethodObject: function() {
        return this._registerMethodObject;
    },
    getUnregisterMethodObject: function() {
        return this._unregisterMethodObject;
    },
};
Microsoft.Office.Common.ServiceEndPoint = function(c) {
    var a = this,
        b = Function._validateParams(arguments, [
            { name: 'serviceEndPointId', type: String, mayBeNull: false },
        ]);
    if (b) throw b;
    a._methodObjectList = {};
    a._eventHandlerProxyList = {};
    a._Id = c;
    a._conversations = {};
    a._policyManager = null;
    a._appDomains = {};
    a._onHandleRequestError = null;
};
Microsoft.Office.Common.ServiceEndPoint.prototype = {
    registerMethod: function(g, h, b, e) {
        var c = 'invokeType',
            a = false,
            d = Function._validateParams(arguments, [
                { name: 'methodName', type: String, mayBeNull: a },
                { name: 'method', type: Function, mayBeNull: a },
                { name: c, type: Number, mayBeNull: a },
                { name: 'blockingOthers', type: Boolean, mayBeNull: a },
            ]);
        if (d) throw d;
        if (
            b !== Microsoft.Office.Common.InvokeType.async &&
            b !== Microsoft.Office.Common.InvokeType.sync
        )
            throw OsfMsAjaxFactory.msAjaxError.argument(c);
        var f = new Microsoft.Office.Common.MethodObject(h, b, e);
        this._methodObjectList[g] = f;
    },
    unregisterMethod: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'methodName', type: String, mayBeNull: false },
        ]);
        if (a) throw a;
        delete this._methodObjectList[b];
    },
    registerEvent: function(f, d, c) {
        var a = false,
            b = Function._validateParams(arguments, [
                { name: 'eventName', type: String, mayBeNull: a },
                { name: 'registerMethod', type: Function, mayBeNull: a },
                { name: 'unregisterMethod', type: Function, mayBeNull: a },
            ]);
        if (b) throw b;
        var e = new Microsoft.Office.Common.EventMethodObject(
            new Microsoft.Office.Common.MethodObject(
                d,
                Microsoft.Office.Common.InvokeType.syncRegisterEvent,
                a
            ),
            new Microsoft.Office.Common.MethodObject(
                c,
                Microsoft.Office.Common.InvokeType.syncUnregisterEvent,
                a
            )
        );
        this._methodObjectList[f] = e;
    },
    registerEventEx: function(h, f, d, e, c) {
        var a = false,
            b = Function._validateParams(arguments, [
                { name: 'eventName', type: String, mayBeNull: a },
                { name: 'registerMethod', type: Function, mayBeNull: a },
                { name: 'registerMethodInvokeType', type: Number, mayBeNull: a },
                { name: 'unregisterMethod', type: Function, mayBeNull: a },
                { name: 'unregisterMethodInvokeType', type: Number, mayBeNull: a },
            ]);
        if (b) throw b;
        var g = new Microsoft.Office.Common.EventMethodObject(
            new Microsoft.Office.Common.MethodObject(f, d, a),
            new Microsoft.Office.Common.MethodObject(e, c, a)
        );
        this._methodObjectList[h] = g;
    },
    unregisterEvent: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'eventName', type: String, mayBeNull: false },
        ]);
        if (a) throw a;
        this.unregisterMethod(b);
    },
    registerConversation: function(c, g, b, f) {
        var d = 'appDomains',
            a = true,
            e = Function._validateParams(arguments, [
                { name: 'conversationId', type: String, mayBeNull: false },
                { name: 'conversationUrl', type: String, mayBeNull: false, optional: a },
                { name: d, type: Object, mayBeNull: a, optional: a },
                { name: 'serializerVersion', type: Number, mayBeNull: a, optional: a },
            ]);
        if (e) throw e;
        if (b) {
            if (!(b instanceof Array)) throw OsfMsAjaxFactory.msAjaxError.argument(d);
            this._appDomains[c] = b;
        }
        this._conversations[c] = { url: g, serializerVersion: f };
    },
    unregisterConversation: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'conversationId', type: String, mayBeNull: false },
        ]);
        if (a) throw a;
        delete this._conversations[b];
    },
    setPolicyManager: function(a) {
        var b = 'policyManager',
            c = Function._validateParams(arguments, [{ name: b, type: Object, mayBeNull: false }]);
        if (c) throw c;
        if (!a.checkPermission) throw OsfMsAjaxFactory.msAjaxError.argument(b);
        this._policyManager = a;
    },
    getPolicyManager: function() {
        return this._policyManager;
    },
    dispose: function() {
        var a = null,
            b = this;
        b._methodObjectList = a;
        b._eventHandlerProxyList = a;
        b._Id = a;
        b._conversations = a;
        b._policyManager = a;
        b._appDomains = a;
        b._onHandleRequestError = a;
    },
};
Microsoft.Office.Common.ClientEndPoint = function(f, b, g, d) {
    var c = 'targetWindow',
        a = this,
        e = Function._validateParams(arguments, [
            { name: 'conversationId', type: String, mayBeNull: false },
            { name: c, mayBeNull: false },
            { name: 'targetUrl', type: String, mayBeNull: false },
            { name: 'serializerVersion', type: Number, mayBeNull: true, optional: true },
        ]);
    if (e) throw e;
    try {
        if (!b.postMessage) throw OsfMsAjaxFactory.msAjaxError.argument(c);
    } catch (h) {
        if (!Object.prototype.hasOwnProperty.call(b, 'postMessage'))
            throw OsfMsAjaxFactory.msAjaxError.argument(c);
    }
    a._conversationId = f;
    a._targetWindow = b;
    a._targetUrl = g;
    a._callingIndex = 0;
    a._callbackList = {};
    a._eventHandlerList = {};
    if (d != null) a._serializerVersion = d;
    else a._serializerVersion = OSF.SerializerVersion.Browser;
};
Microsoft.Office.Common.ClientEndPoint.prototype = {
    invoke: function(h, d, b) {
        var a = this,
            g = Function._validateParams(arguments, [
                { name: 'targetMethodName', type: String, mayBeNull: false },
                { name: 'callback', type: Function, mayBeNull: true },
                { name: 'param', mayBeNull: true },
            ]);
        if (g) throw g;
        var c = a._callingIndex++,
            k = new Date(),
            e = { callback: d, createdOn: k.getTime() };
        if (b && typeof b === 'object' && typeof b.__timeout__ === 'number') {
            e.timeout = b.__timeout__;
            delete b.__timeout__;
        }
        a._callbackList[c] = e;
        try {
            var i = new Microsoft.Office.Common.Request(
                    h,
                    Microsoft.Office.Common.ActionType.invoke,
                    a._conversationId,
                    c,
                    b
                ),
                j = Microsoft.Office.Common.MessagePackager.envelope(i, a._serializerVersion);
            a._targetWindow.postMessage(j, a._targetUrl);
            Microsoft.Office.Common.XdmCommunicationManager._startMethodTimeoutTimer();
        } catch (f) {
            try {
                d !== null && d(Microsoft.Office.Common.InvokeResultCode.errorInRequest, f);
            } finally {
                delete a._callbackList[c];
            }
        }
    },
    registerForEvent: function(d, g, c, i) {
        var a = this,
            f = Function._validateParams(arguments, [
                { name: 'targetEventName', type: String, mayBeNull: false },
                { name: 'eventHandler', type: Function, mayBeNull: false },
                { name: 'callback', type: Function, mayBeNull: true },
                { name: 'data', mayBeNull: true, optional: true },
            ]);
        if (f) throw f;
        var b = a._callingIndex++,
            k = new Date();
        a._callbackList[b] = { callback: c, createdOn: k.getTime() };
        try {
            var h = new Microsoft.Office.Common.Request(
                    d,
                    Microsoft.Office.Common.ActionType.registerEvent,
                    a._conversationId,
                    b,
                    i
                ),
                j = Microsoft.Office.Common.MessagePackager.envelope(h, a._serializerVersion);
            a._targetWindow.postMessage(j, a._targetUrl);
            Microsoft.Office.Common.XdmCommunicationManager._startMethodTimeoutTimer();
            a._eventHandlerList[d] = g;
        } catch (e) {
            try {
                c !== null && c(Microsoft.Office.Common.InvokeResultCode.errorInRequest, e);
            } finally {
                delete a._callbackList[b];
            }
        }
    },
    unregisterForEvent: function(d, c, h) {
        var a = this,
            f = Function._validateParams(arguments, [
                { name: 'targetEventName', type: String, mayBeNull: false },
                { name: 'callback', type: Function, mayBeNull: true },
                { name: 'data', mayBeNull: true, optional: true },
            ]);
        if (f) throw f;
        var b = a._callingIndex++,
            j = new Date();
        a._callbackList[b] = { callback: c, createdOn: j.getTime() };
        try {
            var g = new Microsoft.Office.Common.Request(
                    d,
                    Microsoft.Office.Common.ActionType.unregisterEvent,
                    a._conversationId,
                    b,
                    h
                ),
                i = Microsoft.Office.Common.MessagePackager.envelope(g, a._serializerVersion);
            a._targetWindow.postMessage(i, a._targetUrl);
            Microsoft.Office.Common.XdmCommunicationManager._startMethodTimeoutTimer();
        } catch (e) {
            try {
                c !== null && c(Microsoft.Office.Common.InvokeResultCode.errorInRequest, e);
            } finally {
                delete a._callbackList[b];
            }
        } finally {
            delete a._eventHandlerList[d];
        }
    },
};
Microsoft.Office.Common.XdmCommunicationManager = (function() {
    var l = 'serviceEndPointId',
        c = true,
        k = 'channel is not ready.',
        f = 'conversationId',
        j = 'Unknown conversation Id.',
        b = false,
        a = null,
        o = [],
        n = a,
        g = a,
        q = 10,
        i = b,
        h = a,
        w = 2e3,
        p = 65000,
        s = p,
        e = {},
        d = {},
        t = b;
    function x(b) {
        for (var a in e) if (e[a]._conversations[b]) return e[a];
        OsfMsAjaxFactory.msAjaxDebug.trace(j);
        throw OsfMsAjaxFactory.msAjaxError.argument(f);
    }
    function y(b) {
        var a = d[b];
        !a && OsfMsAjaxFactory.msAjaxDebug.trace(j);
        return a;
    }
    function B(e, c) {
        var b = e._methodObjectList[c._actionName];
        if (!b) {
            OsfMsAjaxFactory.msAjaxDebug.trace(
                'The specified method is not registered on service endpoint:' + c._actionName
            );
            throw OsfMsAjaxFactory.msAjaxError.argument('messageObject');
        }
        var d = a;
        if (c._actionType === Microsoft.Office.Common.ActionType.invoke) d = b;
        else if (c._actionType === Microsoft.Office.Common.ActionType.registerEvent)
            d = b.getRegisterMethodObject();
        else d = b.getUnregisterMethodObject();
        return d;
    }
    function E(a) {
        o.push(a);
    }
    function D() {
        if (g !== a) {
            if (!i)
                if (o.length > 0) {
                    var b = o.shift();
                    r(b);
                } else {
                    clearInterval(g);
                    g = a;
                }
        } else OsfMsAjaxFactory.msAjaxDebug.trace(k);
    }
    function r(a) {
        i = a.getInvokeBlockingFlag();
        a.invoke();
        n = new Date().getTime();
    }
    function A() {
        if (h) {
            var c,
                f = 0,
                j = new Date(),
                e;
            for (var i in d) {
                c = d[i];
                for (var g in c._callbackList) {
                    var b = c._callbackList[g];
                    e = b.timeout ? b.timeout : s;
                    if (e >= 0 && Math.abs(j.getTime() - b.createdOn) >= e)
                        try {
                            b.callback &&
                                b.callback(
                                    Microsoft.Office.Common.InvokeResultCode
                                        .errorHandlingMethodCallTimedout,
                                    a
                                );
                        } finally {
                            delete c._callbackList[g];
                        }
                    else f++;
                }
            }
            if (f === 0) {
                clearInterval(h);
                h = a;
            }
        } else OsfMsAjaxFactory.msAjaxDebug.trace(k);
    }
    function z() {
        i = b;
    }
    function C(a) {
        if (window.addEventListener) window.addEventListener('message', a, b);
        else if (navigator.userAgent.indexOf('MSIE') > -1 && window.attachEvent)
            window.attachEvent('onmessage', a);
        else {
            OsfMsAjaxFactory.msAjaxDebug.trace("Browser doesn't support the required API.");
            throw OsfMsAjaxFactory.msAjaxError.argument('Browser');
        }
    }
    function F(e, f) {
        var g = b;
        if (e === c) return c;
        if (!e || !f || !e.length || !f.length) return g;
        var d, a;
        d = document.createElement('a');
        a = document.createElement('a');
        d.href = e;
        a.href = f;
        g = v(d, a);
        delete d, a;
        return g;
    }
    function m(a, g) {
        var c = b;
        if (!g || !g.length || !a || !(a instanceof Array) || !a.length) return c;
        var f = document.createElement('a'),
            e = document.createElement('a');
        f.href = g;
        for (var d = 0; d < a.length && !c; d++)
            if (a[d].indexOf('://') !== -1) {
                e.href = a[d];
                c = v(f, e);
            }
        delete f, e;
        return c;
    }
    function v(a, b) {
        return a.hostname == b.hostname && a.protocol == b.protocol && a.port == b.port;
    }
    function G(e) {
        var l = 'Access Denied';
        if (!OSF) return;
        if (e.data != '') {
            var d,
                f = OSF.SerializerVersion.Browser,
                I = e.data;
            try {
                d = Microsoft.Office.Common.MessagePackager.unenvelope(
                    I,
                    OSF.SerializerVersion.Browser
                );
                f = d._serializerVersion != a ? d._serializerVersion : f;
            } catch (k) {
                return;
            }
            if (d._messageType === Microsoft.Office.Common.MessageType.request) {
                var w = e.origin == a || e.origin == 'null' ? d._origin : e.origin;
                try {
                    var h = x(d._conversationId),
                        p = h._conversations[d._conversationId];
                    f = p.serializerVersion != a ? p.serializerVersion : f;
                    var t = [p.url].concat(h._appDomains[d._conversationId]);
                    if (!m(t, e.origin))
                        if (!OfficeExt.appSpecificCheckOrigin(t, e, d._origin, m))
                            throw 'Failed origin check';
                    var v = h.getPolicyManager();
                    if (v && !v.checkPermission(d._conversationId, d._actionName, d._data)) throw l;
                    var L = B(h, d),
                        H = new Microsoft.Office.Common.InvokeCompleteCallback(
                            e.source,
                            w,
                            d._actionName,
                            d._conversationId,
                            d._correlationId,
                            z,
                            f
                        ),
                        G = new Microsoft.Office.Common.Invoker(
                            L,
                            d._data,
                            H,
                            h._eventHandlerProxyList,
                            d._conversationId,
                            d._actionName,
                            f
                        ),
                        A = c;
                    if (g == a)
                        if ((n == a || new Date().getTime() - n > q) && !i) {
                            r(G);
                            A = b;
                        } else g = setInterval(D, q);
                    A && E(G);
                } catch (k) {
                    h && h._onHandleRequestError && h._onHandleRequestError(d, k);
                    var C = Microsoft.Office.Common.InvokeResultCode.errorHandlingRequest;
                    if (k == l)
                        C =
                            Microsoft.Office.Common.InvokeResultCode
                                .errorHandlingRequestAccessDenied;
                    var K = new Microsoft.Office.Common.Response(
                            d._actionName,
                            d._conversationId,
                            d._correlationId,
                            C,
                            Microsoft.Office.Common.ResponseType.forCalling,
                            k
                        ),
                        J = Microsoft.Office.Common.MessagePackager.envelope(K, f),
                        u = b;
                    try {
                        u = !!(e.source && e.source.postMessage);
                    } catch (k) {}
                    u && e.source.postMessage(J, w);
                }
            } else if (d._messageType === Microsoft.Office.Common.MessageType.response) {
                var j = y(d._conversationId);
                if (!j) return;
                j._serializerVersion = f;
                if (!F(j._targetUrl, e.origin)) throw 'Failed orgin check';
                if (d._responseType === Microsoft.Office.Common.ResponseType.forCalling) {
                    var o = j._callbackList[d._correlationId];
                    if (o)
                        try {
                            o.callback && o.callback(d._errorCode, d._data);
                        } finally {
                            delete j._callbackList[d._correlationId];
                        }
                } else {
                    var s = j._eventHandlerList[d._actionName];
                    s !== undefined && s !== a && s(d._data);
                }
            } else return;
        }
    }
    function u() {
        if (!t) {
            C(G);
            t = c;
        }
    }
    return {
        connect: function(b, e, f, c) {
            var a = d[b];
            if (!a) {
                u();
                a = new Microsoft.Office.Common.ClientEndPoint(b, e, f, c);
                d[b] = a;
            }
            return a;
        },
        getClientEndPoint: function(c) {
            var a = Function._validateParams(arguments, [{ name: f, type: String, mayBeNull: b }]);
            if (a) throw a;
            return d[c];
        },
        createServiceEndPoint: function(a) {
            u();
            var b = new Microsoft.Office.Common.ServiceEndPoint(a);
            e[a] = b;
            return b;
        },
        getServiceEndPoint: function(c) {
            var a = Function._validateParams(arguments, [{ name: l, type: String, mayBeNull: b }]);
            if (a) throw a;
            return e[c];
        },
        deleteClientEndPoint: function(c) {
            var a = Function._validateParams(arguments, [{ name: f, type: String, mayBeNull: b }]);
            if (a) throw a;
            delete d[c];
        },
        deleteServiceEndPoint: function(c) {
            var a = Function._validateParams(arguments, [{ name: l, type: String, mayBeNull: b }]);
            if (a) throw a;
            delete e[c];
        },
        checkUrlWithAppDomains: function(a, b) {
            return m(a, b);
        },
        _setMethodTimeout: function(a) {
            var c = Function._validateParams(arguments, [
                { name: 'methodTimeout', type: Number, mayBeNull: b },
            ]);
            if (c) throw c;
            s = a <= 0 ? p : a;
        },
        _startMethodTimeoutTimer: function() {
            if (!h) h = setInterval(A, w);
        },
    };
})();
Microsoft.Office.Common.Message = function(g, h, e, f, c) {
    var b = false,
        a = this,
        d = Function._validateParams(arguments, [
            { name: 'messageType', type: Number, mayBeNull: b },
            { name: 'actionName', type: String, mayBeNull: b },
            { name: 'conversationId', type: String, mayBeNull: b },
            { name: 'correlationId', mayBeNull: b },
            { name: 'data', mayBeNull: true, optional: true },
        ]);
    if (d) throw d;
    a._messageType = g;
    a._actionName = h;
    a._conversationId = e;
    a._correlationId = f;
    a._origin = window.location.href;
    if (typeof c == 'undefined') a._data = null;
    else a._data = c;
};
Microsoft.Office.Common.Message.prototype = {
    getActionName: function() {
        return this._actionName;
    },
    getConversationId: function() {
        return this._conversationId;
    },
    getCorrelationId: function() {
        return this._correlationId;
    },
    getOrigin: function() {
        return this._origin;
    },
    getData: function() {
        return this._data;
    },
    getMessageType: function() {
        return this._messageType;
    },
};
Microsoft.Office.Common.Request = function(c, d, a, b, e) {
    Microsoft.Office.Common.Request.uber.constructor.call(
        this,
        Microsoft.Office.Common.MessageType.request,
        c,
        a,
        b,
        e
    );
    this._actionType = d;
};
OSF.OUtil.extend(Microsoft.Office.Common.Request, Microsoft.Office.Common.Message);
Microsoft.Office.Common.Request.prototype.getActionType = function() {
    return this._actionType;
};
Microsoft.Office.Common.Response = function(d, a, b, e, c, f) {
    Microsoft.Office.Common.Response.uber.constructor.call(
        this,
        Microsoft.Office.Common.MessageType.response,
        d,
        a,
        b,
        f
    );
    this._errorCode = e;
    this._responseType = c;
};
OSF.OUtil.extend(Microsoft.Office.Common.Response, Microsoft.Office.Common.Message);
Microsoft.Office.Common.Response.prototype.getErrorCode = function() {
    return this._errorCode;
};
Microsoft.Office.Common.Response.prototype.getResponseType = function() {
    return this._responseType;
};
Microsoft.Office.Common.MessagePackager = {
    envelope: function(a) {
        if (typeof a === 'object') a._serializerVersion = OSF.SerializerVersion.Browser;
        return JSON.stringify(a);
    },
    unenvelope: function(a) {
        return JSON.parse(a);
    },
};
Microsoft.Office.Common.ResponseSender = function(f, i, k, g, h, j, e) {
    var c = false,
        a = this,
        d = Function._validateParams(arguments, [
            { name: 'requesterWindow', mayBeNull: c },
            { name: 'requesterUrl', type: String, mayBeNull: c },
            { name: 'actionName', type: String, mayBeNull: c },
            { name: 'conversationId', type: String, mayBeNull: c },
            { name: 'correlationId', mayBeNull: c },
            { name: 'responsetype', type: Number, maybeNull: c },
            { name: 'serializerVersion', type: Number, maybeNull: true, optional: true },
        ]);
    if (d) throw d;
    a._requesterWindow = f;
    a._requesterUrl = i;
    a._actionName = k;
    a._conversationId = g;
    a._correlationId = h;
    a._invokeResultCode = Microsoft.Office.Common.InvokeResultCode.noError;
    a._responseType = j;
    var b = a;
    a._send = function(f) {
        try {
            var d = new Microsoft.Office.Common.Response(
                    b._actionName,
                    b._conversationId,
                    b._correlationId,
                    b._invokeResultCode,
                    b._responseType,
                    f
                ),
                c = Microsoft.Office.Common.MessagePackager.envelope(d, e);
            b._requesterWindow.postMessage(c, b._requesterUrl);
        } catch (a) {
            OsfMsAjaxFactory.msAjaxDebug.trace('ResponseSender._send error:' + a.message);
        }
    };
};
Microsoft.Office.Common.ResponseSender.prototype = {
    getRequesterWindow: function() {
        return this._requesterWindow;
    },
    getRequesterUrl: function() {
        return this._requesterUrl;
    },
    getActionName: function() {
        return this._actionName;
    },
    getConversationId: function() {
        return this._conversationId;
    },
    getCorrelationId: function() {
        return this._correlationId;
    },
    getSend: function() {
        return this._send;
    },
    setResultCode: function(a) {
        this._invokeResultCode = a;
    },
};
Microsoft.Office.Common.InvokeCompleteCallback = function(e, h, i, f, g, d, c) {
    var b = this;
    Microsoft.Office.Common.InvokeCompleteCallback.uber.constructor.call(
        b,
        e,
        h,
        i,
        f,
        g,
        Microsoft.Office.Common.ResponseType.forCalling,
        c
    );
    b._postCallbackHandler = d;
    var a = b;
    b._send = function(g, b) {
        if (b != undefined) a._invokeResultCode = b;
        try {
            var f = new Microsoft.Office.Common.Response(
                    a._actionName,
                    a._conversationId,
                    a._correlationId,
                    a._invokeResultCode,
                    a._responseType,
                    g
                ),
                e = Microsoft.Office.Common.MessagePackager.envelope(f, c);
            a._requesterWindow.postMessage(e, a._requesterUrl);
            a._postCallbackHandler();
        } catch (d) {
            OsfMsAjaxFactory.msAjaxDebug.trace('InvokeCompleteCallback._send error:' + d.message);
        }
    };
};
OSF.OUtil.extend(
    Microsoft.Office.Common.InvokeCompleteCallback,
    Microsoft.Office.Common.ResponseSender
);
Microsoft.Office.Common.Invoker = function(i, j, e, f, h, k, g) {
    var c = true,
        b = false,
        a = this,
        d = Function._validateParams(arguments, [
            { name: 'methodObject', mayBeNull: b },
            { name: 'paramValue', mayBeNull: c },
            { name: 'invokeCompleteCallback', mayBeNull: b },
            { name: 'eventHandlerProxyList', mayBeNull: c },
            { name: 'conversationId', type: String, mayBeNull: b },
            { name: 'eventName', type: String, mayBeNull: b },
            { name: 'serializerVersion', type: Number, mayBeNull: c, optional: c },
        ]);
    if (d) throw d;
    a._methodObject = i;
    a._param = j;
    a._invokeCompleteCallback = e;
    a._eventHandlerProxyList = f;
    a._conversationId = h;
    a._eventName = k;
    a._serializerVersion = g;
};
Microsoft.Office.Common.Invoker.prototype = {
    invoke: function() {
        var a = this;
        try {
            var b;
            switch (a._methodObject.getInvokeType()) {
                case Microsoft.Office.Common.InvokeType.async:
                    a._methodObject.getMethod()(a._param, a._invokeCompleteCallback.getSend());
                    break;
                case Microsoft.Office.Common.InvokeType.sync:
                    b = a._methodObject.getMethod()(a._param);
                    a._invokeCompleteCallback.getSend()(b);
                    break;
                case Microsoft.Office.Common.InvokeType.syncRegisterEvent:
                    var d = a._createEventHandlerProxyObject(a._invokeCompleteCallback);
                    b = a._methodObject.getMethod()(d.getSend(), a._param);
                    a._eventHandlerProxyList[a._conversationId + a._eventName] = d.getSend();
                    a._invokeCompleteCallback.getSend()(b);
                    break;
                case Microsoft.Office.Common.InvokeType.syncUnregisterEvent:
                    var g = a._eventHandlerProxyList[a._conversationId + a._eventName];
                    b = a._methodObject.getMethod()(g, a._param);
                    delete a._eventHandlerProxyList[a._conversationId + a._eventName];
                    a._invokeCompleteCallback.getSend()(b);
                    break;
                case Microsoft.Office.Common.InvokeType.asyncRegisterEvent:
                    var c = a._createEventHandlerProxyObject(a._invokeCompleteCallback);
                    a._methodObject.getMethod()(
                        c.getSend(),
                        a._invokeCompleteCallback.getSend(),
                        a._param
                    );
                    a._eventHandlerProxyList[a._callerId + a._eventName] = c.getSend();
                    break;
                case Microsoft.Office.Common.InvokeType.asyncUnregisterEvent:
                    var f = a._eventHandlerProxyList[a._callerId + a._eventName];
                    a._methodObject.getMethod()(f, a._invokeCompleteCallback.getSend(), a._param);
                    delete a._eventHandlerProxyList[a._callerId + a._eventName];
            }
        } catch (e) {
            a._invokeCompleteCallback.setResultCode(
                Microsoft.Office.Common.InvokeResultCode.errorInResponse
            );
            a._invokeCompleteCallback.getSend()(e);
        }
    },
    getInvokeBlockingFlag: function() {
        return this._methodObject.getBlockingFlag();
    },
    _createEventHandlerProxyObject: function(a) {
        return new Microsoft.Office.Common.ResponseSender(
            a.getRequesterWindow(),
            a.getRequesterUrl(),
            a.getActionName(),
            a.getConversationId(),
            a.getCorrelationId(),
            Microsoft.Office.Common.ResponseType.forEventing,
            this._serializerVersion
        );
    },
};
OSF.OUtil.setNamespace('OSF', window);
OSF.MessageIDs = {
    FetchBundleUrl: 0,
    LoadReactBundle: 1,
    LoadBundleSuccess: 2,
    LoadBundleError: 3,
};
OSF.AppName = {
    Unsupported: 0,
    Excel: 1,
    Word: 2,
    PowerPoint: 4,
    Outlook: 8,
    ExcelWebApp: 16,
    WordWebApp: 32,
    OutlookWebApp: 64,
    Project: 128,
    AccessWebApp: 256,
    PowerpointWebApp: 512,
    ExcelIOS: 1024,
    Sway: 2048,
    WordIOS: 4096,
    PowerPointIOS: 8192,
    Access: 16384,
    Lync: 32768,
    OutlookIOS: 65536,
    OneNoteWebApp: 131072,
    OneNote: 262144,
    ExcelWinRT: 524288,
    WordWinRT: 1048576,
    PowerpointWinRT: 2097152,
    OutlookAndroid: 4194304,
    OneNoteWinRT: 8388608,
    ExcelAndroid: 8388609,
    VisioWebApp: 8388610,
    OneNoteIOS: 8388611,
    WordAndroid: 8388613,
    PowerpointAndroid: 8388614,
};
OSF.InternalPerfMarker = {
    DataCoercionBegin: 'Agave.HostCall.CoerceDataStart',
    DataCoercionEnd: 'Agave.HostCall.CoerceDataEnd',
};
OSF.HostCallPerfMarker = {
    IssueCall: 'Agave.HostCall.IssueCall',
    ReceiveResponse: 'Agave.HostCall.ReceiveResponse',
    RuntimeExceptionRaised: 'Agave.HostCall.RuntimeExecptionRaised',
};
OSF.AgaveHostAction = {
    Select: 0,
    UnSelect: 1,
    CancelDialog: 2,
    InsertAgave: 3,
    CtrlF6In: 4,
    CtrlF6Exit: 5,
    CtrlF6ExitShift: 6,
    SelectWithError: 7,
    NotifyHostError: 8,
    RefreshAddinCommands: 9,
    PageIsReady: 10,
    TabIn: 11,
    TabInShift: 12,
    TabExit: 13,
    TabExitShift: 14,
    EscExit: 15,
    F2Exit: 16,
    ExitNoFocusable: 17,
    ExitNoFocusableShift: 18,
    MouseEnter: 19,
    MouseLeave: 20,
    UpdateTargetUrl: 21,
    InstallCustomFunctions: 22,
    SendTelemetryEvent: 23,
};
OSF.SharedConstants = { NotificationConversationIdSuffix: '_ntf' };
OSF.DialogMessageType = {
    DialogMessageReceived: 0,
    DialogParentMessageReceived: 1,
    DialogClosed: 12006,
};
OSF.OfficeAppContext = function(
    y,
    u,
    p,
    n,
    r,
    v,
    q,
    t,
    x,
    j,
    w,
    l,
    k,
    m,
    h,
    g,
    f,
    e,
    i,
    c,
    d,
    s,
    o,
    b
) {
    var a = this;
    a._id = y;
    a._appName = u;
    a._appVersion = p;
    a._appUILocale = n;
    a._dataLocale = r;
    a._docUrl = v;
    a._clientMode = q;
    a._settings = t;
    a._reason = x;
    a._osfControlType = j;
    a._eToken = w;
    a._correlationId = l;
    a._appInstanceId = k;
    a._touchEnabled = m;
    a._commerceAllowed = h;
    a._appMinorVersion = g;
    a._requirementMatrix = f;
    a._hostCustomMessage = e;
    a._hostFullVersion = i;
    a._isDialog = false;
    a._clientWindowHeight = c;
    a._clientWindowWidth = d;
    a._addinName = s;
    a._appDomains = o;
    a._dialogRequirementMatrix = b;
    a.get_id = function() {
        return this._id;
    };
    a.get_appName = function() {
        return this._appName;
    };
    a.get_appVersion = function() {
        return this._appVersion;
    };
    a.get_appUILocale = function() {
        return this._appUILocale;
    };
    a.get_dataLocale = function() {
        return this._dataLocale;
    };
    a.get_docUrl = function() {
        return this._docUrl;
    };
    a.get_clientMode = function() {
        return this._clientMode;
    };
    a.get_bindings = function() {
        return this._bindings;
    };
    a.get_settings = function() {
        return this._settings;
    };
    a.get_reason = function() {
        return this._reason;
    };
    a.get_osfControlType = function() {
        return this._osfControlType;
    };
    a.get_eToken = function() {
        return this._eToken;
    };
    a.get_correlationId = function() {
        return this._correlationId;
    };
    a.get_appInstanceId = function() {
        return this._appInstanceId;
    };
    a.get_touchEnabled = function() {
        return this._touchEnabled;
    };
    a.get_commerceAllowed = function() {
        return this._commerceAllowed;
    };
    a.get_appMinorVersion = function() {
        return this._appMinorVersion;
    };
    a.get_requirementMatrix = function() {
        return this._requirementMatrix;
    };
    a.get_dialogRequirementMatrix = function() {
        return this._dialogRequirementMatrix;
    };
    a.get_hostCustomMessage = function() {
        return this._hostCustomMessage;
    };
    a.get_hostFullVersion = function() {
        return this._hostFullVersion;
    };
    a.get_isDialog = function() {
        return this._isDialog;
    };
    a.get_clientWindowHeight = function() {
        return this._clientWindowHeight;
    };
    a.get_clientWindowWidth = function() {
        return this._clientWindowWidth;
    };
    a.get_addinName = function() {
        return this._addinName;
    };
    a.get_appDomains = function() {
        return this._appDomains;
    };
};
OSF.OsfControlType = { DocumentLevel: 0, ContainerLevel: 1 };
OSF.ClientMode = { ReadOnly: 0, ReadWrite: 1 };
OSF.OUtil.setNamespace('Microsoft', window);
OSF.OUtil.setNamespace('Office', Microsoft);
OSF.OUtil.setNamespace('Client', Microsoft.Office);
OSF.OUtil.setNamespace('WebExtension', Microsoft.Office);
Microsoft.Office.WebExtension.InitializationReason = {
    Inserted: 'inserted',
    DocumentOpened: 'documentOpened',
};
Microsoft.Office.WebExtension.ValueFormat = { Unformatted: 'unformatted', Formatted: 'formatted' };
Microsoft.Office.WebExtension.FilterType = { All: 'all' };
Microsoft.Office.WebExtension.Parameters = {
    BindingType: 'bindingType',
    CoercionType: 'coercionType',
    ValueFormat: 'valueFormat',
    FilterType: 'filterType',
    Columns: 'columns',
    SampleData: 'sampleData',
    GoToType: 'goToType',
    SelectionMode: 'selectionMode',
    Id: 'id',
    PromptText: 'promptText',
    ItemName: 'itemName',
    FailOnCollision: 'failOnCollision',
    StartRow: 'startRow',
    StartColumn: 'startColumn',
    RowCount: 'rowCount',
    ColumnCount: 'columnCount',
    Callback: 'callback',
    AsyncContext: 'asyncContext',
    Data: 'data',
    Rows: 'rows',
    OverwriteIfStale: 'overwriteIfStale',
    FileType: 'fileType',
    EventType: 'eventType',
    Handler: 'handler',
    SliceSize: 'sliceSize',
    SliceIndex: 'sliceIndex',
    ActiveView: 'activeView',
    Status: 'status',
    PlatformType: 'platformType',
    HostType: 'hostType',
    ForceConsent: 'forceConsent',
    ForceAddAccount: 'forceAddAccount',
    AuthChallenge: 'authChallenge',
    Reserved: 'reserved',
    Tcid: 'tcid',
    Xml: 'xml',
    Namespace: 'namespace',
    Prefix: 'prefix',
    XPath: 'xPath',
    Text: 'text',
    ImageLeft: 'imageLeft',
    ImageTop: 'imageTop',
    ImageWidth: 'imageWidth',
    ImageHeight: 'imageHeight',
    TaskId: 'taskId',
    FieldId: 'fieldId',
    FieldValue: 'fieldValue',
    ServerUrl: 'serverUrl',
    ListName: 'listName',
    ResourceId: 'resourceId',
    ViewType: 'viewType',
    ViewName: 'viewName',
    GetRawValue: 'getRawValue',
    CellFormat: 'cellFormat',
    TableOptions: 'tableOptions',
    TaskIndex: 'taskIndex',
    ResourceIndex: 'resourceIndex',
    CustomFieldId: 'customFieldId',
    Url: 'url',
    MessageHandler: 'messageHandler',
    Width: 'width',
    Height: 'height',
    RequireHTTPs: 'requireHTTPS',
    MessageToParent: 'messageToParent',
    DisplayInIframe: 'displayInIframe',
    MessageContent: 'messageContent',
    HideTitle: 'hideTitle',
    UseDeviceIndependentPixels: 'useDeviceIndependentPixels',
    PromptBeforeOpen: 'promptBeforeOpen',
    AppCommandInvocationCompletedData: 'appCommandInvocationCompletedData',
    Base64: 'base64',
    FormId: 'formId',
};
OSF.OUtil.setNamespace('DDA', OSF);
OSF.DDA.DocumentMode = { ReadOnly: 1, ReadWrite: 0 };
OSF.DDA.PropertyDescriptors = { AsyncResultStatus: 'AsyncResultStatus' };
OSF.DDA.EventDescriptors = {};
OSF.DDA.ListDescriptors = {};
OSF.DDA.UI = {};
OSF.DDA.getXdmEventName = function(b, a) {
    if (
        a == Microsoft.Office.WebExtension.EventType.BindingSelectionChanged ||
        a == Microsoft.Office.WebExtension.EventType.BindingDataChanged ||
        a == Microsoft.Office.WebExtension.EventType.DataNodeDeleted ||
        a == Microsoft.Office.WebExtension.EventType.DataNodeInserted ||
        a == Microsoft.Office.WebExtension.EventType.DataNodeReplaced
    )
        return b + '_' + a;
    else return a;
};
OSF.DDA.MethodDispId = {
    dispidMethodMin: 64,
    dispidGetSelectedDataMethod: 64,
    dispidSetSelectedDataMethod: 65,
    dispidAddBindingFromSelectionMethod: 66,
    dispidAddBindingFromPromptMethod: 67,
    dispidGetBindingMethod: 68,
    dispidReleaseBindingMethod: 69,
    dispidGetBindingDataMethod: 70,
    dispidSetBindingDataMethod: 71,
    dispidAddRowsMethod: 72,
    dispidClearAllRowsMethod: 73,
    dispidGetAllBindingsMethod: 74,
    dispidLoadSettingsMethod: 75,
    dispidSaveSettingsMethod: 76,
    dispidGetDocumentCopyMethod: 77,
    dispidAddBindingFromNamedItemMethod: 78,
    dispidAddColumnsMethod: 79,
    dispidGetDocumentCopyChunkMethod: 80,
    dispidReleaseDocumentCopyMethod: 81,
    dispidNavigateToMethod: 82,
    dispidGetActiveViewMethod: 83,
    dispidGetDocumentThemeMethod: 84,
    dispidGetOfficeThemeMethod: 85,
    dispidGetFilePropertiesMethod: 86,
    dispidClearFormatsMethod: 87,
    dispidSetTableOptionsMethod: 88,
    dispidSetFormatsMethod: 89,
    dispidExecuteRichApiRequestMethod: 93,
    dispidAppCommandInvocationCompletedMethod: 94,
    dispidCloseContainerMethod: 97,
    dispidGetAccessTokenMethod: 98,
    dispidOpenBrowserWindow: 102,
    dispidCreateDocumentMethod: 105,
    dispidInsertFormMethod: 106,
    dispidDisplayRibbonCalloutAsyncMethod: 109,
    dispidGetSelectedTaskMethod: 110,
    dispidGetSelectedResourceMethod: 111,
    dispidGetTaskMethod: 112,
    dispidGetResourceFieldMethod: 113,
    dispidGetWSSUrlMethod: 114,
    dispidGetTaskFieldMethod: 115,
    dispidGetProjectFieldMethod: 116,
    dispidGetSelectedViewMethod: 117,
    dispidGetTaskByIndexMethod: 118,
    dispidGetResourceByIndexMethod: 119,
    dispidSetTaskFieldMethod: 120,
    dispidSetResourceFieldMethod: 121,
    dispidGetMaxTaskIndexMethod: 122,
    dispidGetMaxResourceIndexMethod: 123,
    dispidCreateTaskMethod: 124,
    dispidAddDataPartMethod: 128,
    dispidGetDataPartByIdMethod: 129,
    dispidGetDataPartsByNamespaceMethod: 130,
    dispidGetDataPartXmlMethod: 131,
    dispidGetDataPartNodesMethod: 132,
    dispidDeleteDataPartMethod: 133,
    dispidGetDataNodeValueMethod: 134,
    dispidGetDataNodeXmlMethod: 135,
    dispidGetDataNodesMethod: 136,
    dispidSetDataNodeValueMethod: 137,
    dispidSetDataNodeXmlMethod: 138,
    dispidAddDataNamespaceMethod: 139,
    dispidGetDataUriByPrefixMethod: 140,
    dispidGetDataPrefixByUriMethod: 141,
    dispidGetDataNodeTextMethod: 142,
    dispidSetDataNodeTextMethod: 143,
    dispidMessageParentMethod: 144,
    dispidSendMessageMethod: 145,
    dispidExecuteFeature: 146,
    dispidQueryFeature: 147,
    dispidMethodMax: 147,
};
OSF.DDA.EventDispId = {
    dispidEventMin: 0,
    dispidInitializeEvent: 0,
    dispidSettingsChangedEvent: 1,
    dispidDocumentSelectionChangedEvent: 2,
    dispidBindingSelectionChangedEvent: 3,
    dispidBindingDataChangedEvent: 4,
    dispidDocumentOpenEvent: 5,
    dispidDocumentCloseEvent: 6,
    dispidActiveViewChangedEvent: 7,
    dispidDocumentThemeChangedEvent: 8,
    dispidOfficeThemeChangedEvent: 9,
    dispidDialogMessageReceivedEvent: 10,
    dispidDialogNotificationShownInAddinEvent: 11,
    dispidDialogParentMessageReceivedEvent: 12,
    dispidObjectDeletedEvent: 13,
    dispidObjectSelectionChangedEvent: 14,
    dispidObjectDataChangedEvent: 15,
    dispidContentControlAddedEvent: 16,
    dispidActivationStatusChangedEvent: 32,
    dispidRichApiMessageEvent: 33,
    dispidAppCommandInvokedEvent: 39,
    dispidOlkItemSelectedChangedEvent: 46,
    dispidOlkRecipientsChangedEvent: 47,
    dispidOlkAppointmentTimeChangedEvent: 48,
    dispidOlkRecurrenceChangedEvent: 49,
    dispidOlkAttachmentsChangedEvent: 50,
    dispidTaskSelectionChangedEvent: 56,
    dispidResourceSelectionChangedEvent: 57,
    dispidViewSelectionChangedEvent: 58,
    dispidDataNodeAddedEvent: 60,
    dispidDataNodeReplacedEvent: 61,
    dispidDataNodeDeletedEvent: 62,
    dispidEventMax: 63,
};
OSF.Constants = {
    FileVersion: '16.0.10908.10000',
    ThreePartsFileVersion: '16.0.10908',
    OmexAnonymousServiceExtension: '/anonymousserviceextension.aspx',
    OmexGatedServiceExtension: '/gatedserviceextension.aspx',
    OmexUnGatedServiceExtension: '/ungatedserviceextension.aspx',
    OmexConsentNotificationPage: '/client/consentnotification.aspx',
    Http: 'http',
    Https: 'https',
    ProtocolSeparator: '://',
    SignInRedirectUrl: '/logontoliveforwac.aspx?returnurl=',
    ETokenParameterName: 'et',
    ActivatedCacheKey: '__OSF_RUNTIME_.Activated.{0}.{1}.{2}',
    AuthenticatedConnectMaxTries: 3,
    IgnoreSandBoxSupport: 'Ignore_SandBox_Support',
    IEUpgradeUrl: 'https://office.microsoft.com/redir/HA102789344.aspx',
    OmexForceAnonymousParamName: 'SKAV',
    OmexForceAnonymousParamValue: '274AE4CD-E50B-4342-970E-1E7F36C70037',
    EndPointInternalSuffix: '_internal',
    PreloadOfficeJsId: 'OFFICEJSPRELOAD',
    PreloadOfficeJsUrl: '//appsforoffice.microsoft.com/preloading/preloadoffice.js',
    StringResourceFile: 'osfruntime_strings.js',
};
var __extends =
        (this && this.__extends) ||
        function(b, a) {
            for (var c in a) if (a.hasOwnProperty(c)) b[c] = a[c];
            function d() {
                this.constructor = b;
            }
            b.prototype = a === null ? Object.create(a) : ((d.prototype = a.prototype), new d());
        },
    OfficeExt;
(function(a) {
    var b;
    (function(m) {
        var k = 'ov:Control',
            j = 'ov:SourceLocation',
            e = 'resid',
            d = 'ov:Description',
            c = 'ov:Title',
            i = 'bt:Image',
            h = 'ov:VersionOverrides',
            g = 'o:OfficeApp',
            a = null,
            f = (function() {
                function a(a) {
                    this.name = 'AddinManifestError';
                    this.message = this.name + ': ' + a;
                }
                return a;
            })(),
            x = (function() {
                function a(a) {
                    this.name = 'AddinInternalError';
                    this.message = a;
                }
                return a;
            })();
        function b(c, b) {
            if (c == a) throw new f(b);
        }
        var q = (function() {
            function a(b) {
                var c = 'bt:String',
                    a = this;
                a.Images = {};
                a.Urls = {};
                a.LongStrings = {};
                a.ShortStrings = {};
                var e = b.manifest._xmlProcessor.selectSingleNode(g),
                    d = b.selectSingleNode(e, [h, 'ov:Resources']);
                a.parseCollection(b, b.selectChildNodes(i, d, ['bt:Images']), a.Images);
                a.parseCollection(b, b.selectChildNodes('bt:Url', d, ['bt:Urls']), a.Urls);
                a.parseCollection(b, b.selectChildNodes(c, d, ['bt:LongStrings']), a.LongStrings);
                a.parseCollection(b, b.selectChildNodes(c, d, ['bt:ShortStrings']), a.ShortStrings);
            }
            a.prototype.parseCollection = function(d, b, f) {
                for (var e = b.length, a = 0; a < e; a++) {
                    var c = b[a],
                        g = c.getAttribute('id');
                    f[g] = d.parseLocaleAwareSettingsAndGetValue(c);
                }
            };
            return a;
        })();
        m.ManifestResourceManager = q;
        var l = (function() {
            function g(d, c, b, e) {
                var a = this;
                a.hostType = d;
                a.formFactor = c;
                a.entitlement = b;
                a.manifest = e;
                a.resources = new q(a);
            }
            g.prototype.parseIdRequired = function(c) {
                var a = c.getAttribute('id');
                b(a, 'Id required');
                return a;
            };
            g.prototype.parseLabel = function(c) {
                var b = this.manifest._xmlProcessor.selectSingleNode('ov:Label', c);
                if (b != a) return this.getShortString(b);
                return a;
            };
            g.prototype.parseLabelRequired = function(c) {
                var a = this.parseLabel(c);
                b(a, 'Label required');
                return a;
            };
            g.prototype.parseRequiredSuperTip = function(c) {
                var a = this.parseSuperTip(c);
                b(a, 'SuperTip required');
                return a;
            };
            g.prototype.parseSuperTip = function(k) {
                var f = this,
                    h = a,
                    e = f.manifest._xmlProcessor.selectSingleNode('ov:Supertip', k);
                if (e != a) {
                    var i = e,
                        j,
                        g;
                    e = f.manifest._xmlProcessor.selectSingleNode(c, i);
                    b(e, 'Title is necessary for SuperTip.');
                    j = f.getShortString(e);
                    e = f.manifest._xmlProcessor.selectSingleNode(d, i);
                    b(e, 'Description is necessary for SuperTip.');
                    g = f.getLongString(e);
                    h = { title: j, description: g };
                }
                return h;
            };
            g.prototype.parseRequiredIcon = function(c) {
                var a = this.parseIcon(c);
                b(a, 'Icon required');
                return a;
            };
            g.prototype.parseIcon = function(g) {
                var c = this.selectChildNodes(i, g, ['ov:Icon']),
                    f = c.length;
                if (f == 0) return a;
                for (var e = {}, b = 0; b < f; b++) {
                    var d = c[b],
                        h = d.getAttribute('size');
                    e[h] = this.getImageResource(d);
                }
                return e;
            };
            g.prototype.parseChildControls = function(a, d, c) {
                var b = this.manifest._xmlProcessor.selectNodes(a, d);
                return this.parseControls(b, c);
            };
            g.prototype.parseControls = function(e, f) {
                for (var c = [], g = e.length, a = 0; a < g; a++) {
                    var h = e[a],
                        d = f(this, h);
                    b(d, 'parser must return a control.');
                    c.push(d);
                }
                return c;
            };
            g.prototype.parseControlInGroup = function(c) {
                var b = c.getAttribute(g.typeAttributeName),
                    a;
                switch (b) {
                    case 'Menu':
                        a = new F();
                        break;
                    case 'Button':
                        a = new J(b);
                        break;
                    default:
                        throw new f('Unsupported control type.');
                }
                a.parse(this, c);
                return a;
            };
            g.prototype.parseMenuItem = function(b) {
                var a = new I();
                a.parse(this, b);
                return a;
            };
            g.prototype.parseLocaleAwareSettingsAndGetValue = function(c) {
                var b = this,
                    a = {},
                    f = c.getAttribute('DefaultValue');
                a[b.manifest._defaultLocale] = f;
                a[b.manifest._defaultLocale.toLocaleLowerCase()] = f;
                var d = b.manifest._xmlProcessor.selectNodes('bt:Override', c);
                if (d)
                    for (var i = d.length, e = 0; e < i; e++) {
                        var c = d[e],
                            g = c.getAttribute('Locale'),
                            h = c.getAttribute('Value');
                        a[g] = h;
                        a[g.toLocaleLowerCase()] = h;
                    }
                return b.manifest._getDefaultValue(a);
            };
            g.prototype.selectSingleNode = function(b, c) {
                if (c == a) return b;
                for (var d = 0; d < c.length; d++) {
                    b = this.manifest._xmlProcessor.selectSingleNode(c[d], b);
                    if (b == a) break;
                }
                return b;
            };
            g.prototype.selectChildNodes = function(c, b, d) {
                b = this.selectSingleNode(b, d);
                if (b == a) return [];
                return this.manifest._xmlProcessor.selectNodes(c, b);
            };
            g.prototype.getResourceByNode = function(f, d) {
                var a = d.getAttribute(e),
                    c = f[a];
                b(c, 'resid: ' + a + ' not found');
                return c;
            };
            g.prototype.getImageResource = function(a) {
                return this.getResourceByNode(this.resources.Images, a);
            };
            g.prototype.getUrlResource = function(a) {
                return this.getResourceByNode(this.resources.Urls, a);
            };
            g.prototype.getLongString = function(a) {
                return this.getResourceByNode(this.resources.LongStrings, a);
            };
            g.prototype.getShortString = function(a) {
                return this.getResourceByNode(this.resources.ShortStrings, a);
            };
            g.typeAttributeName = 'xsi:type';
            return g;
        })();
        m.ParsingContext = l;
        var n = (function() {
                function a() {}
                a.buildControls = function(c, b) {
                    for (var e = b.length, a = 0; a < e; a++) {
                        var d = b[a];
                        d.apply(c);
                    }
                };
                return a;
            })(),
            z = (function() {
                function a(a, b) {
                    this.functionFile = a;
                    this.builder = b;
                }
                return a;
            })(),
            C = (function() {
                function a() {}
                a.prototype.parse = function(a, f) {
                    var e = a.manifest._xmlProcessor,
                        h = e.selectSingleNode(c, f);
                    b(h, 'Title is necessary for GetStarted.');
                    this.title = a.getShortString(h);
                    var g = e.selectSingleNode(d, f);
                    b(g, 'Description is necessary for GetStarted.');
                    this.description = a.getLongString(g);
                    var i = e.selectSingleNode('ov:LearnMoreUrl', f);
                    this.learnMoreUrl = a.getUrlResource(i);
                };
                return a;
            })(),
            t = (function() {
                function a(a) {
                    this.type = a;
                }
                a.prototype.buildAction = function() {};
                a.prototype.parse = function() {};
                return a;
            })(),
            E = (function(d) {
                __extends(c, d);
                function c() {
                    d.apply(this, arguments);
                    this.title = a;
                }
                c.prototype.parse = function(a, d) {
                    var c = a.manifest._xmlProcessor.selectSingleNode(j, d);
                    b(c, 'SourceLocation is necessary for ShowTaskpane action');
                    this.sourceLocation = a.getUrlResource(c);
                    a.manifest.addManifestUrl(this.sourceLocation);
                };
                return c;
            })(t),
            B = (function(d) {
                __extends(b, d);
                function b() {
                    d.apply(this, arguments);
                }
                b.prototype.buildAction = function(a) {
                    return a.actionBuilder.buildShowTaskpane(
                        this.sourceLocation,
                        this.title,
                        this.taskpaneId
                    );
                };
                b.prototype.parse = function(e, f) {
                    d.prototype.parse.call(this, e, f);
                    var b = e.manifest._xmlProcessor.selectSingleNode('ov:TaskpaneId', f);
                    if (b != a) this.taskpaneId = b.firstChild.nodeValue;
                    b = e.manifest._xmlProcessor.selectSingleNode(c, f);
                    if (b != a) this.title = e.getShortString(b);
                };
                return b;
            })(E),
            y = (function(c) {
                __extends(a, c);
                function a() {
                    c.apply(this, arguments);
                }
                a.prototype.buildAction = function(a) {
                    b(
                        a.functionFile,
                        'Function file source url is necessary for ExecuteFunctionAction.'
                    );
                    return a.actionBuilder.buildCallFunction(
                        a.functionFile,
                        this.functionName,
                        this.controlId
                    );
                };
                a.prototype.parse = function(a, d) {
                    var c = a.manifest._xmlProcessor.selectSingleNode('ov:FunctionName', d);
                    b(c, 'FunctionName is necessary for ExecuteFunctionAction.');
                    this.functionName = a.manifest._xmlProcessor.getNodeValue(c);
                };
                return a;
            })(t),
            o = (function() {
                function a() {}
                a.prototype.parse = function(a, b) {
                    this.id = a.parseIdRequired(b);
                    this.label = a.parseLabelRequired(b);
                };
                return a;
            })(),
            F = (function(b) {
                __extends(a, b);
                function a() {
                    b.apply(this, arguments);
                }
                a.prototype.apply = function(a) {
                    a.controlBuilder.startBuildMenu(this);
                    n.buildControls(a, this.children);
                    a.controlBuilder.endBuildMenu();
                };
                a.prototype.parse = function(a, d) {
                    var c = this;
                    b.prototype.parse.call(c, a, d);
                    c.icon = a.parseRequiredIcon(d);
                    c.superTip = a.parseRequiredSuperTip(d);
                    var e = a.selectChildNodes('ov:Item', d, ['ov:Items']);
                    c.children = a.parseControls(e, function(a, b) {
                        return a.parseMenuItem(b);
                    });
                };
                return a;
            })(o),
            s = (function(c) {
                __extends(a, c);
                function a(a) {
                    c.call(this);
                    this.controlType = a;
                }
                a.prototype.apply = function(b) {
                    var a = this,
                        d = a.action.buildAction(b),
                        c = {
                            id: a.id,
                            label: a.label,
                            icon: a.icon,
                            superTip: a.superTip,
                            actionType: a.actionType,
                            action: d,
                        };
                    a.applyControl(b, c);
                };
                a.prototype.parse = function(d, h) {
                    var a = this;
                    c.prototype.parse.call(a, d, h);
                    a.icon = a.parseIcon(d, h);
                    a.superTip = d.parseRequiredSuperTip(h);
                    var i = d.manifest._xmlProcessor.selectSingleNode('ov:Action', h);
                    b(i, 'Action is necessary for itemControl.');
                    var e = i.getAttribute(l.typeAttributeName),
                        g;
                    switch (e) {
                        case 'ShowTaskpane':
                            g = new B(e);
                            break;
                        case 'ExecuteFunction':
                            var j = (g = new y(e));
                            j.controlId = a.id;
                            break;
                        default:
                            throw new f('Unsupported action type.');
                    }
                    g.parse(d, i);
                    a.actionType = e;
                    a.action = g;
                };
                a.prototype.applyControl = function() {
                    throw new x('Not implemented method applyControl for ItemControl.');
                };
                a.prototype.parseIcon = function(a, b) {
                    return a.parseIcon(b);
                };
                return a;
            })(o),
            J = (function(b) {
                __extends(a, b);
                function a() {
                    b.apply(this, arguments);
                }
                a.prototype.applyControl = function(a, b) {
                    a.controlBuilder.addButton(b);
                };
                a.prototype.parseIcon = function(a, b) {
                    return a.parseRequiredIcon(b);
                };
                return a;
            })(s),
            I = (function(b) {
                __extends(a, b);
                function a() {
                    b.call(this, 'MenuItem');
                }
                a.prototype.applyControl = function(a, b) {
                    a.controlBuilder.addMenuItem(b);
                };
                return a;
            })(s),
            u = (function() {
                function b(c) {
                    var b = this;
                    b.label = a;
                    b.isOfficeTab = false;
                    b.children = [];
                    b.isOfficeTab = c;
                }
                b.prototype.apply = function(a) {
                    a.builder.ribbonBuilder.startBuildTab(this);
                    for (var d = this.children.length, b = 0; b < d; b++) {
                        var c = this.children[b];
                        c.apply(a);
                    }
                    a.builder.ribbonBuilder.endBuildTab();
                };
                b.prototype.parse = function(b, c) {
                    var a = this;
                    a.id = b.parseIdRequired(c);
                    if (!a.isOfficeTab) a.label = b.parseLabelRequired(c);
                    a.children = b.parseChildControls('ov:Group', c, function(b, c) {
                        var a = new G();
                        a.parse(b, c);
                        return a;
                    });
                };
                return b;
            })(),
            G = (function(b) {
                __extends(a, b);
                function a() {
                    b.apply(this, arguments);
                }
                a.prototype.parse = function(a, c) {
                    b.prototype.parse.call(this, a, c);
                    this.icon = a.parseRequiredIcon(c);
                    this.children = a.parseChildControls(k, c, function(a, b) {
                        return a.parseControlInGroup(b);
                    });
                };
                a.prototype.apply = function(a) {
                    a.builder.ribbonBuilder.startBuildGroup(this);
                    n.buildControls(
                        {
                            functionFile: a.functionFile,
                            actionBuilder: a.builder.actionBuilder,
                            controlBuilder: a.builder.ribbonBuilder,
                        },
                        this.children
                    );
                    a.builder.ribbonBuilder.endBuildGroup();
                };
                return a;
            })(o),
            A = (function() {
                function b(a) {
                    this.type = a;
                    this.tabs = [];
                }
                b.prototype.apply = function(b) {
                    if (this.type == b.builder.commandSurface)
                        for (var c = this.tabs.length, a = 0; a < c; a++) {
                            var d = this.tabs[a];
                            d.apply(b);
                        }
                };
                b.prototype.parse = function(c, e) {
                    var b = c.manifest._xmlProcessor.selectSingleNode('ov:OfficeTab', e);
                    if (b != a) {
                        var d = new u(true);
                        d.parse(c, b);
                        this.tabs.push(d);
                    }
                    b = c.manifest._xmlProcessor.selectSingleNode('ov:CustomTab', e);
                    if (b != a) {
                        var d = new u(false);
                        d.parse(c, b);
                        this.tabs.push(d);
                    }
                };
                return b;
            })(),
            D = (function() {
                function b() {}
                b.prototype.parse = function(a, b) {
                    this.id = a.parseIdRequired(b);
                    this.children = a.parseChildControls(k, b, function(a, b) {
                        return a.parseControlInGroup(b);
                    });
                };
                b.prototype.apply = function(b) {
                    b.controlBuilder.startBuildMenu({ id: this.id, label: a, superTip: a });
                    n.buildControls(b, this.children);
                    b.controlBuilder.endBuildMenu();
                };
                return b;
            })(),
            w = (function() {
                function a(a) {
                    this.type = a;
                }
                a.prototype.apply = function(a) {
                    this.type == a.builder.commandSurface &&
                        n.buildControls(
                            {
                                functionFile: a.functionFile,
                                actionBuilder: a.builder.actionBuilder,
                                controlBuilder: a.builder.contextMenuBuilder,
                            },
                            this.children
                        );
                };
                a.prototype.parse = function(a, b) {
                    this.children = a.parseChildControls('ov:OfficeMenu', b, function(b, c) {
                        var a = new D();
                        a.parse(b, c);
                        return a;
                    });
                };
                return a;
            })(),
            p = (function() {
                function a(a) {
                    this.type = a;
                }
                a.prototype.apply = function() {};
                a.prototype.parse = function(b, c) {
                    var a = this,
                        d = b.manifest._xmlProcessor.selectSingleNode('ov:Namespace', c);
                    if (d) a.namespaceResId = d.getAttribute(e);
                    if (!a.namespaceResId)
                        throw new f(
                            "Missing required <Namespace> element under element <ExtensionPoint xsi:type='CustomFunctions'>."
                        );
                    var h = b.manifest._xmlProcessor.selectSingleNode('ov:Script', c);
                    if (h) a.scriptResId = a._parseSourceLocationResId(b, h);
                    if (!a.scriptResId)
                        throw new f(
                            "Missing required <Script> element under element <ExtensionPoint xsi:type='CustomFunctions'>."
                        );
                    var i = b.manifest._xmlProcessor.selectSingleNode('ov:Page', c);
                    if (i) a.pageResId = a._parseSourceLocationResId(b, i);
                    if (!a.pageResId)
                        throw new f(
                            "Missing required <Page> element under element <ExtensionPoint xsi:type='CustomFunctions'>."
                        );
                    var g = b.manifest._xmlProcessor.selectSingleNode('ov:Metadata', c);
                    if (g) a.metadataResId = a._parseSourceLocationResId(b, g);
                    if (!a.metadataResId)
                        throw new f(
                            "Missing required <Metadata> element under element <ExtensionPoint xsi:type='CustomFunctions'>."
                        );
                };
                a.prototype._parseSourceLocationResId = function(b, c) {
                    var a = b.manifest._xmlProcessor.selectSingleNode(j, c);
                    if (a) return a.getAttribute(e);
                    return undefined;
                };
                return a;
            })();
        m.CustomFunctionsExtensionPoint = p;
        var r = (function() {
            function b() {
                var b = this;
                b.getStartedNode = a;
                b.functionFile = a;
                b.cacheableUrls = [];
                b.ExtensionPoints = [];
            }
            b.prototype.cacheableResources = function() {
                return this.cacheableUrls;
            };
            b.prototype.apply = function(b, e) {
                var a = this;
                try {
                    b.startApplyAddin({
                        entitlement: a.extensionEntitlement,
                        manifest: a.extensionManifest,
                        startedNode: a.getStartedNode,
                        overrides: { type: a.type, description: a.description },
                    });
                    for (
                        var g = new z(a.functionFile, b), i = a.ExtensionPoints.length, d = 0;
                        d < i;
                        d++
                    ) {
                        var h = a.ExtensionPoints[d];
                        h.apply(g);
                    }
                    b.endApplyAddin();
                } catch (c) {
                    c instanceof f &&
                        e.setErrorMessageForAddin(
                            a.extensionEntitlement.assetId,
                            Strings.OsfRuntime.L_AddinCommands_AddinNotSupported_Message
                        );
                    throw c;
                }
            };
            b.prototype.parse = function(b, k) {
                var c = this;
                c.type = k.getAttribute(l.typeAttributeName);
                var h = b.manifest._xmlProcessor.selectSingleNode(d, k);
                if (h != a) c.description = b.getLongString(h);
                for (
                    var q = b.selectChildNodes('ov:Host', k, ['ov:Hosts']),
                        e = a,
                        n = q.length,
                        g = 0;
                    g < n;
                    g++
                ) {
                    var m = q[g],
                        u = m.getAttribute(l.typeAttributeName);
                    if (u == b.hostType) {
                        e = b.manifest._xmlProcessor.selectSingleNode('ov:' + b.formFactor, m);
                        if (e == a)
                            e = b.manifest._xmlProcessor.selectSingleNode('ov:AllFormFactors', m);
                        break;
                    }
                }
                var o = b.manifest._xmlProcessor.selectSingleNode('ov:GetStarted', e);
                if (o != a) {
                    c.getStartedNode = new C();
                    c.getStartedNode.parse(b, o);
                }
                h = b.manifest._xmlProcessor.selectSingleNode('ov:FunctionFile', e);
                if (h != a) {
                    c.functionFile = b.getUrlResource(h);
                    b.manifest.addManifestUrl(c.functionFile);
                }
                var r = b.manifest._xmlProcessor.selectNodes('ov:ExtensionPoint', e);
                n = r.length;
                for (var g = 0; g < n; g++) {
                    var s = r[g],
                        j = s.getAttribute(l.typeAttributeName),
                        i;
                    switch (j) {
                        case 'Events':
                            throw 'Not Implemented';
                        case 'PrimaryCommandSurface':
                            i = new A(j);
                            break;
                        case 'ContextMenu':
                            i = new w(j);
                            break;
                        case 'CustomFunctions':
                            i = new p(j);
                            break;
                        default:
                            throw new f('Unsupported extension type.');
                    }
                    i.parse(b, s);
                    c.ExtensionPoints.push(i);
                }
                var t = b.resources.Images;
                for (var v in t) c.cacheableUrls.push(t[v]);
                c.extensionEntitlement = b.entitlement;
                c.extensionManifest = b.manifest;
            };
            return b;
        })();
        m.VersionOverrides = r;
        var H = (function() {
                function a() {}
                a.prototype.cacheableResources = function() {
                    return [];
                };
                a.prototype.apply = function() {};
                return a;
            })(),
            v = (function() {
                function b(b, a) {
                    this.hostType = b;
                    this.formFactor = a;
                }
                b.prototype.parseExtensions = function(i, b, k) {
                    try {
                        var j = b._xmlProcessor.selectSingleNode(g),
                            e = b._xmlProcessor.selectSingleNode(h, j);
                        if (e == a) return new H();
                        var d = new r();
                        d.parse(new l(this.hostType, this.formFactor, i, b), e);
                        return d;
                    } catch (c) {
                        c instanceof f &&
                            k.setErrorMessageForAddin(
                                i.assetId,
                                Strings.OsfRuntime.L_AddinCommands_AddinNotSupported_Message
                            );
                        throw c;
                    }
                };
                return b;
            })();
        m.AddinCommandsManifestParser = v;
    })((b = a.Parser || (a.Parser = {})));
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var a = (function() {
        function a() {}
        a.createManifestForAddinAction = function(d, i, h, f) {
            var b = null,
                c = new OSF.Manifest.ExtensionSettings(),
                k = OSF.FormFactor.Default,
                e = {},
                g = d._UILocale.toLocaleLowerCase();
            e[g] = h;
            c._defaultHeight = b;
            c._defaultWidth = b;
            c._sourceLocations = {};
            c._sourceLocations[g] = i;
            var a = d,
                j = new OSF.Manifest.Manifest(function(d) {
                    d._xmlProcessor = a._xmlProcessor;
                    d._displayNames = h != b ? e : a._displayNames;
                    d._iconUrls = a._iconUrls;
                    d._extensionSettings = { formFactor: c };
                    d._highResolutionIconUrls = a._highResolutionIconUrls;
                    d._target = a._target;
                    d._id = f != b ? f : a._id;
                    d._version = a._version;
                    d._providerName = a._providerName;
                    d._idIssuer = a._idIssuer;
                    d._alternateId = a._alternateId;
                    d._defaultLocale = a._defaultLocale;
                    d._signature = a._signature;
                    d._capabilities = a._capabilities;
                    d._hosts = a._hosts;
                    d._descriptions = a._descriptions;
                    d._appDomains = a._appDomains;
                    d._permissions = a._permissions;
                    d._requirements = a._requirements;
                    d._webApplicationResource = a._webApplicationResource;
                    d._webApplicationId = a._webApplicationId;
                    d._webApplicationScopes = a._webApplicationScopes;
                    d._webApplicationAuthorizations = a._webApplicationAuthorizations;
                }, a._UILocale);
            return j;
        };
        a.cacheManifestForAction = function(b, c, a) {
            OSF.OsfManifestManager.cacheManifest(c, a, b);
        };
        a.purgeManifestForAction = function(b, a) {
            OSF.OsfManifestManager.purgeManifest(b, a);
        };
        return a;
    })();
    b.AddinCommandsManifestManager = a;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var d = '##UILessContainer##',
        a = null;
    b.AddinActionContextMap = {};
    b.AutoShowTaskPaneControlIdMap = {};
    var g = {};
    (function(a) {
        var c = 'ExclusiveForNew',
            b = 'ExclusiveForCur';
        a[(a['Default'] = 1)] = 'Default';
        a[(a[b] = 2)] = b;
        a[(a[c] = 3)] = c;
    })(b.CommandInvokeMode || (b.CommandInvokeMode = {}));
    var f = b.CommandInvokeMode,
        c;
    (function(a) {
        var d = 'ooeOperationNotSupported',
            c = 'ooeSuccess',
            b = 'ooeTimeout';
        a[(a[b] = -1)] = b;
        a[(a[c] = 0)] = c;
        a[(a[d] = 5e3)] = d;
    })(c || (c = {}));
    var j = (function() {
            function f(a, c, b) {
                this.contextProvider = a;
                this.manifest = b;
                this.entitlement = c;
            }
            f.prototype.buildShowTaskpane = function(a, c, b) {
                return this.CreateManifestAndActivationContextForTaskpaneCommand(a, c, b);
            };
            f.prototype.buildCallFunction = function(a, b, c) {
                return this.CreateManifestAndActivationContextForUILessCommand(a, b, c);
            };
            f.prototype.CreateManifestAndActivationContextForTaskpaneCommand = function(e, h, b) {
                var f = function(d, e) {
                        if (e != c.ooeSuccess) return;
                        if (b != a) g[b] = d;
                    },
                    d = function(e, d) {
                        var b = g[e];
                        if (b == a) return false;
                        var c = d.getOsfControl(b);
                        if (c == a) return false;
                        c._refresh();
                        return true;
                    };
                return this.CreateManifestAndActivationContext(e, h, b, function(h, c, g, e) {
                    b != a && d(b, c);
                    h.showTaskpane(g, e, f);
                });
            };
            f.prototype.CreateManifestAndActivationContext = function(f, h, e, g) {
                var c = this,
                    d = b.AddinCommandsManifestManager.createManifestForAddinAction(
                        this.manifest,
                        f,
                        h,
                        a
                    );
                return function(f) {
                    var i = c.contextProvider.createActionContext(f, function(i, h) {
                        var a = {
                            assetId: c.entitlement.assetId + (e || f),
                            appVersion: c.entitlement.appVersion,
                            storeId: c.entitlement.storeId,
                            storeType: OSF.StoreType.InMemory,
                            targetType: OSF.OsfControlTarget.TaskPane,
                        };
                        d._inMemoryEToken = c.entitlement.eToken;
                        b.AddinCommandsManifestManager.cacheManifestForAction(
                            d,
                            a.assetId,
                            a.appVersion
                        );
                        g(i, h, a, d);
                    });
                    b.AddinActionContextMap[f] = i;
                    var h = b.AutoShowTaskPaneControlIdMap[c.entitlement.assetId];
                    if (h == a && e == 'Office.AutoShowTaskpaneWithDocument')
                        b.AutoShowTaskPaneControlIdMap[c.entitlement.assetId] = f;
                };
            };
            f.prototype.CreateManifestAndActivationContextForUILessCommand = function(i, j, h) {
                var f = this,
                    k = function(a, b) {
                        if (b != c.ooeSuccess) return;
                        var d = { source: { id: h } };
                        e.invokeAppCommand(a, j, d, function() {});
                    },
                    g = b.AddinCommandsManifestManager.createManifestForAddinAction(
                        this.manifest,
                        i,
                        a,
                        a
                    );
                return function(a) {
                    var h = f.contextProvider.createActionContext(a, function(h) {
                        var a = {
                            assetId: f.entitlement.assetId + d,
                            appVersion: f.entitlement.appVersion,
                            storeId: f.entitlement.storeId,
                            storeType: OSF.StoreType.InMemory,
                            targetType: OSF.OsfControlTarget.TaskPane,
                        };
                        b.AddinCommandsManifestManager.cacheManifestForAction(
                            g,
                            a.assetId,
                            a.appVersion
                        );
                        h.createUILessSandbox(a, g, function(a, b) {
                            if (b == c.ooeSuccess) var d = e.ensureOsfHostEntry(a, h);
                            k(a, b);
                        });
                    });
                    b.AddinActionContextMap[a] = h;
                };
            };
            return f;
        })(),
        h = (function() {
            function a(a, b) {
                this.contextProvider = a;
                this.entitlement = b;
            }
            a.prototype.buildShowTaskpane = function() {
                var a = this;
                return function(c) {
                    delete b.AddinActionContextMap[c];
                    b.AddinCommandsManifestManager.purgeManifestForAction(
                        a.entitlement.assetId + c,
                        a.entitlement.appVersion
                    );
                };
            };
            a.prototype.buildCallFunction = function() {
                var a = this;
                return function(c) {
                    delete b.AddinActionContextMap[c];
                    b.AddinCommandsManifestManager.purgeManifestForAction(
                        a.entitlement.assetId + d,
                        a.entitlement.appVersion
                    );
                };
            };
            return a;
        })(),
        i = (function() {
            function a() {}
            a.createActionBuilder = function(a, c, b) {
                return new j(a, c, b);
            };
            a.createDeleterActionBuilder = function(a, b) {
                return new h(a, b);
            };
            a.bindAction = function(a, c) {
                var b = c;
                b(a);
            };
            a.retrieveActionContext = function(a) {
                return b.AddinActionContextMap[a];
            };
            a.retrieveAutoShowTaskPaneControlIdMap = function() {
                return b.AutoShowTaskPaneControlIdMap;
            };
            return a;
        })();
    b.DefaultControlActionBinder = i;
    var k = (function() {
            function b() {
                this.invocationQueue = {};
            }
            b.prototype.invokeAppCommand = function(l, i, d, m, e) {
                var g = this,
                    h = {
                        dispid: OSF.DDA.EventDispId.dispidAppCommandInvokedEvent,
                        controlId: g.osfControlId,
                    };
                h[0] = l;
                h[1] = i;
                h[2] = JSON.stringify(d);
                e = e ? e : b.defaultTimeout;
                var j = d && d.commandMode ? d.commandMode : f.Default,
                    k = { args: h, onComplete: m, timeout: e, timeoutTimer: a },
                    c = g.invocationQueue[i];
                if (c == a) {
                    c = [];
                    g.invocationQueue[i] = c;
                }
                !(j == f.ExclusiveForCur && c.length > 0) &&
                    !(j == f.ExclusiveForNew && c.length > 1) &&
                    c.push(k);
                c.length == 1 && g.trySendInvocation(k);
            };
            b.prototype.invocationCompleted = function(f, g, i) {
                var c = this,
                    h = c;
                for (var e in c.invocationQueue) {
                    var d = c.invocationQueue[e],
                        b = d[0];
                    if (f == b.args[0]) {
                        if (d.length > 1) {
                            d.splice(0, 1);
                            var j = d[0];
                            window.setTimeout(function() {
                                h.trySendInvocation(j);
                            }, 0);
                        } else delete c.invocationQueue[e];
                        if (b.timeoutTimer != a) {
                            window.clearTimeout(b.timeoutTimer);
                            b.timeoutTimer = a;
                        }
                        b.onComplete(g, i);
                        return;
                    }
                }
            };
            b.prototype.sendInvocations = function(c) {
                var b = this;
                b.eventHandler = c;
                if (c == a) return;
                for (var d in b.invocationQueue) {
                    var e = b.invocationQueue[d],
                        f = e[0];
                    b.sendInvocation(c, f);
                }
            };
            b.prototype.trySendInvocation = function(c) {
                var b = this.eventHandler;
                b != a && this.sendInvocation(b, c);
            };
            b.prototype.sendInvocation = function(c, a) {
                var d = this,
                    b = a.args;
                c(b);
                a.timeoutTimer = window.setTimeout(function() {
                    d.invocationTimeout(b[0]);
                }, a.timeout);
            };
            b.prototype.invocationTimeout = function(b) {
                this.invocationCompleted(b, c.ooeTimeout, a);
            };
            b.prototype.disposeHost = function() {
                var b = this;
                for (var c in b.invocationQueue) return;
                b.host.disposeHost(b.osfControlId);
                b.onDisposed != a && b.onDisposed(b);
            };
            b.defaultTimeout = 300 * 1e3;
            return b;
        })(),
        e = (function() {
            var f = 'targetId',
                e = 'controlId',
                d = 'eventDispId';
            function b() {}
            b.registerEvent = function(g, c, a) {
                b.registerEventInternal(a[d], a[e], a[f], g, function(a) {
                    c && c(a == 0);
                });
            };
            b.unregisterEvent = function(g, c, a) {
                b.unregisterEventInternal(a[d], a[e], a[f], g, function(a) {
                    c && c(a == 0);
                });
            };
            b.invokeAppCommand = function(d, c, f, e) {
                var g = b.getOrCreateOsfHostEntry(d),
                    a = b.getNextAppCommandId();
                g.invokeAppCommand(a, c, f, e);
            };
            b.invocationCompleted = function(e, c) {
                var g = b.getOrCreateOsfHostEntry(e),
                    d = c[0],
                    f = c[1],
                    h = c[2] ? JSON.parse(c[2]) : a;
                g.invocationCompleted(d, f, h);
            };
            b.ensureOsfHostEntry = function(d, e) {
                var c = b.getOrCreateOsfHostEntry(d);
                if (c.host == a) c.host = e;
                return c;
            };
            b.getNextAppCommandId = function() {
                return 'AppCmd' + b._nextAppCommandId++;
            };
            b.getOrCreateOsfHostEntry = function(d) {
                var c = b._invocationQueues[d];
                if (c == a) {
                    c = new k();
                    c.osfControlId = d;
                    c.onDisposed = function(a) {
                        delete b._invocationQueues[a.osfControlId];
                    };
                    b._invocationQueues[d] = c;
                }
                return c;
            };
            b.registerEventInternal = function(d, e, h, f, a) {
                switch (d) {
                    case OSF.DDA.EventDispId.dispidAppCommandInvokedEvent:
                        var g = b.getOrCreateOsfHostEntry(e);
                        a(c.ooeSuccess);
                        g.sendInvocations(f);
                        return;
                }
                a(c.ooeOperationNotSupported);
            };
            b.unregisterEventInternal = function(f, g, i, h, d) {
                switch (f) {
                    case OSF.DDA.EventDispId.dispidAppCommandInvokedEvent:
                        var e = b.getOrCreateOsfHostEntry(g);
                        if (e.eventHandler == h) e.eventHandler = a;
                        d(c.ooeSuccess);
                        return;
                }
                d(c.ooeOperationNotSupported);
            };
            b._nextAppCommandId = 0;
            b._invocationQueues = {};
            return b;
        })();
    b.AddinCommandsRuntimeManager = e;
})(OfficeExt || (OfficeExt = {}));
OSF.ShowWindowDialogParameterKeys = {
    Url: 'url',
    Width: 'width',
    Height: 'height',
    DisplayInIframe: 'displayInIframe',
    HideTitle: 'hideTitle',
    UseDeviceIndependentPixels: 'useDeviceIndependentPixels',
    PromptBeforeOpen: 'promptBeforeOpen',
};
OSF.HostThemeButtonStyleKeys = {
    ButtonBorderColor: 'buttonBorderColor',
    ButtonBackgroundColor: 'buttonBackgroundColor',
};
OSF.OmexPageParameterKeys = {
    AppName: 'client',
    AppVersion: 'cv',
    AppUILocale: 'ui',
    AppDomain: 'appDomain',
    StoreLocator: 'rs',
    AssetId: 'assetid',
    NotificationType: 'notificationType',
    AppCorrelationId: 'corr',
    AuthType: 'authType',
    AppId: 'appid',
    Scopes: 'scopes',
};
OSF.AuthType = { Anonymous: 0, MSA: 1, OrgId: 2, ADAL: 3 };
OSF.OmexMessageKeys = { MessageType: 'messageType', MessageValue: 'messageValue' };
OSF.OmexRemoveAddinMessageKeys = {
    RemoveAddinResultCode: 'resultCode',
    RemoveAddinResultValue: 'resultValue',
};
OSF.OmexRemoveAddinResultCode = {
    Success: 0,
    ClientError: 400,
    ServerError: 500,
    UnknownError: 600,
};
var OfficeExt;
(function(a) {
    var b;
    (function(a) {
        var k =
            '^https://[a-z0-9-]+.(officeapps.live|officeapps-df.live|partner.officewebapps).com/';
        function f(a, b) {
            return OSF.OUtil.parseInfoFromWindowName(a, b, OSF.WindowNameItemKeys.AppContext);
        }
        a.parseAppContextFromWindowName = f;
        function c(a) {
            if (typeof JSON !== 'undefined')
                try {
                    return JSON.stringify(a);
                } catch (b) {}
            return '';
        }
        a.serializeObjectToString = c;
        function l() {
            return new RegExp(k).test(OSF.getClientEndPoint()._targetUrl.toLowerCase());
        }
        a.isHostTrusted = l;
        function h(b, e) {
            if (!b) return null;
            b = b.trim() || '';
            var f = '?',
                k = '_host_Info=',
                j = '&_host_Info=',
                d = '#',
                i = b.split(d),
                c = i.shift(),
                h = i.join(d),
                g = c.split(f),
                a;
            if (g.length > 1) a = c + j + e;
            else if (g.length > 0) a = c + f + k + e;
            if (h) return [a, d, h].join('');
            else return a;
        }
        a.addHostInfoAsQueryParam = h;
        function i(b) {
            if (!b) return null;
            var a = document.createElement('a');
            a.href = b;
            return a.protocol + '//' + a.host;
        }
        a.getDomainForUrl = i;
        function e() {
            try {
                for (
                    var c = ['Windows NT 6.1', 'Windows NT 6.2', 'Windows NT 6.3'],
                        f = window.navigator.userAgent,
                        a = 0,
                        g = c.length;
                    a < g;
                    a++
                )
                    if (f.indexOf(c[a]) > -1) return d();
                return false;
            } catch (e) {
                b('Error happens in shouldUseLocalStorageToPassMessage.', e);
                return false;
            }
        }
        a.shouldUseLocalStorageToPassMessage = e;
        function d() {
            try {
                var a = window.navigator.userAgent;
                return (
                    a.indexOf('MSIE ') > -1 || a.indexOf('Trident/') > -1 || a.indexOf('Edge/') > -1
                );
            } catch (c) {
                b('Error happens in isInternetExplorer.', c);
                return false;
            }
        }
        a.isInternetExplorer = d;
        function g(c) {
            for (
                var d = OSF.OUtil.getLocalStorage(),
                    e = d.getKeysWithPrefix(''),
                    a = 0,
                    h = e.length;
                a < h;
                a++
            )
                for (var f = e[a], b = 0, g = c.length; b < g; b++)
                    if (c[b].test(f)) {
                        d.removeItem(f);
                        break;
                    }
        }
        a.removeMatchesFromLocalStorage = g;
        function b(b, a) {
            OsfMsAjaxFactory.msAjaxDebug.trace(b + ' Exception details: ' + c(a));
        }
        a.logExceptionToBrowserConsole = b;
        var j = (function() {
            function a() {}
            a.GatedCacheKeyPrefix = '__OSF_GATED_OMEX.';
            a.AuthenticatedAppInstallInfoCacheKey =
                a.GatedCacheKeyPrefix + 'appinstall_authenticated.{0}.{1}.{2}.{3}';
            a.EntitlementsKey = 'entitle.{0}.{1}';
            return a;
        })();
        a.CacheConstants = j;
    })((b = a.WACUtils || (a.WACUtils = {})));
})(OfficeExt || (OfficeExt = {}));
OSF.XmlConstants = { MaxXmlSize: 1048576, MaxElementDepth: 64 };
OSF.Xpath3Provider = function(f, e) {
    var a = this;
    a._xmldoc = new DOMParser().parseFromString(f, 'text/xml');
    a._evaluator = new XPathEvaluator();
    a._namespaceMapping = {};
    a._defaultNamespace = null;
    for (var d = e.split(' '), b, c = 0; c < d.length; ++c) {
        b = /xmlns="([^"]*)"/g.exec(d[c]);
        if (b) {
            a._defaultNamespace = b[1];
            continue;
        }
        b = /xmlns:([^=]*)="([^"]*)"/g.exec(d[c]);
        if (b) {
            a._namespaceMapping[b[1]] = b[2];
            continue;
        }
    }
    a._resolver = a;
};
OSF.Xpath3Provider.prototype = {
    lookupNamespaceURI: function(a) {
        var b = this._namespaceMapping[a];
        return b || this._defaultNamespace;
    },
    addNamespaceMapping: function(a, b) {
        var c = this._namespaceMapping[a];
        if (c) return false;
        else {
            this._namespaceMapping[a] = b;
            return true;
        }
    },
    selectSingleNode: function(d, a) {
        var c = (a ? './' : '/') + d;
        a = a || this.getDocumentElement();
        var b = this._evaluator.evaluate(
            c,
            a,
            this._resolver,
            XPathResult.FIRST_ORDERED_NODE_TYPE,
            null
        );
        if (b) return b.singleNodeValue;
        else return null;
    },
    selectNodes: function(f, a) {
        var e = (a ? './' : '/') + f;
        a = a || this.getDocumentElement();
        var b = this._evaluator.evaluate(
                e,
                a,
                this._resolver,
                XPathResult.ORDERED_NODE_ITERATOR_TYPE,
                null
            ),
            d = [];
        if (b) {
            var c = b.iterateNext();
            while (c) {
                d.push(c);
                c = b.iterateNext();
            }
        }
        return d;
    },
    selectNodesByXPath: function(e, d) {
        var a = this._evaluator.evaluate(
                e,
                d,
                this._resolver,
                XPathResult.ORDERED_NODE_ITERATOR_TYPE,
                null
            ),
            c = [];
        if (a) {
            var b = a.iterateNext();
            while (b) {
                c.push(b);
                b = a.iterateNext();
            }
        }
        return c;
    },
    getDocumentElement: function() {
        return this._xmldoc.documentElement;
    },
};
OSF.IEXpathProvider = function(f, e) {
    for (var a = null, c = ['MSXML2.DOMDocument.6.0'], b = 0; b < c.length; b++)
        try {
            a = new ActiveXObject(c[b]);
            a.setProperty('ResolveExternals', false);
            a.setProperty('ValidateOnParse', false);
            a.setProperty('ProhibitDTD', true);
            a.setProperty('MaxXMLSize', OSF.XmlConstants.MaxXmlSize);
            a.setProperty('MaxElementDepth', OSF.XmlConstants.MaxElementDepth);
            a.async = false;
            a.loadXML(f);
            a.setProperty('SelectionLanguage', 'XPath');
            a.setProperty('SelectionNamespaces', e);
            break;
        } catch (d) {
            OsfMsAjaxFactory.msAjaxDebug.trace('xml doc creating error:' + d);
        }
    this._xmldoc = a;
};
OSF.IEXpathProvider.prototype = {
    selectSingleNode: function(c, a) {
        var b = (a ? './' : '/') + c;
        a = a || this.getDocumentElement();
        return a.selectSingleNode(b);
    },
    addNamespaceMapping: function(b, f) {
        var c = 'SelectionNamespaces',
            a = this._xmldoc.getProperty(c),
            e = 'xmlns:' + b + '=',
            d = 'xmlns:' + b + '="' + f + '"';
        if (a.indexOf(e) != -1) return false;
        a = a + ' ' + d;
        this._xmldoc.setProperty(c, a);
        return true;
    },
    selectNodes: function(c, a) {
        var b = (a ? './' : '/') + c;
        a = a || this.getDocumentElement();
        return a.selectNodes(b);
    },
    selectNodesByXPath: function(b, a) {
        return a.selectNodes(b);
    },
    getDocumentElement: function() {
        return this._xmldoc.documentElement;
    },
    getActiveXObject: function() {
        return this._xmldoc;
    },
};
OSF.DomParserProvider = function(g, f) {
    var b = this;
    try {
        b._xmldoc = new DOMParser().parseFromString(g, 'text/xml');
    } catch (e) {
        Sys.Debug.trace('xml doc creating error:' + e);
    }
    b._namespaceMapping = {};
    b._defaultNamespace = null;
    for (var d = f.split(' '), a, c = 0; c < d.length; ++c) {
        a = /xmlns="([^"]*)"/g.exec(d[c]);
        if (a) {
            b._defaultNamespace = a[1];
            continue;
        }
        a = /xmlns:([^=]*)="([^"]*)"/g.exec(d[c]);
        if (a) {
            b._namespaceMapping[a[1]] = a[2];
            continue;
        }
    }
};
OSF.DomParserProvider.prototype = {
    addNamespaceMapping: function(a, b) {
        var c = this._namespaceMapping[a];
        if (c) return false;
        else {
            this._namespaceMapping[a] = b;
            return true;
        }
    },
    selectSingleNode: function(d, c) {
        var b = c || this._xmldoc,
            a = this._selectNodes(d, b);
        if (a.length === 0) return null;
        return a[0];
    },
    selectNodes: function(c, b) {
        var a = b || this._xmldoc;
        return this._selectNodes(c, a);
    },
    selectNodesByXPath: function() {
        return null;
    },
    _selectNodes: function(h, g) {
        var d = [];
        if (!h) return d;
        var a = h.split(':'),
            f,
            e;
        if (a.length === 1) {
            f = null;
            e = a[0];
        } else if (a.length === 2) {
            f = this._namespaceMapping[a[0]];
            e = a[1];
        } else throw OsfMsAjaxFactory.msAjaxError.argument('name');
        if (!g.hasChildNodes) return d;
        for (var c = g.childNodes, b = 0; b < c.length; b++)
            e === this._removeNodePrefix(c[b].nodeName) && f === c[b].namespaceURI && d.push(c[b]);
        return d;
    },
    _removeNodePrefix: function(b) {
        var a = b.split(':');
        if (a.length === 1) return b;
        else return a[1];
    },
    getDocumentElement: function() {
        return this._xmldoc.documentElement;
    },
};
OSF.XmlProcessor = function(c, b) {
    var a = this,
        d = Function._validateParams(arguments, [
            { name: 'xml', type: String, mayBeNull: false },
            { name: 'xmlNamespaces', type: String, mayBeNull: false },
        ]);
    if (d) throw d;
    if (document.implementation && document.implementation.hasFeature('XPath', '3.0'))
        a._provider = new OSF.Xpath3Provider(c, b);
    else {
        a._provider = new OSF.IEXpathProvider(c, b);
        if (!a._provider.getActiveXObject()) a._provider = new OSF.DomParserProvider(c, b);
    }
};
OSF.XmlProcessor.prototype = {
    addNamespaceMapping: function(b, c) {
        var a = Function._validateParams(arguments, [
            { name: 'namespacePrefix', type: String, mayBeNull: false },
            { name: 'namespaceUri', type: String, mayBeNull: false },
        ]);
        if (a) throw a;
        return this._provider.addNamespaceMapping(b, c);
    },
    selectSingleNode: function(c, b) {
        var a = Function._validateParams(arguments, [
            { name: 'name', type: String, mayBeNull: false },
            { name: 'contextNode', mayBeNull: true, optional: true },
        ]);
        if (a) throw a;
        return this._provider.selectSingleNode(c, b);
    },
    selectNodes: function(c, b) {
        var a = Function._validateParams(arguments, [
            { name: 'name', type: String, mayBeNull: false },
            { name: 'contextNode', mayBeNull: true, optional: true },
        ]);
        if (a) throw a;
        return this._provider.selectNodes(c, b);
    },
    selectNodesByXPath: function(c, a) {
        var b = Function._validateParams(arguments, [
            { name: 'xpath', type: String, mayBeNull: false },
            { name: 'contextNode', mayBeNull: true, optional: true },
        ]);
        if (b) throw b;
        a = a || this._provider.getDocumentElement();
        return this._provider.selectNodesByXPath(c, a);
    },
    getDocumentElement: function() {
        return this._provider.getDocumentElement();
    },
    getNodeValue: function(b) {
        var c = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
        ]);
        if (c) throw c;
        var a;
        if (b.text) a = b.text;
        else a = b.textContent;
        return a;
    },
    getNodeText: function(a) {
        var c = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
        ]);
        if (c) throw c;
        if (this.getNodeType(a) == 9) return this.getNodeText(this.getDocumentElement());
        var b;
        if (a.text) b = a.text;
        else b = a.textContent;
        return b;
    },
    setNodeText: function(b, c) {
        var a = false,
            d = Function._validateParams(arguments, [
                { name: 'node', type: Object, mayBeNull: a },
                { name: 'text', type: String, mayBeNull: a },
            ]);
        if (d) throw d;
        if (this.getNodeType(b) == 9) return a;
        try {
            if (b.text) b.text = c;
            else b.textContent = c;
        } catch (e) {
            return a;
        }
        return true;
    },
    getNodeXml: function(b) {
        var c = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
        ]);
        if (c) throw c;
        var a;
        if (b.xml) a = b.xml;
        else {
            a = new XMLSerializer().serializeToString(b);
            if (this.getNodeType(b) == 2) a = this.getNodeBaseName(b) + '="' + a + '"';
        }
        return a;
    },
    setNodeXml: function(c, e) {
        var d = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
            { name: 'xml', type: String, mayBeNull: false },
        ]);
        if (d) throw d;
        var a = new OSF.XmlProcessor(e, '');
        if (!a.isValidXml()) return null;
        var b = a.getDocumentElement();
        try {
            c.parentNode.replaceChild(b, c);
        } catch (f) {
            return null;
        }
        return b;
    },
    getNodeNamespaceURI: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
        ]);
        if (a) throw a;
        return b.namespaceURI;
    },
    getNodePrefix: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
        ]);
        if (a) throw a;
        return b.prefix;
    },
    getNodeBaseName: function(a) {
        var c = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
        ]);
        if (c) throw c;
        var b;
        if (a.nodeType && (a.nodeType == 1 || a.nodeType == 2))
            if (a.baseName) b = a.baseName;
            else b = a.localName;
        else b = a.nodeName;
        return b;
    },
    getNodeType: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
        ]);
        if (a) throw a;
        return b.nodeType;
    },
    appendChild: function(e, d) {
        var c = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
            { name: 'childXml', type: String, mayBeNull: false },
        ]);
        if (c) throw c;
        var b = new OSF.XmlProcessor(d, '');
        if (!b.isValidXml()) return null;
        var a = b.getDocumentElement();
        e.appendChild(a);
        return a;
    },
    _getAttributeLocalName: function(a) {
        var b;
        if (a.localName) b = a.localName;
        else b = a.baseName;
        return b;
    },
    readAttributes: function(e, c, h) {
        var f = Function._validateParams(arguments, [
            { name: 'node', type: Object, mayBeNull: false },
            { name: 'attributesToRead', type: Object, mayBeNull: false },
            { name: 'objectToFill', type: Object, mayBeNull: false },
        ]);
        if (f) throw f;
        for (var a, d, b = 0; b < e.attributes.length; b++) {
            a = e.attributes[b];
            d = this._getAttributeLocalName(a);
            for (var g in c) if (d === g) h[c[g]] = a.value;
        }
    },
    isValidXml: function() {
        var a = 'parsererror',
            b = this.getDocumentElement();
        if (b == null) return false;
        else if (this._provider._xmldoc.getElementsByTagName(a).length > 0) {
            var e = new DOMParser(),
                d = e.parseFromString('<', 'text/xml'),
                c = d.getElementsByTagName(a)[0].namespaceURI;
            return this._provider._xmldoc.getElementsByTagNameNS(c, a).length <= 0;
        }
        return true;
    },
};
var OfficeExt;
(function(a) {
    var d = (function() {
        function a() {}
        a.prototype.Serialize = function(a) {
            try {
                return JSON.stringify(a);
            } catch (b) {
                return null;
            }
        };
        a.prototype.Deserialize = function(a) {
            try {
                return JSON.parse(a);
            } catch (b) {
                return null;
            }
        };
        return a;
    })();
    a.SafeSerializer = d;
    var b = (function() {
        function a(a, b) {
            this._localStorage = a;
            this._serializer = b;
        }
        a.prototype.GetCacheItem = function(j, h, f, i, g) {
            var c = 'cacheExpired',
                b = true,
                e = this;
            if (h === void 0) h = b;
            if (g === void 0) g = b;
            e.ValidateCurrentCache();
            var k = e._localStorage.getItem(j);
            if (k) {
                var d = e._serializer.Deserialize(k);
                if (typeof i != 'undefined' && i > 0 && i - d.createdOn > 0) {
                    e._localStorage.removeItem(j);
                    if (f) f[c] = b;
                } else if (h) {
                    var l = new Date();
                    if (Math.abs(l.getTime() - d.createdOn) < a.msPerDay * d.refreshRate)
                        return d.data;
                    else if (g) {
                        e._localStorage.removeItem(j);
                        if (f) f[c] = b;
                    }
                } else return d.data;
            }
        };
        a.prototype.SetCacheItem = function(e, d, b) {
            b = b || a.defaultRefreshRateInDays;
            var f = new Date(),
                c = { data: d, createdOn: f.getTime(), refreshRate: b };
            this._localStorage.setItem(e, this._serializer.Serialize(c));
        };
        a.prototype.RemoveCacheItem = function(a) {
            this._localStorage.removeItem(a);
        };
        a.prototype.RemoveAll = function(c) {
            for (var b = this._localStorage.getKeysWithPrefix(c), a = 0, d = b.length; a < d; a++)
                this._localStorage.removeItem(b[a]);
        };
        a.prototype.RemoveMatches = function(c) {
            for (var d = this._localStorage.getKeysWithPrefix(''), a = 0, g = d.length; a < g; a++)
                for (var e = d[a], b = 0, f = c.length; b < f; b++)
                    if (c[b].test(e)) {
                        this._localStorage.removeItem(e);
                        break;
                    }
        };
        a.prototype.ValidateCurrentCache = function() {
            var b = this._localStorage.getItem(a.cacheVersionKey);
            if (b != a.currentSchemaVersion) {
                this.RemoveMatches([new RegExp('__OSF_(?!.*activated).*$', 'i')]);
                this._localStorage.setItem(a.cacheVersionKey, a.currentSchemaVersion);
            }
        };
        a.defaultRefreshRateInDays = 3;
        a.msPerDay = 8.64e7;
        a.currentSchemaVersion = '1';
        a.checkedCache = false;
        a.cacheVersionKey = 'osfCacheVersion';
        return a;
    })();
    a.AppsDataCacheManager = b;
    var c = (function(b) {
        __extends(a, b);
        function a(a, c) {
            b.call(this, a, c);
        }
        a.prototype.GetRefreshToken = function(d, c) {
            var e = OSF.OUtil.formatString(a._refreshTokenCacheKey, d, c);
            return b.prototype.GetCacheItem.call(this, e);
        };
        a.prototype.AddRefreshToken = function(c, e, d) {
            var f = OSF.OUtil.formatString(a._refreshTokenCacheKey, e, d);
            b.prototype.SetCacheItem.call(this, f, c);
        };
        a.prototype.RemoveAll = function() {
            b.prototype.RemoveAll.call(this, a._refreshTokenCachePrefixKey);
        };
        a.prototype.RemoveRefreshToken = function(d, c) {
            var e = OSF.OUtil.formatString(a._refreshTokenCacheKey, d, c);
            b.prototype.RemoveCacheItem.call(this, e);
        };
        a._refreshTokenCacheKey = '_OSF_PRIVATECATALOG_REFRESHTOKEN_{0}_{1}';
        a._refreshTokenCachePrefixKey = '_OSF_PRIVATECATALOG_REFRESHTOKEN';
        return a;
    })(b);
    a.TokenCacheManager = c;
})(OfficeExt || (OfficeExt = {}));
var OSFLog;
(function(j) {
    var f = 'Error',
        e = 'ResponseTime',
        d = 'Result',
        h = 'OperationMetadata',
        c = 'ErrorResult',
        g = 'AssetId',
        b = 'CorrelationId',
        a = true,
        i = (function() {
            function b(a) {
                this._table = a;
                this._fields = {};
            }
            Object.defineProperty(b.prototype, 'Fields', {
                get: function() {
                    return this._fields;
                },
                enumerable: a,
                configurable: a,
            });
            Object.defineProperty(b.prototype, 'Table', {
                get: function() {
                    return this._table;
                },
                enumerable: a,
                configurable: a,
            });
            b.prototype.SerializeFields = function() {};
            b.prototype.SetSerializedField = function(b, a) {
                if (typeof a !== 'undefined' && a !== null)
                    this._serializedFields[b] = a.toString();
            };
            b.prototype.SerializeRow = function() {
                var a = this;
                a._serializedFields = {};
                a.SetSerializedField('Table', a._table);
                a.SerializeFields();
                return JSON.stringify(a._serializedFields);
            };
            return b;
        })();
    j.BaseUsageData = i;
    var t = (function(t) {
        var s = 'Stage11Time',
            r = 'Stage10Time',
            q = 'Stage9Time',
            p = 'Stage8Time',
            o = 'Stage7Time',
            n = 'Stage6Time',
            m = 'Stage5Time',
            l = 'Stage4Time',
            k = 'Stage3Time',
            j = 'Stage2Time',
            i = 'Stage1Time',
            h = 'InstanceId',
            f = 'ActivationInfo',
            e = 'AppInfo';
        __extends(d, t);
        function d() {
            t.call(this, 'AppLoadTime');
        }
        Object.defineProperty(d.prototype, b, {
            get: function() {
                return this.Fields[b];
            },
            set: function(a) {
                this.Fields[b] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, e, {
            get: function() {
                return this.Fields[e];
            },
            set: function(a) {
                this.Fields[e] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, f, {
            get: function() {
                return this.Fields[f];
            },
            set: function(a) {
                this.Fields[f] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, h, {
            get: function() {
                return this.Fields[h];
            },
            set: function(a) {
                this.Fields[h] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, g, {
            get: function() {
                return this.Fields[g];
            },
            set: function(a) {
                this.Fields[g] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, i, {
            get: function() {
                return this.Fields[i];
            },
            set: function(a) {
                this.Fields[i] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, j, {
            get: function() {
                return this.Fields[j];
            },
            set: function(a) {
                this.Fields[j] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, k, {
            get: function() {
                return this.Fields[k];
            },
            set: function(a) {
                this.Fields[k] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, l, {
            get: function() {
                return this.Fields[l];
            },
            set: function(a) {
                this.Fields[l] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, m, {
            get: function() {
                return this.Fields[m];
            },
            set: function(a) {
                this.Fields[m] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, n, {
            get: function() {
                return this.Fields[n];
            },
            set: function(a) {
                this.Fields[n] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, o, {
            get: function() {
                return this.Fields[o];
            },
            set: function(a) {
                this.Fields[o] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, p, {
            get: function() {
                return this.Fields[p];
            },
            set: function(a) {
                this.Fields[p] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, q, {
            get: function() {
                return this.Fields[q];
            },
            set: function(a) {
                this.Fields[q] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, r, {
            get: function() {
                return this.Fields[r];
            },
            set: function(a) {
                this.Fields[r] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, s, {
            get: function() {
                return this.Fields[s];
            },
            set: function(a) {
                this.Fields[s] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, c, {
            get: function() {
                return this.Fields[c];
            },
            set: function(a) {
                this.Fields[c] = a;
            },
            enumerable: a,
            configurable: a,
        });
        d.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(b, a.CorrelationId);
            a.SetSerializedField(e, a.AppInfo);
            a.SetSerializedField(f, a.ActivationInfo);
            a.SetSerializedField(h, a.InstanceId);
            a.SetSerializedField(g, a.AssetId);
            a.SetSerializedField(i, a.Stage1Time);
            a.SetSerializedField(j, a.Stage2Time);
            a.SetSerializedField(k, a.Stage3Time);
            a.SetSerializedField(l, a.Stage4Time);
            a.SetSerializedField(m, a.Stage5Time);
            a.SetSerializedField(n, a.Stage6Time);
            a.SetSerializedField(o, a.Stage7Time);
            a.SetSerializedField(p, a.Stage8Time);
            a.SetSerializedField(q, a.Stage9Time);
            a.SetSerializedField(r, a.Stage10Time);
            a.SetSerializedField(s, a.Stage11Time);
            a.SetSerializedField(c, a.ErrorResult);
        };
        return d;
    })(i);
    j.AppLoadTimeUsageData = t;
    var s = (function(f) {
        var d = 'NotificationClickInfo';
        __extends(e, f);
        function e() {
            f.call(this, 'AppNotification');
        }
        Object.defineProperty(e.prototype, b, {
            get: function() {
                return this.Fields[b];
            },
            set: function(a) {
                this.Fields[b] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(e.prototype, c, {
            get: function() {
                return this.Fields[c];
            },
            set: function(a) {
                this.Fields[c] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(e.prototype, d, {
            get: function() {
                return this.Fields[d];
            },
            set: function(a) {
                this.Fields[d] = a;
            },
            enumerable: a,
            configurable: a,
        });
        e.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(b, a.CorrelationId);
            a.SetSerializedField(c, a.ErrorResult);
            a.SetSerializedField(d, a.NotificationClickInfo);
        };
        return e;
    })(i);
    j.AppNotificationUsageData = s;
    var r = (function(d) {
        __extends(b, d);
        function b() {
            d.call(this, 'AppManagementMenu');
        }
        Object.defineProperty(b.prototype, g, {
            get: function() {
                return this.Fields[g];
            },
            set: function(a) {
                this.Fields[g] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, h, {
            get: function() {
                return this.Fields[h];
            },
            set: function(a) {
                this.Fields[h] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, c, {
            get: function() {
                return this.Fields[c];
            },
            set: function(a) {
                this.Fields[c] = a;
            },
            enumerable: a,
            configurable: a,
        });
        b.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(g, a.AssetId);
            a.SetSerializedField(h, a.OperationMetadata);
            a.SetSerializedField(c, a.ErrorResult);
        };
        return b;
    })(i);
    j.AppManagementMenuUsageData = r;
    var p = (function(i) {
        var f = 'LastActiveTabCount',
            e = 'LastActiveTab',
            d = 'DialogState',
            c = 'TrustPageSessionTime',
            b = 'TotalSessionTime';
        __extends(h, i);
        function h() {
            i.call(this, 'InsertionDialogSession');
        }
        Object.defineProperty(h.prototype, g, {
            get: function() {
                return this.Fields[g];
            },
            set: function(a) {
                this.Fields[g] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(h.prototype, b, {
            get: function() {
                return this.Fields[b];
            },
            set: function(a) {
                this.Fields[b] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(h.prototype, c, {
            get: function() {
                return this.Fields[c];
            },
            set: function(a) {
                this.Fields[c] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(h.prototype, d, {
            get: function() {
                return this.Fields[d];
            },
            set: function(a) {
                this.Fields[d] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(h.prototype, e, {
            get: function() {
                return this.Fields[e];
            },
            set: function(a) {
                this.Fields[e] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(h.prototype, f, {
            get: function() {
                return this.Fields[f];
            },
            set: function(a) {
                this.Fields[f] = a;
            },
            enumerable: a,
            configurable: a,
        });
        h.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(g, a.AssetId);
            a.SetSerializedField(b, a.TotalSessionTime);
            a.SetSerializedField(c, a.TrustPageSessionTime);
            a.SetSerializedField(d, a.DialogState);
            a.SetSerializedField(e, a.LastActiveTab);
            a.SetSerializedField(f, a.LastActiveTabCount);
        };
        return h;
    })(i);
    j.InsertionDialogSessionUsageData = p;
    var q = (function(e) {
        __extends(d, e);
        function d() {
            e.call(this, 'UploadFileDevCatelog');
        }
        Object.defineProperty(d.prototype, b, {
            get: function() {
                return this.Fields[b];
            },
            set: function(a) {
                this.Fields[b] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, h, {
            get: function() {
                return this.Fields[h];
            },
            set: function(a) {
                this.Fields[h] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(d.prototype, c, {
            get: function() {
                return this.Fields[c];
            },
            set: function(a) {
                this.Fields[c] = a;
            },
            enumerable: a,
            configurable: a,
        });
        d.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(b, a.CorrelationId);
            a.SetSerializedField(h, a.OperationMetadata);
            a.SetSerializedField(c, a.ErrorResult);
        };
        return d;
    })(i);
    j.UploadFileDevCatelogUsageData = q;
    var o = (function(k) {
        var f = 'AppSizeHeight',
            e = 'AppSizeWidth',
            d = 'IsAppCommand',
            j = 'AppTargetType',
            i = 'AppVersion',
            h = 'AppId',
            g = 'StoreType';
        __extends(c, k);
        function c() {
            k.call(this, 'UploadFileDevCatalogUsage');
        }
        Object.defineProperty(c.prototype, b, {
            get: function() {
                return this.Fields[b];
            },
            set: function(a) {
                this.Fields[b] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, g, {
            get: function() {
                return this.Fields[g];
            },
            set: function(a) {
                this.Fields[g] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, h, {
            get: function() {
                return this.Fields[h];
            },
            set: function(a) {
                this.Fields[h] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, i, {
            get: function() {
                return this.Fields[i];
            },
            set: function(a) {
                this.Fields[i] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, j, {
            get: function() {
                return this.Fields[j];
            },
            set: function(a) {
                this.Fields[j] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, d, {
            get: function() {
                return this.Fields[d];
            },
            set: function(a) {
                this.Fields[d] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, e, {
            get: function() {
                return this.Fields[e];
            },
            set: function(a) {
                this.Fields[e] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, f, {
            get: function() {
                return this.Fields[f];
            },
            set: function(a) {
                this.Fields[f] = a;
            },
            enumerable: a,
            configurable: a,
        });
        c.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(b, a.CorrelationId);
            a.SetSerializedField(g, a.StoreType);
            a.SetSerializedField(h, a.AppId);
            a.SetSerializedField(i, a.AppVersion);
            a.SetSerializedField(j, a.AppTargetType);
            a.SetSerializedField(d, a.IsAppCommand);
            a.SetSerializedField(e, a.AppSizeWidth);
            a.SetSerializedField(f, a.AppSizeHeight);
        };
        return c;
    })(i);
    j.UploadFileDevCatalogUsageUsageData = o;
    var k = (function(c) {
        __extends(b, c);
        function b() {
            c.call(this, 'OneDriveCatalogGetAccessToken');
        }
        Object.defineProperty(b.prototype, d, {
            get: function() {
                return this.Fields[d];
            },
            set: function(a) {
                this.Fields[d] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, e, {
            get: function() {
                return this.Fields[e];
            },
            set: function(a) {
                this.Fields[e] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, f, {
            get: function() {
                return this.Fields[f];
            },
            set: function(a) {
                this.Fields[f] = a;
            },
            enumerable: a,
            configurable: a,
        });
        b.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(d, a.Result);
            a.SetSerializedField(e, a.ResponseTime);
            a.SetSerializedField(f, a.Error);
        };
        return b;
    })(i);
    j.OneDriveCatalogGetAccessTokenUsageData = k;
    var m = (function(c) {
        __extends(b, c);
        function b() {
            c.call(this, 'OneDriveCatalogGetManifests');
        }
        Object.defineProperty(b.prototype, d, {
            get: function() {
                return this.Fields[d];
            },
            set: function(a) {
                this.Fields[d] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, e, {
            get: function() {
                return this.Fields[e];
            },
            set: function(a) {
                this.Fields[e] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, f, {
            get: function() {
                return this.Fields[f];
            },
            set: function(a) {
                this.Fields[f] = a;
            },
            enumerable: a,
            configurable: a,
        });
        b.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(d, a.Result);
            a.SetSerializedField(e, a.ResponseTime);
            a.SetSerializedField(f, a.Error);
        };
        return b;
    })(i);
    j.OneDriveCatalogGetManifestsUsageData = m;
    var n = (function(g) {
        var b = 'id';
        __extends(c, g);
        function c() {
            g.call(this, 'OneDriveCatalogGetManifest');
        }
        Object.defineProperty(c.prototype, b, {
            get: function() {
                return this.Fields[b];
            },
            set: function(a) {
                this.Fields[b] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, d, {
            get: function() {
                return this.Fields[d];
            },
            set: function(a) {
                this.Fields[d] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, e, {
            get: function() {
                return this.Fields[e];
            },
            set: function(a) {
                this.Fields[e] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(c.prototype, f, {
            get: function() {
                return this.Fields[f];
            },
            set: function(a) {
                this.Fields[f] = a;
            },
            enumerable: a,
            configurable: a,
        });
        c.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(b, a.id);
            a.SetSerializedField(d, a.Result);
            a.SetSerializedField(e, a.ResponseTime);
            a.SetSerializedField(f, a.Error);
        };
        return c;
    })(i);
    j.OneDriveCatalogGetManifestUsageData = n;
    var l = (function(c) {
        __extends(b, c);
        function b() {
            c.call(this, 'OneDriveCatalogInsertManifest');
        }
        Object.defineProperty(b.prototype, d, {
            get: function() {
                return this.Fields[d];
            },
            set: function(a) {
                this.Fields[d] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, e, {
            get: function() {
                return this.Fields[e];
            },
            set: function(a) {
                this.Fields[e] = a;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, f, {
            get: function() {
                return this.Fields[f];
            },
            set: function(a) {
                this.Fields[f] = a;
            },
            enumerable: a,
            configurable: a,
        });
        b.prototype.SerializeFields = function() {
            var a = this;
            a.SetSerializedField(d, a.Result);
            a.SetSerializedField(e, a.ResponseTime);
            a.SetSerializedField(f, a.Error);
        };
        return b;
    })(i);
    j.OneDriveCatalogInsertManifestUsageData = l;
})(OSFLog || (OSFLog = {}));
var Telemetry;
(function(b) {
    var a = null;
    ('use strict');
    (function(a) {
        var c = 'verboseEx',
            b = 'unexpected';
        a[(a[b] = 10)] = b;
        a[(a['warning'] = 15)] = 'warning';
        a[(a['info'] = 50)] = 'info';
        a[(a['verbose'] = 100)] = 'verbose';
        a[(a[c] = 200)] = c;
    })(b.ULSTraceLevel || (b.ULSTraceLevel = {}));
    var c = b.ULSTraceLevel;
    (function(a) {
        var h = 'msoulscat_Osf_UploadFileDevCatalogUsage',
            g = 'msoulscat_Osf_UploadFileDevCatelog',
            f = 'msoulscat_Osf_InsertionDialogSession',
            e = 'msoulscat_Osf_AppManagementMenu',
            d = 'msoulscat_Osf_Runtime',
            c = 'msoulscat_Osf_Notification',
            b = 'msoulscat_Osf_Latency';
        a[(a[b] = 1401)] = b;
        a[(a[c] = 1402)] = c;
        a[(a[d] = 1403)] = d;
        a[(a[e] = 1404)] = e;
        a[(a[f] = 1405)] = f;
        a[(a[g] = 1406)] = g;
        a[(a[h] = 1411)] = h;
    })(b.ULSCat || (b.ULSCat = {}));
    var f = b.ULSCat,
        h;
    (function(a) {
        var d = 'IsAnonymous',
            c = 'InsertionDialogClosed',
            b = 'ConfirmationDialogCancel';
        a[(a[b] = 256)] = b;
        a[(a[c] = 512)] = c;
        a[(a[d] = 1024)] = d;
    })(h || (h = {}));
    var g;
    (function(a) {
        var e = 'TrustPageVisited',
            d = 'Canceled',
            c = 'Inserted',
            b = 'Undefined';
        a[(a[b] = 0)] = b;
        a[(a[c] = 1)] = c;
        a[(a[d] = 2)] = d;
        a[(a['Closed'] = 3)] = 'Closed';
        a[(a[e] = 8)] = e;
    })(g || (g = {}));
    var e = (function() {
        var a = true;
        function b() {
            this.timeValue = 0;
        }
        b.prototype.Start = function() {
            this.timeValue = -new Date().getTime();
            this.finishedMeasurement = false;
        };
        b.prototype.Stop = function() {
            if (this.timeValue < 0) {
                this.timeValue += new Date().getTime();
                this.finishedMeasurement = a;
            }
        };
        Object.defineProperty(b.prototype, 'Finished', {
            get: function() {
                return this.finishedMeasurement;
            },
            enumerable: a,
            configurable: a,
        });
        Object.defineProperty(b.prototype, 'ElapsedTime', {
            get: function() {
                var a = this.timeValue;
                if (!this.Finished && a < 0) a = Math.abs(a) - new Date().getTime();
                return a;
            },
            enumerable: a,
            configurable: a,
        });
        return b;
    })();
    b.LatencyStopwatch = e;
    var v = (function() {
        function a() {}
        return a;
    })();
    b.Context = v;
    var d = (function() {
            function a() {}
            a.SendULSTraceTag = function(a, b, d, c) {
                if (!Microsoft.Office.WebExtension.FULSSupported) return;
                Diag.UULS.trace(c, a, b, d);
            };
            return a;
        })(),
        m = (function() {
            function a() {}
            a.Instance = function() {
                if (!a.instance) a.instance = new a();
                return a.instance;
            };
            a.prototype.LogData = function(b) {
                d.SendULSTraceTag(a.category, a.level, b.SerializeRow(), 6062431);
            };
            a.category = f.msoulscat_Osf_Notification;
            a.level = c.info;
            return a;
        })();
    b.NotificationLogger = m;
    var l = (function() {
        function a() {}
        a.Instance = function() {
            if (!a.instance) a.instance = new a();
            return a.instance;
        };
        a.prototype.LogData = function(b) {
            d.SendULSTraceTag(a.category, a.level, b.SerializeRow(), 17085957);
        };
        a.category = f.msoulscat_Osf_AppManagementMenu;
        a.level = c.info;
        return a;
    })();
    b.AppManagementMenuLogger = l;
    var k = (function() {
        function a() {}
        a.Instance = function() {
            if (!a.instance) a.instance = new a();
            return a.instance;
        };
        a.prototype.LogData = function(b) {
            d.SendULSTraceTag(a.category, a.level, b.SerializeRow(), 17085958);
        };
        a.category = f.msoulscat_Osf_UploadFileDevCatelog;
        a.level = c.info;
        return a;
    })();
    b.UploadFileDevCatelogLogger = k;
    var i = (function() {
        function a() {}
        a.Instance = function() {
            if (!a.instance) a.instance = new a();
            return a.instance;
        };
        a.prototype.LogData = function(b) {
            d.SendULSTraceTag(a.category, a.level, b.SerializeRow(), 17834653);
        };
        a.category = f.msoulscat_Osf_UploadFileDevCatalogUsage;
        a.level = c.info;
        return a;
    })();
    b.UploadFileDevCatalogUsageLogger = i;
    var n = (function() {
        function a() {}
        a.Instance = function() {
            if (!a.instance) a.instance = new a();
            return a.instance;
        };
        a.prototype.LogData = function(b) {
            d.SendULSTraceTag(a.category, a.level, b.SerializeRow(), 4748055);
        };
        a.category = f.msoulscat_Osf_Latency;
        a.level = c.info;
        return a;
    })();
    b.LatencyLogger = n;
    var j = (function() {
        function a() {}
        a.Instance = function() {
            if (!a.instance) a.instance = new a();
            return a.instance;
        };
        a.prototype.LogData = function(b) {
            d.SendULSTraceTag(a.category, a.level, b.SerializeRow(), 17085959);
        };
        a.category = f.msoulscat_Osf_InsertionDialogSession;
        a.level = c.info;
        return a;
    })();
    b.InsertionDialogSessionLogger = j;
    var t = (function() {
        function a() {}
        a.LogNotification = function(c, d, b) {
            var a = new OSFLog.AppNotificationUsageData();
            a.CorrelationId = c;
            a.ErrorResult = d;
            a.NotificationClickInfo = b;
            m.Instance().LogData(a);
        };
        return a;
    })();
    b.AppNotificationHelper = t;
    var r = (function() {
        function a() {}
        a.LogAppManagementMenuAction = function(c, b, i, d, f, g) {
            var a = new OSFLog.AppManagementMenuUsageData(),
                e =
                    c.toLowerCase().indexOf('wa') === 0
                        ? parseInt(c.substring(2), 10)
                        : parseInt(c, 10);
            if (d) b |= h.InsertionDialogClosed;
            if (f) b |= h.IsAnonymous;
            a.AssetId = e;
            a.OperationMetadata = b;
            a.ErrorResult = g;
            l.Instance().LogData(a);
        };
        return a;
    })();
    b.AppManagementMenuHelper = r;
    var q = (function() {
        function a() {}
        a.LogUploadFileDevCatelogAction = function(c, b, f, e, g, d) {
            var a = new OSFLog.UploadFileDevCatelogUsageData();
            a.CorrelationId = c;
            a.OperationMetadata = b;
            a.ErrorResult = d;
            k.Instance().LogData(a);
        };
        return a;
    })();
    b.UploadFileDevCatelogHelper = q;
    var o = (function() {
        function a() {}
        a.LogUploadFileDevCatalogUsageAction = function(d, h, j, g, c, f, e, b) {
            var a = new OSFLog.UploadFileDevCatalogUsageUsageData();
            a.CorrelationId = d;
            a.StoreType = h;
            a.AppId = j;
            a.AppVersion = g;
            a.AppTargetType = c;
            a.IsAppCommand = f;
            a.AppSizeWidth = e;
            a.AppSizeHeight = b;
            i.Instance().LogData(a);
        };
        return a;
    })();
    b.UploadFileDevCatalogUsageHelper = o;
    var u = (function() {
        var p = 'Stage11Time',
            o = 'Stage10Time',
            m = 'Stage9Time',
            l = 'Stage8Time',
            k = 'Stage7Time',
            j = 'Stage5Time',
            i = 'Stage4Time',
            h = 'Stage2Time',
            g = 'Stage1Time';
        function b() {}
        b.GenerateActivationMessage = function(c, d) {
            var b = '';
            if (c != a) b += 'ActivationRuntimeType: ' + c.toString() + '|';
            if (d != a) b += 'CorrelationId: ' + d;
            return b;
        };
        b.ActivationStart = function(a, s, t, n, r, q) {
            b.activatingNumber++;
            a.LoadTime = new OSFLog.AppLoadTimeUsageData();
            a.Timers = {};
            a.LoadTime.CorrelationId = n;
            a.LoadTime.AppInfo = s;
            a.LoadTime.ActivationInfo = 0;
            a.LoadTime.InstanceId = r;
            a.LoadTime.AssetId = t;
            a.LoadTime.Stage1Time = 0;
            a.Timers[g] = new e();
            a.LoadTime.Stage2Time = 0;
            a.Timers[h] = new e();
            a.LoadTime.Stage3Time = 0;
            a.LoadTime.Stage4Time = 0;
            a.Timers[i] = new e();
            a.LoadTime.Stage5Time = 0;
            a.Timers[j] = new e();
            a.LoadTime.Stage6Time = b.activatingNumber;
            a.LoadTime.Stage7Time = 0;
            a.Timers[k] = new e();
            a.LoadTime.Stage8Time = 0;
            a.Timers[l] = new e();
            a.LoadTime.Stage9Time = 0;
            a.Timers[m] = new e();
            a.LoadTime.Stage10Time = 0;
            a.Timers[o] = new e();
            a.LoadTime.Stage11Time = 0;
            a.Timers[p] = new e();
            a.LoadTime.ErrorResult = 0;
            a.ActivationRuntimeType = q;
            b.StartStopwatch(a, g);
            d.SendULSTraceTag(
                f.msoulscat_Osf_Runtime,
                c.info,
                b.GenerateActivationMessage(q, n),
                19515419
            );
        };
        b.ActivationEnd = function(a) {
            b.ActivateEndInternal(a);
        };
        b.PageStart = function(a) {
            b.StartStopwatch(a, h);
        };
        b.PageLoaded = function(a) {
            b.StopStopwatch(a, h);
        };
        b.ServerCallStart = function(a) {
            b.StartStopwatch(a, i);
        };
        b.ServerCallEnd = function(a) {
            b.StopStopwatch(a, i);
        };
        b.AuthenticationStart = function(a) {
            b.StartStopwatch(a, j);
        };
        b.AuthenticationEnd = function(a) {
            b.StopStopwatch(a, j);
        };
        b.EntitlementCheckStart = function(a) {
            b.StartStopwatch(a, k);
        };
        b.EntitlementCheckEnd = function(a) {
            b.StopStopwatch(a, k);
        };
        b.KilledAppsCheckStart = function(a) {
            b.StartStopwatch(a, l);
        };
        b.KilledAppsCheckEnd = function(a) {
            b.StopStopwatch(a, l);
        };
        b.AppStateCheckStart = function(a) {
            b.StartStopwatch(a, m);
        };
        b.AppStateCheckEnd = function(a) {
            b.StopStopwatch(a, m);
        };
        b.ManifestRequestStart = function(a) {
            b.StartStopwatch(a, o);
        };
        b.ManifestRequestEnd = function(a) {
            b.StopStopwatch(a, o);
        };
        b.OfficeJSStartToLoad = function(a) {
            b.StartStopwatch(a, p);
        };
        b.OfficeJSLoaded = function(a) {
            b.StopStopwatch(a, p);
        };
        b.SetAnonymousFlag = function(c, a) {
            b.SetActivationInfoField(c, b.ConvertFlagToBit(a), 2, 0);
        };
        b.SetRetryCount = function(c, a) {
            b.SetActivationInfoField(c, a, 3, 2);
        };
        b.SetManifestTrustCachedFlag = function(c, a) {
            b.SetActivationInfoField(c, b.ConvertFlagToBit(a), 2, 5);
        };
        b.SetManifestDataCachedFlag = function(c, a) {
            b.SetActivationInfoField(c, b.ConvertFlagToBit(a), 2, 7);
        };
        b.SetOmexHasEntitlementFlag = function(c, a) {
            b.SetActivationInfoField(c, b.ConvertFlagToBit(a), 2, 9);
        };
        b.SetManifestDataInvalidFlag = function(c, a) {
            b.SetActivationInfoField(c, b.ConvertFlagToBit(a), 2, 11);
        };
        b.SetAppStateDataCachedFlag = function(c, a) {
            b.SetActivationInfoField(c, b.ConvertFlagToBit(a), 2, 13);
        };
        b.SetAppStateDataInvalidFlag = function(c, a) {
            b.SetActivationInfoField(c, b.ConvertFlagToBit(a), 2, 15);
        };
        b.SetActivationRuntimeType = function(c, a) {
            b.SetActivationInfoField(c, a, 2, 17);
        };
        b.SetErrorResult = function(a, c) {
            if (a.LoadTime) {
                a.LoadTime.ErrorResult = c;
                b.ActivateEndInternal(a);
            }
        };
        b.SetBit = function(a, e, d, c) {
            b.SetActivationInfoField(a, e, c || 2, d);
        };
        b.StartStopwatch = function(a, c) {
            if (a.LoadTime && a.Timers && a.Timers[c]) {
                a.Timers[c].Start();
                b.UpdateActivatingNumber(a);
            }
        };
        b.StopStopwatch = function(a, c) {
            if (a.LoadTime && a.Timers && a.Timers[c]) {
                a.Timers[c].Stop();
                b.UpdateActivatingNumber(a);
            }
        };
        b.ConvertFlagToBit = function(a) {
            if (a) return 2;
            else return 1;
        };
        b.SetActivationInfoField = function(a, e, c, d) {
            if (a.LoadTime) {
                b.UpdateActivatingNumber(a);
                a.LoadTime.ActivationInfo = b.SetBitField(a.LoadTime.ActivationInfo, e, c, d);
            }
        };
        b.SetBitField = function(d, e, c, a) {
            var f = (Math.pow(2, c) - 1) << a,
                b = d & ~f;
            return b | (e << a);
        };
        b.UpdateActivatingNumber = function(a) {
            if (a.LoadTime)
                a.LoadTime.Stage6Time =
                    a.LoadTime.Stage6Time > b.activatingNumber
                        ? a.LoadTime.Stage6Time
                        : b.activatingNumber;
        };
        b.ActivateEndInternal = function(e) {
            if (e.LoadTime) {
                b.StopStopwatch(e, g);
                if (e.Timers)
                    for (var h in e.Timers)
                        if (e.Timers[h].ElapsedTime != a) e.LoadTime[h] = e.Timers[h].ElapsedTime;
                d.SendULSTraceTag(
                    f.msoulscat_Osf_Runtime,
                    c.info,
                    b.GenerateActivationMessage(e.ActivationRuntimeType, e.LoadTime.CorrelationId),
                    19515420
                );
                n.Instance().LogData(e.LoadTime);
                e.LoadTime = a;
                b.activatingNumber--;
            }
        };
        b.activatingNumber = 0;
        return b;
    })();
    b.AppLoadTimeHelper = u;
    var s = (function() {
        var e = ' AppCorrelationId:';
        function b() {}
        b.LogProxyFailure = function(f, h, g) {
            var e;
            if (f == a) f = '';
            e = OSF.OUtil.formatString('appCorrelationId:{0}, methodName:{1}', f, h);
            Object.keys(g).forEach(function(c) {
                var b = g[c];
                if (b != a) b = b.toString();
                e += ', ' + c + ':' + b;
            });
            d.SendULSTraceTag(b.category, c.warning, e, 6062432);
        };
        b.LogExceptionTag = function(i, f, h, j) {
            var g = i;
            if (f) {
                if (f.name) g += ' Exception name:' + f.name + '.';
                if (f.paramName) g += ' Param name:' + f.paramName + '.';
                if (f.message) g += ' Message:' + f.message + '.';
                if (f.stack) g += ' [Stack:' + f.stack + ']';
            }
            if (h != a) g += e + h + '.';
            d.SendULSTraceTag(b.category, c.warning, g, j);
        };
        b.LogCommonMessageTag = function(g, f, h) {
            if (f != a) g += e + f + '.';
            d.SendULSTraceTag(b.category, c.info, g, h);
        };
        b.category = f.msoulscat_Osf_Runtime;
        return b;
    })();
    b.RuntimeTelemetryHelper = s;
    var p = (function() {
        function a() {}
        a.LogInsertionDialogSession = function(c, f, d, k, i, e) {
            var a = new OSFLog.InsertionDialogSessionUsageData(),
                h =
                    c.toLowerCase().indexOf('wa') === 0
                        ? parseInt(c.substring(2), 10)
                        : parseInt(c, 10),
                b = g.Undefined;
            if (k) b |= g.Inserted;
            else b |= g.Canceled;
            if (d > 0) b |= g.TrustPageVisited;
            a.AssetId = h;
            a.TotalSessionTime = f;
            a.TrustPageSessionTime = d;
            a.DialogState = b;
            a.LastActiveTab = i;
            a.LastActiveTabCount = e;
            j.Instance().LogData(a);
        };
        return a;
    })();
    b.InsertionDialogSessionHelper = p;
})(Telemetry || (Telemetry = {}));
var _omexXmlNamespaces =
    'xmlns="urn:schemas-microsoft-com:office:office" xmlns:o="urn:schemas-microsoft-com:office:office"';
OSF.AppVersion = {
    access: 'ZAC150',
    excel: 'ZXL150',
    excelwebapp: 'WAE160',
    outlook: 'ZOL150',
    outlookwebapp: 'MOW150',
    powerpoint: 'ZPP151',
    powerpointwebapp: 'WAP160',
    project: 'ZPJ150',
    word: 'ZWD150',
    wordwebapp: 'WAW160',
    onenotewebapp: 'WAO160',
};
OSF.AppSubType = { Taskpane: 1, Content: 2, Contextual: 3, Dictionary: 4 };
OSF.ClientAppInfoReturnType = { urlOnly: 0, etokenOnly: 1, both: 2 };
function _getAppSubType(b) {
    var a;
    if (b === 0) a = OSF.AppSubType.Content;
    else if (b === 1) a = OSF.AppSubType.Taskpane;
    else throw OsfMsAjaxFactory.msAjaxError.argument('officeExtentionTarget');
    return a;
}
function _getAppVersion(b) {
    var a = OSF.AppVersion[b.toLowerCase()];
    if (typeof a == 'undefined') throw OsfMsAjaxFactory.msAjaxError.argument('applicationName');
    return a;
}
function _invokeCallbackTag(g, h, l, k, a, m) {
    var b = k;
    if (g) {
        try {
            var d = { status: h, result: l, failureInfo: null },
                e = function(a, c, b) {
                    if (a.failureInfo === null) a.failureInfo = {};
                    a.failureInfo[c] = b;
                };
            if (a) {
                var f = -1;
                if (a.get_statusCode) f = a.get_statusCode();
                if (!b)
                    if (a.get_timedOut && a.get_timedOut()) b = 'Request timed out.';
                    else if (a.get_aborted && a.get_aborted()) b = 'Request aborted.';
                if (f >= 400 || h === statusCode.Failed || b) {
                    e(d, 'statusCode', f);
                    e(d, 'tagId', m);
                    var c = a.get_webRequest();
                    if (c) {
                        c.getResolvedUrl && e(d, 'url', c.getResolvedUrl());
                        if (
                            a.getResponseHeader &&
                            c.get_userContext &&
                            c.get_userContext() &&
                            !c.get_userContext().correlationId
                        ) {
                            var j = a.getResponseHeader('X-CorrelationId');
                            e(d, 'correlationId', j);
                        }
                    }
                }
            }
            if (b) {
                e(d, 'message', b);
                OsfMsAjaxFactory.msAjaxDebug.trace(b);
            }
        } catch (i) {
            OsfMsAjaxFactory.msAjaxDebug.trace('Encountered exception with logging: ' + i);
        }
        g(d);
    }
}
var _serviceEndPoint = null,
    _defaultRefreshRate = 3,
    _msPerDay = 8.64e7,
    _defaultTimeout = 6e4,
    _officeVersionHeader = 'X-Office-Version',
    _hourToDayConversionFactor = 24,
    _buildParameter = '&build=',
    _expectedVersionParameter = '&expver=',
    _queryStringParameters = { clientName: 'client', clientVersion: 'cv' },
    statusCode = { Succeeded: 1, Failed: 0 };
function _sendWebRequest(c, h, d, g, b, e) {
    b = b || {};
    var a = new Sys.Net.WebRequest();
    for (var f in d) a.get_headers()[f] = d[f];
    if (b) {
        if (b.officeVersion) a.get_headers()[_officeVersionHeader] = b.officeVersion;
        if (b.correlationId && c.indexOf('?') > -1) c += '&corr=' + b.correlationId;
    }
    e && a.set_body(e);
    a.set_url(c);
    a.set_httpVerb(h);
    a.set_timeout(_defaultTimeout);
    a.set_userContext(b);
    a.add_completed(g);
    a.invoke();
}
function _onCompleted(a, g) {
    var b = null,
        c = a.get_webRequest().get_userContext(),
        d = a.get_webRequest().get_url();
    if (a.get_timedOut()) {
        OsfMsAjaxFactory.msAjaxDebug.trace('Request timed out: ' + d);
        _invokeCallbackTag(c.callback, statusCode.Failed, b, b, a, 8757955);
    } else if (a.get_aborted()) {
        OsfMsAjaxFactory.msAjaxDebug.trace('Request aborted: ' + d);
        _invokeCallbackTag(c.callback, statusCode.Failed, b, b, a, 8757956);
    } else if (a.get_responseAvailable())
        if (a.get_statusCode() == 200)
            try {
                c._onCompleteHandler(a, g);
            } catch (f) {
                OsfMsAjaxFactory.msAjaxDebug.trace('Request failed with exception ' + f + ': ' + d);
                _invokeCallbackTag(c.callback, statusCode.Failed, f, b, a, 8757957);
            }
        else {
            var e = a.get_statusText();
            OsfMsAjaxFactory.msAjaxDebug.trace('Request failed with status code ' + e + ': ' + d);
            _invokeCallbackTag(c.callback, statusCode.Failed, e, b, a, 8757958);
        }
    else {
        OsfMsAjaxFactory.msAjaxDebug.trace('Request failed: ' + d);
        _invokeCallbackTag(c.callback, statusCode.Failed, e, b, a, 8757959);
    }
}
function _isProxyReady(b, a) {
    a && a({ status: statusCode.Succeeded, result: true });
}
function _createQueryStringFragment(b) {
    var c = '';
    for (var d in b) {
        var a = b[d];
        if (a === null || a === undefined || a === '') continue;
        c += '&' + encodeURIComponent(d) + '=' + encodeURIComponent(a);
    }
    return c;
}
OSF.HostSpecificFileVersionDefault = '16.00';
OSF.HostSpecificFileVersionMap = {
    access: { web: '16.00' },
    agavito: { winrt: '16.00' },
    excel: { ios: '16.00', mac: '16.00', web: '16.00', win32: '16.01', winrt: '16.00' },
    onenote: { web: '16.00', win32: '16.00', winrt: '16.00' },
    outlook: { ios: '16.00', mac: '16.00', web: '16.01', win32: '16.02' },
    powerpoint: { ios: '16.00', mac: '16.00', web: '16.00', win32: '16.01', winrt: '16.00' },
    project: { win32: '16.00' },
    sway: { web: '16.00' },
    word: { ios: '16.00', mac: '16.00', web: '16.00', win32: '16.01', winrt: '16.00' },
};
OSF.HostType = {
    Excel: 'Excel',
    Outlook: 'Outlook',
    Access: 'Access',
    PowerPoint: 'PowerPoint',
    Word: 'Word',
    Sway: 'Sway',
    OneNote: 'OneNote',
};
OSF.ManifestHostType = {
    Workbook: 'Workbook',
    Document: 'Document',
    Presentation: 'Presentation',
    Notebook: 'Notebook',
    Mailbox: 'Mailbox',
};
OSF.HostPlatform = { Web: 'Web' };
OSF.getAppVerCode = function(c) {
    var b = 'Invalid appName.',
        a;
    switch (c) {
        case OSF.AppName.ExcelWebApp:
            a = 'excel.exe';
            break;
        case OSF.AppName.AccessWebApp:
            a = 'ZAC';
            break;
        case OSF.AppName.PowerpointWebApp:
            a = 'WAP';
            break;
        case OSF.AppName.WordWebApp:
            a = 'WAW';
            break;
        case OSF.AppName.OneNoteWebApp:
            a = 'WAO';
            break;
        default:
            OsfMsAjaxFactory.msAjaxDebug.trace(b);
            throw b;
    }
    return a;
};
OSF.getModernAppVerCode = function(c) {
    var b = 'Invalid appName.',
        a;
    switch (c) {
        case OSF.AppName.ExcelWebApp:
            a = 'WAC_Excel';
            break;
        case OSF.AppName.PowerpointWebApp:
            a = 'WAC_PowerPoint';
            break;
        case OSF.AppName.WordWebApp:
            a = 'WAC_Word';
            break;
        case OSF.AppName.OneNoteWebApp:
            a = 'WAC_OneNote';
            break;
        case OSF.AppName.OutlookWebApp:
            a = 'WAC_Outlook';
            break;
        default:
            OsfMsAjaxFactory.msAjaxDebug.trace(b);
            throw b;
    }
    return a;
};
OSF.getManifestHostType = function(b) {
    var a;
    switch (b) {
        case OSF.HostType.Excel:
            a = OSF.ManifestHostType.Workbook;
            break;
        case OSF.HostType.Word:
            a = OSF.ManifestHostType.Document;
            break;
        case OSF.HostType.PowerPoint:
            a = OSF.ManifestHostType.Presentation;
            break;
        case OSF.HostType.OneNote:
            a = OSF.ManifestHostType.Notebook;
            break;
        case OSF.HostType.Outlook:
            a = OSF.ManifestHostType.Mailbox;
        default:
            OsfMsAjaxFactory.msAjaxDebug.trace('Invalid host type.');
            throw 'Invalid hostType.';
    }
    return a;
};
OSF.Capability = {
    Mailbox: 'Mailbox',
    Document: 'Document',
    Workbook: 'Workbook',
    Project: 'Project',
    Presentation: 'Presentation',
    Database: 'Database',
    Sway: 'Sway',
    Notebook: 'Notebook',
};
OSF.HostCapability = {
    Excel: OSF.Capability.Workbook,
    Outlook: OSF.Capability.Mailbox,
    Access: OSF.Capability.Database,
    PowerPoint: OSF.Capability.Presentation,
    Word: OSF.Capability.Document,
    Sway: OSF.Capability.Sway,
    OneNote: OSF.Capability.Notebook,
};
OSF.OsfControlTarget = { Undefined: -1, InContent: 0, TaskPane: 1, Contextual: 2 };
OSF.OsfControlPermission = {
    Restricted: 1,
    ReadDocument: 2,
    WriteDocument: 4,
    ReadItem: 32,
    ReadWriteMailbox: 64,
    ReadAllDocument: 131,
    ReadWriteDocument: 135,
};
OSF.OsfControlStatus = {
    NotActivated: 1,
    Activated: 2,
    AppStoreNotReachable: 3,
    InvalidOsfControl: 4,
    UnsupportedStore: 5,
    UnknownStore: 6,
    ActivationFailed: 7,
    NotSandBoxSupported: 8,
};
OSF.OsfControlPageStatus = {
    NotStarted: 1,
    Loading: 2,
    Ready: 3,
    FailedHandleRequest: 4,
    FailedOriginCheck: 5,
    FailedPermissionCheck: 6,
};
OSF.StoreType = {
    OMEX: 'omex',
    SPCatalog: 'spcatalog',
    SPApp: 'spapp',
    Exchange: 'exchange',
    FileSystem: 'filesystem',
    Registry: 'registry',
    InMemory: 'inmemory',
    OneDrive: 'onedrive',
    PrivateCatalog: 'excatalog',
    HardCodedPreinstall: 'hardcodedpreinstall',
    FirstParty: 'firstparty',
    UploadFileDevCatalog: 'uploadfiledevcatalog',
    Sdx: 'sdxcatalog',
};
OSF.StoreTypeEnum = {
    MarketPlace: 0,
    Catalog: 1,
    SPApp: 2,
    Exchange: 3,
    FileSystem: 4,
    Registry: 5,
    OneDrive: 9,
    PrivateCatalog: 10,
    HardCodedPreinstall: 11,
    FirstParty: 12,
    Sdx: 14,
    UploadFileDevCatalog: 15,
};
OSF.ManifestIdIssuer = { Microsoft: 'Microsoft', Custom: 'Custom' };
OSF.OmexClientAppStatus = {
    OK: 1,
    UnknownAssetId: 2,
    KilledAsset: 3,
    NoEntitlement: 4,
    DownloadsExceeded: 5,
    Expired: 6,
    Invalid: 7,
    Revoked: 8,
    ServerError: 9,
    BadRequest: 10,
    LimitedTrial: 11,
    TrialNotSupported: 12,
    EntitlementDeactivated: 13,
    VersionMismatch: 14,
    VersionNotSupported: 15,
    UserIsMinor: 16,
};
OSF.OmexState = { Killed: 0, OK: 1, Withdrawn: 2, Flagged: 3, DeveloperWithdrawn: 4 };
OSF.OmexTrialType = { None: 0, Office: 1, External: 2 };
OSF.OmexEntitlementType = { Free: 'free', Trial: 'trial', Paid: 'paid' };
OSF.OmexAuthNStatus = {
    NotAttempted: -1,
    CheckFailed: 0,
    Authenticated: 1,
    Anonymous: 2,
    Unknown: 3,
};
OSF.OmexRemoveAppStatus = { Failed: 0, Success: 1 };
OSF.OfficeAppType = {
    ContentApp: OSF.OsfControlTarget.InContent,
    TaskPaneApp: OSF.OsfControlTarget.TaskPane,
    MailApp: OSF.OsfControlTarget.Contextual,
};
OSF.FormFactor = {
    Default: 'DefaultSettings',
    Desktop: 'DesktopSettings',
    Tablet: 'TabletSettings',
    Phone: 'PhoneSettings',
};
OSF.OsfOfficeExtensionManagerPerfMarker = {
    GetEntitlementStart: 'Agave.OfficeExtensionManager.GetEntitlementStart',
    GetEntitlementEnd: 'Agave.OfficeExtensionManager.GetEntitlementEnd',
};
OSF.OsfControlActivationPerfMarker = {
    ActivationStart: 'Agave.AgaveActivationStart',
    ActivationEnd: 'Agave.AgaveActivationEnd',
    DeactivationStart: 'Agave.AgaveDeactivationStart',
    DeactivationEnd: 'Agave.AgaveDeactivationEnd',
    SelectionTimeout: 'Agave.AgaveSelectionTimeout',
};
OSF.NotificationUxPerfMarker = {
    RenderLoadingAnimationStart: 'Agave.NotificationUx.RenderLoadingAnimationStart',
    RenderLoadingAnimationEnd: 'Agave.NotificationUx.RenderLoadingAnimationEnd',
    RemoveLoadingAnimationStart: 'Agave.NotificationUx.RemoveLoadingAnimationStart',
    RemoveLoadingAnimationEnd: 'Agave.NotificationUx.RemoveLoadingAnimationEnd',
    RenderStage1Start: 'Agave.NotificationUx.RenderStage1Start',
    RenderStage1End: 'Agave.NotificationUx.RenderStage1End',
    RemoveStage1Start: 'Agave.NotificationUx.RemoveStage1Start',
    RemoveStage1End: 'Agave.NotificationUx.RemoveStage1End',
    RenderStage2Start: 'Agave.NotificationUx.RenderStage2Start',
    RenderStage2End: 'Agave.NotificationUx.RenderStage2End',
    RemoveStage2Start: 'Agave.NotificationUx.RemoveStage2Start',
    RemoveStage2End: 'Agave.NotificationUx.RemoveStage2End',
};
OSF.ProxyCallStatusCode = { Succeeded: 1, Failed: 0, ProxyNotReady: -1 };
OSF.ClientAppInfoReturnType = { urlOnly: 0, etokenOnly: 1, both: 2 };
OSF.SQMDataPoints = { DATAID_APPSFOROFFICEUSAGE: 10595, DATAID_APPSFOROFFICENOTIFICATIONS: 10942 };
OSF.BWsaStreamTypes = { Static: 1 };
OSF.BWsaConfig = { defaultMaxStreamRows: 1e3 };
OSF.ErrorStatusCodes = {
    E_OEM_EXTENSION_NOT_ENTITLED: 2147758662,
    E_MANIFEST_SERVER_UNAVAILABLE: 2147758672,
    E_USER_NOT_SIGNED_IN: 2147758677,
    E_MANIFEST_DOES_NOT_EXIST: 2147758673,
    E_OEM_EXTENSION_KILLED: 2147758660,
    E_OEM_OMEX_EXTENSION_KILLED: 2147758686,
    E_MANIFEST_UPDATE_AVAILABLE: 2147758681,
    S_OEM_EXTENSION_TRIAL_MODE: 275013,
    E_OEM_EXTENSION_WITHDRAWN_FROM_SALE: 2147758690,
    E_TOKEN_EXPIRED: 2147758675,
    E_TRUSTCENTER_CATALOG_UNTRUSTED_ADMIN_CONTROLLED: 2147757992,
    E_MANIFEST_REFERENCE_INVALID: 2147758678,
    S_USER_CLICKED_BUY: 274205,
    E_MANIFEST_INVALID_VALUE_FORMAT: 2147758654,
    E_TRUSTCENTER_MOE_UNACTIVATED: 2147757996,
    S_OEM_EXTENSION_FLAGGED: 275040,
    S_OEM_EXTENSION_DEVELOPER_WITHDRAWN_FROM_SALE: 275041,
    E_BROWSER_VERSION: 2147758194,
    E_TRUSTCENTER_APP_BLOCKED_FOR_MINOR: -2147209295,
    WAC_AgaveUnsupportedStoreType: 1041,
    WAC_AgaveActivationError: 1042,
    WAC_ActivateAttempLoading: 1043,
    WAC_HTML5IframeSandboxNotSupport: 1044,
    WAC_AgaveRequirementsErrorOmex: 1045,
    WAC_AgaveRequirementsError: 1046,
    WAC_AgaveOriginCheckError: 1047,
    WAC_AgavePermissionCheckError: 1048,
    WAC_AgaveHostHandleRequestError: 1049,
    WAC_AgaveUnknownClientAppStatus: 1050,
    WAC_AgaveAnonymousProxyCreationError: 1051,
    WAC_AgaveOsfControlActivationError: 1052,
    WAC_AgaveEntitlementRequestFailure: 1053,
    WAC_AgaveManifestRequestFailure: 1054,
    WAC_AgaveManifestAndEtokenRequestFailure: 1055,
    WAC_FirstPartyAddInListRequestFailure: 1056,
    WAC_SSOAddinRequireConsent: 1057,
};
OSF.InvokeResultCode = {
    S_OK: 0,
    E_REQUEST_TIME_OUT: -2147471590,
    E_USER_NOT_SIGNED_IN: -2147208619,
    E_CATALOG_ACCESS_DENIED: -2147471591,
    E_CATALOG_REQUEST_FAILED: -2147471589,
    E_OEM_NO_NETWORK_CONNECTION: -2147208640,
    E_PROVIDER_NOT_REGISTERED: -2147208617,
    E_OEM_CACHE_SHUTDOWN: -2147208637,
    E_OEM_REMOVED_FAILED: -2147209421,
    E_CATALOG_NO_APPS: -1,
    E_GENERIC_ERROR: -1e3,
    S_HIDE_PROVIDER: 10,
};
OSF.OmexClientNames = (function() {
    var a = {},
        b = OSF.AppName;
    a[b.ExcelWebApp] = 'WAC_Excel';
    a[b.WordWebApp] = 'WAC_Word';
    a[b.OutlookWebApp] = 'WAC_Outlook';
    a[b.AccessWebApp] = 'WAC_Access';
    a[b.PowerpointWebApp] = 'WAC_Powerpoint';
    a[b.OneNoteWebApp] = 'WAC_OneNote';
    return a;
})();
OSF.OmexAppVersions = (function() {
    var a = {},
        b = OSF.AppName;
    a[b.ExcelWebApp] = OSF.AppVersion.excelwebapp;
    a[b.WordWebApp] = OSF.AppVersion.wordwebapp;
    a[b.OutlookWebApp] = OSF.AppVersion.outlookwebapp;
    a[b.AccessWebApp] = OSF.AppVersion.access;
    a[b.PowerpointWebApp] = OSF.AppVersion.powerpointwebapp;
    a[b.OneNoteWebApp] = OSF.AppVersion.onenotewebapp;
    return a;
})();
OSF.ActivationTypes = { V1Enabled: 0, V1S2SEnabled: 1, V2Enabled: 2, V2S2SEnabled: 3 };
OSF.ManifestRequestTypes = { Manifest: 1, Etoken: 2, Both: 3 };
var OfficeExt;
(function(b) {
    var a = null,
        d = (function() {
            function b() {}
            b.versionLessThan = function(a, b) {
                return OSF.OsfManifestManager.versionLessThan(a, b);
            };
            b.ParseManifest = function(e, d, c) {
                try {
                    return new OSF.Manifest.Manifest(e, d);
                } catch (b) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Invalid manifest:',
                        b,
                        c,
                        20306078
                    );
                    return a;
                }
            };
            return b;
        })();
    b.ManifestUtil = d;
    var e = (function() {
        function c() {}
        c.failed = function(c, f, d) {
            if (c.status != b.DataServiceResultCode.Succeeded) {
                var e = { status: c.status, httpStatus: c.httpStatus };
                if (d != a) e.value = d;
                f(e);
                return true;
            }
            return false;
        };
        return c;
    })();
    b.AsyncUtil = e;
    var c = (function() {
        function b() {}
        b.register = function(a, b) {
            this._registry[a] = b;
        };
        b.resolve = function(e, b) {
            var d = this,
                c = d._resolved[e];
            if (c != a) return c;
            b = b || d._hostInfo;
            if (b != a) {
                var f = d._registry[e];
                if (f == a) return a;
                d._resolved[e] = c = f(b);
            }
            return c;
        };
        b.setHostContext = function(a) {
            this._hostInfo = a;
        };
        b.getHostContext = function() {
            return this._hostInfo;
        };
        b._registry = {};
        b._resolved = {};
        return b;
    })();
    b.CatalogFactory = c;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        function b(a) {
            this._initParams = a;
        }
        b.prototype.getEntitlementAsync = function(c, d, b) {
            b({ status: a.DataServiceResultCode.Failed, httpStatus: 403 });
        };
        b.prototype.getAndCacheManifest = function(e, c, d, b) {
            b({ status: a.DataServiceResultCode.Failed, httpStatus: 404 });
        };
        b.prototype.activateAsync = function(e, c) {
            var b = this;
            if (b._initParams && b._initParams.loaderParams)
                if (b._initParams.controlStatus === OSF.OsfControlStatus.ActivationFailed)
                    c.fail(b._initParams.loaderParams, b._initParams.controlStatus);
                else c.notifyUser(b._initParams.loaderParams);
            else
                c.fail(
                    a.LoaderUtil.error({
                        description: Strings.OsfRuntime.L_AgaveActivationError_ERR,
                        errorCode: OSF.ErrorStatusCodes.WAC_AgaveActivationError,
                    }),
                    OSF.OsfControlStatus.ActivationFailed
                );
        };
        b.prototype.removeAsync = function(d, c, b) {
            b({ status: a.DataServiceResultCode.Failed, httpStatus: 403 });
        };
        b.prototype.getAppDetails = function(e, d, c, b) {
            b({ status: a.DataServiceResultCode.Failed, httpStatus: 403 });
        };
        return b;
    })();
    a.ForbiddenCatalog = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var a = (function() {
        var c = true,
            a = null;
        function b() {}
        b.defaultTitle = function(a) {
            switch (a) {
                case OSF.InfoType.Information:
                    return Strings.OsfRuntime.L_AgaveInformationTitle_TXT;
                case OSF.InfoType.Error:
                    return Strings.OsfRuntime.L_AgaveErrorTile_TXT;
                case OSF.InfoType.Warning:
                    return Strings.OsfRuntime.L_AgaveWarningTitle_TXT;
            }
            return Strings.OsfRuntime.L_AgaveInformationTitle_TXT;
        };
        b.fillMissing = function(d) {
            var e = false;
            d.infoType = b.isNullOrUndefined(d.infoType) ? OSF.InfoType.Information : d.infoType;
            d.title = d.title || b.defaultTitle(d.infoType);
            d.buttonTxt = d.buttonTxt || Strings.OsfRuntime.L_OkButton_TXT;
            d.buttonCallback = d.buttonCallback || a;
            d.url = d.url || a;
            d.urlButtonTxt = d.urlButtonTxt || a;
            d.dismissCallback = d.dismissCallback || a;
            d.reDisplay = !d.dismissCallback ? c : e;
            d.displayDeactive = d.displayDeactive != a ? d.displayDeactive : c;
            d.detailView = d.detailView || e;
            d.logAsError = d.logAsError || e;
            d.highPriority = d.highPriority || e;
            d.retryAll = d.retryAll || e;
            d.errorCode = d.errorCode ? d.errorCode : 0;
            return d;
        };
        b.error = function(d) {
            d.infoType = b.isNullOrUndefined(d.infoType) ? OSF.InfoType.Error : d.infoType;
            d.logAsError = d.logAsError != a ? d.logAsError : c;
            return b.fillMissing(d);
        };
        b.warning = function(d) {
            d.infoType = b.isNullOrUndefined(d.infoType) ? OSF.InfoType.Warning : d.infoType;
            d.logAsError = d.logAsError != a ? d.logAsError : c;
            return b.fillMissing(d);
        };
        b.showNotification = function(a, c) {
            a.notifyUser(b.fillMissing(c));
        };
        b.showError = function(a, c) {
            a.notifyUser(b.error(c));
        };
        b.showWarning = function(a, c) {
            a.notifyUser(b.warning(c));
        };
        b.failWithWarning = function(c, d, a) {
            a = b.isNullOrUndefined(a) ? OSF.OsfControlStatus.ActivationFailed : a;
            c.fail(b.warning(d), a);
        };
        b.failWithError = function(c, d, a) {
            a = b.isNullOrUndefined(a) ? OSF.OsfControlStatus.ActivationFailed : a;
            c.fail(b.error(d), a);
        };
        b.isNullOrUndefined = function(b) {
            return b === a || typeof b === 'undefined';
        };
        return b;
    })();
    b.LoaderUtil = a;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        var c = true;
        function b(b, a) {
            this.osfControl = b;
            this.trusted = a;
        }
        b.prototype.getRequirementsChecker = function() {
            return this.osfControl._contextActivationMgr.getRequirementsChecker();
        };
        b.prototype.load = function(h, g) {
            var d = null,
                f = this;
            if (
                f.osfControl.getReason() ==
                Microsoft.Office.WebExtension.InitializationReason.Inserted
            ) {
                f.osfControl._retryActivate = d;
                f.osfControl._contextActivationMgr.retryAll(h.entitlement.assetId);
            }
            f.osfControl._status !== OSF.OsfControlStatus.NotActivated && f.osfControl.deActivate();
            var e = h.manifest,
                b = f.osfControl;
            b._etoken = h.eToken;
            b._manifest = e;
            if (b._sourceLocationOverrideResourceId)
                b._iframeUrl = e.getSourceLocationOverrideByResourceId(
                    b._sourceLocationOverrideResourceId
                );
            else b._iframeUrl = e.getDefaultSourceLocation(b._contextActivationMgr.getFormFactor());
            if (b.getStoreType() === OSF.StoreType.Sdx && b._iframeUrl)
                if (h.manifestUrl !== d) {
                    var i = h.manifestUrl.lastIndexOf('/');
                    if (i !== -1) {
                        var j = h.manifestUrl.substr(0, i) + '/index.html';
                        b.updateUrlsForSdxBundle(j);
                    }
                }
            b._permission = e.getPermission();
            b._appDomains = e.getAppDomains();
            b.processManifestForCustomFunctions(e);
            if (g != d) b._iframeUrl = g.decorateUrl(b._iframeUrl);
            if (!b._contextActivationMgr._doesUrlHaveSupportedProtocol(b._iframeUrl)) {
                a.LoaderUtil.failWithError(f, {
                    description: Strings.OsfRuntime.L_AgaveManifestError_ERR,
                    detailView: c,
                    errorCode: OSF.ErrorStatusCodes.E_MANIFEST_INVALID_VALUE_FORMAT,
                });
                return;
            }
            g != d && g.preLoad(b, b._contextActivationMgr);
            var k = e.getDefaultDisplayName();
            b._isAddinCommands(function(a) {
                if (a) {
                    b._isvirtualOsfControl = c;
                    b.invokeVirtualOsfControlActivationCallback(e);
                }
                (!a || e.containsCustomFunctionsForAppHost(b._contextActivationMgr._hostType)) &&
                    b._createIframeAndActivateOsfControl(k);
            });
            g != d && g.postLoad(b, b._contextActivationMgr);
        };
        b.prototype.skipTrust = function() {
            var a = this;
            return (
                a.osfControl._contextActivationMgr._autoTrusted ||
                a.osfControl.getTrustNoPrompt() ||
                a.osfControl._isOsfControlInEmbeddingMode(a.osfControl)
            );
        };
        b.prototype.hasConsent = function() {
            return this.trusted || this.isInsertion();
        };
        b.prototype.isInsertion = function() {
            return (
                this.osfControl.getReason() ==
                Microsoft.Office.WebExtension.InitializationReason.Inserted
            );
        };
        b.prototype.setRetryCall = function(a) {
            this.osfControl._retryActivate = a;
        };
        b.prototype.askForTrust = function(a, b) {
            var c = this;
            this.osfControl._showTrustError(
                a.clientName,
                a.displayName,
                a.providerName,
                a.iconUrl,
                a.entitlement.storeType,
                function() {
                    c.restartActivation();
                    b();
                },
                a.url,
                a.isSSOAddin
            );
        };
        b.prototype.askForUpgrade = function(a, b) {
            var c = this;
            a.buttonCallback = function() {
                c.restartActivation();
                b();
            };
            this.notifyUser(a);
        };
        b.prototype.askForConsentForSideloadAddin = function(d, a) {
            var b = this;
            this.osfControl._manifest = d;
            this.osfControl._isAddinCommands(function(d) {
                if (d) b.osfControl.showConsentError(a, OSF.NotificationType.ConsentWhiteDialog, c);
                else b.osfControl.showConsentError(a, OSF.NotificationType.ConsentYellowBar, c);
            });
        };
        b.prototype.fail = function(c, b) {
            var a = this.osfControl;
            a._status = b;
            this.notifyUser(c);
            a._contextActivationMgr.raiseOsfControlStatusChange(a);
        };
        b.prototype.notifyUser = function(b) {
            var a = this.osfControl;
            b.id = a._id;
            a._contextActivationMgr.displayNotification(b);
        };
        b.prototype.restartActivation = function() {
            this.osfControl._restartActivate();
        };
        b.prototype.isForCustomFunctionSandbox = function() {
            return this.osfControl.isCustomFunctionSandbox();
        };
        b.prototype.setIsUpgrading = function(a) {
            this.osfControl.setIsUpgrading(a);
        };
        return b;
    })();
    a.OsfControlLoader = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        function a(a) {
            this._requirementsChecker = a;
        }
        a.prototype.getRequirementsChecker = function() {
            return this._requirementsChecker;
        };
        a.prototype.load = function() {};
        a.prototype.skipTrust = function() {
            return false;
        };
        a.prototype.hasConsent = function() {
            return false;
        };
        a.prototype.setRetryCall = function() {};
        a.prototype.askForTrust = function() {};
        a.prototype.askForUpgrade = function() {};
        a.prototype.askForConsentForSideloadAddin = function() {};
        a.prototype.fail = function() {};
        a.prototype.notifyUser = function() {};
        a.prototype.restartActivation = function() {};
        a.prototype.isForCustomFunctionSandbox = function() {
            return false;
        };
        a.prototype.setIsUpgrading = function() {};
        return a;
    })();
    a.PreCacher = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        var b = null;
        function c() {
            var a = this;
            a.isReady = false;
            a.clientEndPoint = b;
            a.pendingCallbacks = [];
            a.iframe = b;
            a._pendingRequests = {};
            a.conversationId = OSF.OUtil.generateConversationId();
        }
        c.prototype.invokeProxyCommandAsync = function(h, d, c) {
            var i = this,
                e = d || d.correlationId || '',
                f = function(g) {
                    var f = g.value;
                    if (f != b) i.invokeProxyMethodAsync(h, c, d);
                    else {
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'clientendpoint is invalid',
                            b,
                            e,
                            18940552
                        );
                        c({ status: a.DataServiceResultCode.ProxyNotReady });
                    }
                },
                g = function() {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'proxysetup failure',
                        b,
                        e,
                        18940553
                    );
                    c({ status: a.DataServiceResultCode.ProxyNotReady });
                };
            this.prepareProxy(f, g);
        };
        c.prototype.prepareProxy = function() {};
        c.prototype.doesUrlHaveSupportedProtocol = function(c) {
            var a = false;
            if (c) {
                var d = decodeURIComponent(c),
                    e = d.match(/^https?:\/\/.+$/gi);
                a = e != b;
            }
            return a;
        };
        c.prototype.invokeProxyMethodAsync = function(g, o, c) {
            var n = c || c.correlationId || '',
                m = this.clientEndPoint._targetUrl,
                j = [m, g],
                e;
            for (var k in c) {
                e = typeof c[k];
                (e === 'string' || e === 'number' || e === 'boolean') && j.push(c[k]);
            }
            var f = j.join('.'),
                d = this._pendingRequests,
                i = { onCompleted: o, methodName: g, correlationId: n },
                h = d[f];
            if (!h) {
                d[f] = [i];
                var l = function(o, c) {
                    var l = b,
                        i = 0,
                        j = a.DataServiceResultCode.Failed;
                    if (o === 0 && c.status) {
                        l = c.result;
                        j = a.DataServiceResultCode.Succeeded;
                    }
                    var h = d[f];
                    delete d[f];
                    for (var n = h.length, m = 0; m < n; m++) {
                        var e = h.shift();
                        try {
                            if (c && c.failureInfo) {
                                i = c.failureInfo.statusCode || b;
                                c.failureInfo['result'] = c.result;
                                Telemetry.RuntimeTelemetryHelper.LogProxyFailure(
                                    e.correlationId,
                                    e.methodName,
                                    c.failureInfo
                                );
                            }
                            e.onCompleted({ status: j, httpStatus: i, value: l });
                        } catch (g) {
                            var k = 'invokeProxyMethodAsync failed';
                            a.WACUtils.logExceptionToBrowserConsole(k, g);
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                k,
                                g,
                                e.correlationId,
                                19015124
                            );
                        }
                    }
                };
                if (!c) c = {};
                c.officeVersion = OSF.Constants.ThreePartsFileVersion;
                this.clientEndPoint.invoke(g, l, c);
            } else h.push(i);
        };
        return c;
    })();
    a.ProxyBase = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    (function(a) {
        var h = 'ManifestRequest',
            g = 'KilledAppsCheck',
            f = 'AppStateCheck',
            e = 'EntitlementCheck',
            d = 'Authentication',
            c = 'ServerCall',
            b = 'Activation';
        a[(a[b] = 0)] = b;
        a[(a[c] = 1)] = c;
        a[(a[d] = 2)] = d;
        a[(a[e] = 3)] = e;
        a[(a[f] = 4)] = f;
        a[(a[g] = 5)] = g;
        a[(a[h] = 6)] = h;
    })(a.Activity || (a.Activity = {}));
    var f = a.Activity;
    (function(a) {
        var l = 'DmsRequestCachedFlag',
            k = 'ManifestRequestType',
            j = 'ActivationRuntimeType',
            i = 'AppStateDataInvalidFlag',
            h = 'AppStateDataCachedFlag',
            g = 'ManifestDataInvalidFlag',
            f = 'OmexHasEntitlementFlag',
            e = 'ManifestDataCachedFlag',
            d = 'ManifestTrustCachedFlag',
            c = 'RetryCount',
            b = 'AnonymousFlag';
        a[(a[b] = 0)] = b;
        a[(a[c] = 1)] = c;
        a[(a[d] = 2)] = d;
        a[(a[e] = 3)] = e;
        a[(a[f] = 4)] = f;
        a[(a[g] = 5)] = g;
        a[(a[h] = 6)] = h;
        a[(a[i] = 7)] = i;
        a[(a[j] = 8)] = j;
        a[(a[k] = 9)] = k;
        a[(a[l] = 10)] = l;
    })(a.FlagName || (a.FlagName = {}));
    var g = a.FlagName,
        d = (function() {
            function b(b, c, e, f, d) {
                var a = this;
                a.correlationId = b;
                a.perfContext = c;
                a.appInfo = e;
                a.assetId = f;
                a.instanceId = d;
            }
            b.prototype.startActivity = function(e) {
                var c = this;
                switch (e) {
                    case f.Activation:
                        var d = OSF.ActivationTypes.V2Enabled;
                        if ((c.appInfo & 15) === 0 && a.S2SOmexCatalogService._requestHandler)
                            d = OSF.ActivationTypes.V2S2SEnabled;
                        Telemetry.AppLoadTimeHelper.ActivationStart(
                            c.perfContext,
                            c.appInfo,
                            c.assetId,
                            c.correlationId,
                            c.instanceId,
                            d
                        );
                        c.setBits(g.ActivationRuntimeType, d);
                        return;
                }
                Telemetry.AppLoadTimeHelper.StartStopwatch(c.perfContext, b.StopWatchName[e]);
            };
            b.prototype.stopActivity = function(a) {
                Telemetry.AppLoadTimeHelper.StopStopwatch(this.perfContext, b.StopWatchName[a]);
            };
            b.prototype.setFlag = function(a, c) {
                var b = c ? 2 : 1;
                this.setBits(a, b);
            };
            b.prototype.setBits = function(a, c) {
                Telemetry.AppLoadTimeHelper.SetBit(this.perfContext, c, b.FlagOffsetMap[a], 2);
            };
            b.FlagOffsetMap = [0, 2, 5, 7, 9, 11, 13, 15, 17, 19, 21];
            b.StopWatchName = [
                'Stage1Time',
                'Stage4Time',
                'Stage5Time',
                'Stage7Time',
                'Stage9Time',
                'Stage8Time',
                'Stage10Time',
            ];
            return b;
        })();
    a.ActivationTelemetryContext = d;
    var b = (function() {
        function a(a) {
            this.correlationId = a;
        }
        a.prototype.startActivity = function() {};
        a.prototype.stopActivity = function() {};
        a.prototype.setFlag = function() {};
        a.prototype.setBits = function() {};
        return a;
    })();
    a.AddinCommandsTelemetryContext = b;
    var c = (function() {
        function a(a) {
            this.correlationId = a;
        }
        a.prototype.startActivity = function() {};
        a.prototype.stopActivity = function() {};
        a.prototype.setFlag = function() {};
        a.prototype.setBits = function() {};
        return a;
    })();
    a.InsertDialogTelemetryContext = c;
    var e = (function() {
        function a() {}
        a.prototype.startActivity = function() {};
        a.prototype.stopActivity = function() {};
        a.prototype.setFlag = function() {};
        a.prototype.setBits = function() {};
        return a;
    })();
    a.SimpleTelemetryContext = e;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var a = null,
        e = (function() {
            var d = '.';
            function c(d, c) {
                if (c === void 0) c = a;
                this._initParam = d;
                this._cacheManager =
                    c ||
                    new b.AppsDataCacheManager(OSF.OUtil.getLocalStorage(), new b.SafeSerializer());
            }
            c.prototype.getEntitlementAsync = function(i, k, j) {
                var c = this,
                    g = c,
                    d = [],
                    h = [],
                    f = i
                        ? c.getUploadFileDevCatalogAddinCommandsMyAddinsCacheKey()
                        : c.getUploadFileDevCatalogAddinsCacheKey(),
                    e = c._cacheManager.GetCacheItem(f);
                if (e != a) {
                    e.forEach(function(e) {
                        var f = g._cacheManager.GetCacheItem(
                            g.getUploadFileDevCatalogManifestCacheKey(e)
                        );
                        if (f != a) {
                            var c = b.ManifestUtil.ParseManifest(f, g._initParam.appUILocale);
                            if (c == a) return;
                            var i = {
                                assetId: e,
                                appVersion: c.getMarketplaceVersion(),
                                storeId: 'developer',
                                storeType: OSF.StoreType.UploadFileDevCatalog,
                                targetType: c.getTarget(),
                            };
                            h.push(i);
                            d.push(e);
                        }
                    });
                    if (d.length != e.length)
                        if (d.length > 0) c._cacheManager.SetCacheItem(f, d);
                        else c._cacheManager.RemoveCacheItem(f);
                }
                j({ status: b.DataServiceResultCode.Succeeded, value: h });
            };
            c.prototype.getAndCacheManifest = function(d, g, h, f) {
                var c = OSF.OsfManifestManager.getCachedManifest(d.assetId, d.appVersion);
                if (c != a) {
                    f({ status: b.DataServiceResultCode.Succeeded, value: c });
                    return;
                }
                if (c == a) {
                    var e = this._cacheManager.GetCacheItem(
                        this.getUploadFileDevCatalogManifestCacheKey(d.assetId)
                    );
                    if (e != a) {
                        c = b.ManifestUtil.ParseManifest(e, this._initParam.appUILocale);
                        c != a && OSF.OsfManifestManager.cacheManifest(d.assetId, d.appVersion, c);
                    }
                }
                f({
                    status:
                        c != a ? b.DataServiceResultCode.Succeeded : b.DataServiceResultCode.Failed,
                    value: c,
                });
            };
            c.prototype.activateAsync = function(d, c, e) {
                var f = this;
                this.getAndCacheManifest(d, d.storeId, e, function(g) {
                    if (g.status == b.DataServiceResultCode.Succeeded) {
                        var h = b.HostFeatureEnabledInfo.getHostFeatureEnabledInfo();
                        if (h && h.enableSingleSignOnForAddin && !c.isForCustomFunctionSandbox()) {
                            var i = g.value;
                            if (i.isSSOAddin()) {
                                var j = function() {
                                    c.load({ entitlement: d, eToken: '', manifest: g.value }, a);
                                };
                                c.askForConsentForSideloadAddin(i, j);
                                return;
                            }
                        }
                        c.load({ entitlement: d, eToken: '', manifest: g.value }, a);
                        return;
                    }
                    b.LoaderUtil.failWithError(c, {
                        description: Strings.OsfRuntime.L_AgaveManifestRetrieve_ERR,
                        buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                        buttonCallback: function() {
                            c.restartActivation();
                            f.activateAsync(d, c, e);
                        },
                        errorCode: OSF.ErrorStatusCodes.E_MANIFEST_SERVER_UNAVAILABLE,
                    });
                });
            };
            c.prototype.removeAsync = function(d, c, a) {
                a({ status: b.DataServiceResultCode.Failed });
            };
            c.prototype.getAppDetails = function(e, d, c, a) {
                a({ status: b.DataServiceResultCode.Failed });
            };
            c.prototype.validateAndCacheNewManifest = function(b, a, c, d) {
                if (this.validateAddinIdAndVersion(b, a)) {
                    this.cacheManifest(b, a, c, d);
                    return true;
                }
                return false;
            };
            c.prototype.localCacheAddinCommands = function(a) {
                this.cacheMyAddins(this.getUploadFileDevCatalogAddinCommandsMyAddinsCacheKey(), a);
            };
            c.prototype.validateAddinIdAndVersion = function(b, a) {
                return c.idRegExp.test(b) && c.versionRegExp.test(a);
            };
            c.prototype.cacheManifest = function(b, d, c, e) {
                var a = this;
                OSF.OsfManifestManager.cacheManifest(b, d, e);
                a.cacheMyAddins(a.getUploadFileDevCatalogAddinsCacheKey(), b);
                a._cacheManager.SetCacheItem(a.getUploadFileDevCatalogManifestCacheKey(b), c);
            };
            c.prototype.cacheMyAddins = function(c, d) {
                var b = this._cacheManager.GetCacheItem(c);
                if (b == a) b = [];
                if (b.lastIndexOf(d) < 0) {
                    b.push(d);
                    this._cacheManager.SetCacheItem(c, b);
                }
            };
            c.prototype.getUploadFileDevCatalogAddinsCacheKey = function() {
                return (
                    c.UploadFileCatalogCacheKey.myAddins +
                    d +
                    this._initParam.appName +
                    d +
                    this._initParam.userNameHashCode
                );
            };
            c.prototype.getUploadFileDevCatalogAddinCommandsMyAddinsCacheKey = function() {
                return (
                    c.UploadFileCatalogCacheKey.addinCommandsMyAddins +
                    d +
                    this._initParam.appName +
                    d +
                    this._initParam.userNameHashCode
                );
            };
            c.prototype.getUploadFileDevCatalogManifestCacheKey = function(a) {
                return c.UploadFileCatalogCacheKey.manifest + d + this._initParam.appName + d + a;
            };
            c.UploadFileCatalogCacheKeyPrefix = '__OSF_UPLOADFILE.';
            c.UploadFileCatalogCacheKey = {
                myAddins: c.UploadFileCatalogCacheKeyPrefix + 'MyAddins',
                addinCommandsMyAddins: c.UploadFileCatalogCacheKeyPrefix + 'AddinCommandsMyAddins',
                manifest: c.UploadFileCatalogCacheKeyPrefix + 'Manifest',
            };
            c.idRegExp = new RegExp('[\\w-]+');
            c.versionRegExp = new RegExp('(\\d{1,2}.)*\\d{1,2}');
            return c;
        })();
    b.CatalogFactory.register(OSF.StoreType.UploadFileDevCatalog, function(c) {
        if (c.enableUploadFileDevCatalog) {
            var d = new e({
                appName: c.appName,
                appUILocale: c.appUILocale,
                userNameHashCode: c.userNameHashCode,
            });
            return d;
        }
        return new b.ForbiddenCatalog(a);
    });
    var d = (function() {
            var a = 'Should never here';
            function c(b, a) {
                this._catalog = b;
                this._storeType = a;
            }
            c.prototype.validateAndCacheNewManifest = function() {
                throw a;
            };
            c.prototype.getEntitlementsAsync = function(e, c, d, a) {
                this._catalog.getEntitlementAsync(
                    c,
                    new b.AddinCommandsTelemetryContext(OSF.OUtil.Guid.generateNewGuid()),
                    function(b) {
                        a(b.value);
                    },
                    false,
                    d
                );
            };
            c.prototype.getManifestAsync = function() {
                throw a;
            };
            c.prototype.localCacheAddinCommands = function(e, b, d, c) {
                if (this._storeType == OSF.StoreType.UploadFileDevCatalog) {
                    var a = this._catalog;
                    a.localCacheAddinCommands(b, d, c);
                }
            };
            return c;
        })(),
        c = (function() {
            function c() {}
            c.createAddinDataProvider = function(c) {
                var e = b.CatalogFactory.resolve(c);
                if (e == a) return a;
                return new d(e, c);
            };
            return c;
        })();
    b.AddinDataProviderFactory = c;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    (function(a) {
        var e = 'Unauthenticated',
            d = 'UnknownUserType',
            c = 'ProxyNotReady',
            b = 'Succeeded';
        a[(a[b] = 1)] = b;
        a[(a['Failed'] = 0)] = 'Failed';
        a[(a[c] = -1)] = c;
        a[(a[d] = 2)] = d;
        a[(a[e] = 3)] = e;
    })(a.DataServiceResultCode || (a.DataServiceResultCode = {}));
    var b = a.DataServiceResultCode;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        var b = null;
        function c(d, c) {
            if (c === void 0) c = b;
            this._initParam = d;
            this._cacheManager =
                c ||
                new a.AppsDataCacheManager(OSF.OUtil.getLocalStorage(), new a.SafeSerializer());
        }
        c.prototype.getEntitlementAsync = function() {
            throw new Error('in firstParty get Entitlementasync');
        };
        c.prototype.getAndCacheManifest = function() {
            throw new Error('in firstParty getAndCacheManifest');
        };
        c.prototype.removeAsync = function() {
            throw new Error('in firstParty removeAsync');
        };
        c.prototype.getAppDetails = function() {
            throw new Error('in firstParty getappDetails');
        };
        c.prototype.TryFallBackFirstPartyAddInList = function(e, d) {
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                'Falling back to stale 1st party add-ins list.',
                b,
                e.correlationId,
                34366471
            );
            var c = this._cacheManager.GetCacheItem(
                a.CacheConsts.firstPartyAddinListCacheKey,
                false
            );
            if (c) d({ status: a.DataServiceResultCode.Succeeded, value: c });
            else d({ status: a.DataServiceResultCode.Failed, value: b });
        };
        c.prototype.GetFirstyPartyAddInsInfo = function(h, d, c) {
            var e = this,
                f = this._cacheManager.GetCacheItem(
                    a.CacheConsts.firstPartyAddinListCacheKey,
                    true,
                    b,
                    b,
                    false
                );
            if (f) {
                var g = { addInList: f, refreshRate: b };
                c({ status: a.DataServiceResultCode.Succeeded, value: g });
                return;
            }
            h.getFirstPartyAddInList(function(g) {
                if (g.status != a.DataServiceResultCode.Succeeded) {
                    e.TryFallBackFirstPartyAddInList(d, c);
                    return;
                }
                var f = b;
                try {
                    f = a.OmexXmlProcessor.ProcessFirstPartyAddInList(g.value);
                } catch (h) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Problem parsing first party list.',
                        h,
                        d.correlationId,
                        34366472
                    );
                    e.TryFallBackFirstPartyAddInList(d, c);
                    return;
                }
                e._cacheManager.SetCacheItem(
                    a.CacheConsts.firstPartyAddinListCacheKey,
                    f.addInList,
                    f.refreshRate / a.CacheConsts.hourToDayConversionFactor
                );
                c({ status: a.DataServiceResultCode.Succeeded, value: f });
                return;
            });
        };
        c.prototype.TryFallBackFirstPartyManifest = function(f, c, e) {
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                'Falling back to stale manifest for: ' + f,
                b,
                c.correlationId,
                34366473
            );
            var d = this.ReadFirstPartyManifestFromLocalStorage(c, f);
            if (d) e({ status: a.DataServiceResultCode.Succeeded, value: d });
            else e({ status: a.DataServiceResultCode.Failed, value: b });
        };
        c.prototype.ReadFirstPartyManifestFromLocalStorage = function(e, f) {
            var d = OSF.OUtil.formatString(a.CacheConsts.firstPartyManifestCacheKey, f),
                c = this._cacheManager.GetCacheItem(d, false);
            if (c)
                return a.ManifestUtil.ParseManifest(
                    c,
                    this._initParam.appUILocale,
                    e.correlationId
                );
            return b;
        };
        c.prototype.GetFirstPartyManifest = function(i, d, b, e) {
            var f = this,
                c = OSF.OsfManifestManager.getCachedManifest(b.assetId, '');
            if (!c) {
                c = this.ReadFirstPartyManifestFromLocalStorage(d, b.assetId);
                c && OSF.OsfManifestManager.cacheManifest(b.assetId, '', c);
            }
            if (
                c &&
                !OSF.OsfManifestManager.versionLessThan(c.getMarketplaceVersion(), b.version)
            ) {
                e({ status: a.DataServiceResultCode.Succeeded, value: c });
                return;
            }
            var g = '{0}/{1}',
                h = OSF.OUtil.formatString(g, this._initParam.firstPartyManifestCDNUrl, b.path);
            i.getFirstPartyManifest(h, function(g) {
                if (g.status != a.DataServiceResultCode.Succeeded) {
                    f.TryFallBackFirstPartyManifest(b.assetId, d, e);
                    return;
                }
                var c = a.ManifestUtil.ParseManifest(
                    g.value,
                    f._initParam.appUILocale,
                    d.correlationId
                );
                if (!c) {
                    f.TryFallBackFirstPartyManifest(b.assetId, d, e);
                    return;
                }
                OSF.OsfManifestManager.cacheManifest(b.assetId, '', c);
                var h = OSF.OUtil.formatString(a.CacheConsts.firstPartyManifestCacheKey, b.assetId);
                f._cacheManager.SetCacheItem(h, g.value);
                e({ status: a.DataServiceResultCode.Succeeded, value: c });
                return;
            });
        };
        c.prototype.getDataService = function(g, e) {
            var d = this,
                i = d;
            if (d._dataService != b) {
                e({ status: a.DataServiceResultCode.Succeeded, value: d._dataService });
                return;
            }
            var c = { status: a.DataServiceResultCode.Failed, value: b },
                h = function(d, b) {
                    if (d.status == a.DataServiceResultCode.Succeeded) {
                        i._dataService = b;
                        c.value = b;
                        c.status = a.DataServiceResultCode.Succeeded;
                        e(c);
                    } else {
                        c.httpStatus = d.httpStatus;
                        e(c);
                    }
                },
                f = a.ProxyBasedCatalogService.getFirstPartyInstance(d._initParam);
            f.prepareProxy(g.correlationId, function(a) {
                h(a, f);
            });
        };
        c.prototype.createActivityScope = function(b, c) {
            var d = this;
            this.getDataService(b, function(f) {
                if (a.AsyncUtil.failed(f, c)) return;
                var e = f.value,
                    g = {
                        cacheManager: d._cacheManager,
                        cachePrefix: a.CacheConsts.anonymousCacheKeyPrefix,
                        cid: e.getCID(),
                        anonymous: true,
                        telemetryContext: b,
                    },
                    h = e.createScope(g);
                c({ status: a.DataServiceResultCode.Succeeded, value: h });
            });
        };
        c.prototype.activateAsync = function(f, d, c) {
            var g = this;
            c.startActivity(a.Activity.Activation);
            c.startActivity(a.Activity.ServerCall);
            var h = a.HostFeatureEnabledInfo.getHostFeatureEnabledInfo(),
                e = h && h.enableFirstPartySDXErrorMessages;
            this.createActivityScope(c, function(i) {
                if (i.status != a.DataServiceResultCode.Succeeded) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Failed to create 1st party activity scope.',
                        b,
                        c.correlationId,
                        34366474
                    );
                    a.LoaderUtil.failWithError(d, {
                        title: e
                            ? Strings.OsfRuntime.L_AgaveErrorTile_TXT_FirstParty
                            : Strings.OsfRuntime.L_AgaveErrorTile_TXT,
                        description: e
                            ? Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR_FirstParty
                            : Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                        buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                        buttonCallback: function() {
                            d.restartActivation();
                            g.activateAsync(f, d, c);
                        },
                        errorCode: OSF.ErrorStatusCodes.WAC_AgaveAnonymousProxyCreationError,
                    });
                    return;
                }
                var h = i.value;
                g.GetFirstyPartyAddInsInfo(h, c, function(j) {
                    if (j.status != a.DataServiceResultCode.Succeeded) {
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'Failed get list of 1st party addIns.',
                            b,
                            c.correlationId,
                            34366475
                        );
                        a.LoaderUtil.failWithError(d, {
                            title: e
                                ? Strings.OsfRuntime.L_AgaveErrorTile_TXT_FirstParty
                                : Strings.OsfRuntime.L_AgaveErrorTile_TXT,
                            description: e
                                ? Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR_FirstParty
                                : Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                            buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                            buttonCallback: function() {
                                d.restartActivation();
                                g.activateAsync(f, d, c);
                            },
                            errorCode: OSF.ErrorStatusCodes.WAC_FirstPartyAddInListRequestFailure,
                        });
                        return;
                    }
                    var k = j.value,
                        i = k.addInList[f.assetId];
                    if (!i) {
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'Could not find 1st party addin assetId in list: ' + f.assetId,
                            b,
                            c.correlationId,
                            34366476
                        );
                        a.LoaderUtil.failWithError(d, {
                            title: e
                                ? Strings.OsfRuntime.L_AgaveErrorTile_TXT_FirstParty
                                : Strings.OsfRuntime.L_AgaveErrorTile_TXT,
                            description: e
                                ? Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR_FirstParty
                                : Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                            buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                            buttonCallback: function() {
                                d.restartActivation();
                                g.activateAsync(f, d, c);
                            },
                            errorCode: OSF.ErrorStatusCodes.WAC_FirstPartyAddInListRequestFailure,
                        });
                        return;
                    }
                    c.startActivity(a.Activity.ManifestRequest);
                    g.GetFirstPartyManifest(h, c, i, function(h) {
                        if (h.status != a.DataServiceResultCode.Succeeded) {
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                'Could not find get 1st party manifest: ' + f.assetId,
                                b,
                                c.correlationId,
                                34366477
                            );
                            a.LoaderUtil.failWithError(d, {
                                title: e
                                    ? Strings.OsfRuntime.L_AgaveErrorTile_TXT_FirstParty
                                    : Strings.OsfRuntime.L_AgaveErrorTile_TXT,
                                description: e
                                    ? Strings.OsfRuntime
                                          .L_AgaveServerConnectionFailed_ERR_FirstParty
                                    : Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                                buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                buttonCallback: function() {
                                    d.restartActivation();
                                    g.activateAsync(f, d, c);
                                },
                                errorCode: OSF.ErrorStatusCodes.WAC_AgaveManifestRequestFailure,
                            });
                            return;
                        }
                        c.stopActivity(a.Activity.ManifestRequest);
                        c.stopActivity(a.Activity.ServerCall);
                        var i = h.value;
                        d.load({ entitlement: f, manifest: i, eToken: '' }, b);
                    });
                });
            });
        };
        return c;
    })();
    a.FirstPartyCatalog = b;
    a.CatalogFactory.register(OSF.StoreType.FirstParty, function(c) {
        if (c.osfOmexBaseUrl && c.firstPartyManifestCDNUrl) {
            var d,
                e = c.osfOmexBaseUrl.indexOf(OSF.Constants.ProtocolSeparator);
            if (e >= 0) d = c.osfOmexBaseUrl.substr(e);
            else d = OSF.Constants.ProtocolSeparator + c.osfOmexBaseUrl;
            var f = OSF.Constants.Https + d,
                g = new b({
                    appName: c.appName,
                    appUILocale: c.appUILocale,
                    AppVersion: c.appVersion,
                    clientMode: c.clientMode,
                    docUrl: c.docUrl,
                    omexBaseUrl: f,
                    omexForceAnonymous: true,
                    firstPartyManifestCDNUrl: c.firstPartyManifestCDNUrl,
                });
            return g;
        }
        return new a.ForbiddenCatalog({
            loaderParams: a.LoaderUtil.error({
                description: Strings.OsfRuntime.L_AgaveOmexNotConfigured_ERR,
                errorCode: OSF.ErrorStatusCodes.E_TRUSTCENTER_CATALOG_UNTRUSTED_ADMIN_CONTROLLED,
            }),
            controlStatus: OSF.OsfControlStatus.ActivationFailed,
        });
    });
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        var b = 'OMEX_clearCacheAsync',
            f = 'OMEX_removeCacheAsync',
            e = 'OMEX_getAppStateAsync',
            d = 'OMEX_getKilledAppsAsync',
            c = 'OMEX_getManifestAndETokenAsync';
        function a() {}
        a.CheckProxyIsReady = 'OMEX_isProxyReady';
        a.Gated_GetManifestAndEToken = c;
        a.Gated_GetKilledApps = d;
        a.Gated_GetEntitlementSummary = 'OMEX_getEntitlementSummaryAsync';
        a.Gated_GetAppState = e;
        a.Gated_RemoveApp = 'OMEX_removeAppAsync';
        a.Gated_RemoveCache = f;
        a.Gated_ClearCache = b;
        a.UnGated_GetAppDetails = 'OMEX_getAppDetailsAsync';
        a.UnGated_GetRecommendations = 'OMEX_getRecommendationsAsync';
        a.UnGated_ClearCache = b;
        a.Anonymous_GetManifestAndEToken = c;
        a.Anonymous_GetKilledApps = d;
        a.Anonymous_GetAppState = e;
        a.Anonymous_RemoveCache = f;
        a.Anonymous_ClearCache = b;
        a.Anonymous_GetAuthNStatus = 'OMEX_getAuthNStatus';
        a.Anonymous_GetFirstPartyAddInList = 'OMEX_getFirstPartyAddInListAsync';
        a.Anonymous_GetFirstPartyManifest = 'OMEX_getFirstPartyManifestAsync';
        return a;
    })();
    a.OmexProxyMethods = b;
    var c = (function(e) {
        var c = null;
        __extends(d, e);
        function d(a) {
            e.call(this);
            this.osfOmexBaseUrl = a;
        }
        d.prototype.prepareProxy = function(b, e, f) {
            var a = this;
            if (f) {
                a.isReady = false;
                d.resetProxy(a);
            }
            if (a.isReady) b({ status: c, value: { clientEndpoint: a.clientEndPoint } });
            else if (!a.clientEndPoint) a.createProxy(b, e);
            else a.pendingCallbacks.push([b, e]);
        };
        d.resetProxy = function(a) {
            Microsoft.Office.Common.XdmCommunicationManager.getClientEndPoint(a.conversationId) &&
                Microsoft.Office.Common.XdmCommunicationManager.deleteClientEndPoint(
                    a.conversationId
                );
            if (a.iframe) {
                OSF.OUtil.removeEventListener(a.iframe, 'load', a.iframeOnload);
                a.iframe.parentNode.removeChild(a.iframe);
                a.iframe = c;
            }
            a.clientEndPoint = c;
        };
        d.prototype.createProxy = function(l, i) {
            var e = this;
            try {
                !e.doesUrlHaveSupportedProtocol(e.proxyUrl) &&
                    i({
                        status: c,
                        value: { errorMessage: 'Protocal of proxyUrl is not supported.' },
                    });
                var f = document.createElement('iframe');
                f.setAttribute('id', e.proxyName);
                f.setAttribute('name', e.proxyName);
                var h = e.proxyUrl + '?' + e.conversationId;
                h = OSF.OUtil.addXdmInfoAsHash(
                    h,
                    e.conversationId + '|' + e.proxyName + '|' + window.location.href
                );
                h = OSF.OUtil.addSerializerVersionAsHash(h, OSF.SerializerVersion.Browser);
                f.setAttribute('src', h);
                f.setAttribute('scrolling', 'auto');
                f.setAttribute('border', '0');
                f.setAttribute('width', '0');
                f.setAttribute('height', '0');
                f.setAttribute('style', 'position: absolute; left: -100px; top:0px;');
                document.body.appendChild(f);
                var g = e,
                    j = function() {
                        var e = function(f, i) {
                            var b = g.pendingCallbacks.length;
                            if (b == 0) return;
                            var a = c;
                            if (f === 0 && i.status) {
                                g.isReady = true;
                                a = { status: c, value: { clientEndpoint: g.clientEndPoint } };
                            } else {
                                d.resetProxy(g);
                                a = {
                                    status: c,
                                    value: {
                                        errorMessage:
                                            'isProxyReadyCallback failed, error code ' + f,
                                    },
                                };
                            }
                            for (var h = 0; h < b; h++) {
                                var e = g.pendingCallbacks.shift();
                                if (g.isReady) e[0](a);
                                else e[1](a);
                            }
                        };
                        g.clientEndPoint = Microsoft.Office.Common.XdmCommunicationManager.connect(
                            g.conversationId,
                            f.contentWindow,
                            g.proxyUrl
                        );
                        if (g.clientEndPoint)
                            g.clientEndPoint.invoke(b.CheckProxyIsReady, e, { __timeout__: 500 });
                        else {
                            var a =
                                'Unexpected error, iframe loaded again after failing OMEX_isProxyReady';
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(a, c, c, 18121820);
                            i({ status: c, value: { errorMessage: a } });
                        }
                        OSF.OUtil.set_entropy(new Date().getTime());
                    };
                OSF.OUtil.addEventListener(f, 'load', j);
                e.iframeOnload = j;
                e.pendingCallbacks.push([l, i]);
                e.iframe = f;
            } catch (k) {
                var m =
                    'Error creating client endpoint with proxyUrl = [' +
                    e.proxyUrl +
                    '], msg:' +
                    a.WACUtils.serializeObjectToString(k);
                i({ status: c, value: { errorMessage: m } });
            }
        };
        return d;
    })(a.ProxyBase);
    a.OmexProxyBase = c;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function(c) {
        __extends(b, c);
        function b(b) {
            var a = this;
            c.call(a, b);
            a.proxyName = '__omexExtensionAnonymousProxy';
            a.proxyUrl = a.osfOmexBaseUrl + '/anonymousserviceextension.aspx';
        }
        b.prototype.getManifestAsync = function(c, b) {
            this.invokeProxyCommandAsync(
                a.OmexProxyMethods.Anonymous_GetManifestAndEToken,
                c,
                function(c) {
                    if (c.value != null && c.status == a.DataServiceResultCode.Succeeded)
                        c.value = a.OmexXmlProcessor.ConvertClientAppInstallInfo(c.value);
                    b(c);
                }
            );
        };
        b.prototype.getFirstPartyAddInListAsync = function(c, b) {
            this.invokeProxyCommandAsync(
                a.OmexProxyMethods.Anonymous_GetFirstPartyAddInList,
                c,
                function(a) {
                    b(a);
                }
            );
        };
        b.prototype.getFirstPartyManifestAsync = function(c, b) {
            this.invokeProxyCommandAsync(
                a.OmexProxyMethods.Anonymous_GetFirstPartyManifest,
                c,
                function(a) {
                    b(a);
                }
            );
        };
        b.prototype.getAppStateAsync = function(c, b) {
            this.invokeProxyCommandAsync(a.OmexProxyMethods.Anonymous_GetAppState, c, function(c) {
                if (c.value != null && c.status == a.DataServiceResultCode.Succeeded)
                    c.value = a.OmexXmlProcessor.ConvertAppState(c.value);
                b(c);
            });
        };
        b.prototype.getKilledAppAsync = function(c, b) {
            this.invokeProxyCommandAsync(a.OmexProxyMethods.Anonymous_GetKilledApps, c, function(
                c
            ) {
                if (c.value != null && c.status == a.DataServiceResultCode.Succeeded)
                    c.value = a.OmexXmlProcessor.ConvertKilledAppsInfo(c.value);
                b(c);
            });
        };
        b.prototype.getAuthNStatusAsync = function(c, b) {
            this.invokeProxyCommandAsync(a.OmexProxyMethods.Anonymous_GetAuthNStatus, c, b);
        };
        return b;
    })(a.OmexProxyBase);
    a.AnonymousOmexProxy = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function(d) {
        var b = null;
        __extends(c, d);
        function c(b) {
            var a = this;
            d.call(a, b);
            a.proxyName = '__omexExtensionGatedProxy';
            a.proxyUrl = a.osfOmexBaseUrl + '/gatedserviceextension.aspx';
        }
        c.prototype.getOmexEntitlementsAsync = function(d, c) {
            this.invokeProxyCommandAsync(
                a.OmexProxyMethods.Gated_GetEntitlementSummary,
                d,
                function(d) {
                    if (d.value != b && d.status == a.DataServiceResultCode.Succeeded)
                        d.value = a.OmexXmlProcessor.ConvertEntitlementInfo(d.value);
                    c(d);
                }
            );
        };
        c.prototype.getManifestAndETokenAsync = function(d, c) {
            this.invokeProxyCommandAsync(a.OmexProxyMethods.Gated_GetManifestAndEToken, d, function(
                d
            ) {
                if (d.value != b && d.status == a.DataServiceResultCode.Succeeded)
                    d.value = a.OmexXmlProcessor.ConvertClientAppInstallInfo(d.value);
                c(d);
            });
        };
        c.prototype.getAppStateAsync = function(d, c) {
            this.invokeProxyCommandAsync(a.OmexProxyMethods.Gated_GetAppState, d, function(d) {
                if (d.value != b && d.status == a.DataServiceResultCode.Succeeded)
                    d.value = a.OmexXmlProcessor.ConvertAppState(d.value);
                c(d);
            });
        };
        c.prototype.getKilledAppAsync = function(d, c) {
            this.invokeProxyCommandAsync(a.OmexProxyMethods.Gated_GetKilledApps, d, function(d) {
                if (d.value != b && d.status == a.DataServiceResultCode.Succeeded)
                    d.value = a.OmexXmlProcessor.ConvertKilledAppsInfo(d.value);
                c(d);
            });
        };
        c.prototype.removeApps = function(d, c) {
            this.invokeProxyCommandAsync(a.OmexProxyMethods.Gated_RemoveApp, d, function(d) {
                if (d.value != b && d.status == a.DataServiceResultCode.Succeeded)
                    d.value = a.OmexXmlProcessor.ConvertRemoveAppResponse(d.value);
                c(d);
            });
        };
        return c;
    })(a.OmexProxyBase);
    a.GatedOmexProxy = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(c) {
    var f = false,
        b = '',
        e = true,
        a = null,
        d;
    (function(a) {
        var d = 'AnonymousUser',
            c = 'AuthedUser',
            b = 'NotDetected';
        a[(a[b] = 0)] = b;
        a[(a[c] = 1)] = c;
        a[(a[d] = 2)] = d;
    })(d || (d = {}));
    var j = (function() {
        function h(b) {
            var a = this;
            a.currentUserType = d.NotDetected;
            a.omexAuthNStatus = OSF.OmexAuthNStatus.NotAttempted;
            a.omexAuthConnectTries = 1;
            a.initParams = b;
            a.gatedProxy = new c.GatedOmexProxy(b.omexBaseUrl);
            a.ungatedProxy = new c.UnGatedOmexProxy(b.omexBaseUrl);
            a.anonymousProxy = new c.AnonymousOmexProxy(b.omexBaseUrl);
        }
        h.getInstance = function(b) {
            if (h._instance == a) h._instance = new h(b);
            return h._instance;
        };
        h.getFirstPartyInstance = function(c) {
            if (h._firstPartyInstance == a) {
                var b = new h(c);
                b._isFirstParty = e;
                b.omexAuthNStatus = OSF.OmexAuthNStatus.Anonymous;
                this._firstPartyInstance = b;
            }
            return h._firstPartyInstance;
        };
        h.prototype.prepareProxy = function(g, i) {
            var j = this;
            g = g || b;
            var h = function(b) {
                var h = b && b.status != a ? b.status : c.DataServiceResultCode.ProxyNotReady,
                    g;
                if (b && b.value)
                    if (j._isFirstParty) g = e;
                    else if (b.value.currentUserType)
                        if (b.value.currentUserType == d.AuthedUser) g = f;
                        else if (b.value.currentUserType == d.AnonymousUser) g = e;
                i({ status: b.status, value: { anonymous: g } });
            };
            this.ensureOmexProxySetUp(g, h);
        };
        h.prototype.createScope = function(a) {
            return new g(a, this);
        };
        h.prototype.getCID = function() {
            switch (this.currentUserType) {
                case d.AuthedUser:
                    return this._cid;
                case d.AnonymousUser:
                    return b;
            }
            throw 'not initialized';
        };
        h.prototype.ensureOmexProxySetUp = function(f, k) {
            var g = this;
            if (
                g.currentUserType != d.NotDetected &&
                (g.anonymousProxy.isReady || g.gatedProxy.isReady)
            ) {
                k({ status: c.DataServiceResultCode.Succeeded, value: g });
                return;
            }
            var b = g,
                i = function() {
                    b.currentUserType = d.AuthedUser;
                    k({ status: c.DataServiceResultCode.Succeeded, value: b });
                },
                j = function() {
                    if (b.omexAuthConnectTries < OSF.Constants.AuthenticatedConnectMaxTries) {
                        b.omexAuthConnectTries++;
                        if (b.omexAuthNStatus !== OSF.OmexAuthNStatus.CheckFailed)
                            b.anonymousProxy.prepareProxy(l, e);
                        else b.gatedProxy.prepareProxy(i, j);
                    } else {
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'exceed maximum tries and fail',
                            a,
                            f,
                            18657693
                        );
                        b.anonymousProxy.prepareProxy(h, e);
                    }
                },
                l = function(c) {
                    if (c && c.value) {
                        var d = function(d) {
                            var g = d.status;
                            if (g === OSF.ProxyCallStatusCode.Succeeded) {
                                var c = d.value;
                                if (c == OSF.OmexAuthNStatus.Authenticated) {
                                    b.omexAuthNStatus = OSF.OmexAuthNStatus.Authenticated;
                                    b.gatedProxy.prepareProxy(i, j);
                                } else if (
                                    c == OSF.OmexAuthNStatus.Anonymous ||
                                    c == OSF.OmexAuthNStatus.Unknown
                                ) {
                                    b.omexAuthNStatus = OSF.OmexAuthNStatus.Anonymous;
                                    b.anonymousProxy.prepareProxy(h, e);
                                }
                            } else {
                                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                    'auth check failure.',
                                    a,
                                    f,
                                    18657694
                                );
                                b.omexAuthNStatus = OSF.OmexAuthNStatus.CheckFailed;
                                if (b.initParams.omexForceAnonymous)
                                    b.anonymousProxy.prepareProxy(h, e);
                                else b.gatedProxy.prepareProxy(i, j);
                            }
                        };
                        b.anonymousProxy.getAuthNStatusAsync({ correlationId: f }, d);
                    } else
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'GetAuthNStatus callback param invalid',
                            a,
                            f,
                            18657695
                        );
                },
                h = function(a) {
                    if (b.omexAuthNStatus == OSF.OmexAuthNStatus.NotAttempted) l(a);
                    else {
                        b.currentUserType = d.AnonymousUser;
                        k({ status: c.DataServiceResultCode.Succeeded, value: b });
                    }
                },
                e = function() {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'create anonymous proxy failure',
                        a,
                        f,
                        18657696
                    );
                    k({ status: c.DataServiceResultCode.ProxyNotReady });
                };
            if (b.initParams.omexForceAnonymous) b.anonymousProxy.prepareProxy(h, e);
            else b.gatedProxy.prepareProxy(i, j);
        };
        return h;
    })();
    c.ProxyBasedCatalogService = j;
    var h = (function() {
            function a() {}
            a.dummyApplicationName = 'unused';
            return a;
        })(),
        g = (function() {
            var l = 'contentMarket',
                j = 'assetID',
                m = 'applicationName',
                k = 'errors';
            function g(d, c) {
                var a = this;
                a._build = OSF.Constants.FileVersion;
                a._catalogService = c;
                a._appVersion = OSF.OmexAppVersions[a._catalogService.initParams.appName];
                a._clientName = OSF.OmexClientNames[a._catalogService.initParams.appName];
                a._clientVersion = i.getClientVersionFromWACAppVersion(
                    a._catalogService.initParams.AppVersion
                );
                a._correlationId = d.telemetryContext.correlationId || b;
            }
            g.prototype.getFirstPartyAddInList = function(b) {
                var a = this.buildOmexRequestParameters();
                a[k] = {};
                this._catalogService.anonymousProxy.getFirstPartyAddInListAsync(a, b);
            };
            g.prototype.getFirstPartyManifest = function(c, b) {
                var a = this.buildOmexRequestParameters();
                a[k] = {};
                a['manifestUrl'] = c;
                this._catalogService.anonymousProxy.getFirstPartyManifestAsync(a, b);
            };
            g.prototype.tryFail = function(a, d, b) {
                if (a != c.DataServiceResultCode.Succeeded) {
                    b({ status: a });
                    return e;
                } else return f;
            };
            g.prototype.isUserTypeValid = function(b) {
                if (b === d.NotDetected) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'userType is invalid.',
                        a,
                        this._correlationId,
                        18657698
                    );
                    return f;
                }
                return e;
            };
            g.prototype.getEntitlementAsync = function(k, b, j) {
                var a = this,
                    i = a,
                    e = a.buildOmexRequestParameters();
                e[m] = h.dummyApplicationName;
                e['appVersion'] = a._appVersion;
                e['clearEntitlement'] = j || f;
                var g = a._catalogService.currentUserType;
                if (a.isUserTypeValid(g))
                    if (g === d.AuthedUser)
                        a._catalogService.gatedProxy.getOmexEntitlementsAsync(e, function(a) {
                            if (i.tryFail(a.status, a.httpStatus, b)) return;
                            i._catalogService._cid = a.value.cid;
                            b(a);
                        });
                    else
                        g === d.AnonymousUser &&
                            b({
                                status: c.DataServiceResultCode.Succeeded,
                                value: { refreshRate2: 0, entitlements: [] },
                            });
                else
                    b({
                        status: c.DataServiceResultCode.UnknownUserType,
                        value: { refreshRate2: 0, entitlements: [] },
                    });
            };
            g.prototype.getLastStoreUpdate = function() {};
            g.prototype.isStoreDisabled = function(a) {
                a({ status: c.DataServiceResultCode.Succeeded, value: f });
            };
            g.prototype.getManifest = function(e, d, f) {
                var a = function(a) {
                    var d = a && a.value && a.value.manifest ? a.value.manifest : b,
                        e =
                            a && a.value && a.value.status2
                                ? a.value.status2
                                : OSF.OmexClientAppStatus.ServerError,
                        g = a ? a.status : c.DataServiceResultCode.Failed;
                    f({ status: g, value: { status2: e, manifest: d } });
                };
                this.getETokenAndManifestInternal(e, d, OSF.ClientAppInfoReturnType.urlOnly, a);
            };
            g.prototype.getEToken = function(b, a, c) {
                this.getETokenAndManifestInternal(b, a, OSF.ClientAppInfoReturnType.etokenOnly, c);
            };
            g.prototype.getETokenAndManifest = function(b, a, c) {
                this.getETokenAndManifestInternal(b, a, OSF.ClientAppInfoReturnType.both, c);
            };
            g.prototype.getAppState = function(h, f) {
                var a = this,
                    i = a,
                    e = a.buildOmexRequestParameters();
                e[j] = h.assetId;
                e[l] = h.storeId;
                e[k] = {};
                var g = a._catalogService.currentUserType;
                if (a.isUserTypeValid(g))
                    if (g === d.AuthedUser)
                        a._catalogService.gatedProxy.getAppStateAsync(e, function(a) {
                            if (i.tryFail(a.status, a.httpStatus, f)) {
                                i.logServiceCallResponseError('appstate', a.httpStatus);
                                return;
                            }
                            f(a);
                        });
                    else
                        g === d.AnonymousUser &&
                            a._catalogService.anonymousProxy.getAppStateAsync(e, f);
                else
                    f({
                        status: c.DataServiceResultCode.UnknownUserType,
                        value: {
                            refreshRate2: 0,
                            assetId: b,
                            productId: b,
                            version: b,
                            state2: -1,
                        },
                    });
            };
            g.prototype.getKilledApps = function(e) {
                var b = this,
                    h = b,
                    g = b.buildOmexRequestParameters(),
                    f = b._catalogService.currentUserType;
                if (b.isUserTypeValid(f))
                    if (f === d.AuthedUser)
                        b._catalogService.gatedProxy.getKilledAppAsync(g, function(a) {
                            if (h.tryFail(a.status, a.httpStatus, e)) {
                                h.logServiceCallResponseError('killedapps', a.httpStatus);
                                return;
                            }
                            e(a);
                        });
                    else
                        f === d.AnonymousUser &&
                            b._catalogService.anonymousProxy.getKilledAppAsync(g, e);
                else
                    e({
                        status: c.DataServiceResultCode.UnknownUserType,
                        value: { refreshRate2: 0, killedApps: a },
                    });
            };
            g.prototype.getAppDetails = function(f, e, c) {
                var d = this,
                    a = this.buildOmexRequestParameters();
                a['assetid'] = b;
                a[j] = f.join(',');
                a[l] = e;
                this._catalogService.ungatedProxy.getAppDetailsAsync(a, function(a) {
                    if (d.tryFail(a.status, a.httpStatus, c)) {
                        d.logServiceCallResponseError('appdetails', a.httpStatus);
                        return;
                    }
                    c(a);
                });
            };
            g.prototype.removeApps = function(i, e) {
                var a = this,
                    h = a,
                    g = a.buildOmexRequestParameters();
                g['assetid'] = b;
                g[j] = i.join(',');
                var f = a._catalogService.currentUserType;
                if (a.isUserTypeValid(f))
                    if (f === d.AuthedUser)
                        a._catalogService.gatedProxy.removeApps(g, function(a) {
                            if (h.tryFail(a.status, a.httpStatus, e)) {
                                h.logServiceCallResponseError('removeapps', a.httpStatus);
                                return;
                            }
                            e(a);
                        });
                    else
                        f === d.AnonymousUser &&
                            e({
                                status: c.DataServiceResultCode.Succeeded,
                                value: { removedApps: [] },
                            });
                else
                    e({
                        status: c.DataServiceResultCode.UnknownUserType,
                        value: { removedApps: [] },
                    });
            };
            g.prototype.getETokenAndManifestInternal = function(i, p, n, f) {
                var g = this,
                    k = g,
                    e = g.buildOmexRequestParameters();
                e[m] = h.dummyApplicationName;
                e[j] = i.assetId;
                e['clientAppInfoReturnType'] = n;
                var o = g._catalogService.currentUserType;
                if (g.isUserTypeValid(o))
                    if (o === d.AuthedUser && n != OSF.ClientAppInfoReturnType.urlOnly) {
                        e['assetContentMarket'] = p;
                        e['userContentMarket'] = i.storeId;
                        e['expectedVersion'] = i.appVersion;
                        g._catalogService.gatedProxy.getManifestAndETokenAsync(e, function(a) {
                            if (k.tryFail(a.status, a.httpStatus, f)) {
                                k.logServiceCallResponseError('manifestandetoken', a.httpStatus);
                                return;
                            }
                            f(a);
                        });
                    } else {
                        e[l] = i.storeId;
                        if (e.clientAppInfoReturnType == OSF.ClientAppInfoReturnType.etokenOnly)
                            f({
                                status: c.DataServiceResultCode.Succeeded,
                                value: {
                                    status2: OSF.OmexClientAppStatus.OK,
                                    etoken: b,
                                    manifest: a,
                                },
                            });
                        else
                            g._catalogService.anonymousProxy.getManifestAsync(e, function(a) {
                                if (k.tryFail(a.status, a.httpStatus, f)) {
                                    k.logServiceCallResponseError('manifest', a.httpStatus);
                                    return;
                                }
                                f(a);
                            });
                    }
                else
                    f({
                        status: c.DataServiceResultCode.UnknownUserType,
                        value: { etoken: b, manifest: a },
                    });
            };
            g.prototype.buildOmexRequestParameters = function() {
                var a = this,
                    b = {
                        clientName: a._clientName,
                        clientVersion: a._clientVersion,
                        correlationId: a._correlationId,
                        build: a._build,
                    };
                return b;
            };
            g.prototype.logServiceCallResponseError = function(d, b) {
                var c = 'proxybased request ' + d + ' failed';
                if (b) c += ':' + b;
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    c,
                    a,
                    this._correlationId,
                    18657697
                );
            };
            return g;
        })();
    c.ProxyBasedCatalogServiceScope = g;
    var i = (function() {
        function a() {}
        a.getClientVersionFromWACAppVersion = function(c) {
            if (!c) return undefined;
            var b = c.split('.'),
                d = parseInt(b[0], 10),
                e = parseInt(b[1], 10) || 0;
            if (d <= 15 && e <= 0) return undefined;
            var a = OSF.Constants.FileVersion.split('.');
            return d + '.' + e + '.' + a[2] + '.' + a[3];
        };
        a.getOmexEndPointPageUrl = function(b, c, a) {
            return OSF.OUtil.formatString('{0}/{1}/downloads/{2}.aspx', b, a, c);
        };
        return a;
    })();
    c.OmexUtils = i;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function(c) {
        __extends(b, c);
        function b(b) {
            var a = this;
            c.call(a, b);
            a.proxyName = '__omexExtensionProxy';
            a.proxyUrl = a.osfOmexBaseUrl + '/ungatedserviceextension.aspx';
        }
        b.prototype.getAppDetailsAsync = function(c, b) {
            this.invokeProxyCommandAsync(a.OmexProxyMethods.UnGated_GetAppDetails, c, function(c) {
                if (c.value != null && c.status == a.DataServiceResultCode.Succeeded)
                    c.value = a.OmexXmlProcessor.ConvertAppDetails(c.value);
                b(c);
            });
        };
        return b;
    })(a.OmexProxyBase);
    a.UnGatedOmexProxy = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var d = false,
        c = null,
        a = true,
        f = (function() {
            var f = 'cacheExpired';
            function e(b, c) {
                var a = this;
                a._initParam = c;
                a._cacheManager = b.cacheManager;
                a._cachePrefix = b.cachePrefix;
                a._cid = b.cid;
                a._anonymous = b.anonymous;
                a._telemetryContext = b.telemetryContext;
            }
            e.prototype.GetCacheKeyPrefix = function() {
                return this._cachePrefix;
            };
            e.prototype.getOmexEndPointPageUrl = function(c, a) {
                return b.OmexUtils.getOmexEndPointPageUrl(this._initParam.omexBaseUrl, c, a);
            };
            e.prototype.getKilledApps = function(j, f, i) {
                var e = this,
                    h = e;
                e._telemetryContext.startActivity(b.Activity.KilledAppsCheck);
                var g = OSF.OUtil.formatString(
                    b.CacheConsts.killedAppsCacheKey,
                    e.GetCacheKeyPrefix()
                );
                if (i) e._cacheManager.RemoveCacheItem(g);
                else {
                    var d = e._cacheManager.GetCacheItem(g, a);
                    if (d && d.refreshRate2 != c) {
                        e._telemetryContext.stopActivity(b.Activity.KilledAppsCheck);
                        f({ status: b.DataServiceResultCode.Succeeded, value: d });
                        return;
                    }
                }
                j.getKilledApps(function(a) {
                    if (a.status != b.DataServiceResultCode.Succeeded) {
                        f(a);
                        return;
                    }
                    h._telemetryContext.stopActivity(b.Activity.KilledAppsCheck);
                    d = a.value;
                    h._cacheManager.SetCacheItem(
                        g,
                        d,
                        d.refreshRate / b.CacheConsts.hourToDayConversionFactor
                    );
                    f(a);
                });
            };
            e.prototype.getAppState = function(n, h, i, m) {
                var e = this,
                    k = e;
                e._telemetryContext.startActivity(b.Activity.AppStateCheck);
                var j = OSF.OUtil.formatString(
                        b.CacheConsts.appStateCacheKey,
                        e.GetCacheKeyPrefix(),
                        h.storeId,
                        h.assetId
                    ),
                    g;
                if (m) e._cacheManager.RemoveCacheItem(j);
                else {
                    var l = {};
                    g = e._cacheManager.GetCacheItem(j, a, l);
                    e._telemetryContext.setFlag(b.FlagName.AppStateDataInvalidFlag, l[f] || d);
                    if (g && g.state2 != c) {
                        e._telemetryContext.stopActivity(b.Activity.AppStateCheck);
                        e._telemetryContext.setFlag(b.FlagName.AppStateDataCachedFlag, a);
                        i({ status: b.DataServiceResultCode.Succeeded, value: g });
                        return;
                    }
                }
                n.getAppState(h, function(a) {
                    if (a.status != b.DataServiceResultCode.Succeeded) {
                        i(a);
                        return;
                    }
                    k._telemetryContext.stopActivity(b.Activity.AppStateCheck);
                    k._telemetryContext.setFlag(b.FlagName.AppStateDataCachedFlag, d);
                    g = a.value;
                    k._cacheManager.SetCacheItem(
                        j,
                        g,
                        g.refreshRate2 / b.CacheConsts.hourToDayConversionFactor
                    );
                    i(a);
                });
            };
            e.prototype.getManifest = function(o, i, m, j, n) {
                var e = this,
                    h = e;
                e._telemetryContext.startActivity(b.Activity.ManifestRequest);
                var g,
                    k = OSF.OUtil.formatString(
                        b.CacheConsts.anonymousAppInstallInfoCacheKey,
                        i.assetId,
                        i.storeId
                    );
                if (n) e._cacheManager.RemoveCacheItem(k);
                else {
                    var l = {};
                    g = e._cacheManager.GetCacheItem(k, a, l);
                    e._telemetryContext.setFlag(b.FlagName.ManifestDataInvalidFlag, l[f] || d);
                    if (g && g.status2 != c) {
                        e._telemetryContext.stopActivity(b.Activity.ManifestRequest);
                        e._telemetryContext.stopActivity(b.Activity.ServerCall);
                        e._telemetryContext.setFlag(b.FlagName.ManifestDataCachedFlag, a);
                        j({
                            status: b.DataServiceResultCode.Succeeded,
                            value: { status2: g.status2, manifest: g.manifest },
                        });
                        return;
                    }
                }
                o.getManifest(i, m, function(a) {
                    if (
                        a.status != b.DataServiceResultCode.Succeeded ||
                        a.value.status2 != OSF.OmexClientAppStatus.OK
                    ) {
                        j(a);
                        return;
                    }
                    h._telemetryContext.stopActivity(b.Activity.ManifestRequest);
                    h._telemetryContext.stopActivity(b.Activity.ServerCall);
                    h._telemetryContext.setFlag(b.FlagName.ManifestDataCachedFlag, d);
                    h._telemetryContext.setBits(
                        b.FlagName.ManifestRequestType,
                        OSF.ManifestRequestTypes.Manifest
                    );
                    g = { etoken: '', status2: a.value.status2, manifest: a.value.manifest };
                    h._cacheManager.SetCacheItem(k, g, b.CacheConsts.manifestRefreshRate);
                    j(a);
                });
            };
            e.prototype.removeApps = function(f, e, c) {
                var g = this;
                f.removeApps(e, function(e) {
                    if (e.status != b.DataServiceResultCode.Succeeded) {
                        c(e);
                        return;
                    }
                    for (
                        var h = '.*', k = d, j = [], i = e.value.removedApps, f = 0;
                        f < i.length;
                        ++f
                    )
                        if (i[f].result2 == OSF.OmexRemoveAppStatus.Success) {
                            j.push(
                                new RegExp(
                                    OSF.OUtil.formatString(
                                        b.WACUtils.CacheConstants
                                            .AuthenticatedAppInstallInfoCacheKey,
                                        h,
                                        i[f].assetId,
                                        h,
                                        h
                                    ),
                                    'i'
                                )
                            );
                            k = a;
                        }
                    k && g._cacheManager.RemoveMatches(j);
                    c(e);
                });
            };
            e.prototype.getCachedETokenAndManifest = function(h) {
                var g = {},
                    e = this._cacheManager.GetCacheItem(h, a, g);
                this._telemetryContext.setFlag(b.FlagName.ManifestDataInvalidFlag, g[f] || d);
                if (e) {
                    if (
                        e.status2 &&
                        e.tokenExpirationDate2 &&
                        e.tokenExpirationDate2 > new Date().getTime()
                    )
                        return e;
                    e.etoken = c;
                    e.tokenExpirationDate2 = c;
                    e.entitlementType = c;
                }
                return e;
            };
            e.prototype.getETokenAndManifest = function(n, g, k, h, p) {
                var f = this,
                    j = f;
                if (f._anonymous) {
                    f.getManifest(
                        n,
                        g,
                        k,
                        function(a) {
                            if (b.AsyncUtil.failed(a, h)) return;
                            h({
                                status: a.status,
                                value: {
                                    etoken: '',
                                    status2: a.value.status2,
                                    manifest: a.value.manifest,
                                },
                            });
                        },
                        p
                    );
                    return;
                }
                f._telemetryContext.startActivity(b.Activity.ManifestRequest);
                var l = function(c, a) {
                        j._telemetryContext.stopActivity(b.Activity.ManifestRequest);
                        j._telemetryContext.stopActivity(b.Activity.ServerCall);
                        j._telemetryContext.setFlag(b.FlagName.ManifestDataCachedFlag, c);
                        a && j._telemetryContext.setBits(b.FlagName.ManifestRequestType, a);
                    },
                    m = OSF.OUtil.formatString(
                        b.WACUtils.CacheConstants.AuthenticatedAppInstallInfoCacheKey,
                        f._cid,
                        g.assetId,
                        g.storeId,
                        k
                    ),
                    e;
                if (p) f._cacheManager.RemoveCacheItem(m);
                else {
                    var r = {};
                    e = f.getCachedETokenAndManifest(m);
                    if (e && e.etoken && e.manifest) {
                        l(a);
                        h({ status: b.DataServiceResultCode.Succeeded, value: e });
                        return;
                    }
                    var i = e ? e.manifest : c;
                    if (i == c || i == '') {
                        var q = OSF.OUtil.formatString(
                                b.CacheConsts.anonymousAppInstallInfoCacheKey,
                                g.assetId,
                                g.storeId
                            ),
                            o = f._cacheManager.GetCacheItem(q, a);
                        if (o) i = o.manifest;
                    }
                    if (i) {
                        if (!e || !e.etoken)
                            n.getEToken(g, k, function(a) {
                                if (a.status === b.DataServiceResultCode.Succeeded && a.value) {
                                    l(d, OSF.ManifestRequestTypes.Etoken);
                                    e = a.value;
                                    if (e.status2 === OSF.OmexClientAppStatus.OK) {
                                        j._cacheManager.SetCacheItem(
                                            m,
                                            e,
                                            b.CacheConsts.manifestRefreshRate
                                        );
                                        e.manifest = i;
                                    }
                                }
                                h(a);
                            });
                        else {
                            l(a);
                            e.manifest = i;
                            h({ status: b.DataServiceResultCode.Succeeded, value: e });
                        }
                        return;
                    }
                }
                n.getETokenAndManifest(g, k, function(a) {
                    if (a.status != b.DataServiceResultCode.Succeeded) {
                        h(a);
                        return;
                    }
                    l(d, OSF.ManifestRequestTypes.Both);
                    a.value.status2 === OSF.OmexClientAppStatus.OK &&
                        j._cacheManager.SetCacheItem(m, a.value, b.CacheConsts.manifestRefreshRate);
                    h(a);
                });
            };
            e.prototype.getEntitlements = function(i, j, d, k) {
                var e = this,
                    h = e;
                e._telemetryContext.startActivity(b.Activity.EntitlementCheck);
                var a,
                    f,
                    g = function() {
                        if (f == c || a == c) return;
                        a = a.filter(function(a) {
                            return f.every(function(b) {
                                return b.assetId != a.assetId;
                            });
                        });
                        d({
                            status: b.DataServiceResultCode.Succeeded,
                            value: { entitlements: a, killed: f },
                        });
                    };
                if (e._anonymous) {
                    a = [];
                    e._telemetryContext.stopActivity(b.Activity.EntitlementCheck);
                    g();
                } else
                    i.getEntitlementAsync(
                        j,
                        function(e) {
                            h._telemetryContext.stopActivity(b.Activity.EntitlementCheck);
                            if (d == c) return;
                            if (b.AsyncUtil.failed(e, d)) {
                                d = c;
                                return;
                            }
                            if (!h._cid) h._cid = e.value.cid;
                            a = e.value.entitlements;
                            g();
                        },
                        k
                    );
                e.getKilledApps(i, function(a) {
                    if (d == c) return;
                    f = a.status == b.DataServiceResultCode.Succeeded ? a.value.killedApps : [];
                    g();
                });
            };
            e.prototype.activate = function(n, h, e) {
                var f = this,
                    g = {
                        assetId: h.assetId,
                        appVersion: h.appVersion,
                        storeId: h.storeId,
                        storeType: h.storeType,
                        targetType: h.targetType,
                    },
                    o = d,
                    k,
                    l,
                    i = this.getOmexEndPointPageUrl(g.assetId, g.storeId),
                    m = b.HostFeatureEnabledInfo.getHostFeatureEnabledInfo(),
                    r = function(o, s) {
                        switch (o.status2) {
                            case OSF.OmexClientAppStatus.OK:
                                if (
                                    o.tokenExpirationDate2 &&
                                    o.tokenExpirationDate2 <= new Date().getTime()
                                ) {
                                    b.LoaderUtil.failWithWarning(
                                        e,
                                        b.LoaderUtil.warning({
                                            description:
                                                Strings.OsfRuntime.L_AgaveLicenseExpired_ERR,
                                            buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                            buttonCallback: function() {
                                                return j();
                                            },
                                            errorCode: OSF.ErrorStatusCodes.E_TOKEN_EXPIRED,
                                        })
                                    );
                                    return;
                                }
                                var l = b.ManifestUtil.ParseManifest(
                                    o.manifest,
                                    f._initParam.appUILocale,
                                    f._telemetryContext.correlationId
                                );
                                if (l == c) {
                                    b.LoaderUtil.failWithError(e, {
                                        infoType: OSF.InfoType.Error,
                                        buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                        buttonCallback: function() {
                                            e.restartActivation();
                                            f.restartActivationTelemetry();
                                            j();
                                        },
                                        description: Strings.OsfRuntime.L_AgaveManifestRetrieve_ERR,
                                        errorCode:
                                            OSF.ErrorStatusCodes.E_MANIFEST_INVALID_VALUE_FORMAT,
                                    });
                                    return;
                                }
                                var v = l.getMarketplaceVersion();
                                OSF.OsfManifestManager.cacheManifest(g.assetId, h.appVersion, l);
                                if (
                                    l.requirementsSupported === d ||
                                    (l.requirementsSupported === undefined &&
                                        !e.getRequirementsChecker().isManifestSupported(l))
                                ) {
                                    l.requirementsSupported = d;
                                    var u,
                                        B,
                                        C = c;
                                    u =
                                        Strings.OsfRuntime
                                            .L_AgaveManifestRequirementsErrorOmex_ERR ||
                                        Strings.OsfRuntime.L_AgaveManifestError_ERR;
                                    b.LoaderUtil.failWithError(e, {
                                        description: u,
                                        url: i,
                                        detailView: a,
                                        errorCode:
                                            OSF.ErrorStatusCodes.WAC_AgaveRequirementsErrorOmex,
                                    });
                                    return;
                                }
                                l.requirementsSupported = a;
                                f._telemetryContext.setFlag(b.FlagName.ManifestTrustCachedFlag, !s);
                                var r = OSF.OUtil.formatString(
                                    OSF.Constants.ActivatedCacheKey,
                                    h.assetId.toLowerCase(),
                                    h.storeType,
                                    h.storeId
                                );
                                if (s && !e.skipTrust(h)) {
                                    var A = function() {
                                            f.restartActivationTelemetry();
                                            f._cacheManager.SetCacheItem(r, a);
                                            if (f._anonymous) {
                                                e.load(
                                                    {
                                                        entitlement: g,
                                                        manifest: l,
                                                        eToken: o.etoken,
                                                    },
                                                    c
                                                );
                                                return;
                                            }
                                            f.getETokenAndManifest(n, g, g.storeId, function(d) {
                                                if (
                                                    d.status != b.DataServiceResultCode.Succeeded ||
                                                    d.value.status2 != OSF.OmexClientAppStatus.OK
                                                ) {
                                                    b.LoaderUtil.failWithError(e, {
                                                        infoType: OSF.InfoType.Error,
                                                        buttonTxt:
                                                            Strings.OsfRuntime.L_RetryButton_TXT,
                                                        buttonCallback: function() {
                                                            e.restartActivation();
                                                            f.restartActivationTelemetry();
                                                            j();
                                                        },
                                                        description:
                                                            Strings.OsfRuntime
                                                                .L_AgaveServerConnectionFailed_ERR,
                                                        errorCode:
                                                            OSF.ErrorStatusCodes
                                                                .WAC_AgaveManifestAndEtokenRequestFailure,
                                                    });
                                                    return;
                                                }
                                                if (
                                                    d.value.version != c &&
                                                    b.ManifestUtil.versionLessThan(
                                                        g.appVersion,
                                                        d.value.version
                                                    )
                                                )
                                                    g.appVersion = d.value.version;
                                                q(a);
                                            });
                                        },
                                        z = OSF.OmexClientNames[f._initParam.appName],
                                        y = f._anonymous && f._cacheManager.GetCacheItem(r, d);
                                    if (!y && !e.hasConsent(h) && !e.isForCustomFunctionSandbox()) {
                                        e.askForTrust(
                                            {
                                                anonymous: d,
                                                clientName: z,
                                                entitlement: g,
                                                displayName: l.getDefaultDisplayName(),
                                                providerName: l.getProviderName(),
                                                iconUrl: l.getDefaultIconUrl(),
                                                url: i,
                                                isSSOAddin: l.isSSOAddin(),
                                            },
                                            A
                                        );
                                        return;
                                    }
                                }
                                e.hasConsent(h) && f._cacheManager.SetCacheItem(r, a);
                                var p = k.version;
                                if (b.ManifestUtil.versionLessThan(p, h.appVersion))
                                    p = h.appVersion;
                                if (b.ManifestUtil.versionLessThan(v, p)) {
                                    g.appVersion = p;
                                    b.LoaderUtil.showWarning(e, {
                                        description: Strings.OsfRuntime.L_AgaveNewerVersion_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_UpdateButton_TXT,
                                        buttonCallback: function() {
                                            e.restartActivation();
                                            f.restartActivationTelemetry();
                                            e.setIsUpgrading(a);
                                            j(a);
                                            t();
                                        },
                                        url: i,
                                        highPriority: a,
                                        displayDeactive: d,
                                        errorCode: OSF.ErrorStatusCodes.E_MANIFEST_UPDATE_AVAILABLE,
                                    });
                                } else if (k.state2 === OSF.OmexState.DeveloperWithdrawn)
                                    b.LoaderUtil.showWarning(e, {
                                        description: Strings.OsfRuntime.L_AgaveRetiring_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_OkButton_TXT,
                                        url: i,
                                        displayDeactive: d,
                                        errorCode:
                                            OSF.ErrorStatusCodes
                                                .S_OEM_EXTENSION_DEVELOPER_WITHDRAWN_FROM_SALE,
                                    });
                                else if (k.state2 === OSF.OmexState.Flagged)
                                    b.LoaderUtil.showWarning(e, {
                                        description: Strings.OsfRuntime.L_AgaveSoftKilled_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_OkButton_TXT,
                                        url: i,
                                        displayDeactive: d,
                                        errorCode: OSF.ErrorStatusCodes.S_OEM_EXTENSION_FLAGGED,
                                    });
                                else if (
                                    !f._anonymous &&
                                    o.entitlementType &&
                                    o.entitlementType.toLowerCase() ===
                                        OSF.OmexEntitlementType.Trial
                                ) {
                                    b.LoaderUtil.showNotification(e, {
                                        description: Strings.OsfRuntime.L_AgaveTrial_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_BuyButton_TXT,
                                        buttonCallback: function() {
                                            return window.open(i);
                                        },
                                        reDisplay: a,
                                        highPriority: a,
                                        displayDeactive: d,
                                        errorCode: OSF.ErrorStatusCodes.S_OEM_EXTENSION_TRIAL_MODE,
                                    });
                                    b.LoaderUtil.showNotification(e, {
                                        description: Strings.OsfRuntime.L_AgaveTrialRefresh_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_RefreshButton_TXT,
                                        buttonCallback: function() {
                                            e.restartActivation();
                                            f.restartActivationTelemetry();
                                            j(a);
                                        },
                                        detailView: a,
                                        reDisplay: a,
                                        highPriority: a,
                                        displayDeactive: d,
                                        errorCode: OSF.ErrorStatusCodes.S_USER_CLICKED_BUY,
                                    });
                                }
                                e.load({ entitlement: g, manifest: l, eToken: o.etoken }, c);
                                break;
                            case OSF.OmexClientAppStatus.KilledAsset:
                                b.LoaderUtil.failWithError(e, {
                                    description: Strings.OsfRuntime.L_AgaveDisabledByOmex_ERR,
                                    url: i,
                                    errorCode: OSF.ErrorStatusCodes.E_OEM_OMEX_EXTENSION_KILLED,
                                });
                                break;
                            case OSF.OmexClientAppStatus.NoEntitlement:
                            case OSF.OmexClientAppStatus.TrialNotSupported:
                            case OSF.OmexClientAppStatus.LimitedTrial:
                            case OSF.OmexClientAppStatus.EntitlementDeactivated:
                                if (f._anonymous) {
                                    var x = function() {
                                        var b = window.location.href,
                                            a =
                                                f._initParam.omexBaseUrl +
                                                OSF.Constants.SignInRedirectUrl +
                                                encodeURIComponent(b);
                                        window.open(a);
                                    };
                                    b.LoaderUtil.failWithError(e, {
                                        title: Strings.OsfRuntime.L_AgaveSigninRequiredTitle_TXT,
                                        description:
                                            Strings.OsfRuntime.L_AgaveNotViewableAnonymous_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_SignInButton_TXT,
                                        buttonCallback: x,
                                        errorCode: OSF.ErrorStatusCodes.E_USER_NOT_SIGNED_IN,
                                    });
                                } else {
                                    var w = function() {
                                        window.open(i);
                                        b.LoaderUtil.showWarning(e, {
                                            description:
                                                Strings.OsfRuntime
                                                    .L_AgaveLicenseNotAquiredRefresh_ERR,
                                            buttonTxt: Strings.OsfRuntime.L_RefreshButton_TXT,
                                            buttonCallback: function() {
                                                e.restartActivation();
                                                f.restartActivationTelemetry();
                                                j(a);
                                            },
                                            detailView: a,
                                            retryAll: a,
                                            errorCode:
                                                OSF.ErrorStatusCodes.E_OEM_EXTENSION_NOT_ENTITLED,
                                        });
                                    };
                                    e.setRetryCall(function() {
                                        f.restartActivationTelemetry();
                                        j(a);
                                    });
                                    b.LoaderUtil.failWithWarning(e, {
                                        description:
                                            Strings.OsfRuntime.L_AgaveLicenseNotAquired_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_BuyButton_TXT,
                                        buttonCallback: w,
                                        errorCode:
                                            OSF.ErrorStatusCodes.E_OEM_EXTENSION_NOT_ENTITLED,
                                    });
                                }
                                break;
                            case OSF.OmexClientAppStatus.UnknownAssetId:
                                b.LoaderUtil.failWithError(e, {
                                    description: Strings.OsfRuntime.L_AgaveNotExist_ERR,
                                    errorCode: OSF.ErrorStatusCodes.E_MANIFEST_DOES_NOT_EXIST,
                                });
                                break;
                            case OSF.OmexClientAppStatus.Expired:
                            case OSF.OmexClientAppStatus.Invalid:
                                b.LoaderUtil.failWithWarning(e, {
                                    description: Strings.OsfRuntime.L_AgaveLicenseExpired_ERR,
                                    buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                    buttonCallback: function() {
                                        e.restartActivation();
                                        f.restartActivationTelemetry();
                                        j();
                                    },
                                    errorCode: OSF.ErrorStatusCodes.E_TOKEN_EXPIRED,
                                });
                                break;
                            case OSF.OmexClientAppStatus.Revoked:
                                b.LoaderUtil.failWithError(e, {
                                    description: Strings.OsfRuntime.L_AgaveRetired_ERR,
                                    url: i,
                                    errorCode:
                                        OSF.ErrorStatusCodes.E_OEM_EXTENSION_WITHDRAWN_FROM_SALE,
                                });
                                break;
                            case OSF.OmexClientAppStatus.VersionMismatch:
                                g.appVersion = o.version;
                                e.askForUpgrade(
                                    b.LoaderUtil.warning({
                                        description: Strings.OsfRuntime.L_AgaveNewerVersion_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_UpdateButton_TXT,
                                        url: i,
                                        highPriority: a,
                                        logAsError: a,
                                        errorCode: OSF.ErrorStatusCodes.E_MANIFEST_UPDATE_AVAILABLE,
                                    }),
                                    function() {
                                        f.restartActivationTelemetry();
                                        e.setIsUpgrading(a);
                                        j(a);
                                    }
                                );
                                break;
                            case OSF.OmexClientAppStatus.VersionNotSupported:
                                b.LoaderUtil.failWithWarning(
                                    e,
                                    {
                                        description:
                                            Strings.OsfRuntime.L_AgaveUnsupportedStoreType_ERR,
                                        errorCode:
                                            OSF.ErrorStatusCodes.WAC_AgaveUnsupportedStoreType,
                                    },
                                    OSF.OsfControlStatus.UnsupportedStore
                                );
                                break;
                            case OSF.OmexClientAppStatus.UserIsMinor:
                                m &&
                                    m.enableDisplayBlockedMinorError &&
                                    b.LoaderUtil.failWithError(e, {
                                        description: Strings.OsfRuntime.L_AgaveDisabledForMinor_ERR,
                                        errorCode:
                                            OSF.ErrorStatusCodes
                                                .E_TRUSTCENTER_APP_BLOCKED_FOR_MINOR,
                                    });
                                break;
                            default:
                                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                    'unknown clientAppStatus in manifestAndEtoken: ' + o.status2,
                                    c,
                                    f._telemetryContext.correlationId,
                                    20030238
                                );
                                b.LoaderUtil.failWithError(e, {
                                    description:
                                        Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                                    buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                    buttonCallback: function() {
                                        e.restartActivation();
                                        f.restartActivationTelemetry();
                                        j(a);
                                    },
                                    errorCode: OSF.ErrorStatusCodes.WAC_AgaveUnknownClientAppStatus,
                                });
                        }
                    },
                    j = function(h) {
                        var i = l ? l.contentMarket : g.storeId,
                            p = function(c, g) {
                                if (c.status != b.DataServiceResultCode.Succeeded) {
                                    if (m && m.enableDisplayBlockedMinorError)
                                        if (c.httpStatus === 451) {
                                            b.LoaderUtil.failWithError(e, {
                                                description:
                                                    Strings.OsfRuntime.L_AgaveDisabledForMinor_ERR,
                                                errorCode:
                                                    OSF.ErrorStatusCodes
                                                        .E_TRUSTCENTER_APP_BLOCKED_FOR_MINOR,
                                            });
                                            return a;
                                        }
                                    b.LoaderUtil.failWithError(e, {
                                        description:
                                            Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                        buttonCallback: function() {
                                            e.restartActivation();
                                            f.restartActivationTelemetry();
                                            j(h);
                                        },
                                        errorCode: g,
                                    });
                                    return a;
                                }
                                return d;
                            };
                        if (e.skipTrust(g)) {
                            f.getManifest(
                                n,
                                g,
                                i,
                                function(b) {
                                    if (p(b, OSF.ErrorStatusCodes.WAC_AgaveManifestRequestFailure))
                                        return;
                                    if (h) {
                                        k = c;
                                        s(a);
                                        return;
                                    }
                                    r({
                                        etoken: '',
                                        status2: b.value.status2,
                                        manifest: b.value.manifest,
                                    });
                                },
                                h
                            );
                            return;
                        }
                        f.getETokenAndManifest(
                            n,
                            g,
                            i,
                            function(b) {
                                if (
                                    p(
                                        b,
                                        OSF.ErrorStatusCodes
                                            .WAC_AgaveManifestAndEtokenRequestFailure
                                    )
                                )
                                    return;
                                if (h) {
                                    k = c;
                                    o = d;
                                    q(a);
                                    s(a);
                                    return;
                                }
                                r(b.value);
                            },
                            h
                        );
                    },
                    t = function() {
                        var a = OSF.OUtil.formatString(
                            b.CacheConsts.anonymousAppInstallInfoCacheKey,
                            g.assetId,
                            g.storeId
                        );
                        f._cacheManager.RemoveCacheItem(a);
                    },
                    p = function() {
                        if (k == c || !o) return;
                        if (l != c) {
                            g.appVersion = l.version;
                            j();
                            return;
                        }
                        var d, m, q;
                        if (k.state2 === OSF.OmexState.Flagged) d = a;
                        else if (k.state2 === OSF.OmexState.DeveloperWithdrawn) m = a;
                        else if (k.state2 === OSF.OmexState.Withdrawn) q = a;
                        if (d || m || q) {
                            b.LoaderUtil.failWithError(e, {
                                description: Strings.OsfRuntime.L_AgaveRetired_ERR,
                                url: i,
                                errorCode: OSF.ErrorStatusCodes.E_OEM_EXTENSION_WITHDRAWN_FROM_SALE,
                            });
                            if (d) return;
                        }
                        if (e.hasConsent(h)) {
                            j();
                            return;
                        }
                        var s = l ? l.contentMarket : g.storeId;
                        f.getManifest(n, g, s, function(c) {
                            if (c.status != b.DataServiceResultCode.Succeeded) {
                                b.LoaderUtil.failWithError(e, {
                                    description:
                                        Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                                    buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                    buttonCallback: function() {
                                        e.restartActivation();
                                        f.restartActivationTelemetry();
                                        p();
                                    },
                                    errorCode: OSF.ErrorStatusCodes.WAC_AgaveManifestRequestFailure,
                                });
                                return;
                            }
                            r(
                                {
                                    etoken: '',
                                    status2: c.value.status2,
                                    manifest: c.value.manifest,
                                },
                                a
                            );
                        });
                    },
                    q = function(h) {
                        l = c;
                        o = d;
                        f.getEntitlements(
                            n,
                            d,
                            function(h) {
                                if (h.status != b.DataServiceResultCode.Succeeded) {
                                    if (m && m.enableDisplayBlockedMinorError)
                                        if (h.httpStatus === 451) {
                                            b.LoaderUtil.failWithError(e, {
                                                description:
                                                    Strings.OsfRuntime.L_AgaveDisabledForMinor_ERR,
                                                errorCode:
                                                    OSF.ErrorStatusCodes
                                                        .E_TRUSTCENTER_APP_BLOCKED_FOR_MINOR,
                                            });
                                            return;
                                        }
                                    b.LoaderUtil.failWithError(e, {
                                        description:
                                            Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                        buttonCallback: function() {
                                            e.restartActivation();
                                            q();
                                        },
                                        errorCode:
                                            OSF.ErrorStatusCodes.WAC_AgaveEntitlementRequestFailure,
                                    });
                                    return;
                                }
                                if (
                                    h.value.killed.some(function(a) {
                                        return a.assetId == g.assetId;
                                    })
                                ) {
                                    b.LoaderUtil.failWithError(e, {
                                        description: Strings.OsfRuntime.L_AgaveDisabledByOmex_ERR,
                                        url: i,
                                        errorCode: OSF.ErrorStatusCodes.E_OEM_OMEX_EXTENSION_KILLED,
                                    });
                                    return;
                                }
                                h.value.entitlements.some(function(b) {
                                    if (b.assetId.toLowerCase() == g.assetId.toLowerCase()) {
                                        l = b;
                                        i = f.getOmexEndPointPageUrl(b.assetId, b.contentMarket);
                                        return a;
                                    }
                                    return d;
                                });
                                f._telemetryContext.setFlag(
                                    b.FlagName.OmexHasEntitlementFlag,
                                    l != c
                                );
                                o = a;
                                p();
                            },
                            h
                        );
                    },
                    s = function(a) {
                        k = c;
                        f.getAppState(
                            n,
                            g,
                            function(a) {
                                if (a.status != b.DataServiceResultCode.Succeeded) {
                                    k = {
                                        state2: OSF.OmexState.OK,
                                        productId: c,
                                        assetId: g.assetId,
                                        version: g.appVersion,
                                        refreshRate2: 0,
                                    };
                                    p();
                                    return;
                                }
                                var d = a.value.state2;
                                if (d === OSF.OmexState.Killed) {
                                    b.LoaderUtil.failWithError(e, {
                                        description: Strings.OsfRuntime.L_AgaveDisabledByOmex_ERR,
                                        url: i,
                                        errorCode: OSF.ErrorStatusCodes.E_OEM_OMEX_EXTENSION_KILLED,
                                    });
                                    return;
                                }
                                k = a.value;
                                p();
                            },
                            a
                        );
                    };
                s();
                q();
            };
            e.prototype.restartActivationTelemetry = function() {
                var a = this;
                a._telemetryContext.startActivity(b.Activity.Activation);
                a._telemetryContext.startActivity(b.Activity.ServerCall);
                a._telemetryContext.setFlag(b.FlagName.AnonymousFlag, a._anonymous);
            };
            return e;
        })(),
        e = (function() {
            function e(e, d) {
                if (d === void 0) d = c;
                this._anonymous = a;
                this._initParam = e;
                this._cacheManager =
                    d ||
                    new b.AppsDataCacheManager(OSF.OUtil.getLocalStorage(), new b.SafeSerializer());
            }
            e.prototype.GetCacheKeyPrefix = function() {
                if (this._anonymous) return b.CacheConsts.anonymousCacheKeyPrefix;
                return b.WACUtils.CacheConstants.GatedCacheKeyPrefix;
            };
            e.prototype.getOmexEndPointPageUrl = function(b, a) {
                return OSF.OUtil.formatString(
                    '{0}/{1}/downloads/{2}.aspx',
                    this._initParam.omexBaseUrl,
                    a,
                    b
                );
            };
            e.prototype.getDataService = function(a, g) {
                var d = this,
                    e = d;
                if (d._dataService != c) {
                    g({ status: b.DataServiceResultCode.Succeeded, value: d._dataService });
                    return;
                }
                if (d._dataServiceReady != c) {
                    a.startActivity(b.Activity.Authentication);
                    var j = d._dataServiceReady;
                    d._dataServiceReady = function(c) {
                        a.stopActivity(b.Activity.Authentication);
                        j(c);
                        g(c);
                    };
                    return;
                } else d._dataServiceReady = g;
                var f = { status: b.DataServiceResultCode.Failed, value: c },
                    h = function(a, d) {
                        var g = e._dataServiceReady;
                        e._dataServiceReady = c;
                        if (a.status == b.DataServiceResultCode.Succeeded) {
                            e._anonymous = a.value.anonymous;
                            e._dataService = d;
                            f.value = d;
                            f.status = b.DataServiceResultCode.Succeeded;
                            g(f);
                        } else {
                            f.httpStatus = a.httpStatus;
                            g(f);
                        }
                    };
                a.startActivity(b.Activity.Authentication);
                var i = new b.S2SOmexCatalogService(d._initParam);
                i.initialize(a.correlationId, function(d) {
                    if (d.status == b.DataServiceResultCode.Succeeded) {
                        var f = b.HostFeatureEnabledInfo.getHostFeatureEnabledInfo();
                        if (
                            !(f && f.enableAnonymousUseLegacyCatalogService) ||
                            !d.value.anonymous
                        ) {
                            a.stopActivity(b.Activity.Authentication);
                            h(d, i);
                            return;
                        }
                    }
                    a.setBits(b.FlagName.ActivationRuntimeType, OSF.ActivationTypes.V2Enabled);
                    var c = b.ProxyBasedCatalogService.getInstance(e._initParam);
                    c.prepareProxy(a.correlationId, function(d) {
                        a.stopActivity(b.Activity.Authentication);
                        a.setBits(b.FlagName.RetryCount, c.omexAuthConnectTries);
                        h(d, c);
                    });
                });
            };
            e.prototype.createActivityScope = function(d, e) {
                var a = this;
                this.getDataService(d, function(i) {
                    if (b.AsyncUtil.failed(i, e)) {
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'failed to get data service.',
                            c,
                            d.correlationId,
                            18657692
                        );
                        return;
                    }
                    d.setFlag(b.FlagName.AnonymousFlag, a._anonymous);
                    var h = i.value,
                        g = {
                            cacheManager: a._cacheManager,
                            cachePrefix: a.GetCacheKeyPrefix(),
                            cid: h.getCID(),
                            anonymous: a._anonymous,
                            telemetryContext: d,
                        },
                        j = h.createScope(g),
                        k = new f(g, a._initParam);
                    e({
                        status: b.DataServiceResultCode.Succeeded,
                        value: { serviceScope: j, activityScope: k },
                    });
                });
            };
            e.prototype.getEntitlementAsync = function(c, d, a, f, e) {
                var g = this;
                this.createActivityScope(d, function(d) {
                    if (b.AsyncUtil.failed(d, a, [])) return;
                    if (g._anonymous) {
                        a({ status: b.DataServiceResultCode.Failed, httpStatus: 403 });
                        return;
                    }
                    var h = d.value.serviceScope;
                    h.getEntitlementAsync(
                        c,
                        function(e) {
                            if (b.AsyncUtil.failed(e, a, [])) return;
                            for (var f = e.value.entitlements, g = 0; g < f.length; g++) {
                                var d = f[g],
                                    c = d;
                                c.appVersion = d.version;
                                c.storeId = d.contentMarket;
                                c.storeType = OSF.StoreType.OMEX;
                                c.targetType = OSF.OUtil.getTargetType(d.appSubType);
                            }
                            a({ status: e.status, value: f });
                        },
                        f,
                        e
                    );
                });
            };
            e.prototype.getAndCacheManifest = function(e, i, g, a, f) {
                var j = this;
                f = f || d;
                var h = OSF.OsfManifestManager.getCachedManifest(e.assetId, e.appVersion);
                if (!f && h != c) {
                    a({ status: b.DataServiceResultCode.Succeeded, value: h });
                    return;
                }
                this.createActivityScope(g, function(d) {
                    if (b.AsyncUtil.failed(d, a)) return;
                    var h = d.value.serviceScope,
                        k = d.value.activityScope;
                    k.getManifest(
                        h,
                        e,
                        i,
                        function(f) {
                            if (b.AsyncUtil.failed(f, a)) return;
                            if (f.value.status2 != OSF.OmexClientAppStatus.OK) {
                                a({ status: b.DataServiceResultCode.Failed });
                                return;
                            }
                            var d = b.ManifestUtil.ParseManifest(
                                f.value.manifest,
                                j._initParam.appUILocale,
                                g.correlationId
                            );
                            if (d == c) {
                                a({ status: b.DataServiceResultCode.Failed, value: d });
                                return;
                            }
                            OSF.OsfManifestManager.cacheManifest(e.assetId, e.appVersion, d);
                            a({ status: b.DataServiceResultCode.Succeeded, value: d });
                        },
                        f
                    );
                });
            };
            e.prototype.activateAsync = function(e, d, c) {
                var f = this;
                c.startActivity(b.Activity.Activation);
                c.startActivity(b.Activity.ServerCall);
                this.createActivityScope(c, function(g) {
                    f.isStoreDisabled(c, function(h) {
                        if (h.value === a)
                            b.LoaderUtil.failWithError(d, {
                                description: Strings.OsfRuntime.L_OmexStoreDisabledByAdmin,
                                errorCode:
                                    OSF.ErrorStatusCodes
                                        .E_TRUSTCENTER_CATALOG_UNTRUSTED_ADMIN_CONTROLLED,
                            });
                        else if (g.status != b.DataServiceResultCode.Succeeded) {
                            b.LoaderUtil.failWithError(d, {
                                description: Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                                buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                buttonCallback: function() {
                                    d.restartActivation();
                                    f.activateAsync(e, d, c);
                                },
                                errorCode:
                                    OSF.ErrorStatusCodes.WAC_AgaveAnonymousProxyCreationError,
                            });
                            return;
                        }
                    });
                    var h = g.value.serviceScope,
                        i = g.value.activityScope;
                    i.activate(h, e, d);
                });
            };
            e.prototype.removeAsync = function(d, c, a) {
                this.createActivityScope(c, function(c) {
                    if (b.AsyncUtil.failed(c, a)) return;
                    var e = c.value.serviceScope,
                        f = c.value.activityScope;
                    f.removeApps(e, d, a);
                });
            };
            e.prototype.getAppDetails = function(i, m, l, e, n) {
                var f = this,
                    p = f,
                    d = [];
                if (n) f._cacheManager.RemoveAll(b.CacheConsts.ungatedCacheKeyPrefix);
                else {
                    for (var k = i, h = [], g = 0; g < k.length; ++g) {
                        var o = OSF.OUtil.formatString(b.CacheConsts.appDetailKey, k[g]),
                            j = f._cacheManager.GetCacheItem(o, a);
                        if (j && j.state2 != c) d.push(j);
                        else h.push(k[g]);
                    }
                    if (h.length === 0) {
                        e({ status: b.DataServiceResultCode.Succeeded, value: d });
                        return;
                    }
                    i = h;
                }
                f.createActivityScope(l, function(a) {
                    if (b.AsyncUtil.failed(a, e, d)) return;
                    var c = a.value.serviceScope;
                    c.getAppDetails(i, m, function(a) {
                        if (b.AsyncUtil.failed(a, e, d)) return;
                        for (var g = a.value, f = 0; f < g.length; ++f) {
                            var c = g[f],
                                h = OSF.OUtil.formatString(b.CacheConsts.appDetailKey, c.assetId);
                            p._cacheManager.SetCacheItem(h, c);
                            d.push(c);
                        }
                        a.value = d;
                        e(a);
                    });
                });
            };
            e.prototype.isStoreDisabled = function(c, a) {
                this.createActivityScope(c, function(c) {
                    if (b.AsyncUtil.failed(c, a, d)) return;
                    var e = c.value.serviceScope;
                    e.isStoreDisabled(a);
                });
            };
            return e;
        })();
    b.OmexCatalog = e;
    b.CatalogFactory.register(OSF.StoreType.OMEX, function(c) {
        if (c.allowExternalMarketplace && c.osfOmexBaseUrl) {
            var d,
                f = c.osfOmexBaseUrl.indexOf(OSF.Constants.ProtocolSeparator);
            if (f >= 0) d = c.osfOmexBaseUrl.substr(f);
            else d = OSF.Constants.ProtocolSeparator + c.osfOmexBaseUrl;
            var g = OSF.Constants.Https + d;
            if (
                OSF.OUtil.getQueryStringParamValue(
                    window.location.search,
                    OSF.Constants.OmexForceAnonymousParamName
                ).toLowerCase() == OSF.Constants.OmexForceAnonymousParamValue.toLowerCase()
            )
                c.omexForceAnonymous = a;
            var h = new e({
                appName: c.appName,
                appUILocale: c.appUILocale,
                AppVersion: c.appVersion,
                clientMode: c.clientMode,
                docUrl: c.docUrl,
                omexBaseUrl: g,
                omexForceAnonymous: c.omexForceAnonymous,
            });
            return h;
        }
        return new b.ForbiddenCatalog({
            loaderParams: b.LoaderUtil.error({
                description: Strings.OsfRuntime.L_AgaveOmexNotConfigured_ERR,
                errorCode: OSF.ErrorStatusCodes.E_TRUSTCENTER_CATALOG_UNTRUSTED_ADMIN_CONTROLLED,
            }),
            controlStatus: OSF.OsfControlStatus.ActivationFailed,
        });
    });
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var a = (function() {
        function a() {}
        a.anonymousCacheKeyPrefix = '__OSF_ANONYMOUS_OMEX.';
        a.ungatedCacheKeyPrefix = '__OSF_OMEX.';
        a.manifestRefreshRate = 5 * 365;
        a.hourToDayConversionFactor = 24;
        a.anonymousAppInstallInfoCacheKey = a.anonymousCacheKeyPrefix + 'appInstallInfo.{0}.{1}';
        a.firstPartyAddinListCacheKey = a.anonymousCacheKeyPrefix + 'firstPartyAddInList';
        a.firstPartyManifestCacheKey = a.anonymousCacheKeyPrefix + 'firstPartyManifest.{0}';
        a.killedAppsCacheKey = '{0}killedApps';
        a.appStateCacheKey = '{0}appState.{1}.{2}';
        a.appDetailKey = '__OSF_OMEX.appDetails.{0}';
        return a;
    })();
    b.CacheConsts = a;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = null,
        c = true,
        d = (function() {
            function d(d, c, b) {
                var a = this;
                a._handler = d;
                a._initParam = c;
                a._cacheManager = b.cacheManager;
                a._cachePrefix = b.cachePrefix;
                a._cid = b.cid;
                a._correlationId = b.telemetryContext.correlationId;
            }
            d.prototype.tryFail = function(b, d) {
                if (b == 200) return false;
                d({ httpStatus: b, status: a.DataServiceResultCode.Failed });
                return c;
            };
            d.prototype.getLastStoreUpdate = function(c) {
                var b = this,
                    d = b,
                    e = b._initParam.appUILocale;
                b._handler.getLastStoreUpdate(e, b._correlationId, function(b, e) {
                    if (d.tryFail(b, c)) {
                        d.logServiceCallResponseError('laststoreupdate', b);
                        return;
                    }
                    c({
                        status: a.DataServiceResultCode.Succeeded,
                        value: a.OmexXmlProcessor.ProcessLastStoreUpdate(e),
                    });
                });
            };
            d.prototype.getEntitlementAsync = function(j, f, l, k) {
                var d = this,
                    e = d,
                    h = OSF.OmexAppVersions[d._initParam.appName],
                    g = OSF.OUtil.formatString(
                        d._cachePrefix + a.WACUtils.CacheConstants.EntitlementsKey,
                        h,
                        d._cid
                    );
                if (l) d._cacheManager.RemoveCacheItem(g);
                else {
                    var i = d._cacheManager.GetCacheItem(g, c, b, k);
                    if (i != b) {
                        f({ status: a.DataServiceResultCode.Succeeded, value: i });
                        return;
                    }
                }
                d._handler.getEntitlement(j, h, d._correlationId, function(c, d) {
                    if (e.tryFail(c, f)) {
                        e.logServiceCallResponseError('entitlement', c);
                        return;
                    }
                    var b = a.OmexXmlProcessor.ProcessEntitlement(d);
                    b.cid = e._cid;
                    e._cacheManager.SetCacheItem(
                        g,
                        b,
                        b.refreshRate2 / a.CacheConsts.hourToDayConversionFactor
                    );
                    f({ status: a.DataServiceResultCode.Succeeded, value: b });
                });
            };
            d.prototype.getEToken = function(b, e, c) {
                var d = this,
                    h = e,
                    i = b.storeId,
                    f = b.assetId,
                    g = b.appVersion;
                this._handler.getEToken(i, h, f, g, this._correlationId, function(b, e) {
                    if (d.tryFail(b, c)) {
                        d.logServiceCallResponseError('etoken', b);
                        return;
                    }
                    c({
                        status: a.DataServiceResultCode.Succeeded,
                        value: a.OmexXmlProcessor.ProcessClientAppInstallInfo(
                            e,
                            OSF.ClientAppInfoReturnType.etokenOnly
                        ),
                    });
                });
            };
            d.prototype.getETokenAndManifest = function(d, c, b) {
                var e = this;
                this.getEToken(d, c, function(f) {
                    if (f.status != a.DataServiceResultCode.Succeeded) {
                        b(f);
                        return;
                    }
                    e.getManifest(d, c, function(c) {
                        if (c.status != a.DataServiceResultCode.Succeeded) {
                            f.status = c.status;
                            f.httpStatus = c.httpStatus;
                            b(f);
                            return;
                        }
                        f.value.manifest = c.value.manifest;
                        b(f);
                    });
                });
            };
            d.prototype.getManifest = function(c, b, d) {
                var e = b;
                this._handler.getManifest(e, c.assetId, this._correlationId, function(c, b) {
                    d({
                        status: a.DataServiceResultCode.Succeeded,
                        value: a.OmexXmlProcessor.ConvertAnonymousManifest(c, b),
                    });
                });
            };
            d.prototype.getAppState = function(b, c) {
                var d = this,
                    e = b.storeId + ':' + b.assetId;
                this._handler.getAppState(e, this._correlationId, function(b, e) {
                    if (d.tryFail(b, c)) {
                        d.logServiceCallResponseError('appstate', b);
                        return;
                    }
                    c({
                        status: a.DataServiceResultCode.Succeeded,
                        value: a.OmexXmlProcessor.ProcessAppState(e),
                    });
                });
            };
            d.prototype.getKilledApps = function(b) {
                var c = this;
                this._handler.getKilledApps(this._correlationId, function(d, e) {
                    if (c.tryFail(d, b)) {
                        c.logServiceCallResponseError('killedapps', d);
                        return;
                    }
                    b({
                        status: a.DataServiceResultCode.Succeeded,
                        value: a.OmexXmlProcessor.ProcessKilledApps(e),
                    });
                });
            };
            d.prototype.getAppDetails = function(e, d, b) {
                var c = this;
                this._handler.getAppDetails(d, e.join(','), this._correlationId, function(d, e) {
                    if (c.tryFail(d, b)) {
                        c.logServiceCallResponseError('appdetails', d);
                        return;
                    }
                    b({
                        status: a.DataServiceResultCode.Succeeded,
                        value: a.OmexXmlProcessor.ProcessAppDetails(e),
                    });
                });
            };
            d.prototype.removeApps = function(d, c) {
                var b = this;
                this._handler.removeApps(d.join(','), this._correlationId, function(e, f) {
                    if (b.tryFail(e, c)) {
                        b.logServiceCallResponseError('removeapps', e);
                        return;
                    }
                    var d = a.OmexXmlProcessor.ProcessRemoveAppResponse(f);
                    d.removedApps.some(function(a) {
                        return a.result2 == OSF.OmexRemoveAppStatus.Success;
                    }) && b.clearEntitlementCache();
                    c({ status: a.DataServiceResultCode.Succeeded, value: d });
                });
            };
            d.prototype.clearEntitlementCache = function() {
                var b = '.*',
                    c = new RegExp(
                        OSF.OUtil.formatString(a.WACUtils.CacheConstants.EntitlementsKey, b, b),
                        'i'
                    );
                this._cacheManager.RemoveMatches([c]);
            };
            d.prototype.isStoreDisabled = function(b) {
                var c = this;
                this._handler.isStoreDisabled(this._correlationId, function(d) {
                    if (d != 200 && d != 403 && d != 401) {
                        c.logServiceCallResponseError('isStoreDisabled', d);
                        b({ status: a.DataServiceResultCode.Failed, value: false });
                        return;
                    }
                    b({ status: a.DataServiceResultCode.Succeeded, value: d == 401 });
                });
            };
            d.prototype.logServiceCallResponseError = function(d, a) {
                var c = 's2s request ' + d + ' failed';
                if (a) c += ':' + a;
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    c,
                    b,
                    this._correlationId,
                    18657699
                );
            };
            return d;
        })();
    a.OmexCatalogServiceS2SScope = d;
    var e = (function() {
        function e(a) {
            this._cid = '';
            this._initParam = a;
        }
        e.initRequestHandler = function(a) {
            if (e._requestHandler == b) e._requestHandler = a;
        };
        e.prototype.getCID = function() {
            return this._cid;
        };
        e.prototype.initialize = function(f, d) {
            var g = this;
            if (e._requestHandler == b) {
                d({ status: a.DataServiceResultCode.Failed, httpStatus: 404 });
                return;
            }
            if (this._initParam.omexForceAnonymous) {
                d({ status: a.DataServiceResultCode.Succeeded, value: { anonymous: c } });
                return;
            }
            e._requestHandler.getUserId(f, function(e, h) {
                if (e == 200) {
                    g._cid = h.trim();
                    d({ status: a.DataServiceResultCode.Succeeded, value: { anonymous: false } });
                } else if (e == 403)
                    d({ status: a.DataServiceResultCode.Succeeded, value: { anonymous: c } });
                else {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        's2s getuserId request failed ' + e,
                        b,
                        f,
                        18657728
                    );
                    d({ status: a.DataServiceResultCode.Failed, httpStatus: e });
                }
            });
        };
        e.prototype.createScope = function(a) {
            return new d(e._requestHandler, this._initParam, a);
        };
        return e;
    })();
    a.S2SOmexCatalogService = e;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var a = (function() {
        var o = 'description',
            n = 'provider',
            m = 'o:assets',
            l = 'contentMarket',
            k = 'appSubType',
            j = 'expirationDate',
            i = 'state',
            d = 'version',
            h = 'productId',
            c = 'assetId',
            g = 'o:asset',
            f = 'o:results',
            e = 'refreshRate',
            a = null;
        function b() {}
        b.ProcessLastStoreUpdate = function(d) {
            var g = {},
                c = new OSF.XmlProcessor(d, _omexXmlNamespaces),
                f = c.getDocumentElement(),
                b = f.selectSingleNode('o:update');
            if (b.firstChild != a) {
                var e = Date.parse(b.firstChild.nodeValue);
                return e;
            }
            return a;
        };
        b.ProcessAppState = function(l) {
            var k = {},
                a = new OSF.XmlProcessor(l, _omexXmlNamespaces),
                p = a.getDocumentElement();
            a.readAttributes(p, { rr: e }, k);
            var m = a.selectSingleNode(f),
                o = a.selectSingleNode('o:lang', m),
                n = a.selectSingleNode(g, o);
            a.readAttributes(
                n,
                {
                    assetid: c,
                    prodid: h,
                    ver: d,
                    state: i,
                    tdurl: 'takeDownUrl',
                    upv: 'unsafePreviousVersion',
                    expiry: j,
                },
                k
            );
            return b.ConvertAppState(k);
        };
        b.ProcessFirstPartyAddInList = function(m) {
            var g = { addInList: {}, refreshRate: a },
                b = new OSF.XmlProcessor(m, _omexXmlNamespaces),
                n = b.getDocumentElement(),
                l = b.selectSingleNode('o:Apps', n),
                j = l.getAttribute('d1p1:rr');
            g.refreshRate = j ? parseInt(j) : 0;
            for (var k = b.selectNodes('o:App', l), i = 0; i < k.length; i++) {
                var h = k[i],
                    f = { assetId: a, path: a, version: a };
                b.readAttributes(h, { assetid: c }, f);
                var e = b.selectSingleNode('o:Path', h);
                f.path =
                    e.text != a ? e.text : e.textContent != a ? e.textContent : e.nodeTypedValue;
                var d = b.selectSingleNode('o:Version', h);
                f.version =
                    d.text != a ? d.text : d.textContent != a ? d.textContent : d.nodeTypedValue;
                g.addInList[f.assetId] = f;
            }
            return g;
        };
        b.ConvertAppState = function(a) {
            a.refreshRate2 = a.refreshRate ? parseInt(a.refreshRate) : 0;
            a.state2 = a.state ? parseInt(a.state) : 0;
            a.expirationDate2 = b.GetTickByDate(a.expirationDate);
            return a;
        };
        b.ProcessEntitlement = function(q) {
            var f = {},
                a = new OSF.XmlProcessor(q, _omexXmlNamespaces),
                m = a.selectSingleNode('o:entitlementlist'),
                r = a.selectSingleNode('o:hdr', m);
            a.readAttributes(r, { pm: 'billingMarket', pagesize: 'pageSize', rr: e }, f);
            for (
                var n = a.selectNodes('o:entitlement', a.selectSingleNode('o:entitlements', m)),
                    o,
                    g,
                    p = [],
                    i = 0;
                i < n.length;
                ++i
            ) {
                g = {};
                o = n[i];
                a.readAttributes(
                    o,
                    {
                        assetid: c,
                        pid: h,
                        ver: d,
                        appst: k,
                        cm: l,
                        trlt: 'licenseType',
                        acqdate: 'acquireDate',
                        expiry2: j,
                        attreq: 'attentionRequired',
                    },
                    g
                );
                p.push(g);
            }
            f.entitlements = p;
            return b.ConvertEntitlementInfo(f);
        };
        b.ConvertEntitlementInfo = function(c) {
            for (var e = c.entitlements, d = 0; d < e.length; ++d) {
                var a = e[d];
                a.appSubType2 = a.appSubType ? parseInt(a.appSubType) : 0;
                a.acquireDate2 = b.GetTickByDate(a.acquireDate);
                a.expirationDate2 = b.GetTickByDate(a.expirationDate);
                a.attentionRequired2 = a.attentionRequired === 'true' ? true : false;
            }
            c.refreshRate2 = c.refreshRate ? parseInt(c.refreshRate) : 0;
            return c;
        };
        b.ProcessKilledApps = function(l) {
            var d = {},
                a = new OSF.XmlProcessor(l, _omexXmlNamespaces),
                p = a.getDocumentElement();
            a.readAttributes(p, { rr: e }, d);
            for (
                var k = [], n = a.selectSingleNode(m), j = a.selectNodes(g, n), i = 0;
                i < j.length;
                ++i
            ) {
                var o = j[i],
                    f = {};
                a.readAttributes(o, { assetid: c, pid: h }, f);
                k.push({ assetId: f.assetId, productId: f.productId });
            }
            d.killedApps = k;
            return b.ConvertKilledAppsInfo(d);
        };
        b.ConvertKilledAppsInfo = function(a) {
            a.refreshRate2 = a.refreshRate ? parseInt(a.refreshRate) : 0;
            return a;
        };
        b.ProcessClientAppInstallInfo = function(k, j) {
            var f = new OSF.XmlProcessor(k, _omexXmlNamespaces),
                n = f.selectSingleNode(m),
                h = f.selectSingleNode(g, n),
                e = { etoken: a, manifest: a };
            if (j === OSF.ClientAppInfoReturnType.urlOnly) f.readAttributes(h, { url: 'url' }, e);
            else if (j === OSF.ClientAppInfoReturnType.etokenOnly)
                f.readAttributes(h, { etok: 'etoken' }, e);
            else f.readAttributes(h, { url: 'url', etok: 'etoken' }, e);
            f.readAttributes(h, { status: 'status', cm: l, assetid: c, ver: d }, e);
            if (j != OSF.ClientAppInfoReturnType.urlOnly && e.etoken) {
                var i = new OSF.XmlProcessor(e.etoken, ''),
                    o = i.selectSingleNode('t', i.selectSingleNode('r'));
                i.readAttributes(
                    o,
                    { te: 'tokenExpirationDate', et: 'entitlementType', cid: 'cid' },
                    e
                );
            }
            return b.ConvertClientAppInstallInfo(e);
        };
        b.ConvertClientAppInstallInfo = function(a) {
            a.status2 = a.status ? parseInt(a.status) : 0;
            a.tokenExpirationDate2 = b.GetTickByDate(a.tokenExpirationDate);
            return a;
        };
        b.ProcessManifest = function(a) {
            return { manifest: a };
        };
        b.ProcessRemoveAppResponse = function(i) {
            var d = {};
            d.removedApps = [];
            for (
                var a = new OSF.XmlProcessor(i, _omexXmlNamespaces),
                    k = a.getDocumentElement(),
                    j = a.selectSingleNode('o:apps', a.selectSingleNode('o:removedApps')),
                    g = a.selectNodes('o:app', j),
                    h,
                    e,
                    f = 0;
                f < g.length;
                ++f
            ) {
                h = g[f];
                e = {};
                a.readAttributes(h, { assetid: c, result: 'result' }, e);
                d.removedApps.push(e);
            }
            return b.ConvertRemoveAppResponse(d);
        };
        b.ConvertRemoveAppResponse = function(c) {
            for (var d = c.removedApps, b = 0; b < d.length; ++b) {
                var a = d[b];
                a.result2 = a.result ? parseInt(a.result) : 0;
            }
            return c;
        };
        b.ProcessAppDetails = function(m) {
            for (
                var a = new OSF.XmlProcessor(m, _omexXmlNamespaces),
                    p = a.selectSingleNode(f),
                    h = a.selectNodes('o:wainfo', p),
                    l,
                    e,
                    j = [],
                    g = 0;
                g < h.length;
                ++g
            ) {
                l = h[g];
                e = {};
                a.readAttributes(
                    l,
                    {
                        assetid: c,
                        defhei: 'defaultHeight',
                        defwid: 'defaultWidth',
                        title: 'name',
                        prov: n,
                        desc: o,
                        icon: 'iconUrl',
                        ver: d,
                        state: i,
                        appst: k,
                        appvers: 'appVersions',
                        req: 'requirements',
                        hosts: 'hosts',
                        highresicon: 'highResolutionIconUrl',
                    },
                    e
                );
                j.push(e);
            }
            return b.ConvertAppDetails(j);
        };
        b.ConvertAppDetails = function(b) {
            for (var c = 0; c < b.length; ++c) {
                var a = b[c];
                a.defaultHeight2 = a.defaultHeight ? parseInt(a.defaultHeight) : 0;
                a.defaultWidth2 = a.defaultWidth ? parseInt(a.defaultWidth) : 0;
                a.state2 = a.state ? parseInt(a.state) : 0;
                a.appSubType2 = a.appSubType ? parseInt(a.appSubType) : 0;
            }
            return b;
        };
        b.ProcessRecommendations = function(l) {
            for (
                var a = new OSF.XmlProcessor(l, _omexXmlNamespaces),
                    m = a.selectSingleNode(f),
                    k = a.selectNodes('o:wa', m),
                    e,
                    j,
                    h = [],
                    b,
                    g = 0;
                g < k.length;
                ++g
            ) {
                e = k[g];
                b = {};
                a.readAttributes(
                    e,
                    {
                        assetid: c,
                        title: 'name',
                        desc: o,
                        icon: 'iconUrl',
                        ver: d,
                        state: i,
                        rat: 'rating',
                        dls: 'downloads',
                        prov: n,
                    },
                    b
                );
                j = a.selectSingleNode('o:price', e);
                a.readAttributes(
                    j,
                    {
                        fop: 'originalPrice',
                        opt: 'originalPriceTier',
                        fpp: 'promotionalPrice',
                        ppt: 'promotionalPriceTier',
                        cmod: 'priceModel',
                    },
                    b
                );
                h.push(b);
            }
            return h;
        };
        b.ConvertAnonymousManifest = function(c, d) {
            var a,
                b = '';
            switch (c) {
                case 200:
                    a = OSF.OmexClientAppStatus.OK;
                    b = d;
                    break;
                case 204:
                case 1223:
                    a = OSF.OmexClientAppStatus.NoEntitlement;
                    break;
                case 400:
                    a = OSF.OmexClientAppStatus.BadRequest;
                    break;
                case 410:
                    a = OSF.OmexClientAppStatus.KilledAsset;
                    break;
                case 404:
                    a = OSF.OmexClientAppStatus.UnknownAssetId;
                    break;
                case 412:
                    a = OSF.OmexClientAppStatus.VersionNotSupported;
                    break;
                case 451:
                    a = OSF.OmexClientAppStatus.UserIsMinor;
                    break;
                default:
                    a = OSF.OmexClientAppStatus.ServerError;
            }
            return { status2: a, manifest: b };
        };
        b.GetTickByDate = function(b) {
            if (b) return new Date(b).getTime();
            return a;
        };
        return b;
    })();
    b.OmexXmlProcessor = a;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        var c = null;
        function b(e, d, f, b) {
            if (b === void 0) b = c;
            this._cacheManager =
                b ||
                new a.AppsDataCacheManager(OSF.OUtil.getLocalStorage(), new a.SafeSerializer());
            this._privateCatalogService = new a.PrivateCatalogService(
                OSF.OmexClientNames[e],
                OSF.OUtil.normalizeAppVersion(d)
            );
            this._uiLocale = f;
        }
        b.prototype.getEntitlementAsync = function(e, c, d, f) {
            c.startActivity(a.Activity.EntitlementCheck);
            if (f) {
                this._cacheManager.RemoveAll(b._addInsCacheKey);
                this._cacheManager.RemoveCacheItem(b._lastCatalogUpdateKey);
            }
            this.GetAddInList(
                e,
                c,
                function(f) {
                    for (var g = [], e = 0; e < f.length; e++) {
                        var h = f[e];
                        h.addInState === b._addInOkState && g.push(h);
                    }
                    c.stopActivity(a.Activity.EntitlementCheck);
                    d({ status: a.DataServiceResultCode.Succeeded, value: g });
                },
                function(a) {
                    d({ status: a });
                }
            );
        };
        b.prototype.getAppDetails = function(h, o, j, i, m) {
            var e = this,
                l = e;
            m && e._cacheManager.RemoveAll(b._addInDetailsCacheKeyPrefix);
            for (var d = [], g = [], f = 0; f < h.length; f++) {
                var n = b.GetAppDetailsCacheKey(h[f].ProductId),
                    k = e._cacheManager.GetCacheItem(n);
                if (k) d.push(k);
                else g.push(h[f]);
            }
            if (g.length === 0) {
                i({ status: a.DataServiceResultCode.Succeeded, value: d });
                return;
            }
            e._privateCatalogService.GetManifests(
                g,
                c,
                c,
                j,
                function(f) {
                    for (var e = 0; e < f.length; e++) {
                        var g = l.ParseAndCacheManifest(f[e], j);
                        if (!g) continue;
                        var c = b.CreateAddInDetails(g);
                        d.push(c);
                        var h = b.GetAppDetailsCacheKey(c.assetId);
                        l._cacheManager.SetCacheItem(h, c, b._addInDetailsRefreshRateDays);
                    }
                    i({ status: a.DataServiceResultCode.Succeeded, value: d });
                },
                function(a) {
                    i({ status: a });
                }
            );
        };
        b.prototype.getAndCacheManifest = function(c, f, g, d) {
            var e = {
                ProductId: c.assetId,
                Version: c.appVersion,
                AddInState: b._addInOkState,
                StoreInfo: { AssetId: c.storeId, ContentMarket: f },
            };
            this.GetManifest(
                e,
                g,
                function(b) {
                    d({ status: a.DataServiceResultCode.Succeeded, value: b });
                },
                function(a) {
                    d({ status: a });
                }
            );
        };
        b.prototype.activateAsync = function(h, e, f) {
            var d = true,
                i = this;
            f.startActivity(a.Activity.Activation);
            var g = this;
            this.GetAddInList(
                false,
                f,
                function(m) {
                    for (var j, l = /[{}]/g, k = 0; k < m.length; k++) {
                        var n = m[k];
                        if (
                            h.assetId.replace(l, '').toLowerCase() ===
                            n.assetId.replace(l, '').toLowerCase()
                        ) {
                            j = n;
                            break;
                        }
                    }
                    if (!j) {
                        a.LoaderUtil.showWarning(e, {
                            description: Strings.OsfRuntime.L_AgaveNotExist_ERR,
                            buttonTxt: Strings.OsfRuntime.L_RefreshButton_TXT,
                            buttonCallback: function() {
                                e.restartActivation();
                                g._cacheManager.RemoveAll(b._addInsCacheKey);
                                g._cacheManager.RemoveCacheItem(b._lastCatalogUpdateKey);
                                g.activateAsync(h, e, f);
                            },
                            detailView: d,
                            retryAll: d,
                            errorCode: OSF.ErrorStatusCodes.E_OEM_EXTENSION_NOT_ENTITLED,
                        });
                        return;
                    }
                    if (j.addInState !== b._addInOkState) {
                        a.LoaderUtil.failWithError(e, {
                            description: Strings.OsfRuntime.L_AgaveDisabledByAdmin_ERR,
                            url: '',
                            errorCode: OSF.ErrorStatusCodes.E_OEM_OMEX_EXTENSION_KILLED,
                        });
                        return;
                    }
                    h.appVersion = j.appVersion;
                    var o = {
                        ProductId: j.assetId,
                        Version: j.appVersion,
                        AddInState: b._addInOkState,
                        StoreInfo: { AssetId: j.storeId, ContentMarket: '' },
                    };
                    i.GetManifest(
                        o,
                        f,
                        function(a) {
                            e.load({ entitlement: h, manifest: a, eToken: '' }, c);
                        },
                        function() {
                            a.LoaderUtil.failWithError(e, {
                                description:
                                    Strings.OsfRuntime.L_AddinCommands_AddinNotSupported_Message,
                                url: '',
                                errorCode: OSF.ErrorStatusCodes.E_MANIFEST_DOES_NOT_EXIST,
                                buttonTxt: Strings.OsfRuntime.L_RefreshButton_TXT,
                                buttonCallback: function() {
                                    e.restartActivation();
                                    g.activateAsync(h, e, f);
                                },
                            });
                        }
                    );
                },
                function() {
                    a.LoaderUtil.showWarning(e, {
                        description: Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                        buttonTxt: Strings.OsfRuntime.L_RefreshButton_TXT,
                        buttonCallback: function() {
                            e.restartActivation();
                            g._cacheManager.RemoveAll(b._addInsCacheKey);
                            g._cacheManager.RemoveCacheItem(b._lastCatalogUpdateKey);
                            g.activateAsync(h, e, f);
                        },
                        detailView: d,
                        retryAll: d,
                        errorCode: OSF.ErrorStatusCodes.WAC_AgaveActivationError,
                    });
                    f.stopActivity(a.Activity.Activation);
                }
            );
        };
        b.prototype.removeAsync = function(d, c, b) {
            b({ status: a.DataServiceResultCode.Failed });
        };
        b.GetAppDetailsCacheKey = function(a) {
            return (
                b._addInDetailsCacheKeyPrefix +
                OSF.OUtil.formatString(b._addInDetailsCacheKeySufix, a)
            );
        };
        b.GetManifestCacheKey = function(c, a) {
            return (
                b._manifestCacheKeyPrefix + OSF.OUtil.formatString(b._manifestCacheKeySufix, c, a)
            );
        };
        b.CreateAddInDetails = function(a) {
            return {
                assetId: a.getMarketplaceID(),
                defaultHeight2: a.getDefaultHeight() || 0,
                defaultHeight: String(a.getDefaultHeight() || 0),
                defaultWidth2: a.getDefaultWidth() || 0,
                defaultWidth: String(a.getDefaultWidth() || 0),
                name: a.getDefaultDisplayName(),
                provider: a.getProviderName(),
                description: a.getDefaultDescription(),
                iconUrl: a.getDefaultIconUrl(),
                version: a.getMarketplaceVersion(),
                state2: 1,
                state: '1',
                appSubType2: a.getOmexTargetCode(),
                appSubType: String(a.getOmexTargetCode()),
                appVersions: undefined,
                requirements: a.getRequirementsXml(),
                hosts: a.getHostsXml(),
                highResolutionIconUrl: a.getDefaultHighResolutionIconUrl(),
            };
        };
        b.prototype.GetAddInList = function(f, g, e, h) {
            var d = this,
                a;
            if (!f) {
                a = this._cacheManager.GetCacheItem(b._addInsCacheKey);
                if (a) {
                    e(a);
                    return;
                }
            }
            this._privateCatalogService.GetAddInList(
                c,
                c,
                g,
                function(a) {
                    for (var c = 0; c < a.length; c++) {
                        var h = a[c],
                            g = b.GetAppDetailsCacheKey(h.assetId),
                            f = d._cacheManager.GetCacheItem(g);
                        f && f.version !== h.appVersion && d._cacheManager.RemoveCacheItem(g);
                    }
                    d._cacheManager.SetCacheItem(b._addInsCacheKey, a, b._addInListRefreshRateDays);
                    e(a);
                },
                h
            );
        };
        b.prototype.GetManifest = function(e, f, h, i) {
            var g = this,
                l = g;
            f.startActivity(a.Activity.ManifestRequest);
            var d = OSF.OsfManifestManager.getCachedManifest(e.ProductId, e.Version);
            if (d) {
                f.stopActivity(a.Activity.ManifestRequest);
                h(d);
                return;
            }
            var k = b.GetManifestCacheKey(e.ProductId, e.Version),
                j = g._cacheManager.GetCacheItem(k);
            if (j) {
                d = new OSF.Manifest.Manifest(j, g._uiLocale);
                if (!d) {
                    i(a.DataServiceResultCode.Failed);
                    return;
                }
                f.stopActivity(a.Activity.ManifestRequest);
                h(d);
                return;
            }
            g._privateCatalogService.GetManifests(
                [e],
                c,
                c,
                f,
                function(b) {
                    d = l.ParseAndCacheManifest(b[0], f);
                    if (!d) {
                        i(a.DataServiceResultCode.Failed);
                        return;
                    }
                    OSF.OsfManifestManager.cacheManifest(e.ProductId, e.Version, d);
                    f.stopActivity(a.Activity.ManifestRequest);
                    h(d);
                },
                function(a) {
                    i(a);
                }
            );
        };
        b.prototype.ParseAndCacheManifest = function(d, f) {
            try {
                var a = new OSF.Manifest.Manifest(d, this._uiLocale),
                    g = b.GetManifestCacheKey(a.getMarketplaceID(), a.getMarketplaceVersion());
                this._cacheManager.SetCacheItem(g, d, b._addInManifestRefreshRateDays);
                return a;
            } catch (e) {
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    'Invalid manifest retrieved from Private Catalog.',
                    e,
                    f.correlationId,
                    19965729
                );
            }
            return c;
        };
        b._addInsCacheKey = '__OSF_PRIVATECATALOG_ADDINS';
        b._addInDetailsCacheKeyPrefix = '__OSF_PRIVATECATALOG_ADDINDETAILS';
        b._addInDetailsCacheKeySufix = '_{0}';
        b._manifestCacheKeyPrefix = '__OSF_PRIVATECATALOG_MANIFEST';
        b._manifestCacheKeySufix = '_{0}_{1}';
        b._lastCatalogUpdateKey = '_OSF_PRIVATECATALOG_LASTUPDATE';
        b._addInListRefreshRateDays = 1 / 24;
        b._addInDetailsRefreshRateDays = 365;
        b._addInManifestRefreshRateDays = 365;
        b._addInOkState = 'Ok';
        return b;
    })();
    a.PrivateCatalog = b;
    a.CatalogFactory.register(OSF.StoreType.PrivateCatalog, function(a) {
        return new b(a.appName, a.appVersion, a.appUILocale);
    });
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        var d = false,
            b = null;
        function c(b, a) {
            this._clientCode = b;
            this._clientVersion = a;
        }
        c.initRequestHandler = function(f, e, d) {
            if (c._requestHandler == b) c._requestHandler = f;
            if (c.authenticationProxy == b) c.authenticationProxy = e;
            c._isThirdPartyHostEnabled = d;
            c._tokenCacheManager = new a.TokenCacheManager(
                OSF.OUtil.getLocalStorage(),
                new a.SafeSerializer()
            );
            c._cacheManager = new a.AppsDataCacheManager(
                OSF.OUtil.getLocalStorage(),
                new a.SafeSerializer()
            );
        };
        c.ParseAddInList = function(j, e) {
            var f = [],
                d;
            try {
                d = JSON.parse(j);
            } catch (h) {
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    'Could not parse GetAddIns reponse.',
                    h,
                    e.correlationId,
                    19965730
                );
                return b;
            }
            if (!d || !d.AddIns) {
                Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                    'GetPrivateCatalogAddIns response could not be parsed.',
                    e.correlationId,
                    20194262
                );
                return f;
            }
            for (var g = 0, i = d.AddIns; g < i.length; g++) {
                var a = i[g];
                if (!a.AddInState || !a.ProductId || !a.Version) {
                    Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                        OSF.OUtil.formatString(
                            'Add-In metadata was missing some data. ID: "{0}", Version: "{1}", State: "{2}".',
                            a.ProductId || '',
                            a.Version || '',
                            a.AddInState || ''
                        ),
                        e.correlationId,
                        20194263
                    );
                    continue;
                }
                f.push({
                    assetId: a.ProductId,
                    storeId: !a.StoreInfo ? 'none' : a.StoreInfo.AssetId,
                    appVersion: a.Version,
                    storeType: OSF.StoreType.PrivateCatalog,
                    targetType: OSF.OsfControlTarget.Undefined,
                    addInState: a.AddInState,
                    contentMarket: !a.StoreInfo ? '' : a.StoreInfo.ContentMarket,
                });
                c.StoreAuthenticationData(d);
            }
            return f;
        };
        c.ParseAndCacheManifestList = function(j, f) {
            var d = [],
                a;
            try {
                a = JSON.parse(j);
            } catch (g) {
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    'Could not parse GetManifests reponse.',
                    g,
                    f.correlationId,
                    19965731
                );
                return b;
            }
            if (!a || !a.Manifests) {
                Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                    'GetAddInManifests response could not be parsed.',
                    f.correlationId,
                    20194264
                );
                return d;
            }
            for (var e = 0, h = a.Manifests; e < h.length; e++) {
                var i = h[e];
                d.push(i);
            }
            c.StoreAuthenticationData(a);
            return d;
        };
        c.StoreAuthenticationData = function(a) {
            c._tokenCacheManager.AddRefreshToken(a.RefreshToken, a.UserId, a.TenantId);
            c._userId = a.UserId;
            c._tenantId = a.TenantId;
        };
        c.prototype.GetLastPrivateCatalogUpdate = function(h, j, f, i, e) {
            var k = this,
                g = 0;
            c._requestHandler.getLastPrivateCatalogUpdate(
                this._clientCode,
                this._clientVersion,
                h,
                j,
                f.correlationId,
                function(o, q) {
                    g++;
                    if (o === 200) {
                        var m;
                        try {
                            m = JSON.parse(q);
                        } catch (r) {
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                'Could not parse GetLastPrivateCatalogUpdate reponse.',
                                r,
                                f.correlationId,
                                22823177
                            );
                            e(a.DataServiceResultCode.Failed);
                            return;
                        }
                        if (!m || !m.LastUpdate) {
                            Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                                'GetLastPrivateCatalogUpdate response could not be parsed.',
                                f.correlationId,
                                22823178
                            );
                            e(a.DataServiceResultCode.Failed);
                            return;
                        }
                        c.StoreAuthenticationData(m);
                        i(m.LastUpdate);
                        return;
                    }
                    if (o === 403) {
                        if (g == 1) {
                            g++;
                            var n;
                            n = JSON.parse(q);
                            if (n) {
                                var p = c._tokenCacheManager.GetRefreshToken(n.UserId, n.TenantId);
                                if (p != b) {
                                    k.GetLastPrivateCatalogUpdate(h, p, f, i, e);
                                    return;
                                }
                            }
                        }
                        if (g > 2 || h != b) {
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                'Private Catalog: GetLastPrivateCatalogUpdate authentication loop occured.',
                                b,
                                f.correlationId,
                                22823179
                            );
                            e(a.DataServiceResultCode.Unauthenticated);
                            return;
                        }
                        var l = true;
                        setTimeout(function() {
                            c.authenticationProxy.tryAuthorize(
                                function(a) {
                                    if (l) {
                                        l = d;
                                        k.GetLastPrivateCatalogUpdate(a, j, f, i, e);
                                    }
                                },
                                function() {
                                    if (l) {
                                        l = d;
                                        e(a.DataServiceResultCode.Unauthenticated);
                                    }
                                }
                            );
                        }, 0);
                        setTimeout(function() {
                            if (l) {
                                l = d;
                                e(a.DataServiceResultCode.Unauthenticated);
                            }
                        }, 5 * 1e3);
                        return;
                    }
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Private Catalog: GetLastPrivateCatalogUpdate request failed with status code ' +
                            o,
                        b,
                        f.correlationId,
                        22823180
                    );
                    e(a.DataServiceResultCode.Failed);
                }
            );
        };
        c.prototype.GetAddInList = function(h, j, f, i, e) {
            var k = this,
                g = 0;
            c._requestHandler.getPrivateCatalogAddIns(
                this._clientCode,
                this._clientVersion,
                h,
                j,
                f.correlationId,
                function(n, p) {
                    g++;
                    if (n === 200) {
                        var q = c.ParseAddInList(p, f);
                        if (!q) {
                            e(a.DataServiceResultCode.Failed);
                            return;
                        }
                        i(q);
                        return;
                    }
                    if (n === 403) {
                        if (g == 1) {
                            g++;
                            var m;
                            m = JSON.parse(p);
                            if (m) {
                                var o = c._tokenCacheManager.GetRefreshToken(m.UserId, m.TenantId);
                                if (o != b) {
                                    k.GetAddInList(h, o, f, i, e);
                                    return;
                                }
                            }
                        }
                        if (g > 2 || h != b) {
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                'Private Catalog: GetAddInList authentication loop occured. Either authentication attempts count is greater than 2, or authorizationCode is not null. attemptsCount: ' +
                                    g,
                                b,
                                f.correlationId,
                                20497158
                            );
                            e(a.DataServiceResultCode.Unauthenticated);
                            return;
                        }
                        var l = true;
                        setTimeout(function() {
                            c.authenticationProxy.tryAuthorize(
                                function(a) {
                                    if (l) {
                                        l = d;
                                        k.GetAddInList(a, j, f, i, e);
                                    }
                                },
                                function() {
                                    if (l) {
                                        l = d;
                                        e(a.DataServiceResultCode.Failed);
                                    }
                                }
                            );
                        }, 0);
                        setTimeout(function() {
                            if (l) {
                                l = d;
                                var b = c._isThirdPartyHostEnabled
                                    ? a.DataServiceResultCode.Unauthenticated
                                    : a.DataServiceResultCode.Failed;
                                e(b);
                            }
                        }, 5 * 1e3);
                        return;
                    }
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Private Catalog: GetAddInList request failed with status code ' + n,
                        b,
                        f.correlationId,
                        20497159
                    );
                    e(a.DataServiceResultCode.Failed);
                }
            );
        };
        c.prototype.GetManifests = function(i, j, g, d, h, e) {
            var k = this,
                m = [],
                f = 0,
                l = { AddIns: i, RefreshToken: g, UserId: '', TenantId: '' };
            c._requestHandler.getPrivateCatalogManifests(
                a.WACUtils.serializeObjectToString(l),
                j,
                g,
                d.correlationId,
                function(m, p) {
                    f++;
                    if (m === 200) {
                        var o = c.ParseAndCacheManifestList(p, d);
                        if (!o) {
                            e(a.DataServiceResultCode.Failed);
                            return;
                        }
                        h(o);
                        return;
                    }
                    if (m === 403) {
                        if (f == 1) {
                            f++;
                            var l;
                            l = JSON.parse(p);
                            if (l) {
                                var n = c._tokenCacheManager.GetRefreshToken(l.UserId, l.TenantId);
                                if (n != b) {
                                    k.GetManifests(i, j, n, d, h, e);
                                    return;
                                }
                            }
                        }
                        if (f > 2) {
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                'Private Catalog: GetManifests authentication loop occured.',
                                b,
                                d.correlationId,
                                20497160
                            );
                            e(a.DataServiceResultCode.Unauthenticated);
                            return;
                        }
                        c.authenticationProxy.tryAuthorize(
                            function(a) {
                                k.GetManifests(i, a, g, d, h, e);
                            },
                            function() {
                                e(a.DataServiceResultCode.Unauthenticated);
                            }
                        );
                        return;
                    }
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Private Catalog: GetManifests request failed with status code ' + m,
                        b,
                        d.correlationId,
                        20497161
                    );
                    e(a.DataServiceResultCode.Failed);
                }
            );
        };
        c.SignOutUser = function() {
            Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                OSF.OUtil.formatString(
                    'PrivateCatalogService.SignOutUser: userId = {0}, tenantId = {1}',
                    c._userId,
                    c._tenantId
                ),
                b,
                21616005
            );
            c._tokenCacheManager.RemoveRefreshToken(c._userId, c._tenantId);
            c.authenticationProxy.signOut(
                function() {
                    c._cacheManager.RemoveAll(a.PrivateCatalog._addInsCacheKey);
                    c._cacheManager.RemoveAll(a.PrivateCatalog._addInDetailsCacheKeyPrefix);
                },
                function() {
                    Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                        'Private Catalog: Failed to sign out ',
                        b,
                        22316866
                    );
                }
            );
        };
        return c;
    })();
    a.PrivateCatalogService = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        var b = null;
        function c() {}
        c.ConvertSessionStartInfoToDmsRing = function(e) {
            var a = 'Production',
                d = 'Microsoft',
                f = b;
            if (e && e.sessionStartInfoJson) {
                var g = c.JsonSerializer.Deserialize(e.sessionStartInfoJson);
                if (g != b) f = g['AudienceGroup'];
            }
            switch (f) {
                case 'Dogfood':
                case 'Automation':
                    return 'Dogfood';
                case d:
                    return d;
                case a:
                    return a;
                default:
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Could not obtain DMS ring from settings. AudienceGroup value: ' + f,
                        b,
                        b,
                        38590113
                    );
                    return a;
            }
        };
        c.GenerateCapabilitiesList = function(e) {
            var d = [],
                a = e._getSupportedSet();
            if (a != b) {
                a = typeof a === 'string' ? c.JsonSerializer.Deserialize(a) : a;
                d = Object.keys(a).map(function(b) {
                    return { Name: b, Version: a[b] };
                });
            }
            return d;
        };
        c.GenerateDMSPackageListRequestBody = function(f, g, e, b) {
            var a = {};
            a.Hosts = [g];
            a.ReactNativeVersion = '0.0.0.0';
            a.Channel = 'DevMain';
            a.Capabilities = c.GenerateCapabilitiesList(e);
            a.Ring = c.ConvertSessionStartInfoToDmsRing(b);
            a.Platform = 'Web';
            a.Locales = [f];
            if (b && b.clientId) a.ClientId = b.clientId;
            var d = {};
            d.Context = a;
            d.SyncId = 0;
            return c.JsonSerializer.Serialize(d);
        };
        c.GetDMSPackageList = function(g, h, i, b, d, e) {
            var f = { 'Content-Type': 'application/json' };
            a.SdxWebRequestHandler.SendRequestAsync(
                'POST',
                g,
                c.GenerateDMSPackageListRequestBody(h, i, b, d),
                f,
                e
            );
        };
        c.JsonSerializer = new a.SafeSerializer();
        return c;
    })();
    a.DMSHandler = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        function b() {}
        b.GetSdxList = function(c, f) {
            var e = OSF.OUtil.formatString(b.SdxListCacheKeyCompleteFormatter, c, f),
                a = b.CacheManager.GetCacheItem(e, true);
            if (a == null) {
                var d = OSF.OUtil.formatString(b.SdxListCacheKeyHostPrefixFormatter, c);
                b.CacheManager.RemoveAll(d);
            }
            return a;
        };
        b.CacheSdxList = function(a, f, e) {
            var c = a.CacheTtlInSec / (60 * 60 * 24),
                d = OSF.OUtil.formatString(b.SdxListCacheKeyCompleteFormatter, f, e);
            b.CacheManager.SetCacheItem(d, a, c);
        };
        b.CacheManager = new a.AppsDataCacheManager(
            OSF.OUtil.getLocalStorage(),
            new a.SafeSerializer()
        );
        b.SdxListCacheKeyHostPrefixFormatter = '__OSF_SdxList.{0}';
        b.SdxListCacheKeyCompleteFormatter = b.SdxListCacheKeyHostPrefixFormatter + '.{1}';
        return b;
    })();
    a.SdxCache = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        var b = null;
        function c() {}
        c.generateLoaderError = function(g, h, i, b, f, d, e) {
            a.LoaderUtil.failWithError(b, {
                description: g,
                buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                buttonCallback: function() {
                    b.restartActivation();
                    c.activateAsync(i, b, f, d, e);
                },
                errorCode: h,
            });
        };
        c.GetSDXList = function(j, k, f, g, h, i, d) {
            var e = a.SdxCache.GetSdxList(g, f);
            j.setFlag(a.FlagName.DmsRequestCachedFlag, e != b);
            if (e != b) {
                d({ status: a.DataServiceResultCode.Succeeded, value: e });
                return;
            }
            a.DMSHandler.GetDMSPackageList(k, f, g, h, i, function(e) {
                if (e.status != a.DataServiceResultCode.Succeeded) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'GetDMSPackageList request to DMS failed with status = ' + e.status + '.',
                        b,
                        b,
                        37291604
                    );
                    d({ status: e.status, value: b });
                    return;
                }
                var h = c.jsonSerializer.Deserialize(e.value);
                if (h == b) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'GetDMSPackageList DMS response could not be parsed.',
                        b,
                        b,
                        37291605
                    );
                    d({ status: a.DataServiceResultCode.Failed, value: b });
                    return;
                }
                a.SdxCache.CacheSdxList(h, g, f);
                d({ status: a.DataServiceResultCode.Succeeded, value: h });
            });
        };
        c.activateAsync = function(e, i, d, g, h) {
            d.startActivity(a.Activity.Activation);
            d.startActivity(a.Activity.ServerCall);
            var f = a.CatalogFactory.getHostContext(),
                j = OSF.getManifestHostType(f.hostType);
            Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                'Start activating SDX with assetId ".' + e.assetId + '".',
                d.correlationId,
                37291606
            );
            c.GetSDXList(d, f.sdxDmsUrl, f.appUILocale, j, g, h, function(m) {
                if (m.status != a.DataServiceResultCode.Succeeded) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Retrieving SDX list failed.',
                        b,
                        b,
                        37291607
                    );
                    c.generateLoaderError(
                        Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                        OSF.ErrorStatusCodes.WAC_AgaveActivationError,
                        e,
                        i,
                        d,
                        g,
                        h
                    );
                    return;
                }
                for (var j = b, k = 0, n = m.value.Packages; k < n.length; k++) {
                    var l = n[k];
                    if (l.AssetId.toLowerCase() == e.assetId.toLowerCase()) {
                        j = l;
                        break;
                    }
                }
                if (j == b) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Unable to find SDX with assetId "' + e.assetId + '".',
                        b,
                        b,
                        37291608
                    );
                    c.generateLoaderError(
                        Strings.OsfRuntime.L_AgaveNotExist_ERR,
                        OSF.ErrorStatusCodes.E_MANIFEST_DOES_NOT_EXIST,
                        e,
                        i,
                        d,
                        g,
                        h
                    );
                    return;
                }
                d.startActivity(a.Activity.ManifestRequest);
                a.SdxCdnHandler.GetManifestFromCdn(f.sdxCdnUrl, j, function(l) {
                    if (l.status != a.DataServiceResultCode.Succeeded) {
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'Retrieving SDX manifest from CDN failed.',
                            b,
                            b,
                            37291609
                        );
                        c.generateLoaderError(
                            Strings.OsfRuntime.L_AgaveManifestRetrieve_ERR,
                            OSF.ErrorStatusCodes.WAC_AgaveManifestRequestFailure,
                            e,
                            i,
                            d,
                            g,
                            h
                        );
                        return;
                    }
                    var k = a.ManifestUtil.ParseManifest(l.value, f.appUILocale, d.correlationId);
                    if (k == b) {
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'Unable to parse the SDX manifest.',
                            b,
                            b,
                            37291610
                        );
                        c.generateLoaderError(
                            Strings.OsfRuntime.L_AgaveManifestRetrieve_ERR,
                            OSF.ErrorStatusCodes.E_MANIFEST_INVALID_VALUE_FORMAT,
                            e,
                            i,
                            d,
                            g,
                            h
                        );
                        return;
                    }
                    d.stopActivity(a.Activity.ServerCall);
                    d.stopActivity(a.Activity.ManifestRequest);
                    var m = a.SdxCdnHandler.GetManifestCdnUrl(f.sdxCdnUrl, j);
                    i.load({ entitlement: e, manifest: k, eToken: '', manifestUrl: m }, b);
                });
            });
        };
        c.jsonSerializer = new a.SafeSerializer();
        return c;
    })();
    a.SDXCatalog = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        function b() {}
        b.GetManifestFromCdn = function(c, e, d) {
            var f = b.GetManifestCdnUrl(c, e);
            a.SdxWebRequestHandler.SendRequestAsync('GET', f, null, null, d);
        };
        b.GetManifestCdnUrl = function(b, a) {
            var c = 'en-us';
            return OSF.OUtil.formatString(b, a.AssetId, a.FFN, a.Version, c);
        };
        return b;
    })();
    a.SdxCdnHandler = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(a) {
    var b = (function() {
        function b() {}
        b.SendRequestAsync = function(f, h, i, e, g) {
            var c = 'HTTP request (',
                b = null;
            if (i === void 0) i = b;
            if (e === void 0) e = b;
            var d = new XMLHttpRequest();
            d.open(f, h, true);
            d.onload = function() {
                if (d.readyState == XMLHttpRequest.DONE) {
                    var e = d.status;
                    if (e >= 200 && e < 300)
                        if (d.responseText != b) {
                            g({ status: a.DataServiceResultCode.Succeeded, value: d.responseText });
                            return;
                        }
                }
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    c + f + ' ' + h + ') failed with status code = ' + d.status + '.',
                    b,
                    b,
                    37291611
                );
                g({ status: a.DataServiceResultCode.Failed, value: b });
            };
            d.onerror = function() {
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    c + f + ' ' + h + ') failed with unexpected error.',
                    b,
                    b,
                    37291612
                );
                g({ status: a.DataServiceResultCode.Failed, value: b });
            };
            d.timeout = 3e3;
            d.ontimeout = function() {
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    c + f + ' ' + h + ') timeout.',
                    b,
                    b,
                    37291613
                );
                g({ status: a.DataServiceResultCode.Failed, value: b });
            };
            if (e != b) for (var j in e) d.setRequestHeader(j, e[j]);
            d.send(i);
        };
        return b;
    })();
    a.SdxWebRequestHandler = b;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var d = false,
        a = null,
        c = true,
        e = (function() {
            function e(a, b) {
                this._initParam = b;
                this._cacheManager = a.cacheManager;
                this._telemetryContext = a.telemetryContext;
            }
            e.prototype.getManifest = function(k, e, f, j) {
                var g = this,
                    h = g;
                g._telemetryContext.startActivity(b.Activity.ManifestRequest);
                var i = OSF.OsfManifestManager.getCachedManifest(
                    e.OfficeExtensionID,
                    e.OfficeExtensionVersion
                );
                if (i) {
                    g._telemetryContext.stopActivity(b.Activity.ManifestRequest);
                    g._telemetryContext.stopActivity(b.Activity.ServerCall);
                    f({
                        status: b.DataServiceResultCode.Succeeded,
                        value: { manifest: i, cached: c },
                    });
                    return;
                } else if (e.EncodedAbsUrl)
                    k.getManifest(
                        e.EncodedAbsUrl,
                        e.OfficeExtensionID,
                        e.OfficeExtensionVersion,
                        function(c) {
                            h._telemetryContext.stopActivity(b.Activity.ManifestRequest);
                            h._telemetryContext.stopActivity(b.Activity.ServerCall);
                            if (c.status != b.DataServiceResultCode.Succeeded) {
                                f({ status: c.status, value: { manifest: a, cached: d } });
                                return;
                            }
                            var e = b.ManifestUtil.ParseManifest(
                                c.value.manifest,
                                h._initParam.appUILocale,
                                h._telemetryContext.correlationId
                            );
                            if (e == a) c.status = b.DataServiceResultCode.Failed;
                            f({ status: c.status, value: { manifest: e, cached: d } });
                        },
                        j
                    );
                else
                    f({
                        status: b.DataServiceResultCode.Failed,
                        value: { manifest: a, cached: d },
                    });
            };
            e.prototype.activate = function(l, f, e) {
                var g = this,
                    i = {
                        assetId: f.assetId,
                        appVersion: f.appVersion,
                        storeId: f.storeId,
                        storeType: f.storeType,
                        targetType: f.targetType,
                    },
                    h,
                    m = function(l, r) {
                        var h = l.manifest,
                            n = h.getMarketplaceVersion();
                        OSF.OsfManifestManager.cacheManifest(f.assetId, f.appVersion, h);
                        if (l.cached)
                            if (b.ManifestUtil.versionLessThan(n, f.appVersion)) {
                                j(c);
                                return;
                            }
                        if (
                            h.requirementsSupported === d ||
                            (h.requirementsSupported === undefined &&
                                !e.getRequirementsChecker().isManifestSupported(h))
                        ) {
                            h.requirementsSupported = d;
                            var m,
                                s,
                                t = a;
                            m =
                                Strings.OsfRuntime.L_AgaveManifestRequirementsError_ERR ||
                                Strings.OsfRuntime.L_AgaveManifestError_ERR;
                            b.LoaderUtil.failWithError(e, {
                                description: m,
                                detailView: c,
                                errorCode: OSF.ErrorStatusCodes.WAC_AgaveRequirementsError,
                            });
                            return;
                        }
                        h.requirementsSupported = c;
                        if (r && !e.skipTrust(f)) {
                            var k = OSF.OUtil.formatString(
                                    OSF.Constants.ActivatedCacheKey,
                                    f.assetId.toLowerCase(),
                                    f.storeType,
                                    f.storeId
                                ),
                                q = function() {
                                    g._cacheManager.SetCacheItem(k, c);
                                    e.load({ entitlement: i, manifest: h, eToken: a }, a);
                                },
                                p = OSF.OmexClientNames[g._initParam.applicationName],
                                o = g._cacheManager.GetCacheItem(k, d);
                            if (!o && !e.hasConsent(f) && !e.isForCustomFunctionSandbox()) {
                                e.askForTrust(
                                    {
                                        anonymous: a,
                                        clientName: p,
                                        entitlement: i,
                                        displayName: h.getDefaultDisplayName(),
                                        providerName: h.getProviderName(),
                                        iconUrl: h.getDefaultIconUrl(),
                                        isSSOAddin: h.isSSOAddin(),
                                    },
                                    q
                                );
                                return;
                            }
                        }
                        e.hasConsent(f) && g._cacheManager.SetCacheItem(k, c);
                        e.load({ entitlement: i, manifest: h, eToken: a }, a);
                    },
                    k = function(a) {
                        g.getManifest(
                            l,
                            h,
                            function(d) {
                                if (
                                    d.status === b.DataServiceResultCode.Succeeded &&
                                    d.value.manifest
                                )
                                    m(d.value, c);
                                else {
                                    b.LoaderUtil.failWithError(e, {
                                        description: Strings.OsfRuntime.L_AgaveManifestRetrieve_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                        buttonCallback: function() {
                                            e.restartActivation();
                                            k(a);
                                        },
                                        errorCode:
                                            OSF.ErrorStatusCodes.E_MANIFEST_SERVER_UNAVAILABLE,
                                    });
                                    return;
                                }
                            },
                            a
                        );
                    },
                    n = function(a) {
                        if (!h) {
                            b.LoaderUtil.failWithError(e, {
                                description: Strings.OsfRuntime.L_AgaveNotExist_ERR,
                                buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                buttonCallback: function() {
                                    e.restartActivation();
                                    g._telemetryContext.startActivity(b.Activity.Activation);
                                    g._telemetryContext.startActivity(b.Activity.ServerCall);
                                    j(c);
                                },
                                errorCode: OSF.ErrorStatusCodes.E_MANIFEST_DOES_NOT_EXIST,
                            });
                            return;
                        }
                        if (h.OfficeExtensionKillbit) {
                            b.LoaderUtil.failWithError(e, {
                                description: Strings.OsfRuntime.L_AgaveDisabledByAdmin_ERR,
                                errorCode: OSF.ErrorStatusCodes.E_OEM_EXTENSION_KILLED,
                            });
                            return;
                        }
                        k(a);
                    },
                    j = function(c) {
                        h = a;
                        g._telemetryContext.startActivity(b.Activity.EntitlementCheck);
                        l.getEntitlementAsync(
                            d,
                            f.targetType,
                            function(m) {
                                if (m.status != b.DataServiceResultCode.Succeeded) {
                                    b.LoaderUtil.failWithError(e, {
                                        description:
                                            Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                                        buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                                        buttonCallback: function() {
                                            e.restartActivation();
                                            g._telemetryContext.startActivity(
                                                b.Activity.Activation
                                            );
                                            g._telemetryContext.startActivity(
                                                b.Activity.ServerCall
                                            );
                                            j();
                                        },
                                        errorCode:
                                            OSF.ErrorStatusCodes.E_MANIFEST_SERVER_UNAVAILABLE,
                                    });
                                    return;
                                }
                                g._telemetryContext.stopActivity(b.Activity.EntitlementCheck);
                                for (
                                    var f = a, l = m.value.entitlements, d, k = 0;
                                    k < l.length;
                                    k++
                                ) {
                                    d = l[k];
                                    if (
                                        d.OfficeExtensionID &&
                                        i.assetId &&
                                        d.OfficeExtensionID.toLowerCase() == i.assetId.toLowerCase()
                                    )
                                        if (
                                            !f ||
                                            b.ManifestUtil.versionLessThan(
                                                f.OfficeExtensionVersion,
                                                d.OfficeExtensionVersion
                                            )
                                        )
                                            f = d;
                                }
                                h = f;
                                n(c);
                            },
                            c
                        );
                    };
                j();
            };
            return e;
        })(),
        f = (function() {
            function f(e, d) {
                var c = this;
                if (d === void 0) d = a;
                c._appDataService = {};
                c._catalogUrlDataService = {};
                c._initParam = e;
                c._cacheManager =
                    d ||
                    new b.AppsDataCacheManager(OSF.OUtil.getLocalStorage(), new b.SafeSerializer());
            }
            f.prototype.getDataService = function(b, a, c) {
                this.getDataServiceInternal(this._appDataService, b, a, c);
            };
            f.prototype.getCatalogUrlDataService = function(b, a, c) {
                this.getDataServiceInternal(this._catalogUrlDataService, b, a, c);
            };
            f.prototype.getDataServiceInternal = function(d, c, f, g) {
                if (d[c] == a) d[c] = { spCatalogService: a, spCatalogServiceReady: a };
                if (d[c].spCatalogService != a) {
                    g({ status: b.DataServiceResultCode.Succeeded, value: d[c].spCatalogService });
                    return;
                }
                if (d[c].spCatalogServiceReady != a) {
                    var j = d[c].spCatalogServiceReady;
                    d[c].spCatalogServiceReady = function(a) {
                        j(a);
                        g(a);
                    };
                    return;
                } else d[c].spCatalogServiceReady = g;
                var e = { status: b.DataServiceResultCode.Failed, value: a },
                    i = function(g, f) {
                        var h = d[c].spCatalogServiceReady;
                        d[c].spCatalogServiceReady = a;
                        if (g.status == b.DataServiceResultCode.Succeeded) {
                            d[c].spCatalogService = f;
                            e.value = f;
                            e.status = b.DataServiceResultCode.Succeeded;
                            h(e);
                        } else {
                            e.httpStatus = g.httpStatus;
                            h(e);
                        }
                    };
                f.startActivity(b.Activity.Authentication);
                var h = b.SPCatalogProxyBasedCatalogService.getInstance(this._initParam);
                h.prepareProxy(c, f.correlationId, function(a) {
                    f.stopActivity(b.Activity.Authentication);
                    i(a, h);
                });
            };
            f.prototype.createActivityScope = function(d, a, c) {
                var f = this;
                this.getDataService(d, a, function(h) {
                    if (b.AsyncUtil.failed(h, c)) return;
                    var k = h.value,
                        g = { cacheManager: f._cacheManager, storeId: d, telemetryContext: a },
                        i = k.createScope(g),
                        j = new e(g, f._initParam);
                    c({
                        status: b.DataServiceResultCode.Succeeded,
                        value: { serviceScope: i, activityScope: j },
                    });
                });
            };
            f.prototype.getEntitlementAsync = function(h, g, c, i, j, d) {
                var e = this;
                d = d || this.myOrgCatalogUrl || a;
                var f = function(d) {
                    if (d.status !== b.DataServiceResultCode.Succeeded) {
                        c({ status: d.status, value: a });
                        return;
                    }
                    e.myOrgCatalogUrl = d.value;
                    e.createActivityScope(d.value, g, function(d) {
                        if (b.AsyncUtil.failed(d, c, [])) return;
                        var f = d.value.serviceScope;
                        f.getEntitlementAsync(
                            h,
                            a,
                            function(d) {
                                if (b.AsyncUtil.failed(d, c, [])) return;
                                for (var f = d.value.entitlements, g = 0; g < f.length; g++) {
                                    var a = f[g];
                                    a.assetId = a.OfficeExtensionID;
                                    a.appVersion = a.OfficeExtensionVersion;
                                    a.storeId = e.myOrgCatalogUrl;
                                    a.storeType = OSF.StoreType.SPCatalog;
                                    a.targetType = OSF.OfficeAppType[a.OEType];
                                }
                                c({ status: d.status, value: f });
                            },
                            i
                        );
                    });
                };
                if (!d) this.getSPCatalogUrl(g, f);
                else f({ status: b.DataServiceResultCode.Succeeded, value: d });
            };
            f.prototype.getAndCacheManifest = function(f, j, g, e) {
                var h = this,
                    i = function(i) {
                        OSF.OUtil.writeProfilerMark(
                            OSF.OsfOfficeExtensionManagerPerfMarker.GetEntitlementEnd
                        );
                        if (i.status === b.DataServiceResultCode.Succeeded && i.value) {
                            for (var k = i.value, l = k.length, c = a, j = 0; j < l; j++) {
                                var d = k[j];
                                if (
                                    d.OfficeExtensionID &&
                                    f.assetId &&
                                    d.OfficeExtensionID.toLowerCase() === f.assetId.toLowerCase()
                                )
                                    if (
                                        !c ||
                                        OSF.OsfManifestManager.versionLessThan(
                                            c.OfficeExtensionVersion,
                                            d.OfficeExtensionVersion
                                        )
                                    )
                                        c = d;
                            }
                            if (c != a)
                                h.createActivityScope(h.myOrgCatalogUrl, g, function(a) {
                                    if (b.AsyncUtil.failed(a, e)) return;
                                    var d = a.value.activityScope;
                                    d.getManifest(a.value.serviceScope, c, function(a) {
                                        e({ status: a.status, value: a.value.manifest });
                                    });
                                });
                            else e({ status: b.DataServiceResultCode.Failed, value: a });
                        } else e({ status: b.DataServiceResultCode.Failed, value: a });
                    };
                this.getEntitlementAsync(c, g, i, d, 0, f.storeId);
            };
            f.prototype.activateAsync = function(d, c, a) {
                var e = this;
                a.startActivity(b.Activity.Activation);
                a.startActivity(b.Activity.ServerCall);
                this.createActivityScope(d.storeId, a, function(f) {
                    if (f.status != b.DataServiceResultCode.Succeeded) {
                        b.LoaderUtil.failWithError(c, {
                            description: Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                            buttonTxt: Strings.OsfRuntime.L_RetryButton_TXT,
                            buttonCallback: function() {
                                c.restartActivation();
                                e.activateAsync(d, c, a);
                            },
                            errorCode: OSF.ErrorStatusCodes.WAC_AgaveAnonymousProxyCreationError,
                        });
                        return;
                    }
                    var g = f.value.serviceScope,
                        h = f.value.activityScope;
                    h.activate(g, d, c);
                });
            };
            f.prototype.removeAsync = function(d, c, a) {
                a({ status: b.DataServiceResultCode.Failed });
            };
            f.prototype.getAppDetails = function(e, d, c, a) {
                a({ status: b.DataServiceResultCode.Failed });
            };
            f.prototype.getSPCatalogUrl = function(a, d) {
                var c = this;
                this.getCatalogUrlDataService(this._initParam.spBaseUrl, a, function() {
                    var e = b.SPCatalogProxyBasedCatalogService.getInstance(c._initParam);
                    e.getSPCatalogUrl(c._initParam.spBaseUrl, a.correlationId, d);
                });
            };
            return f;
        })();
    b.CatalogFactory.register(OSF.StoreType.SPCatalog, function(a) {
        var b = new f({
            applicationName: OSF.HostCapability[a.hostType],
            AppVersion: a.appVersion,
            clientMode: a.clientMode,
            appUILocale: a.appUILocale,
            spBaseUrl: a.spBaseUrl,
            docUrl: a.docUrl,
        });
        return b;
    });
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var a = (function() {
        function a() {}
        a.CheckProxyIsReady = 'OEM_isProxyReady';
        a.GetEntitlementSummary = 'OEM_getEntitlementSummaryAsync';
        a.GetManifest = 'OEM_getManifestAsync';
        a.GetSPCatalogUrl = 'OEM_getSPCatalogUrlAsync';
        return a;
    })();
    b.SPCatalogProxyMethods = a;
    var c = (function() {
        function a() {
            this.iframeProxies = {};
            this.iframeProxyCount = 0;
        }
        a.iframeNamePrefix = '__officeExtensionProxy';
        return a;
    })();
    b.IframeProxyGroup = c;
    var d = (function(f) {
        var d = null;
        __extends(e, f);
        function e(b, a) {
            f.call(this);
            this.proxyUrl = b;
            this.iframeProxyGroup = a;
        }
        e.prototype.getEntitlementsAsync = function(c, b) {
            this.invokeProxyCommandAsync(a.GetEntitlementSummary, c, b);
        };
        e.prototype.getManifestAsync = function(c, b) {
            this.invokeProxyCommandAsync(a.GetManifest, c, b);
        };
        e.prototype.getSPCatalogUrlAsync = function(c, b) {
            this.invokeProxyCommandAsync(a.GetSPCatalogUrl, c, b);
        };
        e.prototype.prepareProxy = function(b, c) {
            var a = this;
            if (a.isReady) b({ status: d, value: { clientEndpoint: a.clientEndPoint } });
            else if (!a.clientEndPoint) a.createProxy(b, c);
            else a.pendingCallbacks.push([b, c]);
        };
        e.resetProxy = function(a) {
            delete a.iframeProxyGroup.iframeProxies[a.proxyUrl];
            a.iframeProxyGroup.iframeProxyCount = a.iframeProxyGroup.iframeProxyCount - 1;
            Microsoft.Office.Common.XdmCommunicationManager.getClientEndPoint(a.conversationId) &&
                Microsoft.Office.Common.XdmCommunicationManager.deleteClientEndPoint(
                    a.conversationId
                );
            if (a.iframe) {
                OSF.OUtil.removeEventListener(a.iframe, 'load', a.iframeOnload);
                a.iframe.parentNode.removeChild(a.iframe);
                a.iframe = d;
            }
            a.clientEndPoint = d;
        };
        e.prototype.createProxy = function(p, k) {
            var f = this;
            try {
                if (!f.doesUrlHaveSupportedProtocol(f.proxyUrl)) {
                    k({
                        status: d,
                        value: { errorMessage: 'Protocal of proxyUrl is not supported.' },
                    });
                    return;
                }
                f.iframeProxyGroup.iframeProxies[f.proxyUrl] = f;
                f.iframeProxyGroup.iframeProxyCount = f.iframeProxyGroup.iframeProxyCount + 1;
                var j = f.proxyUrl,
                    n = j.length;
                if (j.charAt(n - 1) === '/') j = j.substr(0, n - 1);
                var g = document.createElement('iframe'),
                    l = c.iframeNamePrefix + f.iframeProxyGroup.iframeProxyCount;
                g.setAttribute('id', l);
                g.setAttribute('name', l);
                var i = j + '/_layouts/15/OfficeExtensionManager.aspx?' + f.conversationId;
                i = OSF.OUtil.addXdmInfoAsHash(
                    i,
                    f.conversationId + '|' + l + '|' + window.location.href
                );
                i = OSF.OUtil.addSerializerVersionAsHash(i, OSF.SerializerVersion.Browser);
                g.setAttribute('scrolling', 'auto');
                g.setAttribute('border', '0');
                g.setAttribute('width', '0');
                g.setAttribute('height', '0');
                g.setAttribute('style', 'position: absolute; left: -100px; top:0px;');
                var h = f;
                document.body.appendChild(g);
                var m = function() {
                    var c = function(c, i) {
                        var a = d;
                        if (c === 0 && i.status) {
                            h.isReady = true;
                            a = { status: d, value: { clientEndpoint: h.clientEndPoint } };
                        } else {
                            e.resetProxy(h);
                            a = {
                                status: d,
                                value: {
                                    errorMessage: 'isProxyReadyCallback failed, error code ' + c,
                                },
                            };
                        }
                        for (var g = h.pendingCallbacks.length, f = 0; f < g; f++) {
                            var b = h.pendingCallbacks.shift();
                            if (h.isReady) b[0](a);
                            else b[1](a);
                        }
                    };
                    h.clientEndPoint = Microsoft.Office.Common.XdmCommunicationManager.connect(
                        h.conversationId,
                        g.contentWindow,
                        h.proxyUrl
                    );
                    if (h.clientEndPoint)
                        h.clientEndPoint.invoke(a.CheckProxyIsReady, c, { __timeout__: 2e3 });
                    else {
                        var b =
                            'Unexpected error, iframe loaded again after failing OEM_isProxyReady';
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(b, d, d, 18657365);
                        k({ status: d, value: { errorMessage: b } });
                    }
                };
                OSF.OUtil.addEventListener(g, 'load', m);
                g.setAttribute('src', i);
                f.iframeOnload = m;
                f.pendingCallbacks.push([p, k]);
                f.iframe = g;
            } catch (o) {
                var q =
                    'Error creating client endpoint with proxyUrl = [' +
                    f.proxyUrl +
                    '], msg:' +
                    b.WACUtils.serializeObjectToString(o);
                k({ status: d, value: { errorMessage: q } });
            }
        };
        return e;
    })(b.ProxyBase);
    b.SPCatalogProxy = d;
})(OfficeExt || (OfficeExt = {}));
var OfficeExt;
(function(b) {
    var a = null,
        d = (function() {
            function d(a) {
                this.proxyRetries = {};
                this.initParams = a;
                this.iframeProxyGroup = new b.IframeProxyGroup();
            }
            d.getInstance = function(b) {
                if (d._instance == a) d._instance = new d(b);
                return d._instance;
            };
            d.prototype.prepareProxy = function(d, c, f) {
                c = c || '';
                var e = function(c) {
                    var d = c && c.status != a ? c.status : b.DataServiceResultCode.ProxyNotReady;
                    f({ status: c.status });
                };
                this.proxyRetries[d] = 1;
                this.ensureSPCatalogProxySetUp(d, c, e);
            };
            d.prototype.createScope = function(a) {
                return new c(a, this);
            };
            d.prototype.getSPCatalogUrl = function(c, d, e) {
                var g = this,
                    f = function() {
                        var h;
                        if (c && (h = g.iframeProxyGroup.iframeProxies[c])) {
                            var f = {};
                            f['webUrl'] = c;
                            h.getSPCatalogUrlAsync(f, function(f) {
                                var c = 'getspcatalogurl failed';
                                if (f.status !== b.DataServiceResultCode.Succeeded) {
                                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                        c,
                                        a,
                                        d,
                                        19015125
                                    );
                                    OsfMsAjaxFactory.msAjaxDebug.trace(c);
                                }
                                e(f);
                            });
                        } else {
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                OSF.OUtil.formatString(
                                    'getspcatalogurl proxy not found, webUrl: {0}',
                                    c
                                ),
                                a,
                                d,
                                19969545
                            );
                            e({ status: b.DataServiceResultCode.ProxyNotReady });
                        }
                    };
                this.prepareProxy(c, d, f);
            };
            d.prototype.ensureSPCatalogProxySetUp = function(c, h, e) {
                if (!c) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'proxyUrl is null',
                        a,
                        h,
                        19969546
                    );
                    e({ status: b.DataServiceResultCode.Failed });
                    return;
                }
                var d = this.iframeProxyGroup.iframeProxies[c];
                if (!d) d = new b.SPCatalogProxy(c, this.iframeProxyGroup);
                if (d.isReady) {
                    e({ status: b.DataServiceResultCode.Succeeded });
                    return;
                }
                var i = this,
                    f = function() {
                        e({ status: b.DataServiceResultCode.Succeeded });
                    },
                    g = function() {
                        if (i.proxyRetries[c] < OSF.Constants.AuthenticatedConnectMaxTries) {
                            i.proxyRetries[c]++;
                            d.prepareProxy(f, g);
                        } else {
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                'sp exceed maximum tries and fail',
                                a,
                                h,
                                18940555
                            );
                            e({ status: b.DataServiceResultCode.ProxyNotReady });
                        }
                    };
                d.prepareProxy(f, g);
            };
            return d;
        })();
    b.SPCatalogProxyBasedCatalogService = d;
    var c = (function() {
        var d = 'clearCache';
        function c(a, b) {
            this._catalogService = b;
            this.proxyUrl = a.storeId;
            this._correlationId = a.telemetryContext.correlationId || '';
        }
        c.prototype.tryFail = function(a, d, c) {
            if (a != b.DataServiceResultCode.Succeeded) {
                c({ status: a });
                return true;
            } else return false;
        };
        c.prototype.getEntitlementAsync = function(i, f, c, g) {
            var b = this,
                e = b,
                h = b._catalogService.iframeProxyGroup.iframeProxies[b.proxyUrl],
                a = {};
            a['webUrl'] = b.proxyUrl;
            a['applicationName'] = b._catalogService.initParams.applicationName;
            a['officeExtentionTarget'] = f;
            a[d] = g || false;
            a['supportedManifestVersions'] = { '1.0': true, '1.1': true };
            h.getEntitlementsAsync(a, function(a) {
                if (e.tryFail(a.status, a.httpStatus, c)) {
                    e.logServiceCallResponseError('entitlement', a.httpStatus);
                    return;
                }
                c(a);
            });
        };
        c.prototype.getLastStoreUpdate = function() {};
        c.prototype.getManifest = function(e, i, g, b, f) {
            var c = this,
                h = this._catalogService.iframeProxyGroup.iframeProxies[this.proxyUrl],
                a = {};
            a['manifestUrl'] = e;
            a['id'] = i;
            a['version'] = g;
            a[d] = f;
            h.getManifestAsync(a, function(a) {
                if (c.tryFail(a.status, a.httpStatus, b)) {
                    c.logServiceCallResponseError('manifest', a.httpStatus);
                    return;
                }
                b(a);
            });
        };
        c.prototype.logServiceCallResponseError = function(d, b) {
            var c = 'spproxy request ' + d + ' failed';
            if (b) c += ':' + b;
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(c, a, this._correlationId, 18940556);
        };
        return c;
    })();
    b.SPCatalogProxyBasedCatalogServiceScope = c;
})(OfficeExt || (OfficeExt = {}));
OSF.InfoType = { Error: 0, Warning: 1, Information: 2, SecurityInfo: 3 };
OSF.NotificationType = {
    TrustYellowBar: 0,
    ConsentYellowBar: 1,
    ConsentWhiteDialog: 2,
    TrustPromptTaskpane: 3,
    TrustPromptContent: 4,
};
OSF.ConsentResultCode = {
    Success: 0,
    Cancelled: 100,
    ClientError: 400,
    ServerError: 500,
    UnknownError: 600,
};
OSF.OmexMessageType = { ConsentResult: 0, TabExit: 1, ButtonClick: 2, PageLoad: 3 };
OSF._ErrorUXHelper = function(Bb) {
    var M = 'progress_',
        mb = 'input,a,button',
        lb = 'moe-infobar-button2_',
        f = true,
        kb = 'moe-infobar-button_',
        A = 'moe-infobar-button',
        e = false,
        d = 'button',
        jb = 'moe-infobar-dismiss_',
        ib = 'moe-infobar-dismiss',
        hb = 'moe-infobar-message',
        gb = 'moe-infobar-message_',
        fb = 'moe-infobar-title',
        z = 'span',
        eb = 'moe-infobar-message-div',
        db = 'moe-infobar-secinfo',
        cb = 'moe-infobar-info',
        bb = 'moe-infobar-warning',
        ab = 'moe-infobar-error',
        Z = 'moe-infobar-button-cell',
        Y = 'moe-infobar-top-right-cell',
        X = 'moe-infobar-message-cell',
        W = 'moe-infobar-top-left-cell',
        k = 'presentation',
        i = 'role',
        V = 'moe-infobar-infotable',
        E = 'table',
        U = 'moe-infobar-body',
        s = 'alt',
        c = null,
        m = '100%',
        y = 'center',
        x = 'no-repeat',
        w = 'alpha(opacity=100)',
        l = '1',
        L = 'white',
        v = 'url(',
        r = 'onclick',
        q = 'tabindex',
        K = 'image',
        u = 'type',
        J = 'input',
        h = 'id',
        t = 'moe-background',
        a = 'class',
        g = 'div',
        Q = 'moe-trust-prompt-table_',
        I = 'notificationbackground_',
        H = 'moe-infobar-body_',
        D = 'agavedefaulticon96x96.png',
        o = 'moe_status_icons.png',
        nb = 'progress.gif',
        n = 'img',
        b = Bb,
        T = b.getOsfOmexBaseUrl(),
        pb = 'omexNotificationIframeClassName';
    OSF.OUtil.loadCSS(b.getLocalizedCSSFilePath('moeerrorux.css'));
    var Hb = document.createElement(n);
    Hb.src = b.getLocalizedImageFilePath(nb);
    var Fb = document.createElement(n);
    Fb.src = b.getLocalizedImageFilePath(o);
    var Eb = document.createElement(n);
    Eb.src = b.getLocalizedImageFilePath(D);
    var j = {},
        R = 0,
        N = function(a) {
            var d = a.childNodes.length,
                c = 0,
                b;
            while (c < d) {
                b = a.childNodes.item(c);
                if (b.tagName.toLowerCase() === 'iframe') c++;
                else {
                    a.removeChild(b);
                    d--;
                }
            }
        },
        S = function(b) {
            var a = document.getElementById(b);
            a && a.parentNode.removeChild(a);
        },
        Ib = function(a) {
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RemoveStage1Start);
            S('icon_' + a);
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RemoveStage1End);
        },
        G = function(a, d) {
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RemoveStage2Start);
            var b;
            if (d) b = H + a;
            else b = I + a;
            var c = C(a);
            if (c && j[a][0].highPriority) R--;
            S(b);
            c && j[a].shift();
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RemoveStage2End);
        },
        qb = function(a) {
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RemoveStage2Start);
            var c = Q + a.id,
                b = C(a.id);
            if (b && j[a.id][0].highPriority) R--;
            S(c);
            b && j[a.id].shift();
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RemoveStage2End);
        },
        wb = function(d) {
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderStage1Start);
            N(d.div);
            var e = document.createElement(g);
            e.setAttribute(a, t);
            e.setAttribute(h, 'icon_' + d.id);
            var f = document.createElement(J);
            f.setAttribute(h, 'iconImg_' + d.id);
            f.setAttribute(u, K);
            f.setAttribute(q, '0');
            f.src = b.getLocalizedImageFilePath(o);
            var n = function(a) {
                a.sqmDWords[1] |= 2;
                p(a.id);
                var b = OfficeExt.HostFeatureEnabledInfo.getHostFeatureEnabledInfo();
                if (b && b.enableSingleSignOnForAddin) rb(a);
                else vb(a);
            };
            f.setAttribute(r, 'getIntoStage2(params)');
            OSF.OUtil.attachClickHandler(f, function() {
                n(d);
            });
            e.appendChild(f);
            if (d.displayDeactive) {
                e.style.backgroundImage = v + b.getLocalizedImageFilePath(D) + ')';
                e.style.backgroundColor = L;
                e.style.opacity = l;
                e.style.filter = w;
                e.style.backgroundRepeat = x;
                e.style.backgroundPosition = y;
                e.style.height = m;
            }
            var i, k, j;
            if (d.infoType === OSF.InfoType.Error) {
                i = 'moe-status-error-icon';
                k = 'iconImg_error_' + d.id;
                j = Strings.OsfRuntime.L_InfobarIconErrorAccessibleName_TXT;
            } else if (d.infoType === OSF.InfoType.Warning) {
                i = 'moe-status-warning-icon';
                k = 'iconImg_warning_' + d.id;
                j = Strings.OsfRuntime.L_InfobarIconWarningAccessibleName_TXT;
            } else if (d.infoType === OSF.InfoType.Information) {
                i = 'moe-status-info-icon';
                k = 'iconImg_info_' + d.id;
                j = Strings.OsfRuntime.L_InfobarIconInfoAccessibleName_TXT;
            } else {
                i = 'moe-status-secinfo-icon';
                k = 'iconImg_secinfo_' + d.id;
                j = Strings.OsfRuntime.L_InfobarIconSecInfoAccessibleName_TXT;
            }
            var z = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
            if (z.exec(navigator.userAgent) != c && parseFloat(RegExp.$1) == 9) i += '_ie';
            f.setAttribute(a, i);
            f.setAttribute(h, k);
            f.setAttribute(s, j);
            if (d.div.childNodes.length != 0) d.div.insertBefore(e, d.div.childNodes[0]);
            else d.div.appendChild(e);
            O(d.id, OSF.AgaveHostAction.TabIn);
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderStage1End);
        },
        vb = function(j) {
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderStage2Start);
            N(j.div);
            var Bb = j.description;
            if (j.title.length > 100) j.title = j.title.substring(0, 99);
            if (j.description.length > 255) j.description = j.description.substring(0, 254);
            var xb = H + j.id,
                S = document.getElementById(xb);
            if (S == undefined) {
                S = document.createElement(g);
                S.setAttribute(a, U);
                S.setAttribute(h, xb);
            }
            var sb = document.createElement(g);
            sb.innerHTML = Bb;
            S.setAttribute('title', sb.textContent);
            sb = c;
            var nb = document.createElement(E);
            nb.setAttribute(a, V);
            nb.setAttribute(i, k);
            for (var yb, ub = 0; ub < 3; ub++) {
                yb = nb.insertRow(ub);
                yb.setAttribute(i, k);
            }
            var C = nb.rows;
            C[0].insertCell(0);
            C[0].insertCell(1);
            C[0].insertCell(2);
            C[0].cells[1].setAttribute('rowSpan', '2');
            C[1].insertCell(0);
            C[1].insertCell(1);
            C[2].insertCell(0);
            C[2].insertCell(1);
            C[2].insertCell(2);
            C[0].cells[0].setAttribute(a, W);
            C[0].cells[1].setAttribute(a, X);
            C[0].cells[2].setAttribute(a, Y);
            C[2].cells[1].setAttribute(a, Z);
            var qb = document.createElement(n);
            qb.src = b.getLocalizedImageFilePath(o);
            var mb, ob;
            if (j.infoType === OSF.InfoType.Error) {
                mb = ab;
                ob = Strings.OsfRuntime.L_InfobarIconErrorAccessibleName_TXT;
            } else if (j.infoType === OSF.InfoType.Warning) {
                mb = bb;
                ob = Strings.OsfRuntime.L_InfobarIconWarningAccessibleName_TXT;
            } else if (j.infoType === OSF.InfoType.Information) {
                mb = cb;
                ob = Strings.OsfRuntime.L_InfobarIconInfoAccessibleName_TXT;
            } else {
                mb = db;
                ob = Strings.OsfRuntime.L_InfobarIconSecInfoAccessibleName_TXT;
            }
            qb.setAttribute(a, mb);
            qb.setAttribute(s, ob);
            C[0].cells[0].appendChild(qb);
            var pb = document.createElement('a');
            pb.setAttribute(a, eb);
            pb.setAttribute(q, l);
            var tb = document.createElement(z);
            tb.setAttribute(a, fb);
            tb.innerHTML = j.title;
            var vb = gb + j.id,
                T = document.getElementById(vb);
            if (T == undefined) {
                T = document.createElement(z);
                T.setAttribute(a, hb);
                T.setAttribute(h, vb);
            }
            T.innerHTML = j.description;
            pb.appendChild(tb);
            pb.appendChild(T);
            C[0].cells[1].appendChild(pb);
            var rb = function(a) {
                    var c = b.getOsfControl(a.id);
                    Telemetry.AppNotificationHelper.LogNotification(
                        c._appCorrelationId,
                        a.sqmDWords[0],
                        a.sqmDWords[1]
                    );
                },
                wb = function() {
                    j.sqmDWords[1] |= 8;
                    rb(j);
                    !j.reDisplay && G(j.id, j.displayDeactive);
                    p(j.id);
                    if (j.reDisplay) P(j);
                    else B(j.id);
                    j.dismissCallback && j.dismissCallback();
                },
                M = document.createElement(J);
            M.setAttribute(u, K);
            M.setAttribute('src', b.getLocalizedImageFilePath(o));
            M.setAttribute(a, ib);
            M.setAttribute(h, jb + j.id);
            M.setAttribute(q, '0');
            M.setAttribute(s, Strings.OsfRuntime.L_InfobarIconCloseButtonAccessibleName_TXT);
            M.setAttribute(i, d);
            M.setAttribute(r, 'handleDismiss();');
            OSF.OUtil.attachClickHandler(M, wb);
            C[0].cells[2].appendChild(M);
            j.detailView = e;
            var Q = document.createElement(d);
            Q.setAttribute(a, A);
            Q.innerHTML = j.buttonTxt;
            Q.setAttribute(h, kb + j.id);
            Q.setAttribute(q, l);
            Q.setAttribute(u, d);
            if (j.buttonCallback) {
                var Ab = function() {
                    j.sqmDWords[1] |= 4;
                    rb(j);
                    G(j.id, e);
                    p(j.id);
                    B(j.id);
                    if (j.retryAll === f) {
                        var a = b.getOsfControl(j.id);
                        a._retryActivate = c;
                        b.retryAll(a._marketplaceID);
                    }
                    j.buttonCallback();
                };
                Q.setAttribute(r, 'handleButtonClick()');
                OSF.OUtil.attachClickHandler(Q, Ab);
            } else {
                Q.setAttribute(r, 'handleDismiss()');
                OSF.OUtil.attachClickHandler(Q, wb);
            }
            C[2].cells[1].appendChild(Q);
            if (j.url) {
                var zb = function() {
                        j.sqmDWords[1] |= 4;
                        rb(j);
                        j.sqmDWords[1] = 1;
                        window.open(j.url);
                    },
                    R = document.createElement(d);
                R.setAttribute(a, A);
                R.innerHTML = j.urlButtonTxt
                    ? j.urlButtonTxt
                    : Strings.OsfRuntime.L_MoreInfoButton_TXT;
                R.setAttribute(h, lb + j.id);
                R.setAttribute(r, 'moreInfoButtonClick()');
                OSF.OUtil.attachClickHandler(R, zb);
                R.setAttribute(q, l);
                R.setAttribute(u, d);
                C[2].cells[1].appendChild(R);
            }
            S.appendChild(nb);
            var F = document.createElement(g);
            F.setAttribute(a, t);
            F.setAttribute(h, I + j.id);
            if (j.displayDeactive) {
                F.style.backgroundImage = v + b.getLocalizedImageFilePath(D) + ')';
                F.style.backgroundColor = L;
                F.style.opacity = l;
                F.style.filter = w;
                F.style.backgroundRepeat = x;
                F.style.backgroundPosition = y;
                F.style.height = m;
            }
            F.appendChild(S);
            if (j.div.childNodes.length != 0) j.div.insertBefore(F, j.div.childNodes[0]);
            else j.div.appendChild(F);
            O(j.id, OSF.AgaveHostAction.TabIn);
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderStage2End);
        },
        rb = function(a) {
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderStage2Start);
            try {
                N(a.div);
                var i = a.description;
                if (a.title.length > 100) a.title = a.title.substring(0, 99);
                if (a.description.length > 255) a.description = a.description.substring(0, 254);
                var f = H + a.id,
                    e = document.getElementById(f);
                if (e == undefined) {
                    e = document.createElement(g);
                    e.className = U;
                    e.id = f;
                }
                e.title = i;
                if (a.iframeNotificationUrl) e.appendChild(xb(a, e));
                else e.appendChild(yb(a));
                var d = document.createElement(g);
                d.className = t;
                d.id = I + a.id;
                if (a.displayDeactive) {
                    d.style.backgroundImage = v + b.getLocalizedImageFilePath(D) + ')';
                    d.style.backgroundColor = L;
                    d.style.opacity = l;
                    d.style.filter = w;
                    d.style.backgroundRepeat = x;
                    d.style.backgroundPosition = y;
                    d.style.height = m;
                }
                d.appendChild(e);
                if (a.div.childNodes.length != 0) a.div.insertBefore(d, a.div.childNodes[0]);
                else a.div.appendChild(d);
                O(a.id, OSF.AgaveHostAction.TabIn);
            } catch (h) {
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    'Failed to show infobar, error message: ',
                    h,
                    c,
                    23455900
                );
            }
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderStage2End);
        },
        zb = function(a) {
            function q(f) {
                function b(c, b) {
                    var a = c.insertRow(-1);
                    a.className = 'moe-trust-prompt-row ' + b;
                    a.setAttribute(i, k);
                    var d = a.insertCell(-1);
                    d.className = 'moe-trust-prompt-cell';
                }
                var j = f.id,
                    e = Q + f.id,
                    a = document.getElementById(e);
                if (a === c) {
                    a = document.createElement(E);
                    a.id = e;
                    a.className = 'moe-trust-prompt-table';
                    a.setAttribute(i, k);
                }
                var h = a.createTHead();
                b(h, 'moe-trust-prompt-header');
                var d = a.createTBody();
                b(d, 'moe-trust-prompt-preview');
                b(d, 'moe-trust-prompt-description');
                var g = a.createTFoot();
                b(g, 'moe-trust-prompt-footer');
                return a;
            }
            function t(c) {
                var d = document.createElement(g);
                d.className =
                    'moe-trust-prompt-collapse cui-ctl-iconContainer cui-img-cont-float cui-img-16by16';
                var a = document.createElement(n);
                switch (c.clientName) {
                    case 'WAC_Powerpoint':
                        a.src = b.getLocalizedImageFilePath('per.png');
                        a.className = 'per_UpChevron_16x16x32';
                        break;
                    case 'WAC_Word':
                        a.src = b.getLocalizedImageFilePath('we.png');
                        a.className = 'we_UpChevron_16x16x32';
                        break;
                    case 'WAC_Excel':
                        a.src = b.getLocalizedImageFilePath('EwaEdit.png');
                        a.className = 'ewaboot_UpChevron16';
                }
                a.alt = Strings.OsfRuntime.L_InfobarIconCloseButtonAccessibleName_TXT;
                var e = function() {
                    var a = 'collapsed';
                    if (c.collapsed === f) c.div.classList.remove(a);
                    else c.div.classList.add(a);
                    c.collapsed = !c.collapsed;
                };
                d.appendChild(a);
                OSF.OUtil.attachClickHandler(d, e);
                return d;
            }
            function x(b) {
                var a = document.createElement('p');
                a.innerHTML =
                    b.notificationType === OSF.NotificationType.TrustPromptContent
                        ? b.name
                        : b.title;
                a.className = 'moe-trust-prompt-header-title';
                return a;
            }
            function z(b) {
                var a = document.createElement(n);
                a.src = b.icon;
                a.className = 'moe-trust-prompt-preview-img';
                a.setAttribute(s, b.iconTitle);
                return a;
            }
            function w(b) {
                var a = document.createElement('p');
                a.innerHTML = b.name;
                a.className = 'moe-trust-prompt-preview-title';
                return a;
            }
            function A(b) {
                var a = document.createElement('p');
                a.innerHTML = b.provider;
                a.className = 'moe-trust-prompt-preview-sub';
                return a;
            }
            function r(b) {
                var a = document.createElement('p');
                a.innerHTML = b.description;
                a.className = 'moe-trust-prompt-description-text';
                return a;
            }
            function v() {
                var e = document.createElement(d);
                e.textContent = a.buttonTxt;
                e.className =
                    'moe-trust-prompt-button moe-trust-prompt-button-primary moe-trust-prompt-buttons-action';
                e.id = 'moe-trust-prompt-buttons-action_' + a.id;
                e.tabIndex = 0;
                e.type = d;
                var g;
                if (a.buttonCallback)
                    g = function() {
                        a.sqmDWords[1] |= 4;
                        F(a);
                        qb(a);
                        p(a.id);
                        B(a.id);
                        if (a.retryAll === f) {
                            var d = b.getOsfControl(a.id);
                            d._retryActivate = c;
                            b.retryAll(d._marketplaceID);
                        }
                        a.buttonCallback();
                    };
                else
                    g = function() {
                        a.sqmDWords[1] |= 8;
                        F(a);
                        !a.reDisplay && qb(a);
                        p(a.id);
                        if (a.reDisplay) P(a);
                        else B(a.id);
                        a.dismissCallback && a.dismissCallback();
                    };
                OSF.OUtil.attachClickHandler(e, g);
                return e;
            }
            function y(b) {
                var a = document.createElement(d);
                a.textContent = b.urlButtonTxt || Strings.OsfRuntime.L_MoreInfoButton_TXT;
                a.className = 'moe-trust-prompt-button moe-trust-prompt-buttons-url';
                a.id = 'moe-trust-prompt-buttons-url_' + b.id;
                a.tabIndex = 1;
                a.type = d;
                var c = function() {
                    b.sqmDWords[1] |= 4;
                    F(b);
                    window.open(b.url);
                };
                OSF.OUtil.attachClickHandler(a, c);
                return a;
            }
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderStage2Start);
            try {
                N(a.div);
                var M = 0,
                    j = 1,
                    D = 2,
                    m = 3,
                    h = 0,
                    l = q(a),
                    e = l.rows,
                    J = x(a);
                e[M].cells[h].appendChild(J);
                var K = z(a),
                    I = w(a),
                    L = A(a);
                e[j].cells[h].appendChild(K);
                e[j].cells[h].appendChild(I);
                e[j].cells[h].appendChild(L);
                var C = r(a);
                e[D].cells[h].appendChild(C);
                var u = v(a);
                e[m].cells[h].appendChild(u);
                if (a.url !== c) {
                    var H = y(a);
                    e[m].cells[h].appendChild(H);
                }
                var G = t(a);
                if (a.div.childNodes.length != 0) a.div.insertBefore(l, a.div.childNodes[0]);
                else a.div.appendChild(l);
                a.div.appendChild(G);
                a.div.style.overflowY = 'auto';
                a.div.classList.add('moe-trust-prompt');
                a.div.classList.add(a.clientName);
                a.div.classList.add(
                    a.notificationType === OSF.NotificationType.TrustPromptContent
                        ? 'content-add-in'
                        : 'taskpane-add-in'
                );
                O(a.id, OSF.AgaveHostAction.TabIn);
            } catch (o) {
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    'Failed to show trust prompt, error message: ',
                    o,
                    c,
                    38592974
                );
            }
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderStage2End);
        },
        yb = function(a) {
            var q = ob(a),
                j = q.rows;
            j[0].cells[0].appendChild(sb(a));
            var k = document.createElement('a');
            k.className = eb;
            k.tabIndex = 1;
            var l = document.createElement(z);
            l.className = fb;
            l.textContent = a.title;
            var m = gb + a.id,
                i = document.getElementById(m);
            if (i == undefined) {
                i = document.createElement(z);
                i.className = hb;
                i.id = m;
            }
            i.textContent = a.description;
            k.appendChild(l);
            k.appendChild(i);
            j[0].cells[1].appendChild(k);
            var o = function() {
                    ub(a);
                },
                n = tb(a);
            OSF.OUtil.attachClickHandler(n, o);
            j[0].cells[2].appendChild(n);
            a.detailView = e;
            var g = document.createElement(d);
            g.className = A;
            g.textContent = a.buttonTxt;
            g.id = kb + a.id;
            g.tabIndex = 1;
            g.type = d;
            if (a.buttonCallback) {
                var s = function() {
                    a.sqmDWords[1] |= 4;
                    F(a);
                    G(a.id, e);
                    p(a.id);
                    B(a.id);
                    if (a.retryAll === f) {
                        var d = b.getOsfControl(a.id);
                        d._retryActivate = c;
                        b.retryAll(d._marketplaceID);
                    }
                    a.buttonCallback();
                };
                OSF.OUtil.attachClickHandler(g, s);
            } else OSF.OUtil.attachClickHandler(g, o);
            j[2].cells[1].appendChild(g);
            if (a.url) {
                var r = function() {
                        a.sqmDWords[1] |= 4;
                        F(a);
                        a.sqmDWords[1] = 1;
                        window.open(a.url);
                    },
                    h = document.createElement(d);
                h.className = A;
                h.textContent = a.urlButtonTxt
                    ? a.urlButtonTxt
                    : Strings.OsfRuntime.L_MoreInfoButton_TXT;
                h.id = lb + a.id;
                OSF.OUtil.attachClickHandler(h, r);
                h.tabIndex = 1;
                h.type = d;
                j[2].cells[1].appendChild(h);
            }
            return q;
        },
        xb = function(a, j) {
            var g = 'message',
                n = ob(a),
                l = n.rows,
                d = document.createElement('iframe'),
                q = window.getComputedStyle(a.div, c);
            d.width = m;
            d.frameBorder = '0';
            d.className = pb;
            d.src = a.iframeNotificationUrl;
            l[0].cells[1].appendChild(d);
            var k = 'moe-hovered';
            j.addEventListener('mouseenter', function() {
                OSF.OUtil.addClass(j, k);
                d.contentWindow.postMessage(OSF.AgaveHostAction.MouseEnter, T);
            });
            j.addEventListener('mouseleave', function() {
                OSF.OUtil.removeClass(j, k);
                d.contentWindow.postMessage(OSF.AgaveHostAction.MouseLeave, T);
            });
            a.detailView = e;
            var h = c,
                o = function() {
                    ub(a);
                    window.removeEventListener(g, h);
                },
                i = tb(a);
            OSF.OUtil.attachClickHandler(i, o);
            l[0].cells[2].appendChild(i);
            i.addEventListener('keydown', function(a) {
                if (a.keyCode == 9)
                    if (a.shiftKey) {
                        a.preventDefault();
                        a.stopPropagation();
                        d.contentWindow.postMessage(OSF.AgaveHostAction.TabInShift, T);
                    }
            });
            if (a.buttonCallback) {
                h = function(n) {
                    try {
                        if (n.source == d.contentWindow) {
                            var l = JSON.parse(n.data),
                                k = parseInt(l[OSF.OmexMessageKeys.MessageType]),
                                j = parseInt(l[OSF.OmexMessageKeys.MessageValue]);
                            if (k == OSF.OmexMessageType.ConsentResult) {
                                G(a.id, e);
                                p(a.id);
                                B(a.id);
                                if (
                                    a.retryAll === f &&
                                    (a.notificationType == OSF.NotificationType.TrustYellowBar ||
                                        (a.notificationType ==
                                            OSF.NotificationType.ConsentYellowBar &&
                                            j == OSF.ConsentResultCode.Success))
                                ) {
                                    var m = b.getOsfControl(a.id);
                                    m._retryActivate = c;
                                    b.retryAll(m._marketplaceID);
                                }
                                window.removeEventListener(g, h);
                                a.buttonCallback(j);
                            } else if (k == OSF.OmexMessageType.TabExit)
                                if (j == OSF.AgaveHostAction.TabExitShift && b._notifyHost)
                                    b._notifyHost(a.id, OSF.AgaveHostAction.TabExitShift);
                                else if (j == OSF.AgaveHostAction.TabExit) {
                                    window.focus();
                                    i.focus();
                                }
                        }
                    } catch (o) {
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                            'Exception in receivedMessageHandler: ',
                            o,
                            c,
                            23455901
                        );
                    }
                };
                window.addEventListener(g, h);
            }
            return n;
        },
        ob = function(e) {
            var d = document.createElement(E);
            d.className = V;
            d.setAttribute(i, k);
            for (var g = e.iframeNotificationUrl ? 1 : 3, f = 0; f < g; f++) {
                var h = d.insertRow(f);
                h.setAttribute(i, k);
            }
            var b = d.rows;
            b[0].insertCell(0);
            b[0].insertCell(1);
            b[0].insertCell(2);
            b[0].cells[1].setAttribute('rowSpan', '2');
            b[0].cells[0].setAttribute(a, W);
            b[0].cells[1].setAttribute(a, X);
            b[0].cells[2].setAttribute(a, Y);
            if (e.iframeNotificationUrl == c) {
                b[1].insertCell(0);
                b[1].insertCell(1);
                b[2].insertCell(0);
                b[2].insertCell(1);
                b[2].insertCell(2);
                b[2].cells[1].setAttribute(a, Z);
            }
            b[0].cells[0].appendChild(sb(e));
            return d;
        },
        sb = function(e) {
            var d = document.createElement(n);
            d.src = b.getLocalizedImageFilePath(o);
            var a, c;
            if (e.infoType === OSF.InfoType.Error) {
                a = ab;
                c = Strings.OsfRuntime.L_InfobarIconErrorAccessibleName_TXT;
            } else if (e.infoType === OSF.InfoType.Warning) {
                a = bb;
                c = Strings.OsfRuntime.L_InfobarIconWarningAccessibleName_TXT;
            } else if (e.infoType === OSF.InfoType.Information) {
                a = cb;
                c = Strings.OsfRuntime.L_InfobarIconInfoAccessibleName_TXT;
            } else {
                a = db;
                c = Strings.OsfRuntime.L_InfobarIconSecInfoAccessibleName_TXT;
            }
            d.className = a;
            d.alt = c;
            return d;
        },
        F = function(a) {
            var c = b.getOsfControl(a.id);
            Telemetry.AppNotificationHelper.LogNotification(
                c._appCorrelationId,
                a.sqmDWords[0],
                a.sqmDWords[1]
            );
        },
        ub = function(a) {
            a.sqmDWords[1] |= 8;
            F(a);
            !a.reDisplay && G(a.id, a.displayDeactive);
            p(a.id);
            if (a.reDisplay) P(a);
            else B(a.id);
            a.dismissCallback && a.dismissCallback();
        },
        tb = function(c) {
            var a = document.createElement(J);
            a.type = K;
            a.src = b.getLocalizedImageFilePath(o);
            a.className = ib;
            a.id = jb + c.id;
            a.tabIndex = 0;
            a.alt = Strings.OsfRuntime.L_InfobarIconCloseButtonAccessibleName_TXT;
            a.setAttribute(i, d);
            return a;
        },
        p = function(c) {
            var a = b.getOsfControl(c);
            if (a) a._controlFocus = f;
        },
        Cb = function(e) {
            var a = b.getOsfControl(e);
            if (!a) return;
            if (C(e)) return;
            if (
                a.getStatus() === OSF.OsfControlStatus.Activated &&
                a.getPageStatus() === OSF.OsfControlPageStatus.Ready
            )
                a.notifyAgave(OSF.AgaveHostAction.TabIn);
            else {
                var d = '_trySetFocusInAppContent$newCallback';
                if (
                    a._notifyHostIFrameOnLoaded &&
                    a._notifyHostIFrameOnLoaded.newCallbackIdentity &&
                    a._notifyHostIFrameOnLoaded.newCallbackIdentity === d
                )
                    return;
                var c = (function(b) {
                    return function() {
                        if (b)
                            try {
                                b();
                            } catch (c) {}
                        a.getStatus() === OSF.OsfControlStatus.Activated &&
                            a.getPageStatus() === OSF.OsfControlPageStatus.Ready &&
                            a.notifyAgave(OSF.AgaveHostAction.TabIn);
                        a._notifyHostIFrameOnLoaded = b;
                    };
                })(a._notifyHostIFrameOnLoaded);
                c['newCallbackIdentity'] = d;
                a._notifyHostIFrameOnLoaded = c;
            }
        },
        O = function(d, i) {
            var e = b.getOsfControl(d);
            if (e)
                if (e._controlFocus)
                    if (C(d)) {
                        var a = j[d][0];
                        if (a && a.div)
                            if (a.iframeNotificationUrl != c) {
                                var g = a.div.getElementsByClassName(pb)[0];
                                if (g) {
                                    g.contentWindow.postMessage(OSF.AgaveHostAction.TabIn, T);
                                    b._notifyHost &&
                                        b._notifyHost(d, OSF.AgaveHostAction.SelectWithError);
                                }
                            } else {
                                var f = a.div.querySelectorAll(mb);
                                if (f && f.length > 0) {
                                    var h = f[0];
                                    if (h instanceof HTMLElement) {
                                        window.focus();
                                        h.focus();
                                        b._notifyHost &&
                                            b._notifyHost(d, OSF.AgaveHostAction.SelectWithError);
                                    }
                                }
                            }
                    } else e.notifyAgave(i);
        },
        Ab = function(c, h) {
            var d = b.getOsfControl(c);
            if (d)
                if (d._controlFocus)
                    if (C(c)) {
                        var f = j[c][0];
                        if (f && f.div) {
                            var a = f.div.querySelectorAll(mb);
                            if (a && a.length > 0) {
                                var g = a.length > 1 ? a[1] : a[0];
                                if (g instanceof HTMLElement) {
                                    window.focus();
                                    g.focus();
                                    b._notifyHost &&
                                        b._notifyHost(c, OSF.AgaveHostAction.SelectWithError);
                                }
                            }
                        }
                    } else {
                        d._controlFocus = e;
                        b._notifyHost(c, h);
                    }
        },
        P = function(a) {
            var b = OfficeExt.HostFeatureEnabledInfo.getHostFeatureEnabledInfo(),
                c = b && b.enableNewTrustPromptForAddIn;
            if (
                (a.notificationType === OSF.NotificationType.TrustPromptContent ||
                    a.notificationType === OSF.NotificationType.TrustPromptTaskpane) &&
                c
            ) {
                zb(a);
                return;
            }
            if (a.detailView == undefined || a.detailView === e) {
                a.sqmDWords[1] = 0;
                wb(a);
            } else {
                a.sqmDWords[1] = 1;
                var d = b && b.enableSingleSignOnForAddin;
                if (d) rb(a);
                else vb(a);
            }
        },
        Gb = function(a) {
            if (j[a]) {
                if (j[a].length > 0) {
                    var b = j[a][0].div;
                    N(b);
                }
                delete j[a];
            }
        },
        Db = function(c) {
            var a = document.createElement(g),
                b = document.createTextNode(c);
            a.appendChild(b);
            return a.innerHTML;
        },
        B = function(a) {
            if (C(a)) {
                var b = j[a][0];
                P(b);
            } else Cb(a);
        },
        C = function(a) {
            return j[a] && j[a].length > 0;
        };
    return {
        showProgress: function(i, e) {
            try {
                OSF.OUtil.writeProfilerMark(
                    OSF.NotificationUxPerfMarker.RenderLoadingAnimationStart
                );
                var f = document.getElementById(M + e);
                if (!f) {
                    j[e] = [];
                    var c = document.createElement(g);
                    c.setAttribute(a, t);
                    c.setAttribute(h, M + e);
                    c.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
                    c.style.opacity = l;
                    c.style.filter = w;
                    c.style.height = m;
                    var d = document.createElement(g);
                    d.style.width = m;
                    d.style.height = m;
                    d.style.backgroundImage = v + b.getLocalizedImageFilePath(nb) + ')';
                    d.style.backgroundRepeat = x;
                    d.style.backgroundPosition = y;
                    c.appendChild(d);
                    i.appendChild(c);
                }
                OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RenderLoadingAnimationEnd);
            } catch (k) {}
        },
        showNotification: function(a) {
            a.sqmDWords = [a.errorCode, 0];
            delete a.errorCode;
            if (a.highPriority == undefined)
                a.highPriority = a.infoType === OSF.InfoType.Error ? f : e;
            if (a.reDisplay == undefined) a.reDisplay = a.infoType === OSF.InfoType.Error ? f : e;
            var b = j[a.id];
            if (b === undefined) {
                b = [];
                j[a.id] = b;
            }
            if (a.highPriority === e) b.push(a);
            else {
                b.splice(R, 0, a);
                R++;
            }
            (j[a.id].length === 1 || a.highPriority) && P(b[0]);
        },
        showICon: function(a) {
            wb(a);
        },
        removeDOMElement: function(a) {
            S(a);
        },
        removeProgressDiv: function(a, c) {
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RemoveLoadingAnimationStart);
            var b = a.ownerDocument.getElementById(M + c);
            b && N(a);
            OSF.OUtil.writeProfilerMark(OSF.NotificationUxPerfMarker.RemoveLoadingAnimationEnd);
        },
        removeIConDiv: function(a) {
            Ib(a);
        },
        removeInfoBarDiv: function(b, a) {
            G(b, a);
        },
        dismissMessages: function(a) {
            Gb(a);
        },
        getHTMLEncodedString: function(a) {
            return Db(a);
        },
        purgeOsfControlNotification: function(c) {
            var a = j[c],
                d = b.getOsfControl(c);
            a &&
                a.length > 0 &&
                d &&
                Telemetry.AppNotificationHelper.LogNotification(
                    c,
                    a[0].sqmDWords[0],
                    a[0].sqmDWords[1]
                );
        },
        focusOnNotificationUx: function(a, b) {
            p(a);
            O(a, b);
        },
        focusOnNotificationUxShiftIn: function(a, b) {
            p(a);
            Ab(a, b);
        },
        appHasNotifications: function(a) {
            return C(a);
        },
    };
};
var OfficeExt;
(function(b) {
    var a = (function() {
        function a() {}
        a.setHostFeatureEnabledInfo = function(a) {
            this._hostFeatureEnabledInfo = a;
        };
        a.getHostFeatureEnabledInfo = function() {
            return this._hostFeatureEnabledInfo;
        };
        return a;
    })();
    b.HostFeatureEnabledInfo = a;
})(OfficeExt || (OfficeExt = {}));
OSF.OUtil.setNamespace('AppSpecificSetup', OSF);
OSF.ContextActivationManager = function(f) {
    var g = '0',
        i = "osfControl for the given ID doesn't exist.",
        c = null,
        e = true,
        b = false,
        a = this;
    OSF.OUtil.validateParamObject(
        f,
        {
            appName: { type: Number, mayBeNull: b },
            appVersion: { type: String, mayBeNull: b },
            clientMode: { type: Number, mayBeNull: b },
            appUILocale: { type: String, mayBeNull: b },
            dataLocale: { type: String, mayBeNull: b },
            osfOmexBaseUrl: { type: String, mayBeNull: e },
            devCatalogUrl: { type: String, mayBeNull: e },
            oneDriveCatalogBaseApiUrl: { type: String, mayBeNull: e },
            sdxCdnUrl: { type: String, mayBeNull: e },
            sdxDmsUrl: { type: String, mayBeNull: e },
            spBaseUrl: { type: String, mayBeNull: e },
            docUrl: { type: String, mayBeNull: e },
            hostControl: { type: Object, mayBeNull: e },
            pageBaseUrl: { type: String, mayBeNull: e },
            lcid: { type: String, mayBeNull: e },
            formFactor: { type: String, mayBeNull: e },
            controlStatusChanged: { type: Object, mayBeNull: e },
            notifyHost: { type: Object, mayBeNull: e },
            allowExternalMarketplace: { type: Boolean, mayBeNull: e },
            localizedScriptsUrl: { type: String, mayBeNull: e },
            localizedImagesUrl: { type: String, mayBeNull: e },
            localizedStylesUrl: { type: String, mayBeNull: e },
            localizedResourcesUrl: { type: String, mayBeNull: e },
            trustAgaves: { type: Boolean, mayBeNull: e },
            enableAddinCommands: { type: Boolean, mayBeNull: e },
            enableBlackForestRedirect: { type: Boolean, mayBeNull: e },
            enableMyOrg: { type: Boolean, mayBeNull: e },
            enableMyApps: { type: Boolean, mayBeNull: e },
            enableDevCatalog: { type: Boolean, mayBeNull: e },
            enableOneDriveCatalog: { type: Boolean, mayBeNull: e },
            enablePrivateCatalog: { type: Boolean, mayBeNull: e },
            enableTaskpaneUpgradeToAppCommand: { type: Boolean, mayBeNull: e },
            enableUploadFileDevCatalog: { type: Boolean, mayBeNull: e },
            enableV1RedirectApis: { type: Boolean, mayBeNull: e },
            omexForceAnonymous: { type: Boolean, mayBeNull: e },
            userNameHashCode: { type: Number, mayBeNull: e },
            hostFullVersion: { type: String, mayBeNull: e },
            envCode: { type: String, mayBeNull: e },
            showSignOutFromPrivateCatalogMessage: { type: Boolean, mayBeNull: e },
            enableSingleSignOnForAddin: { type: Boolean, mayBeNull: e },
            enableServiceDeliveredExperience: { type: Boolean, mayBeNull: e },
            hideAppsExtensionUrl: { type: String, mayBeNull: e },
            enableInsertDialogAccessibilityFix: { type: Boolean, mayBeNull: e },
            disableLogging: { type: Boolean, mayBeNull: e },
            enableDisplayBlockedMinorError: { type: Boolean, mayBeNull: e },
            enableFirstPartySSO: { type: Boolean, mayBeNull: e },
            enableFirstPartySSOResourceCheck: { type: Boolean, mayBeNull: e },
            enableFirstPartyUseWopiIdentity: { type: Boolean, mayBeNull: e },
            disableAppsForOfficeThirdParty: { type: Boolean, mayBeNull: e },
            wacSessionId: { type: String, mayBeNull: e },
            enableFirstPartySDXErrorMessages: { type: Boolean, mayBeNull: e },
            isHostDocumentDomain: { type: Boolean, mayBeNull: e },
            enableRichApiCellEditDelay: { type: Boolean, mayBeNull: e },
            enableNewTrustPromptForAddIn: { type: Boolean, mayBeNull: e },
        },
        c
    );
    a._osfOmexBaseUrl = f.osfOmexBaseUrl;
    a._devCatalogUrl = f.devCatalogUrl;
    a._sdxCdnUrl = f.sdxCdnUrl;
    a._sdxDmsUrl = f.sdxDmsUrl;
    a._firstPartyManifestCDNUrl = f.firstPartyManifestCDNUrl;
    a._oneDriveCatalogBaseApiUrl = f.oneDriveCatalogBaseApiUrl;
    a._spBaseUrl = f.spBaseUrl;
    a._myOrgCatalogUrl = c;
    a._enableAddinCommands = f.enableAddinCommands || b;
    a._enableBlackForestRedirect = f.enableBlackForestRedirect || b;
    a._enableInsertDialogAccessibilityFix = f.enableInsertDialogAccessibilityFix || b;
    a._enableFirstPartySDXErrorMessages = f.enableFirstPartySDXErrorMessages || b;
    a._enableMyOrg = f.enableMyOrg || b;
    a._enableMyApps = f.enableMyApps || b;
    a._enableDevCatalog = f.enableDevCatalog || b;
    a._enableOneDriveCatalog = f.enableOneDriveCatalog || b;
    a._enablePrivateCatalog = f.enablePrivateCatalog || b;
    a._showSignOutFromPrivateCatalogMessage = f.showSignOutFromPrivateCatalogMessage || b;
    a._enableTaskpaneUpgradeToAppCommand = f.enableTaskpaneUpgradeToAppCommand || b;
    a._enableUploadFileDevCatalog = f.enableUploadFileDevCatalog || b;
    a._enableV1RedirectApis = f.enableV1RedirectApis || b;
    a._appName = f.appName;
    a._appVersion = f.appVersion;
    a._clientMode = f.clientMode;
    a._appUILocale = f.appUILocale;
    a._dataLocale = f.dataLocale;
    a._docUrl = f.docUrl;
    a._hostControl = f.hostControl;
    a._formFactor = f.formFactor || OSF.FormFactor.Default;
    a._pageBaseUrl = f.pageBaseUrl;
    a._lcid = f.lcid;
    a._controlStatusChanged = f.controlStatusChanged;
    a._notifyHost = f.notifyHost || function() {};
    a._allowExternalMarketplace = f.allowExternalMarketplace;
    a._localizedScriptsUrl = f.localizedScriptsUrl;
    a._localizedImagesUrl = f.localizedImagesUrl;
    a._localizedStylesUrl = f.localizedStylesUrl;
    a._localizedResourcesUrl = f.localizedResourcesUrl;
    a._autoTrusted = f.trustAgaves;
    a._omexForceAnonymous = f.omexForceAnonymous || b;
    a._userNameHashCode = f.userNameHashCode || 0;
    a._hostFullVersion = f.hostFullVersion;
    a._wacHostEnvironment = f.envCode;
    a._enableSingleSignOnForAddin = f.enableSingleSignOnForAddin || b;
    a._enableFirstPartySSO = f.enableFirstPartySSO || b;
    a._enableFirstPartySSOResourceCheck = f.enableFirstPartySSOResourceCheck || b;
    a._enableFirstPartyUseWopiIdentity = f.enableFirstPartyUseWopiIdentity || b;
    a._enableServiceDeliveredExperience = f.enableServiceDeliveredExperience || e;
    a._hideAppsExtensionUrl = a._osfOmexBaseUrl + f.hideAppsExtensionUrl;
    a._disableLogging = f.disableLogging || b;
    a._enableDisplayBlockedMinorError = f.enableDisplayBlockedMinorError || b;
    a._disableAppsForOfficeThirdParty = f.disableAppsForOfficeThirdParty || b;
    a._isHostDocumentDomain = f.isHostDocumentDomain || b;
    a._enableRichApiCellEditDelay = f.enableRichApiCellEditDelay || b;
    a._loggableUserId = f.loggableUserId;
    a._sessionStartInfoJson = f.sessionStartInfoJson;
    a._enableNewTrustPromptForAddIn = f.enableNewTrustPromptForAddIn || b;
    OfficeExt.HostFeatureEnabledInfo.setHostFeatureEnabledInfo(f);
    if (a._pageBaseUrl && a._pageBaseUrl.charAt(a._pageBaseUrl.length - 1) !== '/')
        a._pageBaseUrl = a._pageBaseUrl + '/';
    if (
        a._localizedResourcesUrl &&
        a._localizedResourcesUrl.charAt(a._localizedResourcesUrl.length - 1) !== '/'
    )
        a._localizedResourcesUrl = a._localizedResourcesUrl + '/';
    a._clientId = OSF.OUtil.getUniqueId();
    a._cachedOsfControls = {};
    a._iframeAttributeBag = {};
    a._serviceEndPoint = c;
    a._serviceEndPointInternal = c;
    a._internalConversationId = c;
    a._iframeProxies = {};
    a._iframeProxyCount = 0;
    a._iframeNamePrefix = '__officeExtensionProxy';
    a._webUrl = c;
    a._wsa = c;
    a._insertDialogDiv = c;
    a._hasPreloadedOfficeJs = b;
    a._contextMgrCorrelationId = f.wacSessionId || OSF.OUtil.Guid.generateNewGuid();
    Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
        '_contextMgrCorrelationId :' + a._contextMgrCorrelationId,
        c,
        20194265
    );
    a._hostType = c;
    a._hostPlatform = c;
    a._hostSpecificFileVersion = c;
    a._requirementsChecker = new OSF.RequirementsChecker();
    a._onClickInstallOsfControl = c;
    if (a._osfOmexBaseUrl) {
        var h,
            m = a._osfOmexBaseUrl.indexOf(OSF.Constants.ProtocolSeparator);
        if (m >= 0) h = a._osfOmexBaseUrl.substr(m);
        else h = OSF.Constants.ProtocolSeparator + a._osfOmexBaseUrl;
        var o = OSF.Constants.Https + h,
            n = OSF.Constants.Https + h;
        if (
            OSF.OUtil.getQueryStringParamValue(
                window.location.search,
                OSF.Constants.OmexForceAnonymousParamName
            ).toLowerCase() == OSF.Constants.OmexForceAnonymousParamValue.toLowerCase()
        ) {
            a._omexAuthNStatus = OSF.OmexAuthNStatus.Anonymous;
            a._omexForceAnonymous = e;
        } else a._omexAuthNStatus = OSF.OmexAuthNStatus.NotAttempted;
        a._omexGatedWSProxy = {
            proxyUrl: o + OSF.Constants.OmexGatedServiceExtension,
            proxyName: '__omexExtensionGatedProxy',
            isReady: b,
            clientEndPoint: c,
            pendingCallbacks: [],
        };
        a._omexWSProxy = {
            proxyUrl: n + OSF.Constants.OmexUnGatedServiceExtension,
            proxyName: '__omexExtensionProxy',
            isReady: b,
            clientEndPoint: c,
            pendingCallbacks: [],
        };
        a._omexAnonymousWSProxy = {
            proxyUrl: o + OSF.Constants.OmexAnonymousServiceExtension,
            proxyName: '__omexExtensionAnonymousProxy',
            isReady: b,
            clientEndPoint: c,
            pendingCallbacks: [],
        };
        a._omexBillingMarket = c;
        a._omexEndPointBaseUrl = n;
    }
    a._isFromWacAutomation = (function() {
        if (this._isFromWacAutomation !== undefined && this._isFromWacAutomation !== c)
            return this._isFromWacAutomation;
        else
            try {
                var a = window,
                    d = undefined;
                while (a !== d) {
                    if (!a.location || !a.location.search) return b;
                    var f = a.location.search.toLowerCase(),
                        g = f.indexOf('automation=1');
                    if (g >= 0) return e;
                    else {
                        d = a;
                        a = a.parent;
                    }
                }
            } catch (h) {
                return b;
            }
        return b;
    })();
    OSF.OsfManifestManager._setUILocale(a._appUILocale);
    var d = a,
        v = function(f, j) {
            var k = typeof f === 'string' ? f : typeof f === 'object' && f.length > 0 ? f[0] : c;
            (!k || !j) &&
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    'Parameter validation error in getAppContextAsync.',
                    c,
                    c,
                    19203545
                );
            var a = d.getOsfControl(k);
            if (!a) {
                OsfMsAjaxFactory.msAjaxDebug.trace(i);
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    'Cannot get osfControl with given ID.',
                    c,
                    c,
                    19203546
                );
                throw OsfMsAjaxFactory.msAjaxError.argument('contextId');
            } else {
                Telemetry.AppLoadTimeHelper.OfficeJSLoaded(a._telemetryContext);
                var q = a.getEToken(),
                    m = 0;
                if (d._hostSpecificFileVersion && d._hostSpecificFileVersion.indexOf('.') != -1) {
                    var l = d._hostSpecificFileVersion.split('.'),
                        o = l[1];
                    if (!isNaN(o)) m = parseInt(l[1]);
                }
                var p = d._requirementsChecker._getSupportedSet(),
                    h = new OSF.OfficeAppContext(
                        a.getMarketplaceID(),
                        d._appName,
                        d._appVersion,
                        d._appUILocale,
                        d._dataLocale,
                        d._docUrl || window.location.href,
                        d._clientMode,
                        a.getSettings(),
                        a.getReason(),
                        a.getOsfControlType(),
                        q,
                        a._appCorrelationId,
                        a.getID(),
                        b,
                        e,
                        m,
                        p,
                        a.getHostCustomMessage(),
                        d._hostFullVersion || OSF.Constants.FileVersion,
                        window.innerHeight,
                        window.innerWidth,
                        a.getManifest() ? a.getManifest().getDefaultDisplayName() : c,
                        a._appDomains,
                        undefined
                    );
                h._wacHostEnvironment = d._wacHostEnvironment || g;
                h._isFromWacAutomation = !!d._isFromWacAutomation;
                j(h);
                a._pageStatus = OSF.OsfControlPageStatus.Ready;
                a._pageIsReadyTimerExpired &&
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'App attempted to retrieve context after app activation error has occured.',
                        c,
                        a.getCorrelationId(),
                        19203547
                    );
                a._contextActivationMgr._ErrorUXHelper &&
                    a._contextActivationMgr._ErrorUXHelper.removeProgressDiv(a._div, a._id);
                if (a._timer) {
                    window.clearTimeout(a._timer);
                    a._timer = c;
                }
                var n = a._conversationId + OSF.SharedConstants.NotificationConversationIdSuffix;
                a._agaveEndPoint = Microsoft.Office.Common.XdmCommunicationManager.connect(
                    n,
                    a._frame.contentWindow,
                    a._iframeUrl
                );
                Telemetry.AppLoadTimeHelper.ActivationEnd(a._telemetryContext);
            }
        };
    d.getContextForEmbeddingPage = function() {
        var b = 0;
        if (d._hostSpecificFileVersion && d._hostSpecificFileVersion.indexOf('.') != -1) {
            var a = d._hostSpecificFileVersion.split('.'),
                c = a[1];
            if (!isNaN(c)) b = parseInt(a[1]);
        }
        var e = d._requirementsChecker._getSupportedSet();
        return {
            appName: d._appName,
            appVersion: d._appVersion,
            appUILocal: d._appUILocale,
            dataLocale: d._dataLocale,
            docUrl: d._docUrl || window.location.href,
            clientMode: d._clientMode,
            minorVersion: b,
            requirements: e,
        };
    };
    if (a._enableServiceDeliveredExperience)
        var y = function(b) {
            var a = b && b.contextId ? d.getOsfControl(b.contextId) : c;
            switch (b.id) {
                case OSF.MessageIDs.FetchBundleUrl:
                    if (!a._agaveEndPoint) {
                        var e =
                            a._conversationId +
                            OSF.SharedConstants.NotificationConversationIdSuffix;
                        a._agaveEndPoint = Microsoft.Office.Common.XdmCommunicationManager.connect(
                            e,
                            a._frame.contentWindow,
                            a._iframeUrl
                        );
                    }
                    if (a._bundleUrl) {
                        var f = { id: OSF.MessageIDs.LoadReactBundle, bundleUrl: a._bundleUrl };
                        a.sendMessageToSdx(f);
                    }
                    break;
                case OSF.MessageIDs.LoadBundleSuccess:
                    a._pageStatus = OSF.OsfControlPageStatus.Ready;
                    a._contextActivationMgr._ErrorUXHelper &&
                        a._contextActivationMgr._ErrorUXHelper.removeProgressDiv(a._div, a._id);
                    break;
                case OSF.MessageIDs.LoadBundleError:
                    break;
                default:
                    OsfMsAjaxFactory.msAjaxDebug.trace(
                        'MessageID: ' + b.id + ' onMessageFromSdx got wrong message.'
                    );
            }
        };
    var C = function(a) {
            if (!a || a.length != 2) {
                var g =
                    a &&
                    a.length == 3 &&
                    (a[1] === OSF.AgaveHostAction.UpdateTargetUrl ||
                        a[1] === OSF.AgaveHostAction.SendTelemetryEvent);
                !g &&
                    OsfMsAjaxFactory.msAjaxDebug.trace(
                        'ContextActivationManager_notifyHost params is wrong.'
                    );
            }
            var e = a[0],
                b = a[1],
                c = d.getOsfControl(e);
            if (!c) OsfMsAjaxFactory.msAjaxDebug.trace(i);
            else if (
                b === OSF.AgaveHostAction.TabExitShift ||
                b === OSF.AgaveHostAction.ExitNoFocusableShift
            )
                d._ErrorUXHelper.focusOnNotificationUxShiftIn(e, b);
            else if (b === OSF.AgaveHostAction.UpdateTargetUrl) {
                var f = a[2];
                c.checkAppDomains(f) && c.updateAgaveEndPointTargetUrl(f);
            } else if (b === OSF.AgaveHostAction.SendTelemetryEvent) {
                var h = a[2];
                c._contextActivationMgr._notifyHost(e, b, h);
            } else if (c._contextActivationMgr._notifyHost)
                c._contextActivationMgr._notifyHost(e, b);
            else OsfMsAjaxFactory.msAjaxDebug.trace('No notifyHost provided by the host.');
        },
        z = function(a) {
            window.open(a.strUrl, a.strWindowName, a.strWindowFeatures);
        },
        j = function(a, e) {
            if (!a.hasOwnProperty('fromInsertDialog') || a.fromInsertDialog)
                d._insertDialogDiv != c &&
                    d._insertDialogDiv.childNodes.length == 2 &&
                    d._insertDialogDiv.removeChild(d._insertDialogDiv.lastChild);
            var p = OSF.OUtil.Guid.generateNewGuid(),
                h = new OfficeExt.InsertDialogTelemetryContext(p),
                f;
            if (a.storeType == OSF.StoreTypeEnum.MarketPlace)
                f = { storeType: OSF.StoreType.OMEX, storeLocator: d._osfOmexBaseUrl };
            else if (a.storeType == OSF.StoreTypeEnum.Catalog)
                f = { storeType: OSF.StoreType.SPCatalog, storeLocator: d._myOrgCatalogUrl };
            else if (a.storeType == OSF.StoreTypeEnum.OneDrive)
                f = {
                    storeType: OSF.StoreType.OneDrive,
                    storeLocator: d._oneDriveCatalogBaseApiUrl,
                };
            var g = b || a.refresh,
                i = {
                    assetId: '',
                    contentMarket: '',
                    anonymous: b,
                    clientEndPoint: c,
                    clearCache: g,
                    clearKilledApps: b,
                    referenceInUse: f,
                    hostType: d._hostType,
                };
            if (a && a.storeType == OSF.StoreTypeEnum.MarketPlace) {
                i.clientVersion = d._getClientVersionForOmex();
                if (i.clientVersion) {
                    i.clientName = d._getClientNameForOmex();
                    i.appVersion = d._getAppVersionForOmex();
                }
                var j = OfficeExt.CatalogFactory.resolve(OSF.StoreType.OMEX),
                    o = function(i) {
                        if (i.status == OfficeExt.DataServiceResultCode.Succeeded && i.value) {
                            var l = i.value,
                                f = l.length;
                            f === 0 && e({ errorCode: OSF.InvokeResultCode.S_OK });
                            for (var a, b = {}, n = [], k = 0; k < f; k++) {
                                a = l[k];
                                if (b[a.contentMarket]) b[a.contentMarket].push(a.assetId);
                                else b[a.contentMarket] = [a.assetId];
                            }
                            var m = 0,
                                p = function(g, i) {
                                    if (
                                        g.status == OfficeExt.DataServiceResultCode.Succeeded &&
                                        g.value &&
                                        g.value.length &&
                                        g.value.length > 0
                                    )
                                        for (
                                            var c = g.value, h = d.getRequirementsChecker(), b = 0;
                                            b < c.length;
                                            b++
                                        ) {
                                            if (h.isEntitlementFromOmexSupported(c[b])) {
                                                var a = [];
                                                a.push(c[b].name);
                                                a.push(c[b].assetId);
                                                a.push(c[b].description);
                                                a.push(OSF.OUtil.getTargetType(c[b].appSubType));
                                                a.push(OSF.OUtil.normalizeAppVersion(c[b].version));
                                                a.push(c[b].assetId);
                                                a.push(OSF.StoreType.OMEX);
                                                a.push(parseInt(c[b].defaultWidth));
                                                a.push(parseInt(c[b].defaultHeight));
                                                a.push(c[b].iconUrl);
                                                a.push(c[b].provider);
                                                a.push(i);
                                                a.push(OSF.StoreType.OMEX);
                                                n.push(a);
                                            }
                                            m++;
                                        }
                                    if (m === f) {
                                        var j = { value: n, errorCode: OSF.InvokeResultCode.S_OK };
                                        e(j);
                                    }
                                },
                                q = function(b, a) {
                                    j.getAppDetails(
                                        b,
                                        a,
                                        h,
                                        function(b) {
                                            Function.createDelegate(d, p)(b, a);
                                        },
                                        g
                                    );
                                };
                            for (var o in b) q(b[o], o);
                        } else {
                            var r = {
                                value: c,
                                errorCode: OSF.InvokeResultCode.E_USER_NOT_SIGNED_IN,
                            };
                            e(r);
                        }
                    };
                j.getEntitlementAsync(b, h, Function.createDelegate(d, o), g);
            } else if (a && a.storeType == OSF.StoreTypeEnum.Catalog) {
                var k = OfficeExt.CatalogFactory.resolve(OSF.StoreType.SPCatalog);
                k.myOrgCatalogUrl = d._myOrgCatalogUrl;
                var n = function(h) {
                    OSF.OUtil.writeProfilerMark(
                        OSF.OsfOfficeExtensionManagerPerfMarker.GetEntitlementEnd
                    );
                    var g;
                    if (h.status == OfficeExt.DataServiceResultCode.Succeeded && h.value) {
                        for (
                            var k = h.value,
                                n = k.length,
                                b,
                                l = [],
                                j = 0,
                                m = d.getRequirementsChecker(),
                                i = 0;
                            i < n;
                            i++
                        ) {
                            b = k[i];
                            if (m.isEntitlementFromCorpCatalogSupported(b)) {
                                var a = [];
                                a.push(b.Title);
                                a.push(b.OfficeExtensionID);
                                a.push(b.OfficeExtensionDescription);
                                a.push(OSF.OfficeAppType[b.OEType]);
                                a.push(OSF.OUtil.normalizeAppVersion(b.OfficeExtensionVersion));
                                a.push(b.OfficeExtensionID);
                                a.push(OSF.StoreType.SPCatalog);
                                a.push(parseInt(b.OfficeExtensionDefaultWidth.toString()));
                                a.push(parseInt(b.OfficeExtensionDefaultHeight.toString()));
                                a.push(b.OfficeExtensionIcon);
                                a.push(b.OEProviderName);
                                a.push(f.storeLocator);
                                a.push(OSF.StoreType.SPCatalog);
                                l.push(a);
                                j++;
                            }
                        }
                        if (j > 0) g = { value: l, errorCode: OSF.InvokeResultCode.S_OK };
                        else g = { value: c, errorCode: OSF.InvokeResultCode.E_CATALOG_NO_APPS };
                    } else if (!f.storeLocator)
                        g = { value: c, errorCode: OSF.InvokeResultCode.E_CATALOG_NO_APPS };
                    else g = { value: c, errorCode: OSF.InvokeResultCode.E_GENERIC_ERROR };
                    e(g);
                };
                k.getEntitlementAsync(b, h, Function.createDelegate(d, n), g);
            } else if (a && a.storeType == OSF.StoreTypeEnum.OneDrive) {
                var m = function(a) {
                    var b;
                    if (a.statusCode === OSF.ProxyCallStatusCode.Succeeded && a.value) {
                        var c = a.value.entitlements;
                        b = { value: c, errorCode: OSF.InvokeResultCode.S_OK };
                        e(b);
                    }
                };
                OSF.OsfManifestManager.getOneDriveEntitlementsAsync(i, m);
            } else if (a && a.storeType == OSF.StoreTypeEnum.PrivateCatalog) {
                var l = function(a) {
                        if (a.status == OfficeExt.DataServiceResultCode.Unauthenticated) {
                            e({ value: c, errorCode: OSF.InvokeResultCode.E_USER_NOT_SIGNED_IN });
                            return;
                        }
                        if (a.status !== OfficeExt.DataServiceResultCode.Succeeded || !a.value) {
                            e({
                                value: c,
                                errorCode: OSF.InvokeResultCode.E_CATALOG_REQUEST_FAILED,
                            });
                            return;
                        }
                        var f = a.value,
                            l = f.length;
                        if (l === 0) {
                            e({ errorCode: OSF.InvokeResultCode.E_CATALOG_NO_APPS });
                            return;
                        }
                        var b = [];
                        b = f.map(function(a) {
                            return {
                                ProductId: a.assetId,
                                AddInState: a.addInState,
                                Version: a.appVersion,
                            };
                        });
                        var i = [],
                            k = function(g) {
                                if (
                                    g.status !== OfficeExt.DataServiceResultCode.Succeeded ||
                                    !g.value ||
                                    !g.value.length ||
                                    g.value.length === 0
                                ) {
                                    e({
                                        value: c,
                                        errorCode: OSF.InvokeResultCode.E_CATALOG_REQUEST_FAILED,
                                    });
                                    return;
                                }
                                for (
                                    var f = g.value, h = d.getRequirementsChecker(), b = 0;
                                    b < f.length;
                                    b++
                                ) {
                                    if (!h.isEntitlementFromOmexSupported(f[b])) continue;
                                    var a = [];
                                    a.push(f[b].name);
                                    a.push(f[b].assetId);
                                    a.push(f[b].description);
                                    a.push(OSF.OUtil.getTargetType(f[b].appSubType));
                                    a.push(OSF.OUtil.normalizeAppVersion(f[b].version));
                                    a.push(f[b].assetId);
                                    a.push(OSF.StoreType.PrivateCatalog);
                                    a.push(parseInt(f[b].defaultWidth));
                                    a.push(parseInt(f[b].defaultHeight));
                                    a.push(f[b].iconUrl);
                                    a.push(f[b].provider);
                                    a.push(OSF.StoreType.PrivateCatalog);
                                    a.push(OSF.StoreType.PrivateCatalog);
                                    i.push(a);
                                }
                                e({ value: i, errorCode: OSF.InvokeResultCode.S_OK });
                            };
                        j.getAppDetails(b, '', h, Function.createDelegate(d, k), g);
                    },
                    j = OfficeExt.CatalogFactory.resolve(OSF.StoreType.PrivateCatalog);
                j.getEntitlementAsync(b, h, Function.createDelegate(d, l), g);
            } else OsfMsAjaxFactory.msAjaxDebug.trace('Unknown store type.');
        },
        B = function(a) {
            if (a && a.storeType != OSF.StoreTypeEnum.PrivateCatalog) {
                var e = window.location.href,
                    b = d._osfOmexBaseUrl + OSF.Constants.SignInRedirectUrl + encodeURIComponent(e);
                window.location.assign(b);
            } else
                OfficeExt.PrivateCatalogService.authenticationProxy.getSignInUrl(
                    function(a) {
                        window.top.location.replace(a);
                    },
                    function() {
                        d._notifyHost(g, OSF.AgaveHostAction.NotifyHostError, c);
                    }
                );
        },
        A = function(a) {
            a &&
                a.storeType == OSF.StoreTypeEnum.PrivateCatalog &&
                OfficeExt.PrivateCatalogService.SignOutUser();
            k(a, c);
        },
        x = function(a) {
            window.open(a.pageUrl);
        },
        s = function(a) {
            OsfMsAjaxFactory.msAjaxDebug.trace('onClickInsertOsfControl!');
            d._notifyHost(g, OSF.AgaveHostAction.InsertAgave, a);
        };
    a._onClickInstallOsfControl = function(i) {
        if (!d._enableUploadFileDevCatalog) return;
        OsfMsAjaxFactory.msAjaxDebug.trace('onClickInstallOsfControl!');
        try {
            OSF.OUtil.validateParamObject(i, { manifest: { type: String, mayBeNull: b } }, c);
            var f = new OSF.Manifest.Manifest(i.manifest, d.getAppUILocale()),
                h = f.getMarketplaceID(),
                k = f.getMarketplaceVersion(),
                m = OfficeExt.CatalogFactory.resolve(OSF.StoreType.UploadFileDevCatalog);
            if (m.validateAndCacheNewManifest(h, k, i.manifest, f)) {
                var a = {
                    id: h,
                    targetType: f.getTarget(),
                    appVersion: k,
                    currentStoreType: OSF.StoreType.UploadFileDevCatalog,
                    storeId: 'developer',
                    assetId: h,
                    assetStoreId: OSF.StoreType.UploadFileDevCatalog,
                    width: parseInt(f.getDefaultWidth() || g),
                    height: parseInt(f.getDefaultHeight() || g),
                    isAddinCommands: f._isAddinCommandsManifest(
                        OSF.getManifestHostType(d._hostType)
                    ),
                };
                OSF.OUtil.validateParamObject(
                    a,
                    {
                        id: { type: String, mayBeNull: b },
                        targetType: { type: Number, mayBeNull: b },
                        appVersion: { type: String, mayBeNull: b },
                        width: { type: Number, mayBeNull: e },
                        height: { type: Number, mayBeNull: e },
                    },
                    c
                );
                Telemetry.UploadFileDevCatalogUsageHelper.LogUploadFileDevCatalogUsageAction(
                    this._appCorrelationId,
                    a.currentStoreType,
                    a.assetId,
                    a.appVersion,
                    a.targetType,
                    a.isAddinCommands,
                    a.width,
                    a.height
                );
                d._notifyHost(g, OSF.AgaveHostAction.InsertAgave, a);
            } else d._notifyHost(g, OSF.AgaveHostAction.NotifyHostError, c);
        } catch (j) {
            var l = 'Invalid manifest from addincommands dev catalog.';
            OfficeExt.WACUtils.logExceptionToBrowserConsole(l, j);
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                l,
                j,
                this._appCorrelationId,
                19203548
            );
            d._notifyHost(g, OSF.AgaveHostAction.NotifyHostError, c);
            return;
        }
    };
    var k = function(a) {
            OsfMsAjaxFactory.msAjaxDebug.trace('onClickRefreshfAddinCommands!');
            d._notifyHost(g, OSF.AgaveHostAction.RefreshAddinCommands, a);
        },
        u = function() {
            OsfMsAjaxFactory.msAjaxDebug.trace('onClickCancelDialog!');
            d._notifyHost(g, OSF.AgaveHostAction.CancelDialog);
            if (d._internalConversationId) {
                d._serviceEndPointInternal.unregisterConversation(d._internalConversationId);
                d._internalConversationId = c;
            }
        },
        p = function(a) {
            var e = OSF.OUtil.Guid.generateNewGuid(),
                b = new OfficeExt.InsertDialogTelemetryContext(e),
                g = OfficeExt.CatalogFactory.resolve(OSF.StoreType.OMEX),
                h = new OfficeExt.PreCacher(d.getRequirementsChecker()),
                f = {
                    assetId: a.assetId,
                    storeType: OSF.StoreType.OMEX,
                    storeId: a.storeId,
                    appVersion: '',
                    targetType: c,
                };
            g.activateAsync(f, h, b);
        },
        l = function(e, f) {
            if (d._enableSingleSignOnForAddin) q(e, f);
            else {
                var c = {
                        assetId: e.id,
                        clientVersion: d._getClientVersionForOmex(),
                        clientName: d._getClientNameForOmex(),
                        clientEndPoint: d._omexGatedWSProxy.clientEndPoint,
                    },
                    g = d._insertDialogDiv,
                    a = { errorCode: OSF.InvokeResultCode.E_OEM_REMOVED_FAILED },
                    i = OSF.OUtil.Guid.generateNewGuid(),
                    h = new OfficeExt.InsertDialogTelemetryContext(i),
                    j = OfficeExt.CatalogFactory.resolve(OSF.StoreType.OMEX);
                j.removeAsync([c.assetId], h, function(h) {
                    var l = 0;
                    if (
                        h.status == OfficeExt.DataServiceResultCode.Succeeded &&
                        h.value &&
                        h.value.removedApps &&
                        h.value.removedApps.length > 0
                    ) {
                        for (
                            var k = h.value.removedApps,
                                j = OSF.InvokeResultCode.E_OEM_REMOVED_FAILED,
                                i = 0;
                            i < k.length;
                            i++
                        )
                            if (k[i].assetId == c.assetId) {
                                if (k[i].result == OSF.OmexRemoveAppStatus.Success)
                                    j = OSF.InvokeResultCode.S_OK;
                                break;
                            }
                        if (j == OSF.InvokeResultCode.S_OK) l = d.untrustOsfControls(e);
                        a.errorCode = j;
                    }
                    var m = !document.documentElement.contains(g);
                    Telemetry.AppManagementMenuHelper.LogAppManagementMenuAction(
                        c.assetId,
                        OSF.AppManagementAction.Remove,
                        l,
                        m,
                        b,
                        a.errorCode
                    );
                    f(a);
                });
            }
        },
        q = function(c, i) {
            var f =
                    d._hideAppsExtensionUrl +
                    '&' +
                    OSF.OmexPageParameterKeys.AppName +
                    '=' +
                    OSF.getModernAppVerCode(d._appName) +
                    '&' +
                    OSF.OmexPageParameterKeys.AssetId +
                    '=' +
                    c.id +
                    '&' +
                    OSF.OmexPageParameterKeys.AppCorrelationId +
                    '=' +
                    d._contextMgrCorrelationId,
                a = document.createElement('iframe');
            a.setAttribute('id', 'serviceExtensionIframe');
            a.setAttribute('src', f);
            a.setAttribute('scrolling', 'auto');
            a.setAttribute('border', g);
            a.setAttribute('width', g);
            a.setAttribute('height', g);
            a.setAttribute('style', 'position: absolute; left: -100px; top:0px;');
            document.body.appendChild(a);
            var h = d._insertDialogDiv,
                e = function(n) {
                    if (n.source == a.contentWindow) {
                        var g = { errorCode: OSF.InvokeResultCode.E_OEM_REMOVED_FAILED };
                        document.body.removeChild(a);
                        window.removeEventListener('message', e);
                        var k = 0,
                            m = JSON.parse(n.data),
                            p = parseInt(m[OSF.OmexRemoveAddinMessageKeys.RemoveAddinResultCode]),
                            f = OSF.InvokeResultCode.E_OEM_REMOVED_FAILED;
                        if (p === OSF.OmexRemoveAddinResultCode.Success) {
                            for (
                                var l = m[OSF.OmexRemoveAddinMessageKeys.RemoveAddinResultValue],
                                    j = 0;
                                j < l.length;
                                j++
                            )
                                if (l[j] == c.id) {
                                    f = OSF.InvokeResultCode.S_OK;
                                    break;
                                }
                            if (f == OSF.InvokeResultCode.S_OK) {
                                k = d.untrustOsfControls(c);
                                t(c.id);
                            }
                            g.errorCode = f;
                        }
                        var o = !document.documentElement.contains(h);
                        Telemetry.AppManagementMenuHelper.LogAppManagementMenuAction(
                            c.id,
                            OSF.AppManagementAction.Remove,
                            k,
                            o,
                            b,
                            g.errorCode
                        );
                        i(g);
                    }
                };
            window.addEventListener('message', e);
        },
        t = function(c) {
            var a = '.*',
                b = [];
            b.push(
                new RegExp(
                    OSF.OUtil.formatString(OfficeExt.WACUtils.CacheConstants.EntitlementsKey, a, a),
                    'i'
                )
            );
            b.push(
                new RegExp(
                    OSF.OUtil.formatString(
                        OfficeExt.WACUtils.CacheConstants.AuthenticatedAppInstallInfoCacheKey,
                        a,
                        c,
                        a,
                        a
                    ),
                    'i'
                )
            );
            OfficeExt.WACUtils.removeMatchesFromLocalStorage(b);
        },
        r = function(a) {
            switch (a.datapointName) {
                case OSF.DataPointNames.AppManagementMenu:
                    OSF.OUtil.validateParamObject(
                        a,
                        {
                            assetId: { type: String, mayBeNull: b },
                            operationMetadata: { type: Number, mayBeNull: b },
                            hrStatus: { type: Number, mayBeNull: b },
                        },
                        c
                    );
                    Telemetry.AppManagementMenuHelper.LogAppManagementMenuAction(
                        a.assetId,
                        a.operationMetadata,
                        0,
                        b,
                        b,
                        a.hrStatus
                    );
                    break;
                case OSF.DataPointNames.InsertionDialogSession:
                    OSF.OUtil.validateParamObject(
                        a,
                        {
                            assetId: { type: String, mayBeNull: b },
                            totalSessionTime: { type: Number, mayBeNull: b },
                            trustPageSessionTime: { type: Number, mayBeNull: b },
                            appInserted: { type: Boolean, mayBeNull: b },
                            lastActiveTab: { type: Number, mayBeNull: b },
                            lastActiveTabCount: { type: Number, mayBeNull: b },
                        },
                        c
                    );
                    Telemetry.InsertionDialogSessionHelper.LogInsertionDialogSession(
                        a.assetId,
                        a.totalSessionTime,
                        a.trustPageSessionTime,
                        a.appInserted,
                        a.lastActiveTab,
                        a.lastActiveTabCount
                    );
                    break;
                case OSF.DataPointNames.UploadFileDevCatelog:
                    OSF.OUtil.validateParamObject(
                        a,
                        {
                            operationMetadata: { type: Number, mayBeNull: b },
                            hrStatus: { type: Number, mayBeNull: b },
                        },
                        c
                    );
                    Telemetry.UploadFileDevCatelogHelper.LogUploadFileDevCatelogAction(
                        this._appCorrelationId,
                        a.operationMetadata,
                        0,
                        b,
                        b,
                        a.hrStatus
                    );
                    break;
                case OSF.DataPointNames.UploadFileDevCatalogUsage:
                    OSF.OUtil.validateParamObject(
                        a,
                        {
                            currentStoreType: { type: String, mayBeNull: b },
                            id: { type: String, mayBeNull: e },
                            appVersion: { type: String, mayBeNull: e },
                            appTargetType: { type: Number, mayBeNull: b },
                            isAppCommand: { type: String, mayBeNull: b },
                            appSizeWidth: { type: Number, mayBeNull: e },
                            appSizeHeight: { type: Number, mayBeNull: e },
                        },
                        c
                    );
                    Telemetry.UploadFileDevCatalogUsageHelper.LogUploadFileDevCatalogUsageAction(
                        this._appCorrelationId,
                        a.currentStoreType,
                        a.Id,
                        a.appVersion,
                        a.appTargetType,
                        a.isAppCommand,
                        a.appSizeWidth,
                        a.appSizeHeight
                    );
            }
        };
    a._serviceEndPoint = Microsoft.Office.Common.XdmCommunicationManager.createServiceEndPoint(
        a._clientId
    );
    a._serviceEndPoint._onHandleRequestError = function(g, f) {
        var e, a;
        if (g && (e = g._data)) {
            a = typeof e === 'object' ? e[0] : e;
            a = typeof a === 'string' ? a : c;
            var b;
            if (a && (b = d.getOsfControl(a))) {
                if (f === 'Failed origin check')
                    b._pageStatus = OSF.OsfControlPageStatus.FailedOriginCheck;
                else if (f === 'Access Denied')
                    b._pageStatus = OSF.OsfControlPageStatus.FailedPermissionCheck;
                else b._pageStatus = OSF.OsfControlPageStatus.FailedHandleRequest;
                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                    f,
                    c,
                    b.getCorrelationId(),
                    19203549
                );
            }
        }
    };
    a._serviceEndPoint.registerMethod(
        'ContextActivationManager_getAppContextAsync',
        v,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPoint.registerMethod(
        'ContextActivationManager_notifyHost',
        C,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPoint.registerMethod(
        'ContextActivationManager_openWindowInHost',
        z,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._enableServiceDeliveredExperience &&
        a._serviceEndPoint.registerMethod(
            'Office_sendMessageToHost',
            y,
            Microsoft.Office.Common.InvokeType.async,
            b
        );
    a._serviceEndPointInternal = Microsoft.Office.Common.XdmCommunicationManager.createServiceEndPoint(
        a._clientId + OSF.Constants.EndPointInternalSuffix
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_getEntitlementsForInsertDialog',
        j,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_invokeSignIn',
        B,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_invokeSignOut',
        A,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_invokeWindowOpen',
        x,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_onClickInsertOsfControl',
        s,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_onClickInstallOsfControl',
        a._onClickInstallOsfControl,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_onClickRefreshAddinCommands',
        k,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_onClickCancelDialog',
        u,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_removeAppForInsertDialog',
        l,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_logTelemetryDataForInsertDialog',
        r,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    a._serviceEndPointInternal.registerMethod(
        'ContextActivationManager_getOmexData',
        p,
        Microsoft.Office.Common.InvokeType.async,
        b
    );
    OSF.AppSpecificSetup._setupFacade(
        a._hostControl,
        a,
        a._serviceEndPoint,
        a._serviceEndPointInternal
    );
    f.hostType = a._hostType;
    f.spBaseUrl = a._spBaseUrl;
    OfficeExt.CatalogFactory.setHostContext(f);
    a._localeStringLoadingPendingCallbacks = [];
    if (a._localizedScriptsUrl && a._localizedScriptsUrl != 'null/') {
        var w = function() {
            this._ErrorUXHelper = new OSF._ErrorUXHelper(this);
        };
        a._loadLocaleString(Function.createDelegate(a, w));
    }
    a.queryEntitlementDetails = function(a) {
        j(a, a.callbackFunc);
    };
    a._getOmexData = function(a) {
        p(a);
    };
    a._removeAppForInsertDialog = function(a) {
        l(a, a.callbackFunc);
    };
};
OSF.ContextActivationManager.prototype = {
    insertOsfControl: function(a) {
        var b = true,
            d = false,
            e = this;
        OSF.OUtil.validateParamObject(
            a,
            {
                div: { type: Object, mayBeNull: d },
                id: { type: String, mayBeNull: d },
                marketplaceID: { type: String, mayBeNull: d },
                marketplaceVersion: { type: String, mayBeNull: d },
                store: { type: String, mayBeNull: d },
                storeType: { type: String, mayBeNull: d },
                alternateReference: { type: Object, mayBeNull: b },
                settings: { type: Object, mayBeNull: b },
                reason: { type: String, mayBeNull: b },
                osfControlType: { type: Number, mayBeNull: b },
                snapshotUrl: { type: String, mayBeNull: b },
                preactivationCallback: { type: Object, mayBeNull: b },
                virtualOsfControlActivationCallback: { type: Object, mayBeNull: b },
                isvirtualOsfControl: { type: Boolean, mayBeNull: b },
                isDialog: { type: Boolean, mayBeNull: b },
                hostCustomMessage: { type: String, mayBeNull: b },
                isForUILessAction: { type: Boolean, mayBeNull: b },
                ownerAddinAssetId: { type: String, mayBeNull: b },
                ownerAddinStoreType: { type: String, mayBeNull: b },
            },
            null
        );
        if (
            e._disableAppsForOfficeThirdParty &&
            a.storeType.toLowerCase() !== OSF.StoreType.FirstParty.toLowerCase()
        )
            return;
        var f = {
                div: a.div,
                id: a.id,
                marketplaceID: a.marketplaceID,
                marketplaceVersion: a.marketplaceVersion,
                store: a.store,
                storeType: a.storeType,
                alternateReference: a.alternateReference,
                settings: a.settings,
                reason: a.reason,
                osfControlType: a.osfControlType,
                snapshotUrl: a.snapshotUrl,
                contextActivationMgr: e,
                preactivationCallback: a.preactivationCallback,
                virtualOsfControlActivationCallback: a.virtualOsfControlActivationCallback,
                isvirtualOsfControl: a.isvirtualOsfControl,
                isDialog: a.isDialog,
                hostCustomMessage: a.hostCustomMessage,
                isForUILessAction: a.isForUILessAction,
                ownerAddinAssetId: a.ownerAddinAssetId,
                sourceLocationOverrideResourceId: a.sourceLocationOverrideResourceId,
                ownerAddinStoreType: a.ownerAddinStoreType,
            },
            g = e.getSQMAgaveUsage(f.storeType, f.osfControlType, f.reason, a.marketplaceID),
            c = new OSF.OsfControl(f);
        c._sqmDWords[0] = g[0];
        c._sqmDWords[1] = g[1];
        c._contextActivationMgr._ErrorUXHelper &&
            c._contextActivationMgr._ErrorUXHelper.showProgress(c._div, c._id);
        var h = function() {
            c.activate();
        };
        e._loadLocaleString(Function.createDelegate(e, h));
        return c;
    },
    insertDialogControl: function(a) {
        var b = false;
        OSF.OUtil.validateParamObject(
            a,
            {
                div: { type: Object, mayBeNull: b },
                id: { type: String, mayBeNull: b },
                dialogUrl: { type: String, mayBeNull: b },
                marketplaceID: { type: String, mayBeNull: b },
                marketplaceVersion: { type: String, mayBeNull: b },
                appDomains: { type: Array, mayBeNull: b },
                store: { type: String, mayBeNull: b },
                storeType: { type: String, mayBeNull: b },
                agaveName: { type: String, mayBeNull: true },
            },
            null
        );
        var c = {
                div: a.div,
                id: a.id,
                marketplaceID: a.marketplaceID,
                marketplaceVersion: a.marketplaceVersion,
                store: a.store,
                storeType: a.storeType,
                isDialog: true,
                contextActivationMgr: this,
            },
            d = new OSF.OsfControl(c);
        d.createIframeForDialogControl(a.agaveName, a.dialogUrl, a.appDomains);
    },
    insertBlankControlWithErrorUX: function(a, h) {
        var b = false,
            d = this;
        OSF.OUtil.validateParamObject(
            a,
            {
                div: { type: Object, mayBeNull: b },
                id: { type: String, mayBeNull: b },
                marketplaceID: { type: String, mayBeNull: b },
                marketplaceVersion: { type: String, mayBeNull: b },
                store: { type: String, mayBeNull: b },
                osfControlType: { type: Number, mayBeNull: true },
                storeType: { type: String, mayBeNull: b },
            },
            null
        );
        var g = {
                div: a.div,
                id: a.id,
                marketplaceID: a.marketplaceID,
                marketplaceVersion: a.marketplaceVersion,
                store: a.store,
                storeType: a.storeType,
                osfControlType: a.osfControlType,
                contextActivationMgr: d,
                isvirtualOsfControl: b,
            },
            c = new OSF.OsfControl(g);
        c._contextActivationMgr.registerOsfControl(c);
        var f = function(c, h) {
                var a,
                    d = '',
                    e = '',
                    g = '',
                    f = b;
                if (c.status === OfficeExt.DataServiceResultCode.Succeeded && c.value) {
                    a = c.value;
                    d = a.getDefaultDisplayName();
                    e = a.getProviderName();
                    g = a.getDefaultIconUrl();
                    f = a.isSSOAddin();
                }
                h(d, e, g, f);
            },
            k = OfficeExt.OmexUtils.getOmexEndPointPageUrl(
                d.getOsfOmexBaseUrl(),
                a.marketplaceID,
                a.store
            ),
            e = OfficeExt.CatalogFactory.resolve(a.storeType.toLowerCase());
        if (e != null) {
            var i = {
                    assetId: a.marketplaceID,
                    appVersion: a.marketplaceVersion,
                    storeType: a.storeType,
                    storeId: a.store,
                    targetType: null,
                },
                j = OSF.OmexClientNames[d._appName];
            e.getAndCacheManifest(
                i,
                d._storeLocator,
                new OfficeExt.AddinCommandsTelemetryContext(c.getCorrelationId()),
                function(b) {
                    f(b, function(d, b, f, e) {
                        c._showTrustError(j, d, b, f, a.storeType, h, k, e);
                    });
                }
            );
        }
    },
    purgeDialogControl: function(c) {
        var b = Function._validateParams(arguments, [
            { name: 'id', type: String, mayBeNull: false },
        ]);
        if (b) throw b;
        var a = this._cachedOsfControls[c];
        if (typeof a != 'undefined') {
            a._conversationId &&
                this._getServiceEndPoint().unregisterConversation(a._conversationId);
            this.unregisterOsfControl(a);
        }
    },
    dispose: function() {
        var a = this;
        if (a._serviceEndPoint) {
            a._serviceEndPoint.dispose();
            Microsoft.Office.Common.XdmCommunicationManager.deleteServiceEndPoint(a._clientId);
            a._serviceEndPoint = null;
        }
        if (a._serviceEndPointInternal) {
            a._serviceEndPointInternal.dispose();
            Microsoft.Office.Common.XdmCommunicationManager.deleteServiceEndPoint(
                a._clientId + OSF.Constants.EndPointInternalSuffix
            );
            a._serviceEndPointInternal = null;
        }
    },
    setLocalizedUrl: function(d, e, f) {
        var a = this,
            b = Function._validateParams(arguments, [
                { name: 'scriptUrl', type: String, mayBeNull: false },
                { name: 'imageUrl', type: String, mayBeNull: false },
                { name: 'styleUrl', type: String, mayBeNull: false },
            ]);
        if (b) throw b;
        a._localizedScriptsUrl = d;
        a._localizedImagesUrl = e;
        a._localizedStylesUrl = f;
        if (a._localizedScriptsUrl && a._localizedScriptsUrl != 'null/') {
            var c = function() {
                if (!this._ErrorUXHelper) this._ErrorUXHelper = new OSF._ErrorUXHelper(this);
            };
            a._loadLocaleString(Function.createDelegate(a, c));
        }
    },
    getOsfControlStatus: function(b) {
        var a = this._cachedOsfControls[b];
        if (a) return a.getStatus();
        return OSF.OsfControlStatus.InvalidOsfControl;
    },
    activateOsfControl: function(c) {
        var b = Function._validateParams(arguments, [
            { name: 'id', type: String, mayBeNull: false },
        ]);
        if (b) throw b;
        var a = this._cachedOsfControls[c];
        typeof a != 'undefined' && a.activate();
    },
    deActivateOsfControl: function(c) {
        var b = Function._validateParams(arguments, [
            { name: 'id', type: String, mayBeNull: false },
        ]);
        if (b) throw b;
        var a = this._cachedOsfControls[c];
        typeof a != 'undefined' && a.deActivate();
    },
    purgeOsfControl: function(d, c) {
        var b = Function._validateParams(arguments, [
            { name: 'id', type: String, mayBeNull: false },
            { name: 'purgeManifest', type: Boolean, mayBeNull: false },
        ]);
        if (b) throw b;
        var a = this._cachedOsfControls[d];
        typeof a != 'undefined' && a.purge(c);
    },
    purgeOsfControlNotifications: function() {
        for (var a in this._cachedOsfControls) this._ErrorUXHelper.purgeOsfControlNotification(a);
    },
    untrustOsfControls: function(a) {
        var c = this,
            d = 0,
            e = function(a) {
                return function() {
                    a.activate({ hasConsent: true });
                };
            },
            g = OSF.OUtil.formatString(
                OSF.Constants.ActivatedCacheKey,
                a.id.toLowerCase(),
                a.currentStoreType,
                a.storeId
            );
        c._deleteCachedFlag(g);
        for (var i in c._cachedOsfControls) {
            var b = c._cachedOsfControls[i];
            if (b._marketplaceID.toLowerCase() == a.id.toLowerCase()) {
                c._ErrorUXHelper.purgeOsfControlNotification(b._id);
                b.deActivate();
                var h = OfficeExt.OmexUtils.getOmexEndPointPageUrl(
                        c.getOsfOmexBaseUrl(),
                        b._marketplaceID,
                        a.storeId
                    ),
                    f = OSF.OmexClientNames[c._appName];
                b._showTrustError(
                    f,
                    a.displayName,
                    a.providerName,
                    a.iconUrl,
                    a.currentStoreType,
                    e(b),
                    h
                );
                d++;
            }
        }
        return d;
    },
    retryAll: function(d) {
        var b = this;
        for (var c in b._cachedOsfControls) {
            var a = b._cachedOsfControls[c];
            if (a._marketplaceID.toLowerCase() == d.toLowerCase())
                if (a._retryActivate) {
                    b._ErrorUXHelper.purgeOsfControlNotification(a._id);
                    b._ErrorUXHelper.removeInfoBarDiv(c, false);
                    a._retryActivate();
                    a._retryActivate = null;
                }
        }
    },
    getOsfControl: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'id', type: String, mayBeNull: false },
        ]);
        if (a) throw a;
        return this._cachedOsfControls[b];
    },
    getOsfControls: function() {
        var a = [];
        for (var b in this._cachedOsfControls) a.push(this._cachedOsfControls[b]);
        return a;
    },
    getOsfOmexBaseUrl: function() {
        return this._osfOmexBaseUrl;
    },
    getAppName: function() {
        return this._appName;
    },
    getClientMode: function() {
        return this._clientMode;
    },
    getClientId: function() {
        return this._clientId;
    },
    getFormFactor: function() {
        return this._formFactor;
    },
    getDocUrl: function() {
        return this._docUrl;
    },
    getAppUILocale: function() {
        return this._appUILocale;
    },
    getDataLocale: function() {
        return this._dataLocale;
    },
    getPageBaseUrl: function() {
        return this._pageBaseUrl;
    },
    getLcid: function() {
        return this._lcid;
    },
    isExternalMarketplaceAllowed: function() {
        return this._allowExternalMarketplace;
    },
    isStoreDisabled: function(a) {
        var b = function() {
            var b = OfficeExt.CatalogFactory.resolve(OSF.StoreType.OMEX),
                d = OSF.OUtil.Guid.generateNewGuid(),
                c = new OfficeExt.InsertDialogTelemetryContext(d);
            if (b instanceof OfficeExt.OmexCatalog) b.isStoreDisabled(c, a);
            else {
                var e = { value: false, status: 200 };
                a(e);
            }
        };
        this._loadLocaleString(Function.createDelegate(this, b));
    },
    getLocalizedScriptsUrl: function() {
        return this._localizedScriptsUrl ? this._localizedScriptsUrl : '';
    },
    getLocalizedImagesUrl: function() {
        return this._localizedImagesUrl ? this._localizedImagesUrl : '';
    },
    getLocalizedStylesUrl: function() {
        return this._localizedStylesUrl ? this._localizedStylesUrl : '';
    },
    raiseOsfControlStatusChange: function(a) {
        this._controlStatusChanged && this._controlStatusChanged(a);
    },
    registerOsfControl: function(a) {
        var b = Function._validateParams(arguments, [
            { name: 'osfControl', type: Object, mayBeNull: false },
        ]);
        if (b) throw b;
        this._cachedOsfControls[a.getID()] = a;
    },
    unregisterOsfControl: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'osfControl', type: Object, mayBeNull: false },
        ]);
        if (a) throw a;
        delete this._cachedOsfControls[b.getID()];
    },
    setIframeAttributeBag: function(a) {
        this._iframeAttributeBag = a;
    },
    getOmexIframeNotificationUrl: function(m, k, j) {
        var b = '&',
            a = '=',
            d = this,
            g = Function._validateParams(arguments, [
                { name: 'id', type: String, mayBeNull: false },
                { name: 'notificationType', type: Number, mayBeNull: false },
                { name: 'isForSideloadAddin', type: Boolean, mayBeNull: false },
            ]);
        if (g) throw g;
        var c = d.getOsfControl(m);
        if (c) {
            var e =
                d._osfOmexBaseUrl +
                OSF.Constants.OmexConsentNotificationPage +
                '?' +
                OSF.OmexPageParameterKeys.AppName +
                a +
                OSF.getModernAppVerCode(d._appName) +
                b +
                OSF.OmexPageParameterKeys.AppVersion +
                a +
                (d._hostFullVersion || OSF.Constants.FileVersion) +
                b +
                OSF.OmexPageParameterKeys.AppUILocale +
                a +
                d._appUILocale +
                b +
                OSF.OmexPageParameterKeys.AppDomain +
                a +
                window.location.origin +
                b +
                OSF.OmexPageParameterKeys.StoreLocator +
                a +
                c.getStoreLocator() +
                b +
                OSF.OmexPageParameterKeys.NotificationType +
                a +
                k +
                b +
                OSF.OmexPageParameterKeys.AppCorrelationId +
                a +
                c.getCorrelationId() +
                b +
                OSF.OmexPageParameterKeys.AuthType +
                a +
                d._getAuthTypeForHideAppsExtensionUrl();
            if (j) {
                var l = c.getManifest().getWebApplicationId(),
                    i = c.getManifest().getWebApplicationScopes();
                e =
                    e +
                    b +
                    OSF.OmexPageParameterKeys.AppId +
                    a +
                    l +
                    b +
                    OSF.OmexPageParameterKeys.Scopes +
                    a +
                    encodeURIComponent(i.join(','));
            } else {
                var f = c.getOwnerAddinAssetId(),
                    h = f ? f : c.getMarketplaceID();
                e = e + b + OSF.OmexPageParameterKeys.AssetId + a + h;
            }
            return e;
        } else return null;
    },
    displayNotification: function(a) {
        var g = null,
            b = true,
            d = false,
            f = this;
        OSF.OUtil.validateParamObject(
            a,
            {
                infoType: { type: Number, mayBeNull: d },
                id: { type: String, mayBeNull: d },
                title: { type: String, mayBeNull: d },
                description: { type: String, mayBeNull: d },
                url: { type: String, mayBeNull: b },
                icon: { type: String, mayBeNull: b },
                buttonTxt: { type: String, mayBeNull: b },
                buttonCallback: { type: Function, mayBeNull: b },
                dismissCallback: { type: Function, mayBeNull: b },
                'displayDeactive ': { type: Boolean, mayBeNull: b },
                highPriority: { type: Boolean, mayBeNull: b },
                detailView: { type: Boolean, mayBeNull: b },
                reDisplay: { type: Boolean, mayBeNull: b },
                logAsError: { type: Boolean, mayBeNull: b },
                errorCode: { type: Number, mayBeNull: b },
                retryAll: { type: Boolean, mayBeNull: b },
                iframeNotificationUrl: { type: String, mayBeNull: b },
                notificationType: { type: Number, mayBeNull: b },
            },
            g
        );
        if (!a.errorCode) a.errorCode = 0;
        var c = f._cachedOsfControls[a.id];
        if (c)
            if (c._isvirtualOsfControl) {
                if (
                    a.errorCode == OSF.ErrorStatusCodes.E_OEM_OMEX_EXTENSION_KILLED ||
                    a.errorCode == OSF.ErrorStatusCodes.E_OEM_EXTENSION_KILLED
                ) {
                    f.purgeOsfControl(a.id, b);
                    return;
                }
                if (a.highPriority == undefined)
                    a.highPriority = a.infoType === OSF.InfoType.Error ? b : d;
                if (a.highPriority === d) c._notificationParams.push(a);
                else {
                    for (var e = c._notificationParams, h = 0; h < e.length; h++)
                        if (!e[h].highPriority) {
                            e.splice(h, 0, a);
                            e = g;
                            break;
                        }
                    e != g && e.push(a);
                }
                !c._isvirtualOsfControlCallbackInvoked &&
                    c.ensureToGetVirtualOsfControlManifest(function(a) {
                        c.invokeVirtualOsfControlActivationCallback(a);
                    });
                !c._isManifestProcessedForCustomFunctions &&
                    c.ensureToGetVirtualOsfControlManifest(function(a) {
                        c.processManifestForCustomFunctions(a);
                    });
            } else {
                if (a.logAsError) {
                    Telemetry.AppLoadTimeHelper.SetErrorResult(c._telemetryContext, a.errorCode);
                    if (f._notifyHostError) {
                        var i = { errorCode: a.errorCode };
                        f._notifyHostError(a.id, OSF.AgaveHostAction.NotifyHostError, i);
                    }
                }
                if (a.displayDeactive || a.iframeNotificationUrl != g) a.detailView = b;
                a['div'] = c._div;
                f._ErrorUXHelper.showNotification(a);
            }
    },
    dismissMessages: function(a) {
        this._ErrorUXHelper && this._ErrorUXHelper.dismissMessages(a);
    },
    notifyAgave: function(c, a) {
        var d = Function._validateParams(arguments, [
            { name: 'id', type: String, mayBeNull: false },
            { name: 'actionId', type: Number, mayBeNull: false },
        ]);
        if (d) throw d;
        var b = this._cachedOsfControls[c];
        if (typeof b != 'undefined')
            if (
                a === OSF.AgaveHostAction.CtrlF6In ||
                a === OSF.AgaveHostAction.TabIn ||
                a === OSF.AgaveHostAction.Select
            )
                this._ErrorUXHelper.focusOnNotificationUx(c, a);
            else if (
                a === OSF.AgaveHostAction.TabInShift &&
                b._pageStatus !== OSF.OsfControlPageStatus.Ready
            )
                this._ErrorUXHelper.focusOnNotificationUxShiftIn(c, a);
            else b.notifyAgave(a);
    },
    setWSA: function(b) {
        var a = this;
        a._wsa = b;
        if (a._wsa) {
            a._wsa.createStreamUnobfuscated(
                OSF.SQMDataPoints.DATAID_APPSFOROFFICEUSAGE,
                OSF.BWsaStreamTypes.Static,
                2,
                OSF.BWsaConfig.defaultMaxStreamRows
            );
            a._wsa.createStreamUnobfuscated(
                OSF.SQMDataPoints.DATAID_APPSFOROFFICENOTIFICATIONS,
                OSF.BWsaStreamTypes.Static,
                4,
                OSF.BWsaConfig.defaultMaxStreamRows
            );
        }
    },
    getWSA: function() {
        return this._wsa;
    },
    getSQMAgaveUsage: function(h, i, f, b) {
        var a;
        switch (h.toLowerCase()) {
            case OSF.StoreType.OMEX:
                a = 0;
                break;
            case OSF.StoreType.SPCatalog:
                a = 1;
                break;
            case OSF.StoreType.FileSystem:
                a = 2;
                break;
            case OSF.StoreType.Registry:
                a = 3;
                break;
            case OSF.StoreType.Exchange:
                a = 4;
                break;
            case OSF.StoreType.SPApp:
                a = 5;
                break;
            case OSF.StoreType.FirstParty:
                a = 6;
                break;
            case OSF.StoreType.Sdx:
                a = 7;
                break;
            default:
                a = 15;
        }
        var d;
        switch (i) {
            case OSF.OsfControlType.DocumentLevel:
                d = 1;
                break;
            case OSF.OsfControlType.ContainerLevel:
                d = 0;
                break;
            default:
                d = 2;
        }
        var e = 7;
        if (f && f.toLowerCase)
            switch (f.toLowerCase()) {
                case Microsoft.Office.WebExtension.InitializationReason.Inserted.toLowerCase():
                    e = 0;
                    break;
                case Microsoft.Office.WebExtension.InitializationReason.DocumentOpened.toLowerCase():
                    e = 1;
            }
        var c = 0;
        if (b.toLowerCase().indexOf('wa') === 0 || b.toLowerCase().indexOf('fa') === 0) {
            c = b && b.length > 2 ? parseInt(b.substring(2), 10) : 0;
            if (isNaN(c)) c = 0;
        }
        var g = 0;
        g = (e << 8) | (d << 4) | a;
        return [g, c];
    },
    isMyOrgReady: function(b) {
        var a = this;
        if (!a._enableMyOrg) {
            b({ isReady: false });
            return;
        }
        if (
            a._spBaseUrl &&
            a._iframeProxies &&
            a._iframeProxies[a._spBaseUrl] &&
            a._iframeProxies[a._spBaseUrl].clientEndPoint
        ) {
            b({ isReady: true, clientEndPoint: a._iframeProxies[a._spBaseUrl].clientEndPoint });
            return;
        }
        var c = function(a) {
            if (a) b({ isReady: true, clientEndPoint: a });
            else b({ isReady: false });
        };
        a._createSharePointIFrameProxy(a._spBaseUrl, c);
    },
    openInputUrlDialog: function(d) {
        var e = document.createElement('p');
        e.setAttribute('id', 'title-p');
        e.textContent =
            'DevCatalog server Url is configured in settings.xml - Enter manifest file name only (AppId.xml):';
        d.appendChild(e);
        var a = document.createElement('input');
        a.setAttribute('type', 'url');
        a.setAttribute('id', 'url-input');
        a.setAttribute('size', '80');
        a.setAttribute('data-lpignore', 'true');
        d.appendChild(a);
        var c = this,
            f = function(d) {
                var a = new OSF.Manifest.Manifest(d, c.getAppUILocale());
                !OSF.OsfManifestManager.hasManifest(
                    a.getMarketplaceID(),
                    a.getMarketplaceVersion()
                ) &&
                    OSF.OsfManifestManager.cacheManifest(
                        a.getMarketplaceID(),
                        a.getMarketplaceVersion(),
                        a
                    );
                var b = {
                    id: a.getMarketplaceID(),
                    targetType: a.getTarget(),
                    appVersion: a.getMarketplaceVersion(),
                    currentStoreType: OSF.StoreType.Registry,
                    storeId: 'developer',
                    assetId: a.getMarketplaceID(),
                    assetStoreId: OSF.StoreType.Registry,
                    width: a.getDefaultWidth() || 0,
                    height: a.getDefaultHeight() || 0,
                    isAddinCommands: a._isAddinCommandsManifest(
                        OSF.getManifestHostType(c._hostType)
                    ),
                };
                Telemetry.UploadFileDevCatalogUsageHelper.LogUploadFileDevCatalogUsageAction(
                    this._appCorrelationId,
                    b.currentStoreType,
                    b.id,
                    b.appVersion,
                    b.targetType,
                    b.isAddinCommands,
                    b.width,
                    b.height
                );
                c._notifyHost('0', OSF.AgaveHostAction.InsertAgave, b);
            },
            g = function(a) {
                alert('Error when requsting manifest file: ' + a);
            },
            h = function() {
                OSF.OUtil.xhrGet(c._devCatalogUrl + '/' + a.value, f, g);
            },
            b = document.createElement('input');
        b.setAttribute('type', 'button');
        b.setAttribute('value', 'Insert');
        OSF.OUtil.addEventListener(b, 'click', h);
        d.appendChild(b);
    },
    launchInsertDialog: function(e, n, g) {
        var b = null,
            d = '100%';
        e.childNodes.length != 0 && e.removeChild(e.childNodes.item(0));
        var l = OSF.OUtil.Guid.generateNewGuid(),
            k = new OfficeExt.InsertDialogTelemetryContext(l),
            c;
        if (this._enableDevCatalog) {
            c = document.createElement('div');
            c.style.width = d;
            c.style.height = '80%';
            e.appendChild(c);
            var h = document.createElement('div');
            h.style.width = d;
            h.style.height = '20%';
            e.appendChild(h);
            this.openInputUrlDialog(h);
        } else c = e;
        var a = this;
        a._insertDialogDiv = c;
        var f = document.createElement('div');
        f.style.width = d;
        f.style.height = d;
        f.style.backgroundImage = 'url(' + a.getLocalizedImageFilePath('progress.gif') + ')';
        f.style.backgroundRepeat = 'no-repeat';
        f.style.backgroundPosition = 'center';
        c.appendChild(f);
        var o = {
                MyApp: '0',
                MyOrg: '1',
                Store: '{98143890-AC66-440E-A448-ED8771A02D52}',
                OneDrive: '9',
            },
            i = function(c, d) {
                if (!a._enableMyOrg) {
                    d({ statusCode: OSF.InvokeResultCode.E_CATALOG_NO_APPS, value: b, context: c });
                    return;
                }
                try {
                    OSF.OUtil.validateParamObject(
                        c,
                        { webUrl: { type: String, mayBeNull: false } },
                        d
                    );
                    var f = function(a) {
                        if (a.isReady) {
                            c.clientEndPoint = a.clientEndPoint;
                            var e = OfficeExt.CatalogFactory.resolve(OSF.StoreType.SPCatalog);
                            e.getSPCatalogUrl(k, function(a) {
                                d({ statusCode: a.status, value: a.value, context: c });
                            });
                        } else
                            d({
                                statusCode: OSF.InvokeResultCode.E_GENERIC_ERROR,
                                value: b,
                                context: c,
                            });
                    };
                    a.isMyOrgReady(f);
                } catch (e) {
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                        'Error when getting corporate catalog url:',
                        e,
                        this._appCorrelationId,
                        34719254
                    );
                    d({ statusCode: OSF.InvokeResultCode.E_GENERIC_ERROR, value: b, context: c });
                    return;
                }
            },
            j = function(f) {
                var e = document.createElement('iframe');
                e.setAttribute('id', 'InsertDialog');
                e.setAttribute('src', 'about:blank');
                e.setAttribute('width', d);
                e.setAttribute('height', d);
                e.setAttribute('marginHeight', '0');
                e.setAttribute('marginWidth', '0');
                e.setAttribute('frameBorder', '0');
                e.setAttribute(
                    'sandbox',
                    'allow-scripts allow-forms allow-same-origin ms-allow-popups allow-popups'
                );
                typeof Strings != 'undefined' &&
                    Strings &&
                    Strings.OsfRuntime &&
                    e.setAttribute('title', Strings.OsfRuntime.L_InsertionDialogTile_TXT);
                var i = b,
                    h = [];
                a.isStoreDisabled(function(x) {
                    var d = '"}',
                        j = '], "url":"',
                        v =
                            '{ "IsUploadFileDevCatalogEnabled":' +
                            a._enableUploadFileDevCatalog +
                            ',"isStoreDisabled":' +
                            x.value +
                            ',"showSignOutFromPrivateCatalogMessage":' +
                            a._showSignOutFromPrivateCatalogMessage +
                            ',"enableInsertDialogAccessibilityFix":' +
                            a._enableInsertDialogAccessibilityFix +
                            ',"isBlackForestRedirectEnabled":' +
                            a._enableBlackForestRedirect +
                            ',"isHostDocumentDomain":' +
                            a._isHostDocumentDomain +
                            ' }';
                    if (a.isExternalMarketplaceAllowed()) {
                        var z = a._enableMyApps
                                ? OSF.InvokeResultCode.S_OK.toString()
                                : OSF.InvokeResultCode.S_HIDE_PROVIDER.toString(),
                            s =
                                '{ "provValues":[0,0,0,' +
                                z +
                                j +
                                a._osfOmexBaseUrl +
                                '", "client":"' +
                                a._getClientNameForOmex() +
                                '", "' +
                                OSF.OmexPageParameterKeys.AuthType +
                                '":' +
                                a._getAuthTypeForHideAppsExtensionUrl() +
                                '}';
                        h.push('"myApp":' + s);
                        Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                            'isExternalMarketplaceAllowed is true, myApp tab show firstly.',
                            a._contextMgrCorrelationId,
                            20194266
                        );
                    }
                    if (f && f.value != b) {
                        if (a._enableMyOrg) {
                            a._myOrgCatalogUrl = f.value;
                            var r = f.statusCode,
                                t = '{ "provValues":[1,1,0,' + r + j + f.value + d;
                            h.push('"myOrg":' + t);
                        }
                        if (
                            a._enableOneDriveCatalog &&
                            document.cookie.indexOf('OneDriveCatalog=true') != -1
                        ) {
                            a._myOneDriveCatalogUrl = f.value;
                            var q = '{ "provValues":[9,9,0,0], "url":"' + f.value + d;
                            h.push('"myOneDrive":' + q);
                        }
                    }
                    if (a._enablePrivateCatalog) {
                        var p =
                            '{"provValues":[10,10,0,0], "client":"' + a._getClientNameForOmex() + d;
                        h.push('"privateCatalog":' + p);
                    }
                    if (h.length > 0) i = '{' + h.join(', ') + '}';
                    a._internalConversationId &&
                        a._serviceEndPointInternal.unregisterConversation(
                            a._internalConversationId
                        );
                    var y = a.getClientId() + '_' + a.getDocUrl(),
                        w = OSF.OUtil.getFrameName(y),
                        l = OSF.OUtil.generateConversationId();
                    a._internalConversationId = OSF.OUtil.generateConversationId();
                    e.setAttribute('name', w);
                    var m = b;
                    if (g != b)
                        m =
                            '{ "navigationMode":' +
                            g.navigationMode +
                            ', "navigationModeParameter": "' +
                            g.assetId +
                            '", "category":"' +
                            g.category +
                            d;
                    var k = '',
                        u = [
                            l,
                            encodeURIComponent(window.location.href),
                            a._appVersion,
                            OSF.getAppVerCode(a._appName),
                            a.getLcid(),
                            OSF.Constants.FileVersion,
                            encodeURIComponent(i),
                            n,
                            encodeURIComponent(v),
                            encodeURIComponent(m),
                            a._contextMgrCorrelationId,
                        ];
                    if (a._localizedResourcesUrl)
                        k =
                            a._localizedResourcesUrl +
                            'WefGallery.htm?b=' +
                            OSF.Constants.FileVersion;
                    else
                        k =
                            a._pageBaseUrl +
                            a.getLcid() +
                            '/WefGallery.htm?b=' +
                            OSF.Constants.FileVersion;
                    var o = OSF.OUtil.addXdmInfoAsHash(k, u.join('|'));
                    a._serviceEndPointInternal.registerConversation(l, o);
                    e.setAttribute('src', o);
                    if (a._insertDialogDiv) {
                        c.childNodes.length != 0 && c.removeChild(c.childNodes.item(0));
                        c.appendChild(e);
                    } else {
                        c.insertBefore(e, c.firstChild);
                        a._insertDialogDiv = c;
                    }
                });
            },
            m = { webUrl: a._spBaseUrl };
        i(m, j);
        a._preloadOfficeJs();
    },
    activateAgavesBlockedBySandboxNotSupport: function() {
        for (var b in this._cachedOsfControls) {
            var a = this._cachedOsfControls[b];
            a._status === OSF.OsfControlStatus.NotSandBoxSupported && a.activate();
        }
    },
    setRequirementsChecker: function(a) {
        this._requirementsChecker = a;
    },
    getRequirementsChecker: function() {
        return this._requirementsChecker;
    },
    appHasNotifications: function(a) {
        if (this._ErrorUXHelper) return this._ErrorUXHelper.appHasNotifications(a);
        return false;
    },
    refreshOsfControl: function(d, c) {
        var a = this;
        for (var b in a._cachedOsfControls)
            if (
                a._cachedOsfControls[b] &&
                d == a._cachedOsfControls[b]._marketplaceID &&
                c == a._cachedOsfControls[b]._sourceLocationOverrideResourceId
            ) {
                a._cachedOsfControls[b].refresh();
                break;
            }
    },
    _doesUrlHaveSupportedProtocol: function(b) {
        var a = false;
        if (b) {
            var c = decodeURIComponent(b),
                d = c.match(/^https?:\/\/.+$/gi);
            a = d != null;
        }
        return a;
    },
    _loadLocaleString: function(c) {
        var a = this;
        if (typeof Strings == 'undefined' || !Strings || !Strings.OsfRuntime) {
            a._localeStringLoadingPendingCallbacks.push(c);
            var b = a._localeStringLoadingPendingCallbacks;
            if (b.length === 1) {
                var e = function() {
                    for (var d = b.length, c = 0; c < d; c++) {
                        var a = b.shift();
                        typeof a == 'function' && a();
                    }
                };
                a._loadStringScript(e);
            }
        } else {
            for (var f = a._localeStringLoadingPendingCallbacks.length, d = 0; d < f; d++) {
                var g = a._localeStringLoadingPendingCallbacks.shift();
                g();
            }
            c();
        }
    },
    _loadStringScript: function(e) {
        var d = this,
            b = this.getLocalizedScriptsUrl();
        b += OSF.Constants.StringResourceFile;
        var a = 0,
            c = function() {
                var f = null;
                if (typeof Strings == 'undefined' || !Strings || !Strings.OsfRuntime) {
                    if (++a < 3) {
                        setTimeout(function() {
                            OSF.OUtil.loadScript(b, c);
                        }, 750 * a);
                        return;
                    }
                    d._localeStringLoadingPendingCallbacks.length = 0;
                    var g = OSF.OUtil.formatString(
                        'The locale, {0}, provided by the host app is not supported. Url: {1}',
                        d.getLcid(),
                        b
                    );
                    Telemetry.RuntimeTelemetryHelper.LogExceptionTag(g, f, f, 20306076);
                } else {
                    if (a > 0) {
                        var g = OSF.OUtil.formatString(
                            'osfruntime_strings loaded after {0} retries.',
                            a
                        );
                        Telemetry.RuntimeTelemetryHelper.LogExceptionTag(g, f, f, 20306077);
                    }
                    e();
                }
            };
        OSF.OUtil.loadScript(b, c);
    },
    _getServiceEndPoint: function() {
        return this._serviceEndPoint;
    },
    _getOmexEndPointPageUrl: function(b, a) {
        return OSF.OUtil.formatString(
            '{0}/{1}/downloads/{2}.aspx',
            this._omexEndPointBaseUrl,
            a,
            b
        );
    },
    _getManifestAndTargetByConversationId: function(b) {
        for (var e in this._cachedOsfControls) {
            var a = this._cachedOsfControls[e];
            if (b === a._getConversationId()) {
                var d =
                        a.getStoreType() == OSF.StoreType.FirstParty
                            ? ''
                            : a.getMarketplaceVersion(),
                    c =
                        a.getManifest() ||
                        OSF.OsfManifestManager.getCachedManifest(a.getMarketplaceID());
                return { manifest: c, version: d, target: a.getOsfControlType() };
            }
        }
        return null;
    },
    _createSharePointIFrameProxy: function(b, h) {
        var c = null,
            d = this;
        if (!d._doesUrlHaveSupportedProtocol(b)) {
            h(c);
            return;
        }
        var l = b.length;
        if (b.charAt(l - 1) === '/') b = b.substr(0, l - 1);
        var i = d._iframeProxies[b];
        if (!i) {
            var e = OSF.OUtil.generateConversationId(),
                a = document.createElement('iframe');
            d._iframeProxyCount = d._iframeProxyCount + 1;
            var j = d._iframeNamePrefix + d._iframeProxyCount;
            a.setAttribute('id', j);
            a.setAttribute('name', j);
            var f = b + '/_layouts/15/OfficeExtensionManager.aspx?' + e;
            f = OSF.OUtil.addXdmInfoAsHash(f, e + '|' + j + '|' + window.location.href);
            f = OSF.OUtil.addSerializerVersionAsHash(f, OSF.SerializerVersion.Browser);
            a.setAttribute('scrolling', 'auto');
            a.setAttribute('border', '0');
            a.setAttribute('width', '0');
            a.setAttribute('height', '0');
            a.setAttribute('style', 'position: absolute; left: -100px; top:0px;');
            var g = d,
                m = function(l, m) {
                    var f,
                        d = g._iframeProxies[b];
                    if (d && l === 0 && m.status) {
                        d.isReady = true;
                        f = d.clientEndPoint;
                    } else {
                        delete g._iframeProxies[b];
                        if (Microsoft.Office.Common.XdmCommunicationManager.getClientEndPoint(e)) {
                            Microsoft.Office.Common.XdmCommunicationManager.deleteClientEndPoint(e);
                            OSF.OUtil.removeEventListener(a, 'load', k);
                            a.parentNode.removeChild(a);
                        } else
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                'Unexpected error occured with SharePoint proxy.',
                                c,
                                c,
                                19203550
                            );
                        f = c;
                    }
                    if (d)
                        for (var i = d.pendingCallbacks.length, h = 0; h < i; h++) {
                            var j = d.pendingCallbacks.shift();
                            j(f);
                        }
                },
                k = function() {
                    if (g._iframeProxies[b]) {
                        g._iframeProxies[
                            b
                        ].clientEndPoint = Microsoft.Office.Common.XdmCommunicationManager.connect(
                            e,
                            a.contentWindow,
                            b
                        );
                        g._iframeProxies[b].clientEndPoint.invoke('OEM_isProxyReady', m, {
                            __timeout__: 2e3,
                        });
                    }
                };
            document.body.appendChild(a);
            OSF.OUtil.addEventListener(a, 'load', k);
            a.setAttribute('src', f);
            d._iframeProxies[b] = { clientEndPoint: c, isReady: false, pendingCallbacks: [h] };
        } else if (i.isReady) h(i.clientEndPoint);
        else i.pendingCallbacks.push(h);
    },
    _getClientVersionForOmex: function() {
        if (!this._appVersion) return undefined;
        var b = this._appVersion.split('.'),
            c = parseInt(b[0], 10),
            d = parseInt(b[1], 10) || 0;
        if (c <= 15 && d <= 0) return undefined;
        var a = OSF.Constants.FileVersion.split('.');
        return c + '.' + d + '.' + a[2] + '.' + a[3];
    },
    _getClientNameForOmex: function() {
        return OSF.OmexClientNames[this._appName];
    },
    _getAppVersionForOmex: function() {
        return OSF.OmexAppVersions[this._appName];
    },
    _setCachedFlag: function(b) {
        var a = OSF.OUtil.getLocalStorage();
        a && a.setItem(b, 'true');
    },
    _getCachedFlag: function(c) {
        var a = OSF.OUtil.getLocalStorage();
        if (a) {
            var b = a.getItem(c);
            return b ? true : false;
        }
    },
    _deleteCachedFlag: function(b) {
        var a = OSF.OUtil.getLocalStorage();
        a && a.removeItem(b);
    },
    _preloadOfficeJs: function() {
        var b = this;
        if (b._hasPreloadedOfficeJs) return;
        var a = document.createElement('script');
        a.src = OSF.OUtil.formatString(
            '{0}?locale={1}&host={2}&version={3}',
            OSF.Constants.PreloadOfficeJsUrl,
            b._appUILocale,
            b._appName,
            b._hostSpecificFileVersion
        );
        a.type = 'text/javascript';
        a.id = OSF.Constants.PreloadOfficeJsId;
        a.onerror = function() {
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                'Failed to connect to preload service.',
                null,
                null,
                19203551
            );
        };
        document.getElementsByTagName('head')[0].appendChild(a);
        b._hasPreloadedOfficeJs = true;
    },
    _getAuthTypeForHideAppsExtensionUrl: function() {
        var a = OSF.OUtil.getQueryStringParamValue(
            this._hideAppsExtensionUrl,
            OSF.OmexPageParameterKeys.AuthType
        );
        return a ? a : OSF.AuthType.Anonymous;
    },
    isAddinCommandsAsync: function(b, f) {
        var c = null,
            a = false;
        OSF.OUtil.validateParamObject(
            b,
            {
                marketplaceId: { type: String, mayBeNull: a },
                marketplaceVersion: { type: String, mayBeNull: a },
                storeType: { type: String, mayBeNull: a },
                storeId: { type: String, mayBeNull: a },
                targetData: { type: Object, mayBeNull: a },
                clearCache: { type: Boolean, mayBeNull: true },
            },
            c
        );
        var d = b.storeType.toLowerCase(),
            n,
            e = { contextActivationMgr: c, referenceInUse: c },
            l = b.clearCache || a;
        try {
            e.referenceInUse = {
                id: b.marketplaceId,
                version: b.marketplaceVersion,
                storeType: b.storeType,
                storeLocator: b.storeId,
            };
            e.contextActivationMgr = this;
            var i = function(d) {
                if (
                    d != c &&
                    d.statusCode == OfficeExt.DataServiceResultCode.Succeeded &&
                    d.value != c
                )
                    f(
                        true,
                        d.value._isAddinCommandsManifest(
                            OSF.getManifestHostType(e.contextActivationMgr._hostType)
                        ),
                        b
                    );
                else f(a, a, b);
            };
            if (
                OSF.StoreType.OMEX === d ||
                OSF.StoreType.UploadFileDevCatalog === d ||
                OSF.StoreType.SPCatalog === d ||
                OSF.StoreType.PrivateCatalog === d
            ) {
                var m = OfficeExt.CatalogFactory.resolve(d),
                    g = {
                        assetId: e.referenceInUse.id,
                        storeType: d,
                        storeId: e.referenceInUse.storeLocator,
                        appVersion: e.referenceInUse.version,
                        targetType: c,
                    },
                    k = OSF.OUtil.Guid.generateNewGuid(),
                    j = new OfficeExt.AddinCommandsTelemetryContext(k);
                m.getAndCacheManifest(
                    g,
                    g.storeId,
                    j,
                    function(a) {
                        i({ statusCode: a.status, value: a.value });
                    },
                    l
                );
            } else f(true, a, b);
        } catch (h) {
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                'Error for checking is addincommands or not',
                h,
                c,
                19203552
            );
            f(a, a, b);
        }
    },
    getManifestInvaildErrorString: function() {
        return Strings.OsfRuntime.L_AddinCommands_AddinNotSupported_Message;
    },
    getUserNameHashCode: function() {
        return this._userNameHashCode;
    },
};
OSF.OsfControl = function(b) {
    var c = null,
        e = true,
        d = false,
        a = this;
    OSF.OUtil.validateParamObject(
        b,
        {
            div: { type: Object, mayBeNull: d },
            contextActivationMgr: { type: Object, mayBeNull: d },
            id: { type: String, mayBeNull: d },
            marketplaceID: { type: String, mayBeNull: d },
            marketplaceVersion: { type: String, mayBeNull: d },
            store: { type: String, mayBeNull: d },
            storeType: { type: String, mayBeNull: d },
            alternateReference: { type: Object, mayBeNull: e },
            settings: { type: Object, mayBeNull: e },
            reason: { type: String, mayBeNull: e },
            osfControlType: { type: Number, mayBeNull: e },
            snapshotUrl: { type: String, mayBeNull: e },
            preactivationCallback: { type: Object, mayBeNull: e },
            virtualOsfControlActivationCallback: { type: Object, mayBeNull: e },
            isvirtualOsfControl: { type: Boolean, mayBeNull: e },
            isDialog: { type: Boolean, mayBeNull: e },
            hostCustomMessage: { type: String, mayBeNull: e },
            isForUILessAction: { type: Boolean, mayBeNull: e },
            ownerAddinAssetId: { type: String, mayBeNull: e },
            sourceLocationOverrideResourceId: { type: String, mayBeNull: e },
            ownerAddinStoreType: { type: String, mayBeNull: e },
        },
        c
    );
    a._div = b.div;
    a._sourceLocationOverrideResourceId = b.sourceLocationOverrideResourceId;
    a._contextActivationMgr = b.contextActivationMgr;
    a._id = b.id;
    a._storeType = b.storeType.toLowerCase();
    a._storeLocator = b.store;
    a._marketplaceID = b.marketplaceID;
    a._marketplaceVersion = b.marketplaceVersion;
    a._alternateReference = b.alternateReference;
    a._settings = b.settings || {};
    a._reason =
        b.reason == undefined
            ? Microsoft.Office.WebExtension.InitializationReason.DocumentOpened
            : b.reason;
    a._osfControlType =
        b.osfControlType == undefined ? OSF.OsfControlType.DocumentLevel : b.osfControlType;
    a._snapshotUrl = b.snapshotUrl;
    a._status = OSF.OsfControlStatus.NotActivated;
    a._notificationParams = [];
    a._iframeUrl = c;
    a._permission = c;
    a._conversationId = c;
    a._manifestUrl = c;
    a._pageStatus = OSF.OsfControlPageStatus.NotStarted;
    a._pageIsReadyTimerExpired = d;
    a._timer = c;
    a._retryLoadingNum = 2;
    a._frame = c;
    a._agaveEndPoint = c;
    a._etoken = '';
    a._sqmDWords = [0, 0];
    a._preactivationCallback = b.preactivationCallback;
    a._telemetryContext = {};
    a._controlFocus = d;
    a._agavePageUrl = c;
    a._agaveWindowName = c;
    a._manifest = c;
    a._virtualOsfControlActivationCallback = b.virtualOsfControlActivationCallback;
    a._isvirtualOsfControl = b.isvirtualOsfControl == undefined ? d : b.isvirtualOsfControl;
    a._isvirtualOsfControlCallbackInvoked = d;
    a._isManifestProcessedForCustomFunctions = d;
    a._isDialog = b.isDialog == undefined ? d : b.isDialog;
    a._hostCustomMessage = b.hostCustomMessage;
    a._isUpgrading = d;
    if (a._contextActivationMgr._enableServiceDeliveredExperience) {
        a._bundleUrl = c;
        a._sdxIframeTemplateUrl = 'https://osf-agave/rtm/sdx/index.html';
    }
    a._isUILessAddInCommands = !!b.isForUILessAction;
    a._ownerAddinAssetId = !!b.ownerAddinAssetId ? b.ownerAddinAssetId : c;
    a._ownerAddinStoreType = !!b.ownerAddinStoreType ? b.ownerAddinStoreType : c;
    if (OSF.OUtil.isiOS()) {
        a._div.style.webkitOverflowScrolling = 'touch';
        a._div.style.overflow = 'auto';
    }
    a._appCorrelationId =
        a._contextActivationMgr._contextMgrCorrelationId || OSF.OUtil.Guid.generateNewGuid();
    a._iframeOnLoadDelegate = Function.createDelegate(a, a._iframeOnLoad);
    a._retryActivate = c;
    a._onKeyDownEventDelegate = Function.createDelegate(a, a._onKeydownEvent);
};
OSF.OsfControl.prototype = {
    activate: function(d) {
        var f = true,
            b = null,
            a = this,
            h = a;
        if (a._status === OSF.OsfControlStatus.Activated) {
            a.invokePreactivationCompletedCallback();
            return;
        }
        try {
            a._contextActivationMgr.registerOsfControl(a);
            OSF.OUtil.addEventListener(a._div, 'keydown', a._onKeyDownEventDelegate);
            d = d || {};
            d.hostType = a._contextActivationMgr._hostType;
            d.osfControl = d.osfControl || a;
            d.referenceInUse = d.referenceInUse || {
                id: a._marketplaceID,
                version: a._marketplaceVersion,
                storeType: a._storeType,
                storeLocator: a._storeLocator,
            };
            d.correlationId = d.osfControl._appCorrelationId;
            if (!a._doesBrowserSupportRequiredFeatures()) {
                if (a._contextActivationMgr._enableFirstPartySDXErrorMessages && a.isFirstParty())
                    a._showActivationError(
                        OSF.OsfControlStatus.ActivationFailed,
                        Strings.OsfRuntime.L_AgaveUnsupportedBroswer_ERR_FirstParty,
                        Strings.OsfRuntime.L_RetryButton_TXT,
                        Function.createDelegate(a, a._refresh),
                        b,
                        b,
                        b,
                        f,
                        OSF.ErrorStatusCodes.E_BROWSER_VERSION
                    );
                else
                    a._showActivationError(
                        OSF.OsfControlStatus.ActivationFailed,
                        Strings.OsfRuntime.L_AgaveUnsupportedBroswer_ERR,
                        Strings.OsfRuntime.L_RetryButton_TXT,
                        Function.createDelegate(a, a._refresh),
                        b,
                        b,
                        b,
                        f,
                        OSF.ErrorStatusCodes.E_BROWSER_VERSION
                    );
                a.invokePreactivationCompletedCallback();
                return;
            }
            var o = document.createElement('iframe'),
                w = 'sandbox' in o;
            o = b;
            var l = false,
                k = OSF.OUtil.getLocalStorage();
            if (k) l = k.getItem(OSF.Constants.IgnoreSandBoxSupport);
            if (a._contextActivationMgr._autoTrusted && !w && !l) {
                a._contextActivationMgr._ErrorUXHelper.removeProgressDiv(a._div, a._id);
                a._status = OSF.OsfControlStatus.NotSandBoxSupported;
                if (a._contextActivationMgr._enableFirstPartySDXErrorMessages && a.isFirstParty())
                    a._contextActivationMgr.displayNotification({
                        id: a._id,
                        infoType: OSF.InfoType.Warning,
                        title: Strings.OsfRuntime.L_AppsDisabled_WRN_FirstParty,
                        description: Strings.OsfRuntime.L_NotSandBoxSupported_ERR_FirstParty,
                        icon: b,
                        buttonTxt: Strings.OsfRuntime.L_EnableAppsButton_TXT_FirstParty,
                        buttonCallback: Function.createCallback(
                            a._activateAgavesBlockedBySandboxNotSupport,
                            a._contextActivationMgr
                        ),
                        url: OSF.Constants.IEUpgradeUrl,
                        urlButtonTxt: Strings.OsfRuntime.L_UpgradeBrowserButton_TXT,
                        dismissCallback: b,
                        reDisplay: f,
                        displayDeactive: f,
                        errorCode: OSF.ErrorStatusCodes.WAC_HTML5IframeSandboxNotSupport,
                        highPriority: f,
                    });
                else
                    a._contextActivationMgr.displayNotification({
                        id: a._id,
                        infoType: OSF.InfoType.Warning,
                        title: Strings.OsfRuntime.L_AppsDisabled_WRN,
                        description: Strings.OsfRuntime.L_NotSandBoxSupported_ERR,
                        icon: b,
                        buttonTxt: Strings.OsfRuntime.L_EnableAppsButton_TXT,
                        buttonCallback: Function.createCallback(
                            a._activateAgavesBlockedBySandboxNotSupport,
                            a._contextActivationMgr
                        ),
                        url: OSF.Constants.IEUpgradeUrl,
                        urlButtonTxt: Strings.OsfRuntime.L_UpgradeBrowserButton_TXT,
                        dismissCallback: b,
                        reDisplay: f,
                        displayDeactive: f,
                        errorCode: OSF.ErrorStatusCodes.WAC_HTML5IframeSandboxNotSupport,
                        highPriority: f,
                    });
                a.invokePreactivationCompletedCallback();
                return;
            }
            a.startActivate();
            var e = a,
                c = d.referenceInUse,
                y = '1B4CD97F-DBFE-4C1A-B4C4-FC163B4F9693';
            if (
                c.storeType === OSF.StoreType.OMEX ||
                c.storeType === OSF.StoreType.UploadFileDevCatalog ||
                c.storeType === OSF.StoreType.SPCatalog ||
                c.storeType === OSF.StoreType.PrivateCatalog ||
                c.storeType === OSF.StoreType.FirstParty ||
                c.storeType === OSF.StoreType.Sdx
            ) {
                var n = new OfficeExt.OsfControlLoader(a, d.hasConsent),
                    j = new OfficeExt.ActivationTelemetryContext(
                        a.getCorrelationId(),
                        a._telemetryContext,
                        a._sqmDWords[0],
                        a._sqmDWords[1],
                        a._id
                    );
                if (c.storeType === OSF.StoreType.Sdx)
                    OfficeExt.SDXCatalog.activateAsync(
                        {
                            assetId: c.id,
                            storeId: c.storeLocator,
                            appVersion: c.version,
                            storeType: c.storeType,
                            targetType: '',
                        },
                        n,
                        j,
                        a._contextActivationMgr.getRequirementsChecker(),
                        {
                            clientId: a._contextActivationMgr._loggableUserId,
                            sessionStartInfoJson: a._contextActivationMgr._sessionStartInfoJson,
                        }
                    );
                else {
                    var s =
                            d.noTargetType ||
                            d.osfControl.getOsfControlType() === OSF.OsfControlTarget.TaskPane
                                ? b
                                : d.osfControl.getOsfControlType(),
                        z = OfficeExt.CatalogFactory.resolve(c.storeType);
                    z.activateAsync(
                        {
                            assetId: c.id,
                            storeId: c.storeLocator,
                            appVersion: c.version,
                            storeType: c.storeType,
                            targetType: c.storeType === OSF.StoreType.SPCatalog ? s : '',
                        },
                        n,
                        j
                    );
                }
                a.invokePreactivationCompletedCallback();
                return;
            }
            c.id === y &&
                Telemetry.RuntimeTelemetryHelper.LogCommonMessageTag(
                    'ONO_Onboarding_CorrelationId :' + a.getCorrelationId(),
                    b,
                    23381916
                );
            Telemetry.AppLoadTimeHelper.ActivationStart(
                a._telemetryContext,
                a._sqmDWords[0],
                a._sqmDWords[1],
                a.getCorrelationId(),
                a._id,
                OSF.ActivationTypes.V2Enabled
            );
            Telemetry.AppLoadTimeHelper.ServerCallStart(a._telemetryContext);
            if (c.storeType === OSF.StoreType.Exchange || c.storeType === OSF.StoreType.InMemory)
                OSF.OsfManifestManager.getManifestAsync(d, function(a) {
                    if (a.statusCode === OSF.ProxyCallStatusCode.Succeeded && a.value && !h._etoken)
                        h._etoken = a.value.getInMemoryEToken() || '';
                    h._onGetManifestCompleted(a);
                });
            else if (
                (c.storeType === OSF.StoreType.Registry &&
                    a._contextActivationMgr._enableDevCatalog) ||
                c.storeType === OSF.StoreType.HardCodedPreinstall
            )
                if (
                    d.osfControl.getReason() ==
                    Microsoft.Office.WebExtension.InitializationReason.DocumentOpened
                ) {
                    var v = function(b) {
                            var a = new OSF.Manifest.Manifest(
                                b,
                                e._contextActivationMgr.getAppUILocale()
                            );
                            !OSF.OsfManifestManager.hasManifest(
                                a.getMarketplaceID(),
                                a.getMarketplaceVersion()
                            ) &&
                                OSF.OsfManifestManager.cacheManifest(
                                    a.getMarketplaceID(),
                                    a.getMarketplaceVersion(),
                                    a
                                );
                            OSF.OsfManifestManager.getManifestAsync(
                                d,
                                Function.createDelegate(e, e._onGetManifestCompleted)
                            );
                        },
                        u = function(a) {
                            alert('Error when requsting manifest file: ' + a);
                        };
                    OSF.OUtil.xhrGet(
                        a._contextActivationMgr._devCatalogUrl + '/' + c.id + '.xml',
                        v,
                        u
                    );
                } else
                    OSF.OsfManifestManager.getManifestAsync(
                        d,
                        Function.createDelegate(a, a._onGetManifestCompleted)
                    );
            else if (
                c.storeType === OSF.StoreType.OneDrive &&
                a._contextActivationMgr._enableOneDriveCatalog
            ) {
                var p = function(b) {
                        var a = new OSF.Manifest.Manifest(
                            b,
                            e._contextActivationMgr.getAppUILocale()
                        );
                        OSF.OsfManifestManager.cacheManifest(c.id, a.getMarketplaceVersion(), a);
                        OSF.OsfManifestManager.getManifestAsync(
                            d,
                            Function.createDelegate(e, e._onGetManifestCompleted)
                        );
                    },
                    q = function() {
                        e._showActivationError(
                            OSF.OsfControlStatus.ActivationFailed,
                            Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                            Strings.OsfRuntime.L_RetryButton_TXT,
                            Function.createDelegate(e, e._refresh),
                            b,
                            b,
                            b,
                            b,
                            OSF.ErrorStatusCodes.E_MANIFEST_SERVER_UNAVAILABLE
                        );
                    },
                    x = window.location.protocol + '//' + window.location.host;
                OSF.OneDriveOAuth.setHostCallbackUri(x);
                var g =
                        a._contextActivationMgr._oneDriveCatalogBaseApiUrl +
                        '/root:/Manifests/' +
                        c.id +
                        ':/content?access_token=',
                    r = function(a) {
                        g = g + a;
                        OSF.OUtil.xhrGet(g, p, q);
                    },
                    t = function() {
                        e._showActivationError(
                            OSF.OsfControlStatus.ActivationFailed,
                            Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                            Strings.OsfRuntime.L_RetryButton_TXT,
                            Function.createDelegate(e, e._refresh),
                            b,
                            b,
                            b,
                            b,
                            OSF.ErrorStatusCodes.E_MANIFEST_SERVER_UNAVAILABLE
                        );
                    };
                OSF.OneDriveOAuth.getAccessToken(r, t);
            } else if (c.storeType === OSF.StoreType.SPApp) {
                Telemetry.AppLoadTimeHelper.EntitlementCheckStart(a._telemetryContext);
                d.baseUrl = a._contextActivationMgr.getPageBaseUrl();
                d.pageUrl = a._contextActivationMgr._docUrl;
                d.webUrl = a._contextActivationMgr._webUrl;
                d.appWebUrl = a._contextActivationMgr._webUrl;
                OSF.OsfManifestManager.getSPAppEntitlementsAsync(
                    d,
                    Function.createDelegate(a, a._onGetEntitlementsCompleted)
                );
            } else if (
                c.storeType === OSF.StoreType.FileSystem ||
                c.storeType === OSF.StoreType.Registry ||
                c.storeType === OSF.StoreType.HardCodedPreinstall
            )
                a._showActivationWarning(
                    OSF.OsfControlStatus.UnsupportedStore,
                    Strings.OsfRuntime.L_AgaveUnsupportedStoreType_ERR,
                    b,
                    b,
                    b,
                    b,
                    OSF.ErrorStatusCodes.WAC_AgaveUnsupportedStoreType
                );
            else if (c.storeType === OSF.StoreType.OneDrive)
                a._showActivationWarning(
                    OSF.OsfControlStatus.UnsupportedStore,
                    Strings.OsfRuntime.L_AgaveUnsupportedStoreType_ERR,
                    b,
                    b,
                    b,
                    b,
                    OSF.ErrorStatusCodes.WAC_AgaveUnsupportedStoreType
                );
            else
                a._showActivationError(
                    OSF.OsfControlStatus.UnknownStore,
                    Strings.OsfRuntime.L_AgaveUnknownStoreType_ERR,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    OSF.ErrorStatusCodes.E_MANIFEST_REFERENCE_INVALID
                );
        } catch (i) {
            var m = 'Error getting app data.';
            OfficeExt.WACUtils.logExceptionToBrowserConsole(m, i);
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(m, i, a.getCorrelationId(), 18420419);
            if (a._contextActivationMgr._enableFirstPartySDXErrorMessages && a.isFirstParty())
                a._showActivationError(
                    OSF.OsfControlStatus.ActivationFailed,
                    Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR_FirstParty,
                    Strings.OsfRuntime.L_RetryButton_TXT,
                    Function.createDelegate(a, a._refresh),
                    b,
                    b,
                    b,
                    b,
                    OSF.ErrorStatusCodes.WAC_AgaveOsfControlActivationError
                );
            else
                a._showActivationError(
                    OSF.OsfControlStatus.ActivationFailed,
                    Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                    Strings.OsfRuntime.L_RetryButton_TXT,
                    Function.createDelegate(a, a._refresh),
                    b,
                    b,
                    b,
                    b,
                    OSF.ErrorStatusCodes.WAC_AgaveOsfControlActivationError
                );
        }
        a.invokePreactivationCompletedCallback();
    },
    createIframeForDialogControl: function(e, b, d) {
        var a = this;
        while (a._div.childNodes.length > 0) a._div.removeChild(a._div.childNodes.item(0));
        var c = a._createIframeForControl(e);
        a._iframeUrl = b;
        a._appDomains = d;
        a._setIframeAttribute(c, b);
        a._div.appendChild(c);
        a._contextActivationMgr.registerOsfControl(a);
    },
    deActivate: function() {
        var b = null,
            a = this;
        try {
            OSF.OUtil.writeProfilerMark(OSF.OsfControlActivationPerfMarker.DeactivationStart);
            a._contextActivationMgr.dismissMessages(a._id);
            a._retryActivate = b;
            if (a._status !== OSF.OsfControlStatus.NotActivated) {
                if (a._agaveEndPoint) {
                    Microsoft.Office.Common.XdmCommunicationManager.deleteClientEndPoint(
                        a._agaveEndPoint._conversationId
                    );
                    a._agaveEndPoint = b;
                }
                if (a._frame) {
                    OSF.OUtil.removeEventListener(a._frame, 'load', a._iframeOnLoadDelegate);
                    a._frame = b;
                }
                if (a._timer) {
                    window.clearTimeout(a._timer);
                    a._timer = b;
                }
                while (a._div.childNodes.length > 0) a._div.removeChild(a._div.childNodes.item(0));
                a._status = OSF.OsfControlStatus.NotActivated;
                a._conversationId &&
                    a._contextActivationMgr
                        ._getServiceEndPoint()
                        .unregisterConversation(a._conversationId);
                a._contextActivationMgr.raiseOsfControlStatusChange(a);
            }
            a._controlFocus = false;
            OSF.OUtil.removeEventListener(a._div, 'keydown', a._onKeyDownEventDelegate);
            OSF.OUtil.writeProfilerMark(OSF.OsfControlActivationPerfMarker.DeactivationEnd);
        } catch (c) {
            var d = 'Deactivate failed.';
            OfficeExt.WACUtils.logExceptionToBrowserConsole(d, c);
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(d, c, a.getCorrelationId(), 18420420);
        }
    },
    startActivate: function() {
        var a = this;
        a._controlFocus = true;
        a._pageStatus = OSF.OsfControlPageStatus.Loading;
        OSF.OUtil.writeProfilerMark(OSF.OsfControlActivationPerfMarker.ActivationStart);
        if (a._frame) {
            OSF.OUtil.removeEventListener(a._frame, 'load', a._iframeOnLoadDelegate);
            a._frame = null;
        }
        while (a._div.childNodes.length > 0) a._div.removeChild(a._div.childNodes.item(0));
        a._contextActivationMgr._ErrorUXHelper.showProgress(a._div, a._id);
    },
    refresh: function() {
        this._refresh();
    },
    _restartActivate: function() {
        this.deActivate();
        this.startActivate();
        this.invokePreactivationCompletedCallback();
    },
    purge: function(e) {
        var a = this,
            d = Function._validateParams(arguments, [
                { name: 'purgeManifest', type: Boolean, mayBeNull: false },
            ]);
        if (d) throw d;
        try {
            a._contextActivationMgr._ErrorUXHelper.purgeOsfControlNotification(a._id);
            a.deActivate();
            e && OSF.OsfManifestManager.purgeManifest(a._marketplaceID, a._marketplaceVersion);
            a._contextActivationMgr.unregisterOsfControl(a);
        } catch (b) {
            var c = 'Purge failed.';
            OfficeExt.WACUtils.logExceptionToBrowserConsole(c, b);
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(c, b, a.getCorrelationId(), 18420421);
        }
    },
    invokeVirtualOsfControlActivationCallback: function(d) {
        var a = this;
        try {
            if (a._virtualOsfControlActivationCallback) {
                a._virtualOsfControlActivationCallback(a, d);
                a._isvirtualOsfControlCallbackInvoked = true;
            }
        } catch (b) {
            var c = 'invokeVirtualOsfControlActivationCallback failed.';
            OfficeExt.WACUtils.logExceptionToBrowserConsole(c, b);
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(c, b, a.getCorrelationId(), 36496280);
        }
    },
    ensureToGetVirtualOsfControlManifest: function(d) {
        var b = null,
            a = this,
            g = a;
        if (a._manifest) {
            d(a._manifest);
            return;
        }
        var c = {
                assetId: a._marketplaceID,
                appVersion: a._marketplaceVersion,
                storeType: a._storeType,
                storeId: a._storeLocator,
                targetType: b,
            },
            e = function(a) {
                var c = b;
                if (a.status === OfficeExt.DataServiceResultCode.Succeeded && a.value) c = a.value;
                else g._status = OSF.OsfControlStatus.ActivationFailed;
                d(c);
            },
            f = OfficeExt.CatalogFactory.resolve(c.storeType);
        if (f != b)
            f.getAndCacheManifest(
                c,
                a._storeLocator,
                new OfficeExt.AddinCommandsTelemetryContext(a.getCorrelationId()),
                e
            );
        else {
            alert('AddinCommands is not supported in ' + c.storeType + ' store.');
            e({ status: OfficeExt.DataServiceResultCode.Failed, value: b });
        }
    },
    invokePreactivationCompletedCallback: function() {
        this._preactivationCallback && this._preactivationCallback();
    },
    getMarketplaceID: function() {
        return this._marketplaceID;
    },
    getMarketplaceVersion: function() {
        return this._marketplaceVersion;
    },
    getContainingDiv: function() {
        return this._div;
    },
    getID: function() {
        return this._id;
    },
    getSettings: function() {
        return this._settings;
    },
    setSettings: function(a) {
        this._settings = a;
    },
    getReason: function() {
        return this._reason;
    },
    getManifest: function() {
        return this._manifest;
    },
    getOsfControlType: function() {
        return this._osfControlType;
    },
    getSnapshotUrl: function() {
        return this._snapshotUrl;
    },
    getStoreType: function() {
        return this._storeType;
    },
    isFirstParty: function() {
        return (
            this._storeType &&
            (this._storeType === OSF.StoreType.FirstParty || this._storeType === OSF.StoreType.Sdx)
        );
    },
    updateAgaveEndPointTargetUrl: function(a) {
        this._agaveEndPoint._targetUrl = a;
    },
    getStoreLocator: function() {
        return this._storeLocator;
    },
    getHostCustomMessage: function() {
        return this._hostCustomMessage;
    },
    getProperty: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'name', type: String, mayBeNull: false },
        ]);
        if (a) throw a;
        return this._settings[b];
    },
    addProperty: function(c, b) {
        var a = Function._validateParams(arguments, [
            { name: 'name', type: String, mayBeNull: false },
            { name: 'value', type: String, mayBeNull: false },
        ]);
        if (a) throw a;
        this._settings[c] = b;
    },
    removeProperty: function(b) {
        var a = Function._validateParams(arguments, [
            { name: 'name', type: String, mayBeNull: false },
        ]);
        if (a) throw a;
        delete this._settings[b];
    },
    getStatus: function() {
        return this._status;
    },
    getPageStatus: function() {
        return this._pageStatus;
    },
    checkAppDomains: function(a) {
        return Microsoft.Office.Common.XdmCommunicationManager.checkUrlWithAppDomains(
            this._appDomains,
            a
        );
    },
    getNotificationParams: function() {
        return this._notificationParams;
    },
    removeFirstNotification: function() {
        this._notificationParams.shift();
    },
    getIframeUrl: function() {
        return this._iframeUrl;
    },
    getPermission: function() {
        return this._permission;
    },
    getTrustNoPrompt: function() {
        return false;
    },
    getEToken: function() {
        return this._etoken;
    },
    getCorrelationId: function() {
        return this._appCorrelationId;
    },
    getAgavePageUrl: function() {
        return this._agavePageUrl;
    },
    getAgaveWindowName: function() {
        return this._agaveWindowName;
    },
    notifyAgave: function(a) {
        this._agaveEndPoint && this._agaveEndPoint.invoke('Office_notifyAgave', null, a);
    },
    sendMessageToSdx: function(b, a) {
        this._agaveEndPoint && this._agaveEndPoint.invoke('Office_sendMessageToSdx', a, b);
    },
    isUILessAddInCommands: function() {
        return this._isUILessAddInCommands;
    },
    getOwnerAddinAssetId: function() {
        return this._ownerAddinAssetId;
    },
    getOwnerAddinStoreType: function() {
        return this._ownerAddinStoreType;
    },
    _onKeydownEvent: function(a) {
        var f = 'input, button, a',
            b = this;
        a.preventDefault =
            a.preventDefault ||
            function() {
                a.returnValue = false;
            };
        if (a.keyCode == 117 && (a.ctrlKey || a.metaKey)) {
            a.preventDefault();
            a.stopPropagation();
            var g = OSF.AgaveHostAction.CtrlF6Exit;
            if (a.shiftKey) g = OSF.AgaveHostAction.CtrlF6ExitShift;
            b._contextActivationMgr._notifyHost(b._id, g);
        } else if (a.keyCode == 9) {
            a.preventDefault();
            a.stopPropagation();
            var d = b._div.querySelectorAll(f);
            if (d.length == 0) return;
            var i = OSF.OUtil.focusToNextTabbable(d, a.target || a.srcElement, a.shiftKey);
            if (!i)
                if (a.shiftKey)
                    b._contextActivationMgr._notifyHost(b._id, OSF.AgaveHostAction.TabExitShift);
                else if (b._agaveEndPoint) b.notifyAgave(OSF.AgaveHostAction.TabIn);
                else b._contextActivationMgr._notifyHost(b._id, OSF.AgaveHostAction.TabExit);
        } else if (a.keyCode == 27) {
            a.preventDefault();
            b._contextActivationMgr._notifyHost(b._id, OSF.AgaveHostAction.EscExit);
        } else if (a.keyCode == 113) {
            a.preventDefault();
            b._contextActivationMgr._notifyHost(b._id, OSF.AgaveHostAction.F2Exit);
        } else if (a.keyCode == 13 || a.keyCode == 32)
            for (var e = b._div.querySelectorAll(f), c = 0; c < e.length; c++) {
                var h = a.target || a.srcElement;
                if (e[c] === h) {
                    a.preventDefault();
                    a.stopPropagation();
                    h.click();
                    return;
                }
            }
        else {
            a.preventDefault();
            a.stopPropagation();
        }
    },
    _onGetEntitlementsCompleted: function(b) {
        var a = null,
            d = this;
        if (b.statusCode === OSF.ProxyCallStatusCode.Succeeded && b.value) {
            Telemetry.AppLoadTimeHelper.EntitlementCheckEnd(d._telemetryContext);
            for (
                var h = b.context.referenceInUse,
                    g = b.value.entitlements,
                    i = g.length,
                    c,
                    e = a,
                    f = 0;
                f < i;
                f++
            ) {
                c = g[f];
                if (
                    c.OfficeExtensionID &&
                    h.id &&
                    c.OfficeExtensionID.toLowerCase() === h.id.toLowerCase()
                )
                    if (!e || d._lessThan(e.OfficeExtensionVersion, c.OfficeExtensionVersion))
                        e = c;
            }
            c = e;
            if (!c)
                d._showActivationError(
                    OSF.OsfControlStatus.ActivationFailed,
                    Strings.OsfRuntime.L_AgaveNotExist_ERR,
                    Strings.OsfRuntime.L_RetryButton_TXT,
                    Function.createCallback(
                        function(a) {
                            a.osfControl._refresh(a);
                        },
                        {
                            clearCache: true,
                            referenceInUse: b.context.referenceInUse,
                            osfControl: b.context.osfControl,
                        }
                    ),
                    a,
                    a,
                    a,
                    a,
                    OSF.ErrorStatusCodes.E_MANIFEST_DOES_NOT_EXIST
                );
            else if (c.OfficeExtensionKillbit)
                d._showActivationError(
                    OSF.OsfControlStatus.ActivationFailed,
                    Strings.OsfRuntime.L_AgaveDisabledByAdmin_ERR,
                    a,
                    a,
                    a,
                    a,
                    a,
                    a,
                    OSF.ErrorStatusCodes.E_OEM_EXTENSION_KILLED
                );
            else {
                b.context.manifestUrl = c.EncodedAbsUrl;
                b.context.appInstanceId = c.AppInstanceID;
                b.context.productId = c.ProductID;
                if (b.context.appInstanceId)
                    OSF.OsfManifestManager.getAppInstanceInfoByIdAsync(
                        b.context,
                        Function.createDelegate(d, d._onGetAppInstanceInfoByIdCompleted)
                    );
                else
                    OSF.OsfManifestManager.getManifestAsync(
                        b.context,
                        Function.createDelegate(d, d._onGetManifestCompleted)
                    );
            }
        } else
            d._showActivationError(
                OSF.OsfControlStatus.ActivationFailed,
                Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                Strings.OsfRuntime.L_RetryButton_TXT,
                Function.createDelegate(d, d._refresh),
                a,
                a,
                a,
                a,
                OSF.ErrorStatusCodes.E_MANIFEST_SERVER_UNAVAILABLE
            );
    },
    _onGetAppInstanceInfoByIdCompleted: function(e) {
        var d = null,
            b = this;
        if (e.statusCode === OSF.ProxyCallStatusCode.Succeeded && e.value) {
            var c = e.value,
                a = e.context;
            if (c.AppWebFullUrl) a.appWebUrl = c.AppWebFullUrl;
            a.clientId = c.AppPrincipalId;
            a.remoteAppUrl = c.RemoteAppUrl;
            if (a.appWebUrl && a.productId)
                OSF.OsfManifestManager.getSPTokenByProductIdAsync(
                    a,
                    Function.createDelegate(b, b._onGetSPTokenByProductIdCompleted)
                );
            else
                OSF.OsfManifestManager.getManifestAsync(
                    a,
                    Function.createDelegate(b, b._onGetManifestCompleted)
                );
        } else
            b._showActivationError(
                OSF.OsfControlStatus.ActivationFailed,
                Strings.OsfRuntime.L_AgaveServerConnectionFailed_ERR,
                Strings.OsfRuntime.L_RetryButton_TXT,
                Function.createDelegate(b, b._refresh),
                d,
                d,
                d,
                d,
                OSF.ErrorStatusCodes.E_MANIFEST_SERVER_UNAVAILABLE
            );
    },
    _onGetSPTokenByProductIdCompleted: function(a) {
        if (a.statusCode === OSF.ProxyCallStatusCode.Succeeded && a.value) this._etoken = a.value;
        OSF.OsfManifestManager.getManifestAsync(
            a.context,
            Function.createDelegate(this, this._onGetManifestCompleted)
        );
    },
    _retryActivation: function() {
        var a = this;
        a._retryLoadingNum--;
        if (a._pageStatus === OSF.OsfControlPageStatus.Ready || a._retryLoadingNum <= 0) {
            a._contextActivationMgr._ErrorUXHelper.removeProgressDiv(a._div, a._id);
            a._retryLoadingNum = 2;
        } else a._refresh();
    },
    _iframeOnLoad: function() {
        var a = this;
        Telemetry.AppLoadTimeHelper.PageLoaded(this._telemetryContext);
        var b = function(b) {
            var a = null;
            if (b) {
                if (b._contextActivationMgr._ErrorUXHelper) {
                    OSF.OUtil.writeProfilerMark(
                        OSF.OsfControlActivationPerfMarker.SelectionTimeout
                    );
                    b._contextActivationMgr._ErrorUXHelper.removeProgressDiv(b._div, b._id);
                }
                if (b._pageStatus !== OSF.OsfControlPageStatus.Ready) {
                    if (b._retryLoadingNum === 2) {
                        var c = OSF.ErrorStatusCodes.WAC_AgaveActivationError;
                        switch (b._pageStatus) {
                            case OSF.OsfControlPageStatus.FailedOriginCheck:
                                c = OSF.ErrorStatusCodes.WAC_AgaveOriginCheckError;
                                break;
                            case OSF.OsfControlPageStatus.FailedPermissionCheck:
                                c = OSF.ErrorStatusCodes.WAC_AgavePermissionCheckError;
                                break;
                            case OSF.OsfControlPageStatus.FailedHandleRequest:
                                c = OSF.ErrorStatusCodes.WAC_AgaveHostHandleRequestError;
                        }
                        if (
                            b._contextActivationMgr._enableFirstPartySDXErrorMessages &&
                            b.isFirstParty()
                        )
                            b._showActivationError(
                                OSF.OsfControlStatus.ActivationFailed,
                                Strings.OsfRuntime.L_AgaveActivationError_ERR_FirstParty,
                                Strings.OsfRuntime.L_RetryButton_TXT,
                                Function.createDelegate(b, b._retryActivation),
                                a,
                                a,
                                a,
                                a,
                                c
                            );
                        else
                            b._showActivationError(
                                OSF.OsfControlStatus.ActivationFailed,
                                Strings.OsfRuntime.L_AgaveActivationError_ERR,
                                Strings.OsfRuntime.L_RetryButton_TXT,
                                Function.createDelegate(b, b._retryActivation),
                                a,
                                a,
                                a,
                                a,
                                c
                            );
                    } else if (b._retryLoadingNum === 1)
                        if (
                            b._contextActivationMgr._enableFirstPartySDXErrorMessages &&
                            b.isFirstParty()
                        )
                            b._showActivationError(
                                OSF.OsfControlStatus.ActivationFailed,
                                Strings.OsfRuntime.L_ActivateAttempLoading_ERR_FirstParty,
                                Strings.OsfRuntime.L_ActivateButton_TXT,
                                Function.createDelegate(b, b._retryActivation),
                                a,
                                a,
                                a,
                                a,
                                OSF.ErrorStatusCodes.WAC_ActivateAttempLoading
                            );
                        else
                            b._showActivationError(
                                OSF.OsfControlStatus.ActivationFailed,
                                Strings.OsfRuntime.L_ActivateAttempLoading_ERR,
                                Strings.OsfRuntime.L_ActivateButton_TXT,
                                Function.createDelegate(b, b._retryActivation),
                                a,
                                a,
                                a,
                                a,
                                OSF.ErrorStatusCodes.WAC_ActivateAttempLoading
                            );
                } else b._notifyHostIFrameOnLoaded();
                if (b._timer) {
                    window.clearTimeout(b._timer);
                    b._timer = a;
                }
                b._pageIsReadyTimerExpired = true;
            }
        };
        if (a._pageStatus !== OSF.OsfControlPageStatus.Ready)
            a._timer = window.setTimeout(function() {
                b(a);
            }, 5e3 * a._retryLoadingNum + 1);
        else a._notifyHostIFrameOnLoaded();
    },
    _isOsfControlInEmbeddingMode: function(e) {
        var a = false;
        try {
            var d = e.getContainingDiv().parentNode.parentNode,
                c = d.id,
                f = c.match(/^(m_excelEmbedRenderer_|ewaSynd).+$/gi);
            a = f != null;
        } catch (b) {
            OfficeExt.WACUtils.logExceptionToBrowserConsole(
                '_isOsfControlInEmbeddingMode error.',
                b
            );
        }
        return a;
    },
    _createIframeAndActivateOsfControl: function(a) {
        var b = this._createIframeForControl(a);
        this._activate(b, this._iframeUrl);
    },
    _createIframeForControl: function(d) {
        var b = this,
            a = document.createElement('iframe');
        a.setAttribute('id', b._id);
        a.setAttribute('width', '100%');
        a.setAttribute('height', '100%');
        a.setAttribute('frameborder', '0');
        a.setAttribute('allowfullscreen', 'true');
        var c;
        if (b._contextActivationMgr._enableFirstPartySDXErrorMessages && b.isFirstParty())
            c = Strings.OsfRuntime.L_IframeTitle_TXT_FirstParty + ' ' + d;
        else c = Strings.OsfRuntime.L_IframeTitle_TXT + ' ' + d;
        a.setAttribute('title', c);
        a.style.msUserSelect = 'element';
        b._setSandboxAttribute(a);
        for (var e in b._contextActivationMgr._iframeAttributeBag)
            a.setAttribute(e, b._contextActivationMgr._iframeAttributeBag[e]);
        b._frame = a;
        return a;
    },
    _setSandboxAttribute: function(a) {
        a.setAttribute(
            'sandbox',
            'allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox'
        );
        a.setAttribute('allow', 'geolocation;microphone;camera');
    },
    _onGetManifestCompleted: function(e) {
        var b = null,
            f = true,
            a = this;
        if (e.statusCode === OSF.ProxyCallStatusCode.Succeeded && e.value) {
            Telemetry.AppLoadTimeHelper.ManifestRequestEnd(a._telemetryContext);
            Telemetry.AppLoadTimeHelper.ServerCallEnd(a._telemetryContext);
            var c = e.value,
                d = e.context,
                h = d.referenceInUse,
                g = h.storeType,
                k = c.getDefaultDisplayName();
            a._manifest = c;
            if (d.manifestCached && !d.retried) {
                var l = c.getMarketplaceVersion();
                if (a._lessThan(l, h.version))
                    if (g === OSF.StoreType.SPApp) {
                        a._refresh({
                            clearCache: f,
                            referenceInUse: h,
                            osfControl: d.osfControl,
                            retried: f,
                        });
                        return;
                    }
            }
            if (
                c.requirementsSupported === false ||
                (c.requirementsSupported === undefined &&
                    !a._contextActivationMgr.getRequirementsChecker().isManifestSupported(c))
            ) {
                c.requirementsSupported = false;
                var j,
                    i,
                    m = b;
                j =
                    Strings.OsfRuntime.L_AgaveManifestRequirementsError_ERR ||
                    Strings.OsfRuntime.L_AgaveManifestError_ERR;
                i = OSF.ErrorStatusCodes.WAC_AgaveRequirementsError;
                a._showActivationError(
                    OSF.OsfControlStatus.ActivationFailed,
                    j,
                    b,
                    b,
                    m,
                    b,
                    b,
                    f,
                    i
                );
                return;
            }
            c.requirementsSupported = f;
            a._iframeUrl = c.getDefaultSourceLocation(a._contextActivationMgr.getFormFactor());
            g === OSF.StoreType.Sdx && a._iframeUrl && a.updateUrlsForSdxBundle();
            a._permission = c.getPermission();
            a._appDomains = c.getAppDomains();
            if (g === OSF.StoreType.SPApp && a._iframeUrl) {
                if (d.clientId) a._iframeUrl = a._iframeUrl.replace(/~clientid/gi, d.clientId);
                if (d.appWebUrl) a._iframeUrl = a._iframeUrl.replace(/~appweburl/gi, d.appWebUrl);
                if (d.remoteAppUrl)
                    a._iframeUrl = a._iframeUrl.replace(/~remoteappurl/gi, d.remoteAppUrl);
            }
            if (!a._contextActivationMgr._doesUrlHaveSupportedProtocol(a._iframeUrl)) {
                a._showActivationError(
                    OSF.OsfControlStatus.ActivationFailed,
                    Strings.OsfRuntime.L_AgaveManifestError_ERR,
                    b,
                    b,
                    b,
                    b,
                    b,
                    b,
                    OSF.ErrorStatusCodes.E_MANIFEST_INVALID_VALUE_FORMAT
                );
                return;
            }
            a.processManifestForCustomFunctions(c);
            if (!a._isvirtualOsfControl) a._createIframeAndActivateOsfControl(k);
            else !d.showNewerVersion && a.invokeVirtualOsfControlActivationCallback(c);
        } else {
            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                'GetManifest failed:' + OfficeExt.WACUtils.serializeObjectToString(e),
                b,
                b,
                18420422
            );
            a._showActivationError(
                OSF.OsfControlStatus.ActivationFailed,
                Strings.OsfRuntime.L_AgaveManifestRetrieve_ERR,
                Strings.OsfRuntime.L_RetryButton_TXT,
                Function.createDelegate(a, a._refresh),
                b,
                b,
                b,
                b,
                OSF.ErrorStatusCodes.E_MANIFEST_SERVER_UNAVAILABLE
            );
        }
    },
    isCustomFunctionSandbox: function() {
        var a = this;
        if (typeof a._settings == 'object' && typeof a._settings.length == 'number')
            for (var b = 0; b < a._settings.length; b++)
                if (
                    typeof a._settings[b] == 'object' &&
                    typeof a._settings[b].length == 'number' &&
                    typeof a._settings[b][0] == 'string' &&
                    typeof a._settings[b][1] == 'string' &&
                    a._settings[b][0].toLowerCase() == 'customfunctionaddinid'
                )
                    return true;
        return false;
    },
    processManifestForCustomFunctions: function(b) {
        var a = this,
            g = a;
        if (a._isManifestProcessedForCustomFunctions && !a._isUpgrading) return;
        a._isManifestProcessedForCustomFunctions = true;
        if (
            a.getReason() !== Microsoft.Office.WebExtension.InitializationReason.Inserted &&
            a.getReason() !== Microsoft.Office.WebExtension.InitializationReason.DocumentOpened
        )
            return;
        if (!b.containsCustomFunctionsForAppHost(a._contextActivationMgr._hostType)) return;
        var i = OSF.getManifestHostType(a._contextActivationMgr._hostType),
            j = a._contextActivationMgr.getFormFactor(),
            e = new OfficeExt.Parser.ParsingContext(i, j, null, b),
            m = new OfficeExt.Parser.AddinCommandsManifestParser(i, j),
            l = {
                assetId: a._marketplaceID,
                appVersion: a._marketplaceVersion,
                storeType: a._storeType,
                storeId: a._storeLocator,
                targetType: null,
            },
            k = {
                setErrorMessageForAddin: function(b, a) {
                    OsfMsAjaxFactory.msAjaxDebug.trace('Error parsing app manifest: ' + a);
                },
            },
            c = m.parseExtensions(l, b, k);
        if (typeof c.ExtensionPoints !== 'object' || typeof c.ExtensionPoints.length !== 'number')
            return;
        for (var d = 0; d < c.ExtensionPoints.length; d++) {
            if (c.ExtensionPoints[d].type !== 'CustomFunctions') continue;
            var f = c.ExtensionPoints[d],
                h = function() {
                    var a = {
                        osfControl: g,
                        namespace: e.resources.ShortStrings[f.namespaceResId],
                        metadataUrl: e.resources.Urls[f.metadataResId],
                        manifest: b._xmlProcessor.getNodeXml(b._xmlProcessor.getDocumentElement()),
                    };
                    g._contextActivationMgr._notifyHost(
                        g._id,
                        OSF.AgaveHostAction.InstallCustomFunctions,
                        a
                    );
                };
            if (a.isCustomFunctionSandbox()) {
                a._iframeUrl = e.resources.Urls[f.pageResId];
                a._isUpgrading && h();
            } else h();
            break;
        }
    },
    setIsUpgrading: function(a) {
        this._isUpgrading = a;
    },
    getIsUpgrading: function() {
        return this._isUpgrading;
    },
    updateUrlsForSdxBundle: function(c) {
        var a = this;
        if (a._contextActivationMgr._enableServiceDeliveredExperience) {
            var b = '.js',
                d =
                    a._iframeUrl.substr(a._iframeUrl.length - b.length, b.length).toLowerCase() ===
                    b;
            if (d) {
                a._bundleUrl = a._iframeUrl;
                a._iframeUrl = c != null ? c : a._sdxIframeTemplateUrl;
            }
        }
    },
    _lessThan: function(a, b) {
        return OSF.OsfManifestManager.versionLessThan(a, b);
    },
    _showTrustError: function(q, d, g, m, s, k, n, e) {
        var c = true,
            b = null,
            a = this,
            h = OSF.OUtil.formatString(Strings.OsfRuntime.L_AgaveName_INFO, d ? d : '');
        h = a._contextActivationMgr._ErrorUXHelper.getHTMLEncodedString(h);
        var f = OSF.OUtil.formatString(Strings.OsfRuntime.L_AgaveProvider_INFO, g ? g : '');
        f = a._contextActivationMgr._ErrorUXHelper.getHTMLEncodedString(f);
        var i = OSF.OUtil.formatString(Strings.OsfRuntime.L_AgaveUntrusted_INFO, h, f);
        e = e == undefined ? (a.getManifest() ? a.getManifest().isSSOAddin() : false) : e;
        var l = Strings.OsfRuntime.L_ActivateButton_TXT,
            j = OSF.NotificationType.TrustYellowBar,
            r = Strings.OsfRuntime.L_AgaveNewAppTitle_TXT,
            p =
                e && a._storeType === OSF.StoreType.OMEX
                    ? a._contextActivationMgr.getOmexIframeNotificationUrl(
                          a._id,
                          OSF.NotificationType.TrustYellowBar
                      )
                    : b,
            o = a._contextActivationMgr._enableNewTrustPromptForAddIn;
        if (o) {
            i = Strings.OsfRuntime.L_AgaveTrustAddIn_INFO;
            l = Strings.OsfRuntime.L_TrustButton_TXT;
            j =
                a._osfControlType === OSF.OsfControlType.DocumentLevel
                    ? OSF.NotificationType.TrustPromptContent
                    : OSF.NotificationType.TrustPromptTaskpane;
        }
        a._retryActivate = k;
        a._contextActivationMgr.displayNotification({
            id: a._id,
            infoType: OSF.InfoType.SecurityInfo,
            clientName: q,
            name: d ? d : b,
            provider: g,
            title: r,
            description: i,
            icon: m ? m : b,
            buttonTxt: l,
            buttonCallback: k,
            url: n ? n : b,
            dismissCallback: b,
            reDisplay: c,
            displayDeactive: c,
            logAsError: c,
            retryAll: c,
            errorCode: OSF.ErrorStatusCodes.E_TRUSTCENTER_MOE_UNACTIVATED,
            iframeNotificationUrl: p,
            notificationType: j,
        });
    },
    showConsentError: function(c, b, d) {
        var a = this;
        a._retryActivate = c;
        a._contextActivationMgr.displayNotification({
            id: a._id,
            infoType: OSF.InfoType.SecurityInfo,
            title: '',
            description: '',
            icon: null,
            buttonCallback: c,
            dismissCallback: null,
            reDisplay: true,
            displayDeactive: false,
            retryAll: true,
            errorCode: OSF.ErrorStatusCodes.WAC_SSOAddinRequireConsent,
            iframeNotificationUrl: a._contextActivationMgr.getOmexIframeNotificationUrl(
                a._id,
                b,
                d
            ),
            notificationType: b,
        });
    },
    _showActivationError: function(g, l, k, h, m, d, i, j, f) {
        var e = false,
            b = true,
            a = null,
            c = this;
        c._status = g;
        if (c._contextActivationMgr._enableFirstPartySDXErrorMessages && c.isFirstParty())
            var n = {
                id: c._id,
                infoType: OSF.InfoType.Error,
                status: g,
                title: i || Strings.OsfRuntime.L_AgaveErrorTile_TXT_FirstParty,
                description: l,
                icon: a,
                buttonTxt: k || Strings.OsfRuntime.L_OkButton_TXT,
                buttonCallback: h || a,
                url: m || a,
                dismissCallback: d || a,
                reDisplay: !d ? b : e,
                displayDeactive: b,
                detailView: j ? b : e,
                logAsError: b,
                errorCode: f ? f : 0,
            };
        else
            var n = {
                id: c._id,
                infoType: OSF.InfoType.Error,
                status: g,
                title: i || Strings.OsfRuntime.L_AgaveErrorTile_TXT,
                description: l,
                icon: a,
                buttonTxt: k || Strings.OsfRuntime.L_OkButton_TXT,
                buttonCallback: h || a,
                url: m || a,
                dismissCallback: d || a,
                reDisplay: !d ? b : e,
                displayDeactive: b,
                detailView: j ? b : e,
                logAsError: b,
                errorCode: f ? f : 0,
            };
        c._contextActivationMgr.displayNotification(n);
        c._contextActivationMgr.raiseOsfControlStatusChange(c);
    },
    _showActivationWarning: function(f, i, h, g, j, d, e) {
        var c = true,
            a = null,
            b = this;
        b._status = f;
        if (b._contextActivationMgr._enableFirstPartySDXErrorMessages && b.isFirstParty())
            var k = {
                id: b._id,
                infoType: OSF.InfoType.Warning,
                status: f,
                title: Strings.OsfRuntime.L_AgaveWarningTitle_TXT_FirstParty,
                description: i,
                icon: a,
                buttonTxt: h || Strings.OsfRuntime.L_OkButton_TXT,
                buttonCallback: g || a,
                url: j || a,
                dismissCallback: d || a,
                reDisplay: !d ? c : false,
                displayDeactive: c,
                logAsError: c,
                errorCode: e ? e : 0,
            };
        else
            var k = {
                id: b._id,
                infoType: OSF.InfoType.Warning,
                status: f,
                title: Strings.OsfRuntime.L_AgaveWarningTitle_TXT,
                description: i,
                icon: a,
                buttonTxt: h || Strings.OsfRuntime.L_OkButton_TXT,
                buttonCallback: g || a,
                url: j || a,
                dismissCallback: d || a,
                reDisplay: !d ? c : false,
                displayDeactive: c,
                logAsError: c,
                errorCode: e ? e : 0,
            };
        b._contextActivationMgr.displayNotification(k);
        b._contextActivationMgr.raiseOsfControlStatusChange(b);
    },
    _refresh: function(a) {
        this.deActivate();
        this.activate(a);
    },
    _activateAgavesBlockedBySandboxNotSupport: function(b) {
        b.activateAgavesBlockedBySandboxNotSupport();
        var a = OSF.OUtil.getLocalStorage();
        a && a.setItem(OSF.Constants.IgnoreSandBoxSupport, 'true');
    },
    _setCachedFlag: function(a) {
        this._contextActivationMgr._setCachedFlag(a);
    },
    _getCachedFlag: function(a) {
        return this._contextActivationMgr._getCachedFlag(a);
    },
    _deleteCachedFlag: function(a) {
        this._contextActivationMgr._deleteCachedFlag(a);
    },
    _notifyHostIFrameOnLoaded: function() {
        this._contextActivationMgr._notifyHost &&
            this._contextActivationMgr._notifyHost(this._id, OSF.AgaveHostAction.PageIsReady);
    },
    _addETokenAsQueryParameter: function(e) {
        var a = document.createElement('a');
        a.href = e;
        var f = this.getEToken(),
            b =
                OSF.Constants.ETokenParameterName +
                '=' +
                encodeURIComponent(OSF.OUtil.encodeBase64(f)),
            d = a.search.length > 1 ? a.search.substr(1) + '&' : '';
        a.search = d + b;
        var c = a.href;
        a = null;
        return c;
    },
    _activate: function(b, c) {
        var a = this;
        Telemetry.AppLoadTimeHelper.PageStart(a._telemetryContext);
        a._setIframeAttribute(b, c);
        a._pageIsReadyTimerExpired = false;
        OSF.OUtil.addEventListener(b, 'load', a._iframeOnLoadDelegate);
        a._div.appendChild(b);
        a._status = OSF.OsfControlStatus.Activated;
        OSF.OUtil.writeProfilerMark(OSF.OsfControlActivationPerfMarker.ActivationEnd);
        a._contextActivationMgr.raiseOsfControlStatusChange(a);
        Telemetry.AppLoadTimeHelper.OfficeJSStartToLoad(a._telemetryContext);
    },
    _setIframeAttribute: function(f, c) {
        var a = this;
        c = a._addETokenAsQueryParameter(c);
        var l =
                a._contextActivationMgr.getClientId() +
                '_' +
                a._contextActivationMgr.getDocUrl() +
                '_' +
                a._id,
            j = OSF.OUtil.getFrameName(l);
        a._conversationId = OSF.OUtil.generateConversationId();
        var k = [
                a._contextActivationMgr._hostType,
                a._contextActivationMgr._hostPlatform,
                a._contextActivationMgr._hostSpecificFileVersion,
                a._contextActivationMgr._appUILocale,
                a.getCorrelationId(),
                a._isDialog ? 'isDialog' : null,
                a._contextActivationMgr._disableLogging ? 'disableLogging' : null,
            ],
            m = k.join('|'),
            e = c,
            d = window.location.href,
            n =
                a._conversationId +
                '|' +
                a._id +
                '|' +
                (d.indexOf('$') >= 0 ? encodeURIComponent(d) : d),
            b = {};
        b[OSF.WindowNameItemKeys.BaseFrameName] = j;
        b[OSF.WindowNameItemKeys.HostInfo] = m;
        b[OSF.WindowNameItemKeys.XdmInfo] = n;
        b[OSF.WindowNameItemKeys.SerializerVersion] = OSF.SerializerVersion.Browser;
        var i = OSF.OUtil.getLocalStorage();
        if (i) {
            var h = 'CustomFunctionsRuntimeLogging',
                g = i.getItem(h);
            if (g) b[h] = g;
        }
        a._contextActivationMgr
            ._getServiceEndPoint()
            .registerConversation(a._conversationId, e, a._appDomains);
        f.setAttribute('src', e);
        a._agaveWindowName = OfficeExt.WACUtils.serializeObjectToString(b);
        f.setAttribute('name', a._agaveWindowName);
        OSF.OUtil.addClass(f, 'AddinIframe');
        a._agavePageUrl = e;
    },
    _getConversationId: function() {
        return this._conversationId;
    },
    _doesBrowserSupportRequiredFeatures: function() {
        var a = false;
        if (Object.defineProperty)
            try {
                Object.defineProperty({}, 'myTestProperty', {
                    get: function() {
                        return this.desc;
                    },
                    set: function(a) {
                        this.desc = a;
                    },
                });
                a = true;
            } catch (b) {}
        return a;
    },
    _isAddinCommands: function(b) {
        var a = this;
        if (a._isvirtualOsfControl) b(true);
        else if (
            a._contextActivationMgr._enableAddinCommands &&
            a._contextActivationMgr._enableTaskpaneUpgradeToAppCommand &&
            a._virtualOsfControlActivationCallback != null
        ) {
            var c = {
                marketplaceId: a._marketplaceID,
                marketplaceVersion: a._marketplaceVersion,
                storeType: a._storeType,
                storeId: a._storeLocator,
                targetData: {},
            };
            a._contextActivationMgr.isAddinCommandsAsync(c, function(d, a) {
                b(a);
            });
        } else b(false);
    },
};
OSF.OUtil.setNamespace('Manifest', OSF);
OSF.Manifest.HostApp = function(a) {
    this._appName = a;
    this._minVersion = null;
};
OSF.Manifest.HostApp.prototype = {
    getAppName: function() {
        return this._appName;
    },
    getMinVersion: function() {
        return this._minVersion;
    },
    _setMinVersion: function(a) {
        this._minVersion = a;
    },
};
OSF.Manifest.ExtensionSettings = function() {
    this._sourceLocations = {};
    this._defaultHeight = null;
    this._defaultWidth = null;
};
OSF.Manifest.ExtensionSettings.prototype = {
    getDefaultHeight: function() {
        return this._defaultHeight;
    },
    getDefaultWidth: function() {
        return this._defaultWidth;
    },
    getSourceLocations: function() {
        return this._sourceLocations;
    },
    _addSourceLocation: function(a, b) {
        this._sourceLocations[a.toLocaleLowerCase()] = b;
    },
    _setDefaultWidth: function(a) {
        this._defaultWidth = a;
    },
    _setDefaultHeight: function(a) {
        this._defaultHeight = a;
    },
};
OSF.Manifest.WebAppInfoAuthorization = function() {
    this._resource = null;
    this._scopes = null;
};
OSF.Manifest.WebAppInfoAuthorization.prototype = {
    getResource: function() {
        return this._resource;
    },
    getScopes: function() {
        return this._scopes;
    },
};
OSF.Manifest.Manifest = function(g, q) {
    var j = 'o:OfficeApp',
        f = '1.1',
        a = this;
    a._UILocale = q || 'en-us';
    if (typeof g !== 'string') {
        g(a);
        return;
    }
    a._displayNames = {};
    a._descriptions = {};
    a._iconUrls = {};
    a._extensionSettings = {};
    a._highResolutionIconUrls = {};
    var h;
    a._xmlProcessor = new OSF.XmlProcessor(g, OSF.ManifestNamespaces[f]);
    if (a._xmlProcessor.selectSingleNode(j)) {
        h = l;
        a._manifestSchemaVersion = OSF.ManifestSchemaVersion[f];
    } else {
        a._xmlProcessor = new OSF.XmlProcessor(g, OSF.ManifestNamespaces['1.0']);
        h = k;
        a._manifestSchemaVersion = OSF.ManifestSchemaVersion['1.0'];
    }
    var b = a._xmlProcessor.getDocumentElement();
    a._target = OSF.OUtil.parseEnum(b.getAttribute('xsi:type'), OSF.OfficeAppType);
    var c = a._xmlProcessor.selectSingleNode(j);
    b = a._xmlProcessor.selectSingleNode('o:Id', c);
    a._id = a._xmlProcessor.getNodeValue(b);
    var p = new RegExp('^[a-f0-9]{8}(-[a-f0-9]{4}){3}-[a-f0-9]{12}$', 'i');
    if (!p.test(a._id)) throw OsfMsAjaxFactory.msAjaxError.argument('Manifest');
    b = a._xmlProcessor.selectSingleNode('o:Version', c);
    a._version = a._xmlProcessor.getNodeValue(b);
    b = a._xmlProcessor.selectSingleNode('o:ProviderName', c);
    a._providerName = a._xmlProcessor.getNodeValue(b);
    b = a._xmlProcessor.selectSingleNode('o:IdIssuer', c);
    a._idIssuer = a._parseIdIssuer(b);
    b = a._xmlProcessor.selectSingleNode('o:AlternateId', c);
    if (b) a._alternateId = a._xmlProcessor.getNodeValue(b);
    b = a._xmlProcessor.selectSingleNode('o:DefaultLocale', c);
    a._defaultLocale = a._xmlProcessor.getNodeValue(b);
    b = a._xmlProcessor.selectSingleNode('o:DisplayName', c);
    a._parseLocaleAwareSettings(b, Function.createDelegate(a, a._addDisplayName));
    b = a._xmlProcessor.selectSingleNode('o:Description', c);
    a._parseLocaleAwareSettings(b, Function.createDelegate(a, a._addDescription));
    b = a._xmlProcessor.selectSingleNode('o:AppDomains', c);
    a._appDomains = a._parseAppDomains(b);
    b = a._xmlProcessor.selectSingleNode('o:IconUrl', c);
    b && a._parseLocaleAwareSettings(b, Function.createDelegate(a, a._addIconUrl));
    b = a._xmlProcessor.selectSingleNode('o:Signature', c);
    if (b) a._signature = a._xmlProcessor.getNodeValue(b);
    a._parseExtensionSettings();
    b = a._xmlProcessor.selectSingleNode('o:Permissions', c);
    a._permissions = a._parsePermission(b);
    a._allowSnapshot = true;
    b = a._xmlProcessor.selectSingleNode('o:AllowSnapshot', c);
    if (b) a._allowSnapshot = a._parseBooleanNode(b);
    if (a._manifestSchemaVersion === OSF.ManifestSchemaVersion[f]) {
        var d = 'ov:';
        if (a._target == OSF.OfficeAppType.ContentApp) d = 'c:';
        b = a._xmlProcessor.selectSingleNode(d + 'VersionOverrides', c);
        if (b) {
            var e = a._xmlProcessor.selectSingleNode(d + 'WebApplicationInfo', b);
            if (e) {
                var m = a._xmlProcessor.selectSingleNode(d + 'Resource', e);
                a._webApplicationResource = a._xmlProcessor.getNodeValue(m);
                var o = a._xmlProcessor.selectSingleNode(d + 'Id', e);
                a._webApplicationId = a._xmlProcessor.getNodeValue(o);
                var n = a._xmlProcessor.selectSingleNode(d + 'Scopes', e);
                a._webApplicationScopes = a._parseWebApplicationScopes(n, d);
                a._webApplicationAuthorizations = a._parseWebAppInfoAuthorizations(e, d);
            }
        }
    }
    if (a._manifestSchemaVersion === OSF.ManifestSchemaVersion[f]) {
        var i = a._xmlProcessor.selectSingleNode('ov:VersionOverrides', c);
        if (i) a._manifestSourceLocationOverrides = a._parseSourceLocationOverrides(i);
    }
    h.apply(a);
    function k() {
        var a = this,
            d = a._xmlProcessor.selectSingleNode('o:Capabilities', c),
            b = a._xmlProcessor.selectNodes('o:Capability', d);
        a._capabilities = a._parseCapabilities(b);
    }
    function l() {
        var a = this,
            b = a._xmlProcessor.selectSingleNode('o:Hosts', c);
        a._hosts = a._parseHosts(b);
        if (b) a._hostsXml = b.xml || b.outerHTML;
        b = a._xmlProcessor.selectSingleNode('o:Requirements', c);
        a._requirements = a._parseRequirements(b);
        if (b) a._requirementsXml = b.xml || b.outerHTML;
        b = a._xmlProcessor.selectSingleNode('o:HighResolutionIconUrl', c);
        b &&
            a._parseLocaleAwareSettings(b, Function.createDelegate(a, a._addHighResolutionIconUrl));
    }
};
OSF.Manifest.Manifest.prototype = {
    getSourceLocationOverrideByResourceId: function(a) {
        if (a && this._manifestSourceLocationOverrides)
            return this._manifestSourceLocationOverrides[a];
        return null;
    },
    getManifestSchemaVersion: function() {
        return this._manifestSchemaVersion;
    },
    getMarketplaceID: function() {
        return this._id;
    },
    getMarketplaceVersion: function() {
        return this._version;
    },
    getDefaultLocale: function() {
        return this._defaultLocale;
    },
    getProviderName: function() {
        return this._providerName;
    },
    getIdIssuer: function() {
        return this._idIssuer;
    },
    getAlternateId: function() {
        return this._alternateId;
    },
    getSignature: function() {
        return this._signature;
    },
    getCapabilities: function() {
        return this._capabilities;
    },
    getDisplayName: function(a) {
        return this._displayNames[a.toLocaleLowerCase()];
    },
    getDefaultDisplayName: function() {
        return this._getDefaultValue(this._displayNames);
    },
    getDescription: function(a) {
        return this._descriptions[a];
    },
    getDefaultDescription: function() {
        return this._getDefaultValue(this._descriptions);
    },
    getIconUrl: function(a) {
        return this._iconUrls[a];
    },
    getDefaultIconUrl: function() {
        return this._getDefaultValue(this._iconUrls);
    },
    getSourceLocation: function(d, c) {
        var a = this._getExtensionSetting(c),
            b = a.getSourceLocations();
        return b[d.toLocaleLowerCase()];
    },
    getDefaultSourceLocation: function(c) {
        var a = this._getExtensionSetting(c),
            b = a.getSourceLocations();
        return this._getDefaultValue(b);
    },
    getDefaultWidth: function(b) {
        var a = this._getExtensionSetting(b);
        return a.getDefaultWidth();
    },
    getDefaultHeight: function(b) {
        var a = this._getExtensionSetting(b);
        return a.getDefaultHeight();
    },
    getTarget: function() {
        return this._target;
    },
    getOmexTargetCode: function() {
        switch (this._target) {
            case OSF.OfficeAppType.ContentApp:
                return 2;
            case OSF.OfficeAppType.TaskPaneApp:
                return 1;
            case OSF.OfficeAppType.MailApp:
                return 3;
            default:
                return 0;
        }
    },
    getPermission: function() {
        return this._permissions;
    },
    hasPermission: function(a) {
        return (this._permissions & a) === a;
    },
    getHosts: function() {
        return this._hosts;
    },
    getHostsXml: function() {
        return this._hostsXml;
    },
    getRequirements: function() {
        return this._requirements;
    },
    getRequirementsXml: function() {
        return this._requirementsXml;
    },
    getHighResolutionIconUrl: function(a) {
        return this._highResolutionIconUrls[a];
    },
    getDefaultHighResolutionIconUrl: function() {
        return this._getDefaultValue(this._highResolutionIconUrls);
    },
    getAppDomains: function() {
        return this._appDomains;
    },
    getInMemoryEToken: function() {
        return this._inMemoryEToken;
    },
    isAllowSnapshot: function() {
        return this._allowSnapshot;
    },
    addManifestUrl: function(b) {
        var a = OfficeExt.WACUtils.getDomainForUrl(b);
        this._appDomains.indexOf(a) === -1 && this._appDomains.push(a);
    },
    getWebApplicationResource: function() {
        return this._webApplicationResource;
    },
    getWebApplicationId: function() {
        return this._webApplicationId;
    },
    getWebApplicationScopes: function() {
        return this._webApplicationScopes;
    },
    getWebApplicationAuthorizations: function() {
        return this._webApplicationAuthorizations;
    },
    isSSOAddin: function() {
        return !!this._webApplicationResource && !!this._webApplicationId;
    },
    containsAddinCommands: function(b) {
        var a = this._getCurrentHostTypeNode(b);
        if (a !== null) {
            var c = this._xmlProcessor.selectSingleNode('ov:DesktopFormFactor', a);
            if (c != null) return true;
        }
        return false;
    },
    containsCustomFunctions: function(f) {
        var d = this._getCurrentHostTypeNode(f);
        if (d !== null) {
            var c = this._xmlProcessor.selectSingleNode('ov:AllFormFactors', d);
            if (c !== null) {
                var a = this._xmlProcessor.selectNodes('ov:ExtensionPoint', c);
                if (a !== null)
                    for (var g = a.length, b = 0; b < g; b++) {
                        var e = a[b].getAttribute('xsi:type');
                        if (e === 'CustomFunctions') return true;
                    }
            }
        }
        return false;
    },
    containsCustomFunctionsForAppHost: function(a) {
        var b = OSF.getManifestHostType(a);
        return a != OSF.HostType.Outlook && this.containsCustomFunctions(b);
    },
    _getDefaultValue: function(c) {
        var b = this,
            a;
        if (b._UILocale) a = c[b._UILocale] || c[b._UILocale.toLocaleLowerCase()] || undefined;
        if (!a && b._defaultLocale)
            a = c[b._defaultLocale] || c[b._defaultLocale.toLocaleLowerCase()] || undefined;
        if (!a) {
            var d;
            for (var e in c) {
                d = e;
                break;
            }
            a = c[d];
        }
        return a;
    },
    _getExtensionSetting: function(c) {
        var a = this,
            b;
        if (typeof a._extensionSettings[c] != 'undefined') b = a._extensionSettings[c];
        else
            for (var d in a._extensionSettings) {
                b = a._extensionSettings[d];
                break;
            }
        return b;
    },
    _addDisplayName: function(a, b) {
        this._displayNames[a.toLocaleLowerCase()] = b;
    },
    _addDescription: function(a, b) {
        this._descriptions[a] = b;
    },
    _addIconUrl: function(a, b) {
        this._iconUrls[a] = b;
    },
    _parseLocaleAwareSettings: function(a, d) {
        if (!a) throw OsfMsAjaxFactory.msAjaxError.argument('Manifest');
        var f = a.getAttribute('DefaultValue');
        d(this._defaultLocale, f);
        var b = this._xmlProcessor.selectNodes('o:Override', a);
        if (b)
            for (var i = b.length, c = 0; c < i; c++) {
                var e = b[c],
                    g = e.getAttribute('Locale'),
                    h = e.getAttribute('Value');
                d(g, h);
            }
    },
    _parseBooleanNode: function(b) {
        if (!b) return false;
        else {
            var a = this._xmlProcessor.getNodeValue(b).toLowerCase();
            return a === 'true' || a === '1';
        }
    },
    _parseIdIssuer: function(a) {
        if (!a) return OSF.ManifestIdIssuer.Custom;
        else {
            var b = this._xmlProcessor.getNodeValue(a);
            return OSF.OUtil.parseEnum(b, OSF.ManifestIdIssuer);
        }
    },
    _parseCapabilities: function(d) {
        for (var c = [], a, b = 0; b < d.length; b++) {
            var e = d[b];
            a = e.getAttribute('Name');
            a = OSF.OUtil.parseEnum(a, OSF.Capability);
            c.push(a);
        }
        return c;
    },
    _parsePermission: function(a) {
        if (!a) throw OsfMsAjaxFactory.msAjaxError.argument('Manifest');
        var b = this._xmlProcessor.getNodeValue(a);
        return OSF.OUtil.parseEnum(b, OSF.OsfControlPermission);
    },
    _parseExtensionSettings: function() {
        var a = this,
            h = a,
            c,
            d,
            b;
        for (var e in OSF.FormFactor) {
            var g = a._xmlProcessor.selectSingleNode('o:OfficeApp');
            d = a._xmlProcessor.selectSingleNode('o:' + OSF.FormFactor[e], g);
            if (d) {
                c = new OSF.Manifest.ExtensionSettings();
                b = a._xmlProcessor.selectSingleNode('o:SourceLocation', d);
                var f = function(b, a) {
                    c._addSourceLocation(b, a);
                    h.addManifestUrl(a);
                };
                a._parseLocaleAwareSettings(b, f);
                b = a._xmlProcessor.selectSingleNode('o:RequestedWidth', d);
                b && c._setDefaultWidth(a._xmlProcessor.getNodeValue(b));
                b = a._xmlProcessor.selectSingleNode('o:RequestedHeight', d);
                b && c._setDefaultHeight(a._xmlProcessor.getNodeValue(b));
                a._extensionSettings[e] = c;
            }
        }
        if (!c) throw OsfMsAjaxFactory.msAjaxError.argument('Manifest');
    },
    _parseHosts: function(d) {
        var b = [];
        if (d)
            for (var c = this._xmlProcessor.selectNodes('o:Host', d), a = 0; a < c.length; a++)
                b.push(c[a].getAttribute('Name'));
        return b;
    },
    _parseWebApplicationScopes: function(b, e) {
        var d = [];
        if (b)
            for (var c = this._xmlProcessor.selectNodes(e + 'Scope', b), a = 0; a < c.length; a++)
                d.push(this._xmlProcessor.getNodeValue(c[a]));
        return d;
    },
    _parseWebAppInfoAuthorizations: function(l, b) {
        var a = this,
            g = [],
            f = a._xmlProcessor.selectSingleNode(b + 'Authorizations', l);
        if (f) {
            var c = a._xmlProcessor.selectNodes(b + 'Authorization', f);
            if (c)
                for (var n in c) {
                    var j = c[n],
                        d = new OSF.Manifest.WebAppInfoAuthorization(),
                        h = a._xmlProcessor.selectSingleNode(b + 'Resource', j);
                    if (h) d._resource = a._xmlProcessor.getNodeValue(h);
                    var i = a._xmlProcessor.selectSingleNode(b + 'Scopes', j);
                    if (i) {
                        var e = a._xmlProcessor.selectNodes(b + 'Scope', i);
                        if (e) {
                            var k = [];
                            for (var m in e) {
                                var o = e[m];
                                k.push(a._xmlProcessor.getNodeValue(o));
                            }
                            d._scopes = k;
                        }
                    }
                    g.push(d);
                }
        }
        return g;
    },
    _parseRequirements: function(b) {
        var a = this,
            c = { sets: [], methods: [] };
        if (b) {
            var e = a._xmlProcessor.selectSingleNode('o:Sets', b);
            c.sets = a._parseSets(e);
            var d = a._xmlProcessor.selectSingleNode('o:Methods', b);
            c.methods = a._parseMethods(d);
        }
        return c;
    },
    _parseSets: function(a) {
        var e = [];
        if (a)
            for (
                var g = a.getAttribute('DefaultMinVersion'),
                    c = this._xmlProcessor.selectNodes('o:Set', a),
                    b = 0;
                b < c.length;
                b++
            ) {
                var d = c[b],
                    f = d.getAttribute('MinVersion');
                e.push({ name: d.getAttribute('Name'), version: f || g });
            }
        return e;
    },
    _parseMethods: function(c) {
        var d = [];
        if (c)
            for (var b = this._xmlProcessor.selectNodes('o:Method', c), a = 0; a < b.length; a++)
                d.push(b[a].getAttribute('Name'));
        return d;
    },
    _parseSourceLocationOverrides: function(e) {
        var c = {};
        if (e) {
            var f = this._xmlProcessor.selectSingleNode('ov:Resources', e);
            if (f) {
                var g = this._xmlProcessor.selectSingleNode('bt:Urls', f);
                if (g) {
                    var a = this._xmlProcessor.selectNodes('bt:Url', g);
                    if (a)
                        for (var b = 0; b < a.length; b++) {
                            var h = a[b],
                                i = h.getAttribute('id'),
                                d = h.getAttribute('DefaultValue');
                            if (i && d) c[i] = d;
                        }
                }
            }
        }
        return c;
    },
    _parseAppDomains: function(d) {
        var a = [];
        if (d)
            for (
                var c = this._xmlProcessor.selectNodes('o:AppDomain', d), b = 0;
                b < c.length;
                b++
            ) {
                var e = OfficeExt.WACUtils.getDomainForUrl(this._xmlProcessor.getNodeValue(c[b]));
                a.indexOf(e) === -1 && a.push(e);
            }
        return a;
    },
    _addHighResolutionIconUrl: function(a, b) {
        this._highResolutionIconUrls[a] = b;
    },
    _isAddinCommandsManifest: function(a) {
        return this.containsAddinCommands(a) || this.containsCustomFunctions(a);
    },
    _getCurrentHostTypeNode: function(h) {
        var a = null,
            b = this,
            e = b._xmlProcessor.selectSingleNode('o:OfficeApp');
        if (e !== a && b.getManifestSchemaVersion() === OSF.ManifestSchemaVersion['1.1']) {
            var f = b._xmlProcessor.selectSingleNode('ov:VersionOverrides', e);
            if (f !== a) {
                var g = b._xmlProcessor.selectSingleNode('ov:Hosts', f);
                if (g !== a) {
                    var c = b._xmlProcessor.selectNodes('ov:Host', g);
                    if (c !== a)
                        for (var j = c.length, d = 0; d < j; d++) {
                            var i = c[d].getAttribute('xsi:type');
                            if (i === h) return c[d];
                        }
                }
            }
        }
        return a;
    },
};
OSF.OsfManifestManager = (function() {
    var h = 'undefined',
        e = 'marketplaceVersion',
        d = 'marketplaceID',
        b = null,
        c = true,
        a = false,
        f = {},
        i = 'en-us',
        j = {};
    function g(b, a) {
        return b + '_' + a;
    }
    return {
        getManifestAsync: function(d, h) {
            OSF.OUtil.validateParamObject(
                d,
                {
                    osfControl: { type: Object, mayBeNull: a },
                    referenceInUse: { type: Object, mayBeNull: a },
                },
                h
            );
            var e = d.referenceInUse,
                k = g(e.id, e.version),
                i = f[k];
            d.manifestCached = a;
            if (i) {
                d.manifestCached = c;
                h({ statusCode: OSF.ProxyCallStatusCode.Succeeded, value: i, context: d });
            } else if (d.clientEndPoint && d.manifestUrl) {
                Telemetry.AppLoadTimeHelper.ManifestRequestStart(d.osfControl._telemetryContext);
                var j = function(a) {
                        if (a.statusCode === OSF.ProxyCallStatusCode.Succeeded && a.value) {
                            var d;
                            try {
                                d = a.context.osfControl;
                                var f;
                                if (typeof a.value === 'string') {
                                    a.context.manifestCached = c;
                                    f = a.value;
                                } else {
                                    a.context.manifestCached = a.value.cached;
                                    f = a.value.manifest;
                                }
                                Telemetry.AppLoadTimeHelper.SetManifestDataCachedFlag(
                                    d._telemetryContext,
                                    a.value.cached
                                );
                                a.value = new OSF.Manifest.Manifest(
                                    f,
                                    d._contextActivationMgr.getAppUILocale()
                                );
                                OSF.OsfManifestManager.cacheManifest(e.id, e.version, a.value);
                            } catch (g) {
                                a.value = b;
                                var i;
                                if (d) i = d._appCorrelationId;
                                var j = 'Invalid manifest in getManifestAsync.';
                                OfficeExt.WACUtils.logExceptionToBrowserConsole(j, g);
                                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(j, g, i, 18420423);
                            }
                        } else
                            Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
                                'getManifestAsync failed:' +
                                    OfficeExt.WACUtils.serializeObjectToString(a),
                                b,
                                b,
                                18420424
                            );
                        h(a);
                    },
                    l = {
                        manifestUrl: d.manifestUrl,
                        id: e.id,
                        version: e.version,
                        clearCache: d.clearCache || a,
                    };
                this._invokeProxyMethodAsync(d, 'OEM_getManifestAsync', j, l);
            } else h({ statusCode: OSF.ProxyCallStatusCode.Failed, value: b, context: d });
        },
        getAppInstanceInfoByIdAsync: function(b, c) {
            OSF.OUtil.validateParamObject(
                b,
                {
                    webUrl: { type: String, mayBeNull: a },
                    appInstanceId: { type: String, mayBeNull: a },
                    clientEndPoint: { type: Object, mayBeNull: a },
                },
                c
            );
            var d = {
                webUrl: b.webUrl,
                appInstanceId: b.appInstanceId,
                clearCache: b.clearCache || a,
            };
            this._invokeProxyMethodAsync(b, 'OEM_getSPAppInstanceInfoByIdAsync', c, d);
        },
        getSPTokenByProductIdAsync: function(c, d) {
            OSF.OUtil.validateParamObject(
                c,
                {
                    appWebUrl: { type: String, mayBeNull: a },
                    productId: { type: String, mayBeNull: a },
                },
                d
            );
            var f = this,
                e = function(e) {
                    if (e) {
                        var g = {
                            webUrl: c.appWebUrl,
                            productId: c.productId,
                            clearCache: c.clearCache || a,
                            clientEndPoint: e,
                        };
                        f._invokeProxyMethodAsync(c, 'OEM_getSPTokenByProductIdAsync', d, g);
                    } else
                        d({
                            statusCode: OSF.ProxyCallStatusCode.ProxyNotReady,
                            value: b,
                            context: c,
                        });
                };
            c.osfControl._contextActivationMgr._createSharePointIFrameProxy(c.appWebUrl, e);
        },
        getSPAppEntitlementsAsync: function(e, g) {
            var d = '/';
            OSF.OUtil.validateParamObject(
                e,
                {
                    osfControl: { type: Object, mayBeNull: a },
                    referenceInUse: { type: Object, mayBeNull: a },
                    baseUrl: { type: String, mayBeNull: a },
                    pageUrl: { type: String, mayBeNull: a },
                    webUrl: { type: String, mayBeNull: c },
                },
                g
            );
            if (!e.webUrl) {
                var h = document.createElement('a');
                h.href = e.pageUrl;
                var o = h.pathname,
                    m = o.split(d),
                    r = m.length - 1,
                    f = h.href.substring(0, h.href.length - o.length);
                if (f && f.charAt(f.length - 1) !== d) f += d;
                for (var j = [f], k = 0; k < r; k++)
                    if (m[k]) {
                        f = f + m[k] + d;
                        j.push(f);
                    }
                h = b;
                var p = this,
                    l = e.osfControl._contextActivationMgr,
                    i = j.pop(),
                    q = function(b) {
                        if (b.statusCode === OSF.ProxyCallStatusCode.Succeeded) {
                            var a = b.value;
                            if (a && a.charAt(a.length - 1) !== d) a += d;
                            l._webUrl = a;
                            b.context.webUrl = a;
                            b.context.appWebUrl = a;
                            p.getCorporateCatalogEntitlementsAsync(b.context, g);
                        } else g(b);
                    },
                    n = function(c) {
                        if (c) {
                            e.clientEndPoint = c;
                            var d = {
                                pageUrl: e.pageUrl,
                                baseUrl: i,
                                clearCache: e.clearCache || a,
                            };
                            p._invokeProxyMethodAsync(
                                e,
                                'OEM_getSPAppWebUrlFromPageUrlAsync',
                                q,
                                d
                            );
                        } else if (j.length > 0) {
                            i = j.pop();
                            l._createSharePointIFrameProxy(i, n);
                        } else
                            g({ statusCode: OSF.ProxyCallStatusCode.Failed, value: b, context: e });
                    };
                l._createSharePointIFrameProxy(i, n);
            } else this.getCorporateCatalogEntitlementsAsync(e, g);
        },
        getOneDriveEntitlementsAsync: function(e, o) {
            var c = 'Content-Type',
                p = e.referenceInUse.storeLocator,
                m = e.referenceInUse.storeLocator + '/root:/Manifests',
                d = OSF.OneDriveOAuth.getAccessTokenFromCookie();
            if (d == '' || d == undefined);
            var h = '?access_token=' + d,
                k = m + h,
                b = new XMLHttpRequest(),
                a = new XMLHttpRequest();
            b.onreadystatechange = function() {
                if (b.readyState == 4)
                    if (b.status == 200) {
                        var g = JSON.parse(b.response),
                            f = g.id,
                            d = e.referenceInUse.storeLocator + '/items/' + f + '/children' + h;
                        a.open('GET', d);
                        a.setRequestHeader(c, 'json');
                        a.send();
                    }
            };
            var i = [],
                j = 0,
                g = 0,
                f = function() {
                    j == g &&
                        o({
                            statusCode: OSF.ProxyCallStatusCode.Succeeded,
                            value: { entitlements: i },
                            context: e,
                        });
                },
                l = function(e, d) {
                    g++;
                    var c = d;
                    try {
                        var b = new OSF.Manifest.Manifest(e.responseText),
                            a = [];
                        a.push(b.getDefaultDisplayName());
                        a.push(c);
                        a.push(b.getDefaultDescription());
                        a.push(b.getTarget());
                        a.push(b.getMarketplaceVersion());
                        a.push(c);
                        a.push(OSF.StoreType.OneDrive);
                        a.push(b.getDefaultWidth() || 0);
                        a.push(b.getDefaultHeight() || 0);
                        a.push(b.getDefaultIconUrl());
                        a.push(b.getProviderName());
                        a.push(b.getDefaultLocale());
                        a.push(OSF.StoreType.OneDrive);
                        i.push(a);
                    } catch (h) {}
                    f();
                },
                n = function() {
                    g++;
                    f();
                };
            a.onreadystatechange = function() {
                if (a.readyState == 4 && a.status == 200) {
                    for (var c = JSON.parse(a.responseText), b = 0; b < c.value.length; b++)
                        if (
                            c.value[b].name.substr(c.value[b].name.length - 4).toLowerCase() ==
                            '.xml'
                        ) {
                            var e =
                                p +
                                '/root:/Manifests/' +
                                c.value[b].name +
                                ':/content?access_token=' +
                                d;
                            OSF.OUtil.xhrGetFull(e, c.value[b].name, l, n);
                            j++;
                        }
                    f();
                }
            };
            b.open('GET', k);
            b.setRequestHeader(c, 'json');
            b.send();
        },
        getCorporateCatalogEntitlementsAsync: function(d, e) {
            OSF.OUtil.validateParamObject(
                d,
                {
                    osfControl: { type: Object, mayBeNull: a },
                    referenceInUse: { type: Object, mayBeNull: a },
                    webUrl: { type: String, mayBeNull: a },
                },
                e
            );
            Telemetry.AppLoadTimeHelper.AuthenticationStart(d.osfControl._telemetryContext);
            var h = this,
                g = 0,
                f = function(i) {
                    if (i) {
                        Telemetry.AppLoadTimeHelper.AuthenticationEnd(
                            d.osfControl._telemetryContext
                        );
                        d.clientEndPoint = i;
                        var j = {
                            webUrl: d.webUrl,
                            applicationName: OSF.HostCapability[d.hostType],
                            officeExtentionTarget:
                                d.noTargetType ||
                                d.osfControl.getOsfControlType() === OSF.OsfControlTarget.TaskPane
                                    ? b
                                    : d.osfControl.getOsfControlType(),
                            clearCache: d.clearCache || a,
                            supportedManifestVersions: { '1.0': c, '1.1': c },
                        };
                        h._invokeProxyMethodAsync(d, 'OEM_getEntitlementSummaryAsync', e, j);
                    } else if (g < OSF.Constants.AuthenticatedConnectMaxTries) {
                        g++;
                        setTimeout(function() {
                            d.osfControl._contextActivationMgr._createSharePointIFrameProxy(
                                d.webUrl,
                                f
                            );
                        }, 500);
                    } else
                        e({
                            statusCode: OSF.ProxyCallStatusCode.ProxyNotReady,
                            value: b,
                            context: d,
                        });
                };
            d.osfControl._contextActivationMgr._createSharePointIFrameProxy(d.webUrl, f);
        },
        _invokeProxyMethodAsync: function(c, g, p, a) {
            var o = a.clientEndPoint ? a.clientEndPoint._targetUrl : c.clientEndPoint._targetUrl,
                k = [o, g],
                e;
            for (var m in a) {
                e = typeof a[m];
                (e === 'string' || e === 'number' || e === 'boolean') && k.push(a[m]);
            }
            var f = k.join('.'),
                d = j,
                i = { onCompleted: p, context: c, methodName: g },
                h = d[f];
            if (!h) {
                d[f] = [i];
                var n = function(n, c) {
                        var k = b,
                            i = OSF.ProxyCallStatusCode.Failed;
                        if (n === 0 && c.status) {
                            k = c.result;
                            i = OSF.ProxyCallStatusCode.Succeeded;
                        }
                        var h = d[f];
                        delete d[f];
                        for (var m = h.length, l = 0; l < m; l++) {
                            var a = h.shift(),
                                e;
                            try {
                                if (a.context && a.context.osfControl)
                                    e = a.context.osfControl._appCorrelationId;
                                c &&
                                    c.failureInfo &&
                                    Telemetry.RuntimeTelemetryHelper.LogProxyFailure(
                                        e,
                                        a.methodName,
                                        c.failureInfo
                                    );
                                a.onCompleted({ statusCode: i, value: k, context: a.context });
                            } catch (g) {
                                var j = '_invokeProxyMethodAsync failed.';
                                OfficeExt.WACUtils.logExceptionToBrowserConsole(j, g);
                                Telemetry.RuntimeTelemetryHelper.LogExceptionTag(j, g, e, 18420425);
                            }
                        }
                    },
                    l = c.clientEndPoint;
                if (a.clientEndPoint) {
                    l = a.clientEndPoint;
                    delete a.clientEndPoint;
                }
                if (c.referenceInUse && c.referenceInUse.storeType === OSF.StoreType.OMEX)
                    a.officeVersion = OSF.Constants.ThreePartsFileVersion;
                l.invoke(g, n, a);
            } else h.push(i);
        },
        removeOmexCacheAsync: function(b, e) {
            OSF.OUtil.validateParamObject(
                b,
                {
                    osfControl: { type: Object, mayBeNull: a },
                    referenceInUse: { type: Object, mayBeNull: a },
                    clientEndPoint: { type: Object, mayBeNull: a },
                },
                e
            );
            var d = b.referenceInUse,
                c = {
                    applicationName: b.hostType,
                    assetID: d.id,
                    officeExtentionTarget: b.osfControl.getOsfControlType(),
                    clearEntitlement: b.clearEntitlement || a,
                    clearToken: b.clearToken || a,
                    clearAppState: b.clearAppState || a,
                    clearManifest: b.clearManifest || a,
                    appVersion: b.appVersion,
                };
            if (b.anonymous) c.contentMarket = d.storeLocator;
            else {
                c.assetContentMarket = b.osfControl._omexEntitlement.contentMarket;
                c.userContentMarket = d.storeLocator;
            }
            this._invokeProxyMethodAsync(b, 'OMEX_removeCacheAsync', e, c);
        },
        purgeManifest: function(j, i) {
            var c = Function._validateParams(arguments, [
                { name: d, type: String, mayBeNull: a },
                { name: e, type: String, mayBeNull: a },
            ]);
            if (c) throw c;
            var b = g(j, i);
            if (typeof f[b] != h) delete f[b];
        },
        cacheManifestFromXml: function(f, c, g, h) {
            var b = Function._validateParams(arguments, [
                { name: d, type: String, mayBeNull: a },
                { name: e, type: String, mayBeNull: a },
                { name: 'manifestXml', type: String, mayBeNull: a },
                { name: 'uiLocale', type: String, mayBeNull: a },
            ]);
            if (b) throw b;
            this.cacheManifest(f, c, new OSF.Manifest.Manifest(g, h));
        },
        cacheManifest: function(j, h, b) {
            var c = Function._validateParams(arguments, [
                { name: d, type: String, mayBeNull: a },
                { name: e, type: String, mayBeNull: a },
                { name: 'manifest', type: Object, mayBeNull: a },
            ]);
            if (c) throw c;
            var k = g(j, h);
            b._UILocale = b._UILocale || i;
            f[k] = b;
        },
        hasManifest: function(j, i) {
            var b = Function._validateParams(arguments, [
                { name: d, type: String, mayBeNull: a },
                { name: e, type: String, mayBeNull: a },
            ]);
            if (b) throw b;
            var k = g(j, i);
            if (typeof f[k] != h) return c;
            return a;
        },
        getCachedManifest: function(h, c) {
            var b = Function._validateParams(arguments, [
                { name: d, type: String, mayBeNull: a },
                { name: e, type: String, mayBeNull: a },
            ]);
            if (b) throw b;
            var i = g(h, c);
            return f[i];
        },
        versionLessThan: function(j, k) {
            for (
                var e = j.split('.'),
                    d = k.split('.'),
                    g = Math.min(e.length, d.length),
                    f,
                    c,
                    b = 0;
                b < g;
                b++
            )
                try {
                    f = parseFloat(e[b]);
                    c = parseFloat(d[b]);
                    if (f != c) return f < c;
                } catch (i) {}
            if (e.length >= d.length) return a;
            else {
                g = d.length;
                var h = 0;
                for (b = e.length; b < g; b++) {
                    try {
                        c = parseFloat(d[b]);
                    } catch (i) {
                        c = 0;
                    }
                    h += c;
                }
                return h > 0;
            }
        },
        _setUILocale: function(a) {
            i = a;
        },
    };
})();
OSF.ManifestSchemaVersion = { '1.0': '1.0', '1.1': '1.1' };
OSF.ManifestNamespaces = {
    '1.0':
        'xmlns="http://schemas.microsoft.com/office/appforoffice/1.0" xmlns:o="http://schemas.microsoft.com/office/appforoffice/1.0" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"',
    '1.1':
        'xmlns="http://schemas.microsoft.com/office/appforoffice/1.1" xmlns:o="http://schemas.microsoft.com/office/appforoffice/1.1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bt="http://schemas.microsoft.com/office/officeappbasictypes/1.0" xmlns:ov="http://schemas.microsoft.com/office/taskpaneappversionoverrides" xmlns:c="http://schemas.microsoft.com/office/contentappversionoverrides"',
};
OSF.OsfNavigationMode = { DefaultMode: 0, CategoryMode: 1, TrustPageMode: 2, QueryResultMode: 3 };
OSF.RequirementsChecker = function(d, f, e, c, b) {
    var a = this;
    a.setCapabilities(d);
    a.setHosts(f);
    a.setRequirements(e);
    a.setSupportedControlTargets(c);
    a.setSupportedOmexAppVersions(b);
    a.setFilteringEnabled(false);
};
OSF.RequirementsChecker.prototype = {
    defaultMinMaxVersion: '1.1',
    isManifestSupported: function(a) {
        if (!this.isFilteringEnabled()) return true;
        if (!a) return false;
        var b = a.getManifestSchemaVersion() || OSF.ManifestSchemaVersion['1.0'];
        switch (b) {
            case OSF.ManifestSchemaVersion['1.0']:
                return this._checkManifest1_0(a);
            case OSF.ManifestSchemaVersion['1.1']:
                return this._checkManifest1_1(a);
            default:
                return false;
        }
    },
    isEntitlementFromOmexSupported: function(a) {
        var c = this;
        if (!c.isFilteringEnabled()) return true;
        if (!a) return false;
        var d;
        switch (a.appSubType) {
            case '1':
                d = OSF.OsfControlTarget.TaskPane;
                break;
            case '2':
                d = OSF.OsfControlTarget.InContent;
                break;
            case '3':
                d = OSF.OsfControlTarget.Contextual;
                break;
            case '4':
                d = OSF.OsfControlTarget.TaskPane;
                break;
            default:
                return false;
        }
        if (!c._checkControlTarget(d)) return false;
        if (!a.requirements && !a.hosts) {
            if (!a.hasOwnProperty('appVersions') || a.appVersions === undefined) return true;
            return c._checkOmexAppVersions(a.appVersions);
        }
        var b = new OSF.Manifest.Manifest(function() {}),
            e,
            f,
            h,
            g;
        if (a.requirements) {
            b._xmlProcessor = new OSF.XmlProcessor(a.requirements, OSF.ManifestNamespaces['1.1']);
            f = b._xmlProcessor.getDocumentElement();
        }
        e = b._parseRequirements(f);
        if (a.hosts) {
            b._xmlProcessor = new OSF.XmlProcessor(a.hosts, OSF.ManifestNamespaces['1.1']);
            g = b._xmlProcessor.getDocumentElement();
        }
        h = b._parseHosts(g);
        return c._checkHosts(h) && c._checkSets(e.sets) && c._checkMethods(e.methods);
    },
    isEntitlementFromCorpCatalogSupported: function(c) {
        var a = this;
        if (!a.isFilteringEnabled()) return true;
        if (!c) return false;
        var i = OSF.OfficeAppType[c.OEType];
        if (!a._checkControlTarget(i)) return false;
        var b = new OSF.Manifest.Manifest(function() {}),
            g,
            h,
            f;
        if (c.OfficeExtensionCapabilitiesXML) {
            b._xmlProcessor = new OSF.XmlProcessor(
                c.OfficeExtensionCapabilitiesXML,
                OSF.ManifestNamespaces['1.1']
            );
            var e, d;
            e = b._xmlProcessor.getDocumentElement();
            d = b._parseRequirements(e);
            h = d.sets;
            f = d.methods;
            g = b._parseHosts(e);
        }
        return a._checkHosts(g) && a._checkSets(h) && a._checkMethods(f);
    },
    setCapabilities: function(a) {
        this._supportedCapabilities = this._scalarArrayToObject(a);
    },
    setHosts: function(a) {
        this._supportedHosts = this._scalarArrayToObject(a);
    },
    setRequirements: function(a) {
        var b = this;
        b._supportedSets = (a && b._arrayToSetsObject(a.sets)) || {};
        b._supportedMethods = (a && b._scalarArrayToObject(a.methods)) || {};
    },
    setSupportedControlTargets: function(a) {
        this._supportedControlTargets = this._scalarArrayToObject(a);
    },
    setSupportedOmexAppVersions: function(a) {
        this._supportedOmexAppVersions = a && a.slice ? a.slice(0) : [];
    },
    setFilteringEnabled: function(a) {
        this._filteringEnabled = a ? true : false;
    },
    isFilteringEnabled: function() {
        return this._filteringEnabled;
    },
    _checkManifest1_0: function(a) {
        return this._checkCapabilities(a.getCapabilities());
    },
    _checkCapabilities: function(a) {
        if (!a || a.length === 0) return true;
        for (var b = 0; b < a.length; b++) if (this._supportedCapabilities[a[b]]) return true;
        return false;
    },
    _checkManifest1_1: function(b) {
        var a = b.getRequirements() || {};
        return (
            this._checkHosts(b.getHosts()) &&
            this._checkSets(a.sets) &&
            this._checkMethods(a.methods)
        );
    },
    _checkHosts: function(a) {
        if (!a || a.length === 0) return true;
        for (var b = 0; b < a.length; b++) if (this._supportedHosts[a[b]]) return true;
        return false;
    },
    _checkSets: function(b) {
        var a = this;
        if (!b || b.length === 0) return true;
        for (var e = 0; e < b.length; e++) {
            var c = b[e],
                d = a._supportedSets[c.name.toLowerCase()];
            if (!d) return false;
            if (c.version)
                if (
                    a._compareVersionStrings(d.minVersion || a.defaultMinMaxVersion, c.version) >
                        0 ||
                    a._compareVersionStrings(d.maxVersion || a.defaultMinMaxVersion, c.version) < 0
                )
                    return false;
        }
        return true;
    },
    _checkMethods: function(a) {
        if (!a || a.length === 0) return true;
        for (var b = 0; b < a.length; b++) if (!this._supportedMethods[a[b]]) return false;
        return true;
    },
    _checkControlTarget: function(a) {
        return a != undefined && this._supportedControlTargets[a];
    },
    _checkOmexAppVersions: function(b) {
        if (!b) return false;
        for (var a = 0; a < this._supportedOmexAppVersions.length; a++)
            if (b.indexOf(this._supportedOmexAppVersions[a]) >= 0) return true;
        return false;
    },
    _scalarArrayToObject: function(a) {
        var c = {};
        if (a && a.length) for (var b = 0; b < a.length; b++) if (a[b] != undefined) c[a[b]] = true;
        return c;
    },
    _arrayToSetsObject: function(a) {
        var d = {};
        if (a && a.length)
            for (var c = 0; c < a.length; c++) {
                var b = a[c];
                if (b && b.name != undefined) d[b.name.toLowerCase()] = b;
            }
        return d;
    },
    _getSupportedSet: function() {
        for (
            var a = {}, c = Object.getOwnPropertyNames(this._supportedSets), b = 0;
            b < c.length;
            b++
        ) {
            var d = this._supportedSets[c[b]];
            a[d.name.toLowerCase()] = d.maxVersion || this.defaultMinMaxVersion;
        }
        if (typeof JSON !== 'undefined') return JSON.stringify(a);
        return a;
    },
    _compareVersionStrings: function(b, a) {
        b = b.split('.');
        a = a.split('.');
        for (var f = Math.max(b.length, a.length), c = 0; c < f; c++) {
            var e = parseInt(b[c], 10) || 0,
                d = parseInt(a[c], 10) || 0;
            if (e === d) continue;
            return e - d;
        }
        return 0;
    },
};
OfficeExt.appSpecificCheckOrigin = function(c, a, d, b) {
    try {
        if (
            !a ||
            !a.source ||
            !a.source.location ||
            !a.source.location.pathname ||
            a.source.location.pathname.indexOf('projection.aspx') < 0
        )
            return false;
        return b(c, d);
    } catch (e) {
        return false;
    }
};
var OsfruntimeWindow = window;
OsfruntimeWindow.OfficeExt = OfficeExt;
